// src/resources/actors/get.ts
import { mtMap } from "@metorial/util-resource-mapper";
var mapActorsGetOutput = mtMap.object({
  id: mtMap.objectField("id", mtMap.passthrough()),
  name: mtMap.objectField("name", mtMap.passthrough()),
  type: mtMap.objectField("type", mtMap.passthrough()),
  metadata: mtMap.objectField("metadata", mtMap.passthrough()),
  createdAt: mtMap.objectField("created_at", mtMap.date()),
  updatedAt: mtMap.objectField("updated_at", mtMap.date())
});

// src/resources/actors/list.ts
import { mtMap as mtMap2 } from "@metorial/util-resource-mapper";
var mapActorsListOutput = mtMap2.object({
  items: mtMap2.objectField(
    "items",
    mtMap2.array(
      mtMap2.object({
        id: mtMap2.objectField("id", mtMap2.passthrough()),
        name: mtMap2.objectField("name", mtMap2.passthrough()),
        type: mtMap2.objectField("type", mtMap2.passthrough()),
        metadata: mtMap2.objectField("metadata", mtMap2.passthrough()),
        createdAt: mtMap2.objectField("created_at", mtMap2.date()),
        updatedAt: mtMap2.objectField("updated_at", mtMap2.date())
      })
    )
  ),
  pagination: mtMap2.objectField(
    "pagination",
    mtMap2.object({
      afterCursor: mtMap2.objectField("after_cursor", mtMap2.passthrough()),
      beforeCursor: mtMap2.objectField("before_cursor", mtMap2.passthrough()),
      hasMoreBefore: mtMap2.objectField("has_more_before", mtMap2.passthrough()),
      hasMoreAfter: mtMap2.objectField("has_more_after", mtMap2.passthrough()),
      pageSize: mtMap2.objectField("page_size", mtMap2.passthrough()),
      sort: mtMap2.objectField(
        "sort",
        mtMap2.array(
          mtMap2.object({
            field: mtMap2.objectField("field", mtMap2.passthrough()),
            order: mtMap2.objectField("order", mtMap2.passthrough())
          })
        )
      )
    })
  )
});
var mapActorsListQuery = mtMap2.object({
  id: mtMap2.objectField(
    "id",
    mtMap2.union([
      mtMap2.unionOption(
        "object",
        mtMap2.object({
          in: mtMap2.objectField("in", mtMap2.array(mtMap2.passthrough())),
          eq: mtMap2.objectField("eq", mtMap2.passthrough())
        })
      ),
      mtMap2.unionOption("string", mtMap2.passthrough())
    ])
  ),
  ids: mtMap2.objectField(
    "ids",
    mtMap2.union([
      mtMap2.unionOption(
        "object",
        mtMap2.object({
          in: mtMap2.objectField("in", mtMap2.array(mtMap2.passthrough())),
          eq: mtMap2.objectField("eq", mtMap2.passthrough())
        })
      ),
      mtMap2.unionOption("string", mtMap2.passthrough())
    ])
  ),
  createdAt: mtMap2.objectField(
    "created_at",
    mtMap2.union([
      mtMap2.unionOption(
        "object",
        mtMap2.object({
          eq: mtMap2.objectField("eq", mtMap2.date()),
          gt: mtMap2.objectField("gt", mtMap2.date()),
          gte: mtMap2.objectField("gte", mtMap2.date()),
          lt: mtMap2.objectField("lt", mtMap2.date()),
          lte: mtMap2.objectField("lte", mtMap2.date())
        })
      ),
      mtMap2.unionOption("date", mtMap2.passthrough())
    ])
  ),
  updatedAt: mtMap2.objectField(
    "updated_at",
    mtMap2.union([
      mtMap2.unionOption(
        "object",
        mtMap2.object({
          eq: mtMap2.objectField("eq", mtMap2.date()),
          gt: mtMap2.objectField("gt", mtMap2.date()),
          gte: mtMap2.objectField("gte", mtMap2.date()),
          lt: mtMap2.objectField("lt", mtMap2.date()),
          lte: mtMap2.objectField("lte", mtMap2.date())
        })
      ),
      mtMap2.unionOption("date", mtMap2.passthrough())
    ])
  ),
  type: mtMap2.objectField(
    "type",
    mtMap2.union([
      mtMap2.unionOption(
        "object",
        mtMap2.object({
          in: mtMap2.objectField("in", mtMap2.array(mtMap2.passthrough())),
          eq: mtMap2.objectField("eq", mtMap2.passthrough())
        })
      ),
      mtMap2.unionOption("string", mtMap2.passthrough())
    ])
  ),
  types: mtMap2.objectField(
    "types",
    mtMap2.union([
      mtMap2.unionOption(
        "object",
        mtMap2.object({
          in: mtMap2.objectField("in", mtMap2.array(mtMap2.passthrough())),
          eq: mtMap2.objectField("eq", mtMap2.passthrough())
        })
      ),
      mtMap2.unionOption("string", mtMap2.passthrough())
    ])
  ),
  sort: mtMap2.objectField(
    "sort",
    mtMap2.union([
      mtMap2.unionOption("string", mtMap2.passthrough()),
      mtMap2.unionOption(
        "array",
        mtMap2.union([
          mtMap2.unionOption(
            "object",
            mtMap2.object({
              field: mtMap2.objectField("field", mtMap2.passthrough()),
              order: mtMap2.objectField("order", mtMap2.passthrough())
            })
          )
        ])
      )
    ])
  ),
  threadId: mtMap2.objectField("thread_id", mtMap2.passthrough()),
  limit: mtMap2.objectField("limit", mtMap2.passthrough()),
  cursor: mtMap2.objectField("cursor", mtMap2.passthrough()),
  order: mtMap2.objectField("order", mtMap2.passthrough())
});

// src/resources/agents/get.ts
import { mtMap as mtMap3 } from "@metorial/util-resource-mapper";
var mapAgentsGetOutput = mtMap3.object({
  id: mtMap3.objectField("id", mtMap3.passthrough()),
  slug: mtMap3.objectField("slug", mtMap3.passthrough()),
  name: mtMap3.objectField("name", mtMap3.passthrough()),
  status: mtMap3.objectField("status", mtMap3.passthrough()),
  instanceId: mtMap3.objectField("instance_id", mtMap3.passthrough()),
  agentId: mtMap3.objectField("agent_id", mtMap3.passthrough()),
  createdAt: mtMap3.objectField("created_at", mtMap3.date()),
  updatedAt: mtMap3.objectField("updated_at", mtMap3.date()),
  currentRelease: mtMap3.objectField(
    "current_release",
    mtMap3.object({
      id: mtMap3.objectField("id", mtMap3.passthrough()),
      agentId: mtMap3.objectField("agent_id", mtMap3.passthrough()),
      version: mtMap3.objectField("version", mtMap3.passthrough()),
      createdAt: mtMap3.objectField("created_at", mtMap3.date())
    })
  )
});

// src/resources/agents/list.ts
import { mtMap as mtMap4 } from "@metorial/util-resource-mapper";
var mapAgentsListOutput = mtMap4.object({
  items: mtMap4.objectField(
    "items",
    mtMap4.array(
      mtMap4.object({
        id: mtMap4.objectField("id", mtMap4.passthrough()),
        slug: mtMap4.objectField("slug", mtMap4.passthrough()),
        name: mtMap4.objectField("name", mtMap4.passthrough()),
        status: mtMap4.objectField("status", mtMap4.passthrough()),
        instanceId: mtMap4.objectField("instance_id", mtMap4.passthrough()),
        agentId: mtMap4.objectField("agent_id", mtMap4.passthrough()),
        createdAt: mtMap4.objectField("created_at", mtMap4.date()),
        updatedAt: mtMap4.objectField("updated_at", mtMap4.date()),
        currentRelease: mtMap4.objectField(
          "current_release",
          mtMap4.object({
            id: mtMap4.objectField("id", mtMap4.passthrough()),
            agentId: mtMap4.objectField("agent_id", mtMap4.passthrough()),
            version: mtMap4.objectField("version", mtMap4.passthrough()),
            createdAt: mtMap4.objectField("created_at", mtMap4.date())
          })
        )
      })
    )
  ),
  pagination: mtMap4.objectField(
    "pagination",
    mtMap4.object({
      afterCursor: mtMap4.objectField("after_cursor", mtMap4.passthrough()),
      beforeCursor: mtMap4.objectField("before_cursor", mtMap4.passthrough()),
      hasMoreBefore: mtMap4.objectField("has_more_before", mtMap4.passthrough()),
      hasMoreAfter: mtMap4.objectField("has_more_after", mtMap4.passthrough()),
      pageSize: mtMap4.objectField("page_size", mtMap4.passthrough()),
      sort: mtMap4.objectField(
        "sort",
        mtMap4.array(
          mtMap4.object({
            field: mtMap4.objectField("field", mtMap4.passthrough()),
            order: mtMap4.objectField("order", mtMap4.passthrough())
          })
        )
      )
    })
  )
});
var mapAgentsListQuery = mtMap4.object({
  createdAt: mtMap4.objectField(
    "created_at",
    mtMap4.union([
      mtMap4.unionOption(
        "object",
        mtMap4.object({
          eq: mtMap4.objectField("eq", mtMap4.date()),
          gt: mtMap4.objectField("gt", mtMap4.date()),
          gte: mtMap4.objectField("gte", mtMap4.date()),
          lt: mtMap4.objectField("lt", mtMap4.date()),
          lte: mtMap4.objectField("lte", mtMap4.date())
        })
      ),
      mtMap4.unionOption("date", mtMap4.passthrough())
    ])
  ),
  id: mtMap4.objectField(
    "id",
    mtMap4.union([
      mtMap4.unionOption(
        "object",
        mtMap4.object({
          in: mtMap4.objectField("in", mtMap4.array(mtMap4.passthrough())),
          eq: mtMap4.objectField("eq", mtMap4.passthrough())
        })
      ),
      mtMap4.unionOption("string", mtMap4.passthrough())
    ])
  ),
  ids: mtMap4.objectField(
    "ids",
    mtMap4.union([
      mtMap4.unionOption(
        "object",
        mtMap4.object({
          in: mtMap4.objectField("in", mtMap4.array(mtMap4.passthrough())),
          eq: mtMap4.objectField("eq", mtMap4.passthrough())
        })
      ),
      mtMap4.unionOption("string", mtMap4.passthrough())
    ])
  ),
  sort: mtMap4.objectField(
    "sort",
    mtMap4.union([
      mtMap4.unionOption("string", mtMap4.passthrough()),
      mtMap4.unionOption(
        "array",
        mtMap4.union([
          mtMap4.unionOption(
            "object",
            mtMap4.object({
              field: mtMap4.objectField("field", mtMap4.passthrough()),
              order: mtMap4.objectField("order", mtMap4.passthrough())
            })
          )
        ])
      )
    ])
  ),
  limit: mtMap4.objectField("limit", mtMap4.passthrough()),
  cursor: mtMap4.objectField("cursor", mtMap4.passthrough()),
  order: mtMap4.objectField("order", mtMap4.passthrough())
});

// src/resources/client-tokens/jwks/list.ts
import { mtMap as mtMap5 } from "@metorial/util-resource-mapper";
var mapClientTokensJwksListOutput = mtMap5.object({
  items: mtMap5.objectField(
    "items",
    mtMap5.array(
      mtMap5.object({
        kid: mtMap5.objectField("kid", mtMap5.passthrough()),
        kty: mtMap5.objectField("kty", mtMap5.passthrough()),
        alg: mtMap5.objectField("alg", mtMap5.passthrough()),
        use: mtMap5.objectField("use", mtMap5.passthrough()),
        iat: mtMap5.objectField("iat", mtMap5.passthrough()),
        exp: mtMap5.objectField("exp", mtMap5.passthrough())
      })
    )
  ),
  pagination: mtMap5.objectField(
    "pagination",
    mtMap5.object({
      afterCursor: mtMap5.objectField("after_cursor", mtMap5.passthrough()),
      beforeCursor: mtMap5.objectField("before_cursor", mtMap5.passthrough()),
      hasMoreBefore: mtMap5.objectField(
        "has_more_before",
        mtMap5.passthrough()
      ),
      hasMoreAfter: mtMap5.objectField("has_more_after", mtMap5.passthrough()),
      pageSize: mtMap5.objectField("page_size", mtMap5.passthrough()),
      sort: mtMap5.objectField(
        "sort",
        mtMap5.array(
          mtMap5.object({
            field: mtMap5.objectField("field", mtMap5.passthrough()),
            order: mtMap5.objectField("order", mtMap5.passthrough())
          })
        )
      )
    })
  )
});

// src/resources/files/get.ts
import { mtMap as mtMap6 } from "@metorial/util-resource-mapper";
var mapFilesGetOutput = mtMap6.object({
  id: mtMap6.objectField("id", mtMap6.passthrough()),
  purpose: mtMap6.objectField("purpose", mtMap6.passthrough()),
  name: mtMap6.objectField("name", mtMap6.passthrough()),
  size: mtMap6.objectField("size", mtMap6.passthrough()),
  mimeType: mtMap6.objectField("mime_type", mtMap6.passthrough()),
  createdAt: mtMap6.objectField("created_at", mtMap6.date())
});

// src/resources/files/links/create.ts
import { mtMap as mtMap7 } from "@metorial/util-resource-mapper";
var mapFilesLinksCreateOutput = mtMap7.object({
  id: mtMap7.objectField("id", mtMap7.passthrough()),
  purpose: mtMap7.objectField("purpose", mtMap7.passthrough()),
  name: mtMap7.objectField("name", mtMap7.passthrough()),
  size: mtMap7.objectField("size", mtMap7.passthrough()),
  mimeType: mtMap7.objectField("mime_type", mtMap7.passthrough()),
  createdAt: mtMap7.objectField("created_at", mtMap7.date())
});

// src/resources/files/list.ts
import { mtMap as mtMap8 } from "@metorial/util-resource-mapper";
var mapFilesListOutput = mtMap8.object({
  items: mtMap8.objectField(
    "items",
    mtMap8.array(
      mtMap8.object({
        id: mtMap8.objectField("id", mtMap8.passthrough()),
        purpose: mtMap8.objectField("purpose", mtMap8.passthrough()),
        name: mtMap8.objectField("name", mtMap8.passthrough()),
        size: mtMap8.objectField("size", mtMap8.passthrough()),
        mimeType: mtMap8.objectField("mime_type", mtMap8.passthrough()),
        createdAt: mtMap8.objectField("created_at", mtMap8.date())
      })
    )
  ),
  pagination: mtMap8.objectField(
    "pagination",
    mtMap8.object({
      afterCursor: mtMap8.objectField("after_cursor", mtMap8.passthrough()),
      beforeCursor: mtMap8.objectField("before_cursor", mtMap8.passthrough()),
      hasMoreBefore: mtMap8.objectField("has_more_before", mtMap8.passthrough()),
      hasMoreAfter: mtMap8.objectField("has_more_after", mtMap8.passthrough()),
      pageSize: mtMap8.objectField("page_size", mtMap8.passthrough()),
      sort: mtMap8.objectField(
        "sort",
        mtMap8.array(
          mtMap8.object({
            field: mtMap8.objectField("field", mtMap8.passthrough()),
            order: mtMap8.objectField("order", mtMap8.passthrough())
          })
        )
      )
    })
  )
});
var mapFilesListQuery = mtMap8.object({
  id: mtMap8.objectField(
    "id",
    mtMap8.union([
      mtMap8.unionOption(
        "object",
        mtMap8.object({
          in: mtMap8.objectField("in", mtMap8.array(mtMap8.passthrough())),
          eq: mtMap8.objectField("eq", mtMap8.passthrough())
        })
      ),
      mtMap8.unionOption("string", mtMap8.passthrough())
    ])
  ),
  ids: mtMap8.objectField(
    "ids",
    mtMap8.union([
      mtMap8.unionOption(
        "object",
        mtMap8.object({
          in: mtMap8.objectField("in", mtMap8.array(mtMap8.passthrough())),
          eq: mtMap8.objectField("eq", mtMap8.passthrough())
        })
      ),
      mtMap8.unionOption("string", mtMap8.passthrough())
    ])
  ),
  createdAt: mtMap8.objectField(
    "created_at",
    mtMap8.union([
      mtMap8.unionOption(
        "object",
        mtMap8.object({
          eq: mtMap8.objectField("eq", mtMap8.date()),
          gt: mtMap8.objectField("gt", mtMap8.date()),
          gte: mtMap8.objectField("gte", mtMap8.date()),
          lt: mtMap8.objectField("lt", mtMap8.date()),
          lte: mtMap8.objectField("lte", mtMap8.date())
        })
      ),
      mtMap8.unionOption("date", mtMap8.passthrough())
    ])
  ),
  purpose: mtMap8.objectField(
    "purpose",
    mtMap8.union([
      mtMap8.unionOption(
        "object",
        mtMap8.object({
          in: mtMap8.objectField("in", mtMap8.array(mtMap8.passthrough())),
          eq: mtMap8.objectField("eq", mtMap8.passthrough())
        })
      ),
      mtMap8.unionOption("string", mtMap8.passthrough())
    ])
  ),
  sort: mtMap8.objectField(
    "sort",
    mtMap8.union([
      mtMap8.unionOption("string", mtMap8.passthrough()),
      mtMap8.unionOption(
        "array",
        mtMap8.union([
          mtMap8.unionOption(
            "object",
            mtMap8.object({
              field: mtMap8.objectField("field", mtMap8.passthrough()),
              order: mtMap8.objectField("order", mtMap8.passthrough())
            })
          )
        ])
      )
    ])
  ),
  threadId: mtMap8.objectField("thread_id", mtMap8.passthrough()),
  limit: mtMap8.objectField("limit", mtMap8.passthrough()),
  cursor: mtMap8.objectField("cursor", mtMap8.passthrough()),
  order: mtMap8.objectField("order", mtMap8.passthrough())
});

// src/resources/groups/blocks/delete.ts
import { mtMap as mtMap9 } from "@metorial/util-resource-mapper";
var mapGroupsBlocksDeleteOutput = mtMap9.object(
  {
    id: mtMap9.objectField("id", mtMap9.passthrough()),
    status: mtMap9.objectField("status", mtMap9.passthrough()),
    expiresAt: mtMap9.objectField("expires_at", mtMap9.date()),
    policy: mtMap9.objectField(
      "policy",
      mtMap9.object({
        id: mtMap9.objectField("id", mtMap9.passthrough()),
        status: mtMap9.objectField("status", mtMap9.passthrough()),
        isDefault: mtMap9.objectField("is_default", mtMap9.passthrough()),
        slug: mtMap9.objectField("slug", mtMap9.passthrough()),
        name: mtMap9.objectField("name", mtMap9.passthrough()),
        description: mtMap9.objectField("description", mtMap9.passthrough()),
        entitlements: mtMap9.objectField(
          "entitlements",
          mtMap9.array(
            mtMap9.object({
              id: mtMap9.objectField("id", mtMap9.passthrough()),
              status: mtMap9.objectField("status", mtMap9.passthrough()),
              policyId: mtMap9.objectField("policy_id", mtMap9.passthrough()),
              type: mtMap9.objectField("type", mtMap9.passthrough()),
              amount: mtMap9.objectField("amount", mtMap9.passthrough()),
              windowDuration: mtMap9.objectField(
                "window_duration",
                mtMap9.object({
                  size: mtMap9.objectField("size", mtMap9.passthrough()),
                  unit: mtMap9.objectField("unit", mtMap9.passthrough())
                })
              ),
              overageBlockDuration: mtMap9.objectField(
                "overage_block_duration",
                mtMap9.object({
                  size: mtMap9.objectField("size", mtMap9.passthrough()),
                  unit: mtMap9.objectField("unit", mtMap9.passthrough())
                })
              ),
              agents: mtMap9.objectField(
                "agents",
                mtMap9.union([
                  mtMap9.unionOption(
                    "object",
                    mtMap9.object({
                      type: mtMap9.objectField("type", mtMap9.passthrough()),
                      agentIds: mtMap9.objectField(
                        "agent_ids",
                        mtMap9.array(mtMap9.passthrough())
                      )
                    })
                  )
                ])
              ),
              createdAt: mtMap9.objectField("created_at", mtMap9.date()),
              updatedAt: mtMap9.objectField("updated_at", mtMap9.date())
            })
          )
        ),
        createdAt: mtMap9.objectField("created_at", mtMap9.date()),
        updatedAt: mtMap9.objectField("updated_at", mtMap9.date())
      })
    ),
    reason: mtMap9.objectField(
      "reason",
      mtMap9.object({
        type: mtMap9.objectField("type", mtMap9.passthrough()),
        entitlementIds: mtMap9.objectField(
          "entitlement_ids",
          mtMap9.array(mtMap9.passthrough())
        )
      })
    ),
    groupId: mtMap9.objectField("group_id", mtMap9.passthrough())
  }
);

// src/resources/groups/blocks/get.ts
import { mtMap as mtMap10 } from "@metorial/util-resource-mapper";
var mapGroupsBlocksGetOutput = mtMap10.object({
  id: mtMap10.objectField("id", mtMap10.passthrough()),
  status: mtMap10.objectField("status", mtMap10.passthrough()),
  expiresAt: mtMap10.objectField("expires_at", mtMap10.date()),
  policy: mtMap10.objectField(
    "policy",
    mtMap10.object({
      id: mtMap10.objectField("id", mtMap10.passthrough()),
      status: mtMap10.objectField("status", mtMap10.passthrough()),
      isDefault: mtMap10.objectField("is_default", mtMap10.passthrough()),
      slug: mtMap10.objectField("slug", mtMap10.passthrough()),
      name: mtMap10.objectField("name", mtMap10.passthrough()),
      description: mtMap10.objectField("description", mtMap10.passthrough()),
      entitlements: mtMap10.objectField(
        "entitlements",
        mtMap10.array(
          mtMap10.object({
            id: mtMap10.objectField("id", mtMap10.passthrough()),
            status: mtMap10.objectField("status", mtMap10.passthrough()),
            policyId: mtMap10.objectField("policy_id", mtMap10.passthrough()),
            type: mtMap10.objectField("type", mtMap10.passthrough()),
            amount: mtMap10.objectField("amount", mtMap10.passthrough()),
            windowDuration: mtMap10.objectField(
              "window_duration",
              mtMap10.object({
                size: mtMap10.objectField("size", mtMap10.passthrough()),
                unit: mtMap10.objectField("unit", mtMap10.passthrough())
              })
            ),
            overageBlockDuration: mtMap10.objectField(
              "overage_block_duration",
              mtMap10.object({
                size: mtMap10.objectField("size", mtMap10.passthrough()),
                unit: mtMap10.objectField("unit", mtMap10.passthrough())
              })
            ),
            agents: mtMap10.objectField(
              "agents",
              mtMap10.union([
                mtMap10.unionOption(
                  "object",
                  mtMap10.object({
                    type: mtMap10.objectField("type", mtMap10.passthrough()),
                    agentIds: mtMap10.objectField(
                      "agent_ids",
                      mtMap10.array(mtMap10.passthrough())
                    )
                  })
                )
              ])
            ),
            createdAt: mtMap10.objectField("created_at", mtMap10.date()),
            updatedAt: mtMap10.objectField("updated_at", mtMap10.date())
          })
        )
      ),
      createdAt: mtMap10.objectField("created_at", mtMap10.date()),
      updatedAt: mtMap10.objectField("updated_at", mtMap10.date())
    })
  ),
  reason: mtMap10.objectField(
    "reason",
    mtMap10.object({
      type: mtMap10.objectField("type", mtMap10.passthrough()),
      entitlementIds: mtMap10.objectField(
        "entitlement_ids",
        mtMap10.array(mtMap10.passthrough())
      )
    })
  ),
  groupId: mtMap10.objectField("group_id", mtMap10.passthrough())
});

// src/resources/groups/blocks/list.ts
import { mtMap as mtMap11 } from "@metorial/util-resource-mapper";
var mapGroupsBlocksListOutput = mtMap11.object({
  items: mtMap11.objectField(
    "items",
    mtMap11.array(
      mtMap11.object({
        id: mtMap11.objectField("id", mtMap11.passthrough()),
        status: mtMap11.objectField("status", mtMap11.passthrough()),
        expiresAt: mtMap11.objectField("expires_at", mtMap11.date()),
        policy: mtMap11.objectField(
          "policy",
          mtMap11.object({
            id: mtMap11.objectField("id", mtMap11.passthrough()),
            status: mtMap11.objectField("status", mtMap11.passthrough()),
            isDefault: mtMap11.objectField("is_default", mtMap11.passthrough()),
            slug: mtMap11.objectField("slug", mtMap11.passthrough()),
            name: mtMap11.objectField("name", mtMap11.passthrough()),
            description: mtMap11.objectField("description", mtMap11.passthrough()),
            entitlements: mtMap11.objectField(
              "entitlements",
              mtMap11.array(
                mtMap11.object({
                  id: mtMap11.objectField("id", mtMap11.passthrough()),
                  status: mtMap11.objectField("status", mtMap11.passthrough()),
                  policyId: mtMap11.objectField("policy_id", mtMap11.passthrough()),
                  type: mtMap11.objectField("type", mtMap11.passthrough()),
                  amount: mtMap11.objectField("amount", mtMap11.passthrough()),
                  windowDuration: mtMap11.objectField(
                    "window_duration",
                    mtMap11.object({
                      size: mtMap11.objectField("size", mtMap11.passthrough()),
                      unit: mtMap11.objectField("unit", mtMap11.passthrough())
                    })
                  ),
                  overageBlockDuration: mtMap11.objectField(
                    "overage_block_duration",
                    mtMap11.object({
                      size: mtMap11.objectField("size", mtMap11.passthrough()),
                      unit: mtMap11.objectField("unit", mtMap11.passthrough())
                    })
                  ),
                  agents: mtMap11.objectField(
                    "agents",
                    mtMap11.union([
                      mtMap11.unionOption(
                        "object",
                        mtMap11.object({
                          type: mtMap11.objectField("type", mtMap11.passthrough()),
                          agentIds: mtMap11.objectField(
                            "agent_ids",
                            mtMap11.array(mtMap11.passthrough())
                          )
                        })
                      )
                    ])
                  ),
                  createdAt: mtMap11.objectField("created_at", mtMap11.date()),
                  updatedAt: mtMap11.objectField("updated_at", mtMap11.date())
                })
              )
            ),
            createdAt: mtMap11.objectField("created_at", mtMap11.date()),
            updatedAt: mtMap11.objectField("updated_at", mtMap11.date())
          })
        ),
        reason: mtMap11.objectField(
          "reason",
          mtMap11.object({
            type: mtMap11.objectField("type", mtMap11.passthrough()),
            entitlementIds: mtMap11.objectField(
              "entitlement_ids",
              mtMap11.array(mtMap11.passthrough())
            )
          })
        ),
        groupId: mtMap11.objectField("group_id", mtMap11.passthrough())
      })
    )
  ),
  pagination: mtMap11.objectField(
    "pagination",
    mtMap11.object({
      afterCursor: mtMap11.objectField("after_cursor", mtMap11.passthrough()),
      beforeCursor: mtMap11.objectField("before_cursor", mtMap11.passthrough()),
      hasMoreBefore: mtMap11.objectField("has_more_before", mtMap11.passthrough()),
      hasMoreAfter: mtMap11.objectField("has_more_after", mtMap11.passthrough()),
      pageSize: mtMap11.objectField("page_size", mtMap11.passthrough()),
      sort: mtMap11.objectField(
        "sort",
        mtMap11.array(
          mtMap11.object({
            field: mtMap11.objectField("field", mtMap11.passthrough()),
            order: mtMap11.objectField("order", mtMap11.passthrough())
          })
        )
      )
    })
  )
});
var mapGroupsBlocksListQuery = mtMap11.object({
  id: mtMap11.objectField(
    "id",
    mtMap11.union([
      mtMap11.unionOption(
        "object",
        mtMap11.object({
          in: mtMap11.objectField("in", mtMap11.array(mtMap11.passthrough())),
          eq: mtMap11.objectField("eq", mtMap11.passthrough())
        })
      ),
      mtMap11.unionOption("string", mtMap11.passthrough())
    ])
  ),
  ids: mtMap11.objectField(
    "ids",
    mtMap11.union([
      mtMap11.unionOption(
        "object",
        mtMap11.object({
          in: mtMap11.objectField("in", mtMap11.array(mtMap11.passthrough())),
          eq: mtMap11.objectField("eq", mtMap11.passthrough())
        })
      ),
      mtMap11.unionOption("string", mtMap11.passthrough())
    ])
  ),
  createdAt: mtMap11.objectField(
    "created_at",
    mtMap11.union([
      mtMap11.unionOption(
        "object",
        mtMap11.object({
          eq: mtMap11.objectField("eq", mtMap11.date()),
          gt: mtMap11.objectField("gt", mtMap11.date()),
          gte: mtMap11.objectField("gte", mtMap11.date()),
          lt: mtMap11.objectField("lt", mtMap11.date()),
          lte: mtMap11.objectField("lte", mtMap11.date())
        })
      ),
      mtMap11.unionOption("date", mtMap11.passthrough())
    ])
  ),
  until: mtMap11.objectField(
    "until",
    mtMap11.union([
      mtMap11.unionOption(
        "object",
        mtMap11.object({
          eq: mtMap11.objectField("eq", mtMap11.date()),
          gt: mtMap11.objectField("gt", mtMap11.date()),
          gte: mtMap11.objectField("gte", mtMap11.date()),
          lt: mtMap11.objectField("lt", mtMap11.date()),
          lte: mtMap11.objectField("lte", mtMap11.date())
        })
      ),
      mtMap11.unionOption("date", mtMap11.passthrough())
    ])
  ),
  expiresAt: mtMap11.objectField(
    "expires_at",
    mtMap11.union([
      mtMap11.unionOption(
        "object",
        mtMap11.object({
          eq: mtMap11.objectField("eq", mtMap11.date()),
          gt: mtMap11.objectField("gt", mtMap11.date()),
          gte: mtMap11.objectField("gte", mtMap11.date()),
          lt: mtMap11.objectField("lt", mtMap11.date()),
          lte: mtMap11.objectField("lte", mtMap11.date())
        })
      ),
      mtMap11.unionOption("date", mtMap11.passthrough())
    ])
  ),
  status: mtMap11.objectField(
    "status",
    mtMap11.union([
      mtMap11.unionOption(
        "object",
        mtMap11.object({
          in: mtMap11.objectField("in", mtMap11.array(mtMap11.passthrough())),
          eq: mtMap11.objectField("eq", mtMap11.passthrough())
        })
      ),
      mtMap11.unionOption("string", mtMap11.passthrough())
    ])
  ),
  sort: mtMap11.objectField(
    "sort",
    mtMap11.union([
      mtMap11.unionOption("string", mtMap11.passthrough()),
      mtMap11.unionOption(
        "array",
        mtMap11.union([
          mtMap11.unionOption(
            "object",
            mtMap11.object({
              field: mtMap11.objectField("field", mtMap11.passthrough()),
              order: mtMap11.objectField("order", mtMap11.passthrough())
            })
          )
        ])
      )
    ])
  ),
  groupId: mtMap11.objectField("group_id", mtMap11.passthrough()),
  policyId: mtMap11.objectField("policy_id", mtMap11.passthrough()),
  limit: mtMap11.objectField("limit", mtMap11.passthrough()),
  cursor: mtMap11.objectField("cursor", mtMap11.passthrough()),
  order: mtMap11.objectField("order", mtMap11.passthrough())
});

// src/resources/groups/create.ts
import { mtMap as mtMap12 } from "@metorial/util-resource-mapper";
var mapGroupsCreateOutput = mtMap12.object({
  id: mtMap12.objectField("id", mtMap12.passthrough()),
  status: mtMap12.objectField("status", mtMap12.passthrough()),
  type: mtMap12.objectField("type", mtMap12.passthrough()),
  name: mtMap12.objectField("name", mtMap12.passthrough()),
  policies: mtMap12.objectField(
    "policies",
    mtMap12.array(
      mtMap12.object({
        id: mtMap12.objectField("id", mtMap12.passthrough()),
        status: mtMap12.objectField("status", mtMap12.passthrough()),
        isDefault: mtMap12.objectField("is_default", mtMap12.passthrough()),
        slug: mtMap12.objectField("slug", mtMap12.passthrough()),
        name: mtMap12.objectField("name", mtMap12.passthrough()),
        description: mtMap12.objectField("description", mtMap12.passthrough()),
        entitlements: mtMap12.objectField(
          "entitlements",
          mtMap12.array(
            mtMap12.object({
              id: mtMap12.objectField("id", mtMap12.passthrough()),
              status: mtMap12.objectField("status", mtMap12.passthrough()),
              policyId: mtMap12.objectField("policy_id", mtMap12.passthrough()),
              type: mtMap12.objectField("type", mtMap12.passthrough()),
              amount: mtMap12.objectField("amount", mtMap12.passthrough()),
              windowDuration: mtMap12.objectField(
                "window_duration",
                mtMap12.object({
                  size: mtMap12.objectField("size", mtMap12.passthrough()),
                  unit: mtMap12.objectField("unit", mtMap12.passthrough())
                })
              ),
              overageBlockDuration: mtMap12.objectField(
                "overage_block_duration",
                mtMap12.object({
                  size: mtMap12.objectField("size", mtMap12.passthrough()),
                  unit: mtMap12.objectField("unit", mtMap12.passthrough())
                })
              ),
              agents: mtMap12.objectField(
                "agents",
                mtMap12.union([
                  mtMap12.unionOption(
                    "object",
                    mtMap12.object({
                      type: mtMap12.objectField("type", mtMap12.passthrough()),
                      agentIds: mtMap12.objectField(
                        "agent_ids",
                        mtMap12.array(mtMap12.passthrough())
                      )
                    })
                  )
                ])
              ),
              createdAt: mtMap12.objectField("created_at", mtMap12.date()),
              updatedAt: mtMap12.objectField("updated_at", mtMap12.date())
            })
          )
        ),
        createdAt: mtMap12.objectField("created_at", mtMap12.date()),
        updatedAt: mtMap12.objectField("updated_at", mtMap12.date())
      })
    )
  ),
  metadata: mtMap12.objectField("metadata", mtMap12.passthrough()),
  createdAt: mtMap12.objectField("created_at", mtMap12.date()),
  updatedAt: mtMap12.objectField("updated_at", mtMap12.date())
});
var mapGroupsCreateBody = mtMap12.object({
  id: mtMap12.objectField("id", mtMap12.passthrough()),
  name: mtMap12.objectField("name", mtMap12.passthrough()),
  policyIds: mtMap12.objectField("policy_ids", mtMap12.array(mtMap12.passthrough())),
  metadata: mtMap12.objectField("metadata", mtMap12.passthrough()),
  users: mtMap12.objectField(
    "users",
    mtMap12.array(
      mtMap12.object({
        userId: mtMap12.objectField("user_id", mtMap12.passthrough()),
        roleId: mtMap12.objectField("role_id", mtMap12.passthrough())
      })
    )
  )
});

// src/resources/groups/delete.ts
import { mtMap as mtMap13 } from "@metorial/util-resource-mapper";
var mapGroupsDeleteOutput = mtMap13.object({
  id: mtMap13.objectField("id", mtMap13.passthrough()),
  status: mtMap13.objectField("status", mtMap13.passthrough()),
  type: mtMap13.objectField("type", mtMap13.passthrough()),
  name: mtMap13.objectField("name", mtMap13.passthrough()),
  policies: mtMap13.objectField(
    "policies",
    mtMap13.array(
      mtMap13.object({
        id: mtMap13.objectField("id", mtMap13.passthrough()),
        status: mtMap13.objectField("status", mtMap13.passthrough()),
        isDefault: mtMap13.objectField("is_default", mtMap13.passthrough()),
        slug: mtMap13.objectField("slug", mtMap13.passthrough()),
        name: mtMap13.objectField("name", mtMap13.passthrough()),
        description: mtMap13.objectField("description", mtMap13.passthrough()),
        entitlements: mtMap13.objectField(
          "entitlements",
          mtMap13.array(
            mtMap13.object({
              id: mtMap13.objectField("id", mtMap13.passthrough()),
              status: mtMap13.objectField("status", mtMap13.passthrough()),
              policyId: mtMap13.objectField("policy_id", mtMap13.passthrough()),
              type: mtMap13.objectField("type", mtMap13.passthrough()),
              amount: mtMap13.objectField("amount", mtMap13.passthrough()),
              windowDuration: mtMap13.objectField(
                "window_duration",
                mtMap13.object({
                  size: mtMap13.objectField("size", mtMap13.passthrough()),
                  unit: mtMap13.objectField("unit", mtMap13.passthrough())
                })
              ),
              overageBlockDuration: mtMap13.objectField(
                "overage_block_duration",
                mtMap13.object({
                  size: mtMap13.objectField("size", mtMap13.passthrough()),
                  unit: mtMap13.objectField("unit", mtMap13.passthrough())
                })
              ),
              agents: mtMap13.objectField(
                "agents",
                mtMap13.union([
                  mtMap13.unionOption(
                    "object",
                    mtMap13.object({
                      type: mtMap13.objectField("type", mtMap13.passthrough()),
                      agentIds: mtMap13.objectField(
                        "agent_ids",
                        mtMap13.array(mtMap13.passthrough())
                      )
                    })
                  )
                ])
              ),
              createdAt: mtMap13.objectField("created_at", mtMap13.date()),
              updatedAt: mtMap13.objectField("updated_at", mtMap13.date())
            })
          )
        ),
        createdAt: mtMap13.objectField("created_at", mtMap13.date()),
        updatedAt: mtMap13.objectField("updated_at", mtMap13.date())
      })
    )
  ),
  metadata: mtMap13.objectField("metadata", mtMap13.passthrough()),
  createdAt: mtMap13.objectField("created_at", mtMap13.date()),
  updatedAt: mtMap13.objectField("updated_at", mtMap13.date())
});

// src/resources/groups/get.ts
import { mtMap as mtMap14 } from "@metorial/util-resource-mapper";
var mapGroupsGetOutput = mtMap14.object({
  id: mtMap14.objectField("id", mtMap14.passthrough()),
  status: mtMap14.objectField("status", mtMap14.passthrough()),
  type: mtMap14.objectField("type", mtMap14.passthrough()),
  name: mtMap14.objectField("name", mtMap14.passthrough()),
  policies: mtMap14.objectField(
    "policies",
    mtMap14.array(
      mtMap14.object({
        id: mtMap14.objectField("id", mtMap14.passthrough()),
        status: mtMap14.objectField("status", mtMap14.passthrough()),
        isDefault: mtMap14.objectField("is_default", mtMap14.passthrough()),
        slug: mtMap14.objectField("slug", mtMap14.passthrough()),
        name: mtMap14.objectField("name", mtMap14.passthrough()),
        description: mtMap14.objectField("description", mtMap14.passthrough()),
        entitlements: mtMap14.objectField(
          "entitlements",
          mtMap14.array(
            mtMap14.object({
              id: mtMap14.objectField("id", mtMap14.passthrough()),
              status: mtMap14.objectField("status", mtMap14.passthrough()),
              policyId: mtMap14.objectField("policy_id", mtMap14.passthrough()),
              type: mtMap14.objectField("type", mtMap14.passthrough()),
              amount: mtMap14.objectField("amount", mtMap14.passthrough()),
              windowDuration: mtMap14.objectField(
                "window_duration",
                mtMap14.object({
                  size: mtMap14.objectField("size", mtMap14.passthrough()),
                  unit: mtMap14.objectField("unit", mtMap14.passthrough())
                })
              ),
              overageBlockDuration: mtMap14.objectField(
                "overage_block_duration",
                mtMap14.object({
                  size: mtMap14.objectField("size", mtMap14.passthrough()),
                  unit: mtMap14.objectField("unit", mtMap14.passthrough())
                })
              ),
              agents: mtMap14.objectField(
                "agents",
                mtMap14.union([
                  mtMap14.unionOption(
                    "object",
                    mtMap14.object({
                      type: mtMap14.objectField("type", mtMap14.passthrough()),
                      agentIds: mtMap14.objectField(
                        "agent_ids",
                        mtMap14.array(mtMap14.passthrough())
                      )
                    })
                  )
                ])
              ),
              createdAt: mtMap14.objectField("created_at", mtMap14.date()),
              updatedAt: mtMap14.objectField("updated_at", mtMap14.date())
            })
          )
        ),
        createdAt: mtMap14.objectField("created_at", mtMap14.date()),
        updatedAt: mtMap14.objectField("updated_at", mtMap14.date())
      })
    )
  ),
  metadata: mtMap14.objectField("metadata", mtMap14.passthrough()),
  createdAt: mtMap14.objectField("created_at", mtMap14.date()),
  updatedAt: mtMap14.objectField("updated_at", mtMap14.date())
});

// src/resources/groups/list.ts
import { mtMap as mtMap15 } from "@metorial/util-resource-mapper";
var mapGroupsListOutput = mtMap15.object({
  items: mtMap15.objectField(
    "items",
    mtMap15.array(
      mtMap15.object({
        id: mtMap15.objectField("id", mtMap15.passthrough()),
        status: mtMap15.objectField("status", mtMap15.passthrough()),
        type: mtMap15.objectField("type", mtMap15.passthrough()),
        name: mtMap15.objectField("name", mtMap15.passthrough()),
        policies: mtMap15.objectField(
          "policies",
          mtMap15.array(
            mtMap15.object({
              id: mtMap15.objectField("id", mtMap15.passthrough()),
              status: mtMap15.objectField("status", mtMap15.passthrough()),
              isDefault: mtMap15.objectField("is_default", mtMap15.passthrough()),
              slug: mtMap15.objectField("slug", mtMap15.passthrough()),
              name: mtMap15.objectField("name", mtMap15.passthrough()),
              description: mtMap15.objectField(
                "description",
                mtMap15.passthrough()
              ),
              entitlements: mtMap15.objectField(
                "entitlements",
                mtMap15.array(
                  mtMap15.object({
                    id: mtMap15.objectField("id", mtMap15.passthrough()),
                    status: mtMap15.objectField("status", mtMap15.passthrough()),
                    policyId: mtMap15.objectField(
                      "policy_id",
                      mtMap15.passthrough()
                    ),
                    type: mtMap15.objectField("type", mtMap15.passthrough()),
                    amount: mtMap15.objectField("amount", mtMap15.passthrough()),
                    windowDuration: mtMap15.objectField(
                      "window_duration",
                      mtMap15.object({
                        size: mtMap15.objectField("size", mtMap15.passthrough()),
                        unit: mtMap15.objectField("unit", mtMap15.passthrough())
                      })
                    ),
                    overageBlockDuration: mtMap15.objectField(
                      "overage_block_duration",
                      mtMap15.object({
                        size: mtMap15.objectField("size", mtMap15.passthrough()),
                        unit: mtMap15.objectField("unit", mtMap15.passthrough())
                      })
                    ),
                    agents: mtMap15.objectField(
                      "agents",
                      mtMap15.union([
                        mtMap15.unionOption(
                          "object",
                          mtMap15.object({
                            type: mtMap15.objectField(
                              "type",
                              mtMap15.passthrough()
                            ),
                            agentIds: mtMap15.objectField(
                              "agent_ids",
                              mtMap15.array(mtMap15.passthrough())
                            )
                          })
                        )
                      ])
                    ),
                    createdAt: mtMap15.objectField("created_at", mtMap15.date()),
                    updatedAt: mtMap15.objectField("updated_at", mtMap15.date())
                  })
                )
              ),
              createdAt: mtMap15.objectField("created_at", mtMap15.date()),
              updatedAt: mtMap15.objectField("updated_at", mtMap15.date())
            })
          )
        ),
        metadata: mtMap15.objectField("metadata", mtMap15.passthrough()),
        createdAt: mtMap15.objectField("created_at", mtMap15.date()),
        updatedAt: mtMap15.objectField("updated_at", mtMap15.date())
      })
    )
  ),
  pagination: mtMap15.objectField(
    "pagination",
    mtMap15.object({
      afterCursor: mtMap15.objectField("after_cursor", mtMap15.passthrough()),
      beforeCursor: mtMap15.objectField("before_cursor", mtMap15.passthrough()),
      hasMoreBefore: mtMap15.objectField("has_more_before", mtMap15.passthrough()),
      hasMoreAfter: mtMap15.objectField("has_more_after", mtMap15.passthrough()),
      pageSize: mtMap15.objectField("page_size", mtMap15.passthrough()),
      sort: mtMap15.objectField(
        "sort",
        mtMap15.array(
          mtMap15.object({
            field: mtMap15.objectField("field", mtMap15.passthrough()),
            order: mtMap15.objectField("order", mtMap15.passthrough())
          })
        )
      )
    })
  )
});
var mapGroupsListQuery = mtMap15.object({
  id: mtMap15.objectField(
    "id",
    mtMap15.union([
      mtMap15.unionOption(
        "object",
        mtMap15.object({
          in: mtMap15.objectField("in", mtMap15.array(mtMap15.passthrough())),
          eq: mtMap15.objectField("eq", mtMap15.passthrough())
        })
      ),
      mtMap15.unionOption("string", mtMap15.passthrough())
    ])
  ),
  ids: mtMap15.objectField(
    "ids",
    mtMap15.union([
      mtMap15.unionOption(
        "object",
        mtMap15.object({
          in: mtMap15.objectField("in", mtMap15.array(mtMap15.passthrough())),
          eq: mtMap15.objectField("eq", mtMap15.passthrough())
        })
      ),
      mtMap15.unionOption("string", mtMap15.passthrough())
    ])
  ),
  createdAt: mtMap15.objectField(
    "created_at",
    mtMap15.union([
      mtMap15.unionOption(
        "object",
        mtMap15.object({
          eq: mtMap15.objectField("eq", mtMap15.date()),
          gt: mtMap15.objectField("gt", mtMap15.date()),
          gte: mtMap15.objectField("gte", mtMap15.date()),
          lt: mtMap15.objectField("lt", mtMap15.date()),
          lte: mtMap15.objectField("lte", mtMap15.date())
        })
      ),
      mtMap15.unionOption("date", mtMap15.passthrough())
    ])
  ),
  updatedAt: mtMap15.objectField(
    "updated_at",
    mtMap15.union([
      mtMap15.unionOption(
        "object",
        mtMap15.object({
          eq: mtMap15.objectField("eq", mtMap15.date()),
          gt: mtMap15.objectField("gt", mtMap15.date()),
          gte: mtMap15.objectField("gte", mtMap15.date()),
          lt: mtMap15.objectField("lt", mtMap15.date()),
          lte: mtMap15.objectField("lte", mtMap15.date())
        })
      ),
      mtMap15.unionOption("date", mtMap15.passthrough())
    ])
  ),
  sort: mtMap15.objectField(
    "sort",
    mtMap15.union([
      mtMap15.unionOption("string", mtMap15.passthrough()),
      mtMap15.unionOption(
        "array",
        mtMap15.union([
          mtMap15.unionOption(
            "object",
            mtMap15.object({
              field: mtMap15.objectField("field", mtMap15.passthrough()),
              order: mtMap15.objectField("order", mtMap15.passthrough())
            })
          )
        ])
      )
    ])
  ),
  threadId: mtMap15.objectField("thread_id", mtMap15.passthrough()),
  userId: mtMap15.objectField("user_id", mtMap15.passthrough()),
  limit: mtMap15.objectField("limit", mtMap15.passthrough()),
  cursor: mtMap15.objectField("cursor", mtMap15.passthrough()),
  order: mtMap15.objectField("order", mtMap15.passthrough())
});

// src/resources/groups/threads/create.ts
import { mtMap as mtMap16 } from "@metorial/util-resource-mapper";
var mapGroupsThreadsCreateOutput = mtMap16.object({
  id: mtMap16.objectField("id", mtMap16.passthrough()),
  status: mtMap16.objectField("status", mtMap16.passthrough()),
  groupId: mtMap16.objectField("group_id", mtMap16.passthrough()),
  thread: mtMap16.objectField(
    "thread",
    mtMap16.object({
      id: mtMap16.objectField("id", mtMap16.passthrough()),
      name: mtMap16.objectField("name", mtMap16.passthrough()),
      agentId: mtMap16.objectField("agent_id", mtMap16.passthrough()),
      instanceId: mtMap16.objectField("instance_id", mtMap16.passthrough()),
      timezone: mtMap16.objectField(
        "timezone",
        mtMap16.object({
          code: mtMap16.objectField("code", mtMap16.passthrough()),
          utc: mtMap16.objectField("utc", mtMap16.passthrough()),
          utcOffsetInMinutes: mtMap16.objectField(
            "utc_offset_in_minutes",
            mtMap16.passthrough()
          )
        })
      ),
      country: mtMap16.objectField(
        "country",
        mtMap16.object({ code: mtMap16.objectField("code", mtMap16.passthrough()) })
      ),
      language: mtMap16.objectField(
        "language",
        mtMap16.object({
          code: mtMap16.objectField("code", mtMap16.passthrough()),
          full: mtMap16.objectField("full", mtMap16.passthrough())
        })
      ),
      metadata: mtMap16.objectField("metadata", mtMap16.passthrough()),
      createdAt: mtMap16.objectField("created_at", mtMap16.date()),
      updatedAt: mtMap16.objectField("updated_at", mtMap16.date())
    })
  )
});
var mapGroupsThreadsCreateBody = mtMap16.object({
  groupId: mtMap16.objectField("group_id", mtMap16.passthrough()),
  threadId: mtMap16.objectField("thread_id", mtMap16.passthrough())
});

// src/resources/groups/threads/delete.ts
import { mtMap as mtMap17 } from "@metorial/util-resource-mapper";
var mapGroupsThreadsDeleteOutput = mtMap17.object({
  id: mtMap17.objectField("id", mtMap17.passthrough()),
  status: mtMap17.objectField("status", mtMap17.passthrough()),
  groupId: mtMap17.objectField("group_id", mtMap17.passthrough()),
  thread: mtMap17.objectField(
    "thread",
    mtMap17.object({
      id: mtMap17.objectField("id", mtMap17.passthrough()),
      name: mtMap17.objectField("name", mtMap17.passthrough()),
      agentId: mtMap17.objectField("agent_id", mtMap17.passthrough()),
      instanceId: mtMap17.objectField("instance_id", mtMap17.passthrough()),
      timezone: mtMap17.objectField(
        "timezone",
        mtMap17.object({
          code: mtMap17.objectField("code", mtMap17.passthrough()),
          utc: mtMap17.objectField("utc", mtMap17.passthrough()),
          utcOffsetInMinutes: mtMap17.objectField(
            "utc_offset_in_minutes",
            mtMap17.passthrough()
          )
        })
      ),
      country: mtMap17.objectField(
        "country",
        mtMap17.object({ code: mtMap17.objectField("code", mtMap17.passthrough()) })
      ),
      language: mtMap17.objectField(
        "language",
        mtMap17.object({
          code: mtMap17.objectField("code", mtMap17.passthrough()),
          full: mtMap17.objectField("full", mtMap17.passthrough())
        })
      ),
      metadata: mtMap17.objectField("metadata", mtMap17.passthrough()),
      createdAt: mtMap17.objectField("created_at", mtMap17.date()),
      updatedAt: mtMap17.objectField("updated_at", mtMap17.date())
    })
  )
});

// src/resources/groups/threads/get.ts
import { mtMap as mtMap18 } from "@metorial/util-resource-mapper";
var mapGroupsThreadsGetOutput = mtMap18.object({
  id: mtMap18.objectField("id", mtMap18.passthrough()),
  status: mtMap18.objectField("status", mtMap18.passthrough()),
  groupId: mtMap18.objectField("group_id", mtMap18.passthrough()),
  thread: mtMap18.objectField(
    "thread",
    mtMap18.object({
      id: mtMap18.objectField("id", mtMap18.passthrough()),
      name: mtMap18.objectField("name", mtMap18.passthrough()),
      agentId: mtMap18.objectField("agent_id", mtMap18.passthrough()),
      instanceId: mtMap18.objectField("instance_id", mtMap18.passthrough()),
      timezone: mtMap18.objectField(
        "timezone",
        mtMap18.object({
          code: mtMap18.objectField("code", mtMap18.passthrough()),
          utc: mtMap18.objectField("utc", mtMap18.passthrough()),
          utcOffsetInMinutes: mtMap18.objectField(
            "utc_offset_in_minutes",
            mtMap18.passthrough()
          )
        })
      ),
      country: mtMap18.objectField(
        "country",
        mtMap18.object({ code: mtMap18.objectField("code", mtMap18.passthrough()) })
      ),
      language: mtMap18.objectField(
        "language",
        mtMap18.object({
          code: mtMap18.objectField("code", mtMap18.passthrough()),
          full: mtMap18.objectField("full", mtMap18.passthrough())
        })
      ),
      metadata: mtMap18.objectField("metadata", mtMap18.passthrough()),
      createdAt: mtMap18.objectField("created_at", mtMap18.date()),
      updatedAt: mtMap18.objectField("updated_at", mtMap18.date())
    })
  )
});

// src/resources/groups/threads/list.ts
import { mtMap as mtMap19 } from "@metorial/util-resource-mapper";
var mapGroupsThreadsListOutput = mtMap19.object({
  items: mtMap19.objectField(
    "items",
    mtMap19.array(
      mtMap19.object({
        id: mtMap19.objectField("id", mtMap19.passthrough()),
        status: mtMap19.objectField("status", mtMap19.passthrough()),
        groupId: mtMap19.objectField("group_id", mtMap19.passthrough()),
        thread: mtMap19.objectField(
          "thread",
          mtMap19.object({
            id: mtMap19.objectField("id", mtMap19.passthrough()),
            name: mtMap19.objectField("name", mtMap19.passthrough()),
            agentId: mtMap19.objectField("agent_id", mtMap19.passthrough()),
            instanceId: mtMap19.objectField("instance_id", mtMap19.passthrough()),
            timezone: mtMap19.objectField(
              "timezone",
              mtMap19.object({
                code: mtMap19.objectField("code", mtMap19.passthrough()),
                utc: mtMap19.objectField("utc", mtMap19.passthrough()),
                utcOffsetInMinutes: mtMap19.objectField(
                  "utc_offset_in_minutes",
                  mtMap19.passthrough()
                )
              })
            ),
            country: mtMap19.objectField(
              "country",
              mtMap19.object({
                code: mtMap19.objectField("code", mtMap19.passthrough())
              })
            ),
            language: mtMap19.objectField(
              "language",
              mtMap19.object({
                code: mtMap19.objectField("code", mtMap19.passthrough()),
                full: mtMap19.objectField("full", mtMap19.passthrough())
              })
            ),
            metadata: mtMap19.objectField("metadata", mtMap19.passthrough()),
            createdAt: mtMap19.objectField("created_at", mtMap19.date()),
            updatedAt: mtMap19.objectField("updated_at", mtMap19.date())
          })
        )
      })
    )
  ),
  pagination: mtMap19.objectField(
    "pagination",
    mtMap19.object({
      afterCursor: mtMap19.objectField("after_cursor", mtMap19.passthrough()),
      beforeCursor: mtMap19.objectField("before_cursor", mtMap19.passthrough()),
      hasMoreBefore: mtMap19.objectField("has_more_before", mtMap19.passthrough()),
      hasMoreAfter: mtMap19.objectField("has_more_after", mtMap19.passthrough()),
      pageSize: mtMap19.objectField("page_size", mtMap19.passthrough()),
      sort: mtMap19.objectField(
        "sort",
        mtMap19.array(
          mtMap19.object({
            field: mtMap19.objectField("field", mtMap19.passthrough()),
            order: mtMap19.objectField("order", mtMap19.passthrough())
          })
        )
      )
    })
  )
});
var mapGroupsThreadsListQuery = mtMap19.object({
  id: mtMap19.objectField(
    "id",
    mtMap19.union([
      mtMap19.unionOption(
        "object",
        mtMap19.object({
          in: mtMap19.objectField("in", mtMap19.array(mtMap19.passthrough())),
          eq: mtMap19.objectField("eq", mtMap19.passthrough())
        })
      ),
      mtMap19.unionOption("string", mtMap19.passthrough())
    ])
  ),
  ids: mtMap19.objectField(
    "ids",
    mtMap19.union([
      mtMap19.unionOption(
        "object",
        mtMap19.object({
          in: mtMap19.objectField("in", mtMap19.array(mtMap19.passthrough())),
          eq: mtMap19.objectField("eq", mtMap19.passthrough())
        })
      ),
      mtMap19.unionOption("string", mtMap19.passthrough())
    ])
  ),
  createdAt: mtMap19.objectField(
    "created_at",
    mtMap19.union([
      mtMap19.unionOption(
        "object",
        mtMap19.object({
          eq: mtMap19.objectField("eq", mtMap19.date()),
          gt: mtMap19.objectField("gt", mtMap19.date()),
          gte: mtMap19.objectField("gte", mtMap19.date()),
          lt: mtMap19.objectField("lt", mtMap19.date()),
          lte: mtMap19.objectField("lte", mtMap19.date())
        })
      ),
      mtMap19.unionOption("date", mtMap19.passthrough())
    ])
  ),
  sort: mtMap19.objectField(
    "sort",
    mtMap19.union([
      mtMap19.unionOption("string", mtMap19.passthrough()),
      mtMap19.unionOption(
        "array",
        mtMap19.union([
          mtMap19.unionOption(
            "object",
            mtMap19.object({
              field: mtMap19.objectField("field", mtMap19.passthrough()),
              order: mtMap19.objectField("order", mtMap19.passthrough())
            })
          )
        ])
      )
    ])
  ),
  threadId: mtMap19.objectField("thread_id", mtMap19.passthrough()),
  groupId: mtMap19.objectField("group_id", mtMap19.passthrough()),
  limit: mtMap19.objectField("limit", mtMap19.passthrough()),
  cursor: mtMap19.objectField("cursor", mtMap19.passthrough()),
  order: mtMap19.objectField("order", mtMap19.passthrough())
});

// src/resources/groups/update.ts
import { mtMap as mtMap20 } from "@metorial/util-resource-mapper";
var mapGroupsUpdateOutput = mtMap20.object({
  id: mtMap20.objectField("id", mtMap20.passthrough()),
  status: mtMap20.objectField("status", mtMap20.passthrough()),
  type: mtMap20.objectField("type", mtMap20.passthrough()),
  name: mtMap20.objectField("name", mtMap20.passthrough()),
  policies: mtMap20.objectField(
    "policies",
    mtMap20.array(
      mtMap20.object({
        id: mtMap20.objectField("id", mtMap20.passthrough()),
        status: mtMap20.objectField("status", mtMap20.passthrough()),
        isDefault: mtMap20.objectField("is_default", mtMap20.passthrough()),
        slug: mtMap20.objectField("slug", mtMap20.passthrough()),
        name: mtMap20.objectField("name", mtMap20.passthrough()),
        description: mtMap20.objectField("description", mtMap20.passthrough()),
        entitlements: mtMap20.objectField(
          "entitlements",
          mtMap20.array(
            mtMap20.object({
              id: mtMap20.objectField("id", mtMap20.passthrough()),
              status: mtMap20.objectField("status", mtMap20.passthrough()),
              policyId: mtMap20.objectField("policy_id", mtMap20.passthrough()),
              type: mtMap20.objectField("type", mtMap20.passthrough()),
              amount: mtMap20.objectField("amount", mtMap20.passthrough()),
              windowDuration: mtMap20.objectField(
                "window_duration",
                mtMap20.object({
                  size: mtMap20.objectField("size", mtMap20.passthrough()),
                  unit: mtMap20.objectField("unit", mtMap20.passthrough())
                })
              ),
              overageBlockDuration: mtMap20.objectField(
                "overage_block_duration",
                mtMap20.object({
                  size: mtMap20.objectField("size", mtMap20.passthrough()),
                  unit: mtMap20.objectField("unit", mtMap20.passthrough())
                })
              ),
              agents: mtMap20.objectField(
                "agents",
                mtMap20.union([
                  mtMap20.unionOption(
                    "object",
                    mtMap20.object({
                      type: mtMap20.objectField("type", mtMap20.passthrough()),
                      agentIds: mtMap20.objectField(
                        "agent_ids",
                        mtMap20.array(mtMap20.passthrough())
                      )
                    })
                  )
                ])
              ),
              createdAt: mtMap20.objectField("created_at", mtMap20.date()),
              updatedAt: mtMap20.objectField("updated_at", mtMap20.date())
            })
          )
        ),
        createdAt: mtMap20.objectField("created_at", mtMap20.date()),
        updatedAt: mtMap20.objectField("updated_at", mtMap20.date())
      })
    )
  ),
  metadata: mtMap20.objectField("metadata", mtMap20.passthrough()),
  createdAt: mtMap20.objectField("created_at", mtMap20.date()),
  updatedAt: mtMap20.objectField("updated_at", mtMap20.date())
});
var mapGroupsUpdateBody = mtMap20.object({
  name: mtMap20.objectField("name", mtMap20.passthrough()),
  policyIds: mtMap20.objectField("policy_ids", mtMap20.array(mtMap20.passthrough())),
  metadata: mtMap20.objectField("metadata", mtMap20.passthrough())
});

// src/resources/groups/users/create.ts
import { mtMap as mtMap21 } from "@metorial/util-resource-mapper";
var mapGroupsUsersCreateOutput = mtMap21.object({
  id: mtMap21.objectField("id", mtMap21.passthrough()),
  status: mtMap21.objectField("status", mtMap21.passthrough()),
  groupId: mtMap21.objectField("group_id", mtMap21.passthrough()),
  roles: mtMap21.objectField(
    "roles",
    mtMap21.array(
      mtMap21.object({
        id: mtMap21.objectField("id", mtMap21.passthrough()),
        status: mtMap21.objectField("status", mtMap21.passthrough()),
        isDefault: mtMap21.objectField("is_default", mtMap21.passthrough()),
        slug: mtMap21.objectField("slug", mtMap21.passthrough()),
        name: mtMap21.objectField("name", mtMap21.passthrough()),
        description: mtMap21.objectField("description", mtMap21.passthrough()),
        permissions: mtMap21.objectField(
          "permissions",
          mtMap21.array(mtMap21.passthrough())
        ),
        createdAt: mtMap21.objectField("created_at", mtMap21.date()),
        updatedAt: mtMap21.objectField("updated_at", mtMap21.date())
      })
    )
  ),
  user: mtMap21.objectField(
    "user",
    mtMap21.object({
      id: mtMap21.objectField("id", mtMap21.passthrough()),
      status: mtMap21.objectField("status", mtMap21.passthrough()),
      type: mtMap21.objectField("type", mtMap21.passthrough()),
      name: mtMap21.objectField("name", mtMap21.passthrough()),
      email: mtMap21.objectField("email", mtMap21.passthrough()),
      metadata: mtMap21.objectField("metadata", mtMap21.passthrough()),
      defaultGroupId: mtMap21.objectField(
        "default_group_id",
        mtMap21.passthrough()
      ),
      createdAt: mtMap21.objectField("created_at", mtMap21.date()),
      updatedAt: mtMap21.objectField("updated_at", mtMap21.date())
    })
  )
});
var mapGroupsUsersCreateBody = mtMap21.object({
  userId: mtMap21.objectField("user_id", mtMap21.passthrough()),
  groupId: mtMap21.objectField("group_id", mtMap21.passthrough()),
  roleIds: mtMap21.objectField("role_ids", mtMap21.array(mtMap21.passthrough()))
});

// src/resources/groups/users/delete.ts
import { mtMap as mtMap22 } from "@metorial/util-resource-mapper";
var mapGroupsUsersDeleteOutput = mtMap22.object({
  id: mtMap22.objectField("id", mtMap22.passthrough()),
  status: mtMap22.objectField("status", mtMap22.passthrough()),
  groupId: mtMap22.objectField("group_id", mtMap22.passthrough()),
  roles: mtMap22.objectField(
    "roles",
    mtMap22.array(
      mtMap22.object({
        id: mtMap22.objectField("id", mtMap22.passthrough()),
        status: mtMap22.objectField("status", mtMap22.passthrough()),
        isDefault: mtMap22.objectField("is_default", mtMap22.passthrough()),
        slug: mtMap22.objectField("slug", mtMap22.passthrough()),
        name: mtMap22.objectField("name", mtMap22.passthrough()),
        description: mtMap22.objectField("description", mtMap22.passthrough()),
        permissions: mtMap22.objectField(
          "permissions",
          mtMap22.array(mtMap22.passthrough())
        ),
        createdAt: mtMap22.objectField("created_at", mtMap22.date()),
        updatedAt: mtMap22.objectField("updated_at", mtMap22.date())
      })
    )
  ),
  user: mtMap22.objectField(
    "user",
    mtMap22.object({
      id: mtMap22.objectField("id", mtMap22.passthrough()),
      status: mtMap22.objectField("status", mtMap22.passthrough()),
      type: mtMap22.objectField("type", mtMap22.passthrough()),
      name: mtMap22.objectField("name", mtMap22.passthrough()),
      email: mtMap22.objectField("email", mtMap22.passthrough()),
      metadata: mtMap22.objectField("metadata", mtMap22.passthrough()),
      defaultGroupId: mtMap22.objectField(
        "default_group_id",
        mtMap22.passthrough()
      ),
      createdAt: mtMap22.objectField("created_at", mtMap22.date()),
      updatedAt: mtMap22.objectField("updated_at", mtMap22.date())
    })
  )
});

// src/resources/groups/users/get.ts
import { mtMap as mtMap23 } from "@metorial/util-resource-mapper";
var mapGroupsUsersGetOutput = mtMap23.object({
  id: mtMap23.objectField("id", mtMap23.passthrough()),
  status: mtMap23.objectField("status", mtMap23.passthrough()),
  groupId: mtMap23.objectField("group_id", mtMap23.passthrough()),
  roles: mtMap23.objectField(
    "roles",
    mtMap23.array(
      mtMap23.object({
        id: mtMap23.objectField("id", mtMap23.passthrough()),
        status: mtMap23.objectField("status", mtMap23.passthrough()),
        isDefault: mtMap23.objectField("is_default", mtMap23.passthrough()),
        slug: mtMap23.objectField("slug", mtMap23.passthrough()),
        name: mtMap23.objectField("name", mtMap23.passthrough()),
        description: mtMap23.objectField("description", mtMap23.passthrough()),
        permissions: mtMap23.objectField(
          "permissions",
          mtMap23.array(mtMap23.passthrough())
        ),
        createdAt: mtMap23.objectField("created_at", mtMap23.date()),
        updatedAt: mtMap23.objectField("updated_at", mtMap23.date())
      })
    )
  ),
  user: mtMap23.objectField(
    "user",
    mtMap23.object({
      id: mtMap23.objectField("id", mtMap23.passthrough()),
      status: mtMap23.objectField("status", mtMap23.passthrough()),
      type: mtMap23.objectField("type", mtMap23.passthrough()),
      name: mtMap23.objectField("name", mtMap23.passthrough()),
      email: mtMap23.objectField("email", mtMap23.passthrough()),
      metadata: mtMap23.objectField("metadata", mtMap23.passthrough()),
      defaultGroupId: mtMap23.objectField(
        "default_group_id",
        mtMap23.passthrough()
      ),
      createdAt: mtMap23.objectField("created_at", mtMap23.date()),
      updatedAt: mtMap23.objectField("updated_at", mtMap23.date())
    })
  )
});

// src/resources/groups/users/list.ts
import { mtMap as mtMap24 } from "@metorial/util-resource-mapper";
var mapGroupsUsersListOutput = mtMap24.object({
  items: mtMap24.objectField(
    "items",
    mtMap24.array(
      mtMap24.object({
        id: mtMap24.objectField("id", mtMap24.passthrough()),
        status: mtMap24.objectField("status", mtMap24.passthrough()),
        groupId: mtMap24.objectField("group_id", mtMap24.passthrough()),
        roles: mtMap24.objectField(
          "roles",
          mtMap24.array(
            mtMap24.object({
              id: mtMap24.objectField("id", mtMap24.passthrough()),
              status: mtMap24.objectField("status", mtMap24.passthrough()),
              isDefault: mtMap24.objectField("is_default", mtMap24.passthrough()),
              slug: mtMap24.objectField("slug", mtMap24.passthrough()),
              name: mtMap24.objectField("name", mtMap24.passthrough()),
              description: mtMap24.objectField(
                "description",
                mtMap24.passthrough()
              ),
              permissions: mtMap24.objectField(
                "permissions",
                mtMap24.array(mtMap24.passthrough())
              ),
              createdAt: mtMap24.objectField("created_at", mtMap24.date()),
              updatedAt: mtMap24.objectField("updated_at", mtMap24.date())
            })
          )
        ),
        user: mtMap24.objectField(
          "user",
          mtMap24.object({
            id: mtMap24.objectField("id", mtMap24.passthrough()),
            status: mtMap24.objectField("status", mtMap24.passthrough()),
            type: mtMap24.objectField("type", mtMap24.passthrough()),
            name: mtMap24.objectField("name", mtMap24.passthrough()),
            email: mtMap24.objectField("email", mtMap24.passthrough()),
            metadata: mtMap24.objectField("metadata", mtMap24.passthrough()),
            defaultGroupId: mtMap24.objectField(
              "default_group_id",
              mtMap24.passthrough()
            ),
            createdAt: mtMap24.objectField("created_at", mtMap24.date()),
            updatedAt: mtMap24.objectField("updated_at", mtMap24.date())
          })
        )
      })
    )
  ),
  pagination: mtMap24.objectField(
    "pagination",
    mtMap24.object({
      afterCursor: mtMap24.objectField("after_cursor", mtMap24.passthrough()),
      beforeCursor: mtMap24.objectField("before_cursor", mtMap24.passthrough()),
      hasMoreBefore: mtMap24.objectField("has_more_before", mtMap24.passthrough()),
      hasMoreAfter: mtMap24.objectField("has_more_after", mtMap24.passthrough()),
      pageSize: mtMap24.objectField("page_size", mtMap24.passthrough()),
      sort: mtMap24.objectField(
        "sort",
        mtMap24.array(
          mtMap24.object({
            field: mtMap24.objectField("field", mtMap24.passthrough()),
            order: mtMap24.objectField("order", mtMap24.passthrough())
          })
        )
      )
    })
  )
});
var mapGroupsUsersListQuery = mtMap24.object({
  id: mtMap24.objectField(
    "id",
    mtMap24.union([
      mtMap24.unionOption(
        "object",
        mtMap24.object({
          in: mtMap24.objectField("in", mtMap24.array(mtMap24.passthrough())),
          eq: mtMap24.objectField("eq", mtMap24.passthrough())
        })
      ),
      mtMap24.unionOption("string", mtMap24.passthrough())
    ])
  ),
  ids: mtMap24.objectField(
    "ids",
    mtMap24.union([
      mtMap24.unionOption(
        "object",
        mtMap24.object({
          in: mtMap24.objectField("in", mtMap24.array(mtMap24.passthrough())),
          eq: mtMap24.objectField("eq", mtMap24.passthrough())
        })
      ),
      mtMap24.unionOption("string", mtMap24.passthrough())
    ])
  ),
  createdAt: mtMap24.objectField(
    "created_at",
    mtMap24.union([
      mtMap24.unionOption(
        "object",
        mtMap24.object({
          eq: mtMap24.objectField("eq", mtMap24.date()),
          gt: mtMap24.objectField("gt", mtMap24.date()),
          gte: mtMap24.objectField("gte", mtMap24.date()),
          lt: mtMap24.objectField("lt", mtMap24.date()),
          lte: mtMap24.objectField("lte", mtMap24.date())
        })
      ),
      mtMap24.unionOption("date", mtMap24.passthrough())
    ])
  ),
  sort: mtMap24.objectField(
    "sort",
    mtMap24.union([
      mtMap24.unionOption("string", mtMap24.passthrough()),
      mtMap24.unionOption(
        "array",
        mtMap24.union([
          mtMap24.unionOption(
            "object",
            mtMap24.object({
              field: mtMap24.objectField("field", mtMap24.passthrough()),
              order: mtMap24.objectField("order", mtMap24.passthrough())
            })
          )
        ])
      )
    ])
  ),
  groupId: mtMap24.objectField("group_id", mtMap24.passthrough()),
  userId: mtMap24.objectField("user_id", mtMap24.passthrough()),
  limit: mtMap24.objectField("limit", mtMap24.passthrough()),
  cursor: mtMap24.objectField("cursor", mtMap24.passthrough()),
  order: mtMap24.objectField("order", mtMap24.passthrough())
});

// src/resources/groups/users/update.ts
import { mtMap as mtMap25 } from "@metorial/util-resource-mapper";
var mapGroupsUsersUpdateOutput = mtMap25.object({
  id: mtMap25.objectField("id", mtMap25.passthrough()),
  status: mtMap25.objectField("status", mtMap25.passthrough()),
  groupId: mtMap25.objectField("group_id", mtMap25.passthrough()),
  roles: mtMap25.objectField(
    "roles",
    mtMap25.array(
      mtMap25.object({
        id: mtMap25.objectField("id", mtMap25.passthrough()),
        status: mtMap25.objectField("status", mtMap25.passthrough()),
        isDefault: mtMap25.objectField("is_default", mtMap25.passthrough()),
        slug: mtMap25.objectField("slug", mtMap25.passthrough()),
        name: mtMap25.objectField("name", mtMap25.passthrough()),
        description: mtMap25.objectField("description", mtMap25.passthrough()),
        permissions: mtMap25.objectField(
          "permissions",
          mtMap25.array(mtMap25.passthrough())
        ),
        createdAt: mtMap25.objectField("created_at", mtMap25.date()),
        updatedAt: mtMap25.objectField("updated_at", mtMap25.date())
      })
    )
  ),
  user: mtMap25.objectField(
    "user",
    mtMap25.object({
      id: mtMap25.objectField("id", mtMap25.passthrough()),
      status: mtMap25.objectField("status", mtMap25.passthrough()),
      type: mtMap25.objectField("type", mtMap25.passthrough()),
      name: mtMap25.objectField("name", mtMap25.passthrough()),
      email: mtMap25.objectField("email", mtMap25.passthrough()),
      metadata: mtMap25.objectField("metadata", mtMap25.passthrough()),
      defaultGroupId: mtMap25.objectField(
        "default_group_id",
        mtMap25.passthrough()
      ),
      createdAt: mtMap25.objectField("created_at", mtMap25.date()),
      updatedAt: mtMap25.objectField("updated_at", mtMap25.date())
    })
  )
});
var mapGroupsUsersUpdateBody = mtMap25.object({
  roleIds: mtMap25.objectField("role_ids", mtMap25.array(mtMap25.passthrough()))
});

// src/resources/instance/get.ts
import { mtMap as mtMap26 } from "@metorial/util-resource-mapper";
var mapInstanceGetOutput = mtMap26.object({
  id: mtMap26.objectField("id", mtMap26.passthrough()),
  environment: mtMap26.objectField(
    "environment",
    mtMap26.object({
      id: mtMap26.objectField("id", mtMap26.passthrough()),
      type: mtMap26.objectField("type", mtMap26.passthrough()),
      name: mtMap26.objectField("name", mtMap26.passthrough()),
      createdAt: mtMap26.objectField("created_at", mtMap26.date()),
      updatedAt: mtMap26.objectField("updated_at", mtMap26.date())
    })
  ),
  project: mtMap26.objectField(
    "project",
    mtMap26.object({
      id: mtMap26.objectField("id", mtMap26.passthrough()),
      slug: mtMap26.objectField("slug", mtMap26.passthrough()),
      name: mtMap26.objectField("name", mtMap26.passthrough()),
      organizationId: mtMap26.objectField("organization_id", mtMap26.passthrough()),
      createdAt: mtMap26.objectField("created_at", mtMap26.date()),
      updatedAt: mtMap26.objectField("updated_at", mtMap26.date())
    })
  ),
  slug: mtMap26.objectField("slug", mtMap26.passthrough()),
  name: mtMap26.objectField("name", mtMap26.passthrough()),
  projectId: mtMap26.objectField("project_id", mtMap26.passthrough()),
  organizationId: mtMap26.objectField("organization_id", mtMap26.passthrough()),
  createdAt: mtMap26.objectField("created_at", mtMap26.date()),
  updatedAt: mtMap26.objectField("updated_at", mtMap26.date())
});

// src/resources/management/instances/actors/get.ts
import { mtMap as mtMap27 } from "@metorial/util-resource-mapper";
var mapManagementInstancesActorsGetOutput = mtMap27.object({
  id: mtMap27.objectField("id", mtMap27.passthrough()),
  name: mtMap27.objectField("name", mtMap27.passthrough()),
  type: mtMap27.objectField("type", mtMap27.passthrough()),
  metadata: mtMap27.objectField("metadata", mtMap27.passthrough()),
  createdAt: mtMap27.objectField("created_at", mtMap27.date()),
  updatedAt: mtMap27.objectField("updated_at", mtMap27.date())
});

// src/resources/management/instances/actors/list.ts
import { mtMap as mtMap28 } from "@metorial/util-resource-mapper";
var mapManagementInstancesActorsListOutput = mtMap28.object({
  items: mtMap28.objectField(
    "items",
    mtMap28.array(
      mtMap28.object({
        id: mtMap28.objectField("id", mtMap28.passthrough()),
        name: mtMap28.objectField("name", mtMap28.passthrough()),
        type: mtMap28.objectField("type", mtMap28.passthrough()),
        metadata: mtMap28.objectField("metadata", mtMap28.passthrough()),
        createdAt: mtMap28.objectField("created_at", mtMap28.date()),
        updatedAt: mtMap28.objectField("updated_at", mtMap28.date())
      })
    )
  ),
  pagination: mtMap28.objectField(
    "pagination",
    mtMap28.object({
      afterCursor: mtMap28.objectField("after_cursor", mtMap28.passthrough()),
      beforeCursor: mtMap28.objectField("before_cursor", mtMap28.passthrough()),
      hasMoreBefore: mtMap28.objectField(
        "has_more_before",
        mtMap28.passthrough()
      ),
      hasMoreAfter: mtMap28.objectField("has_more_after", mtMap28.passthrough()),
      pageSize: mtMap28.objectField("page_size", mtMap28.passthrough()),
      sort: mtMap28.objectField(
        "sort",
        mtMap28.array(
          mtMap28.object({
            field: mtMap28.objectField("field", mtMap28.passthrough()),
            order: mtMap28.objectField("order", mtMap28.passthrough())
          })
        )
      )
    })
  )
});
var mapManagementInstancesActorsListQuery = mtMap28.object({
  id: mtMap28.objectField(
    "id",
    mtMap28.union([
      mtMap28.unionOption(
        "object",
        mtMap28.object({
          in: mtMap28.objectField("in", mtMap28.array(mtMap28.passthrough())),
          eq: mtMap28.objectField("eq", mtMap28.passthrough())
        })
      ),
      mtMap28.unionOption("string", mtMap28.passthrough())
    ])
  ),
  ids: mtMap28.objectField(
    "ids",
    mtMap28.union([
      mtMap28.unionOption(
        "object",
        mtMap28.object({
          in: mtMap28.objectField("in", mtMap28.array(mtMap28.passthrough())),
          eq: mtMap28.objectField("eq", mtMap28.passthrough())
        })
      ),
      mtMap28.unionOption("string", mtMap28.passthrough())
    ])
  ),
  createdAt: mtMap28.objectField(
    "created_at",
    mtMap28.union([
      mtMap28.unionOption(
        "object",
        mtMap28.object({
          eq: mtMap28.objectField("eq", mtMap28.date()),
          gt: mtMap28.objectField("gt", mtMap28.date()),
          gte: mtMap28.objectField("gte", mtMap28.date()),
          lt: mtMap28.objectField("lt", mtMap28.date()),
          lte: mtMap28.objectField("lte", mtMap28.date())
        })
      ),
      mtMap28.unionOption("date", mtMap28.passthrough())
    ])
  ),
  updatedAt: mtMap28.objectField(
    "updated_at",
    mtMap28.union([
      mtMap28.unionOption(
        "object",
        mtMap28.object({
          eq: mtMap28.objectField("eq", mtMap28.date()),
          gt: mtMap28.objectField("gt", mtMap28.date()),
          gte: mtMap28.objectField("gte", mtMap28.date()),
          lt: mtMap28.objectField("lt", mtMap28.date()),
          lte: mtMap28.objectField("lte", mtMap28.date())
        })
      ),
      mtMap28.unionOption("date", mtMap28.passthrough())
    ])
  ),
  type: mtMap28.objectField(
    "type",
    mtMap28.union([
      mtMap28.unionOption(
        "object",
        mtMap28.object({
          in: mtMap28.objectField("in", mtMap28.array(mtMap28.passthrough())),
          eq: mtMap28.objectField("eq", mtMap28.passthrough())
        })
      ),
      mtMap28.unionOption("string", mtMap28.passthrough())
    ])
  ),
  types: mtMap28.objectField(
    "types",
    mtMap28.union([
      mtMap28.unionOption(
        "object",
        mtMap28.object({
          in: mtMap28.objectField("in", mtMap28.array(mtMap28.passthrough())),
          eq: mtMap28.objectField("eq", mtMap28.passthrough())
        })
      ),
      mtMap28.unionOption("string", mtMap28.passthrough())
    ])
  ),
  sort: mtMap28.objectField(
    "sort",
    mtMap28.union([
      mtMap28.unionOption("string", mtMap28.passthrough()),
      mtMap28.unionOption(
        "array",
        mtMap28.union([
          mtMap28.unionOption(
            "object",
            mtMap28.object({
              field: mtMap28.objectField("field", mtMap28.passthrough()),
              order: mtMap28.objectField("order", mtMap28.passthrough())
            })
          )
        ])
      )
    ])
  ),
  threadId: mtMap28.objectField("thread_id", mtMap28.passthrough()),
  limit: mtMap28.objectField("limit", mtMap28.passthrough()),
  cursor: mtMap28.objectField("cursor", mtMap28.passthrough()),
  order: mtMap28.objectField("order", mtMap28.passthrough())
});

// src/resources/management/instances/agents/get.ts
import { mtMap as mtMap29 } from "@metorial/util-resource-mapper";
var mapManagementInstancesAgentsGetOutput = mtMap29.object({
  id: mtMap29.objectField("id", mtMap29.passthrough()),
  slug: mtMap29.objectField("slug", mtMap29.passthrough()),
  name: mtMap29.objectField("name", mtMap29.passthrough()),
  status: mtMap29.objectField("status", mtMap29.passthrough()),
  instanceId: mtMap29.objectField("instance_id", mtMap29.passthrough()),
  agentId: mtMap29.objectField("agent_id", mtMap29.passthrough()),
  createdAt: mtMap29.objectField("created_at", mtMap29.date()),
  updatedAt: mtMap29.objectField("updated_at", mtMap29.date()),
  currentRelease: mtMap29.objectField(
    "current_release",
    mtMap29.object({
      id: mtMap29.objectField("id", mtMap29.passthrough()),
      agentId: mtMap29.objectField("agent_id", mtMap29.passthrough()),
      version: mtMap29.objectField("version", mtMap29.passthrough()),
      createdAt: mtMap29.objectField("created_at", mtMap29.date())
    })
  )
});

// src/resources/management/instances/agents/list.ts
import { mtMap as mtMap30 } from "@metorial/util-resource-mapper";
var mapManagementInstancesAgentsListOutput = mtMap30.object({
  items: mtMap30.objectField(
    "items",
    mtMap30.array(
      mtMap30.object({
        id: mtMap30.objectField("id", mtMap30.passthrough()),
        slug: mtMap30.objectField("slug", mtMap30.passthrough()),
        name: mtMap30.objectField("name", mtMap30.passthrough()),
        status: mtMap30.objectField("status", mtMap30.passthrough()),
        instanceId: mtMap30.objectField("instance_id", mtMap30.passthrough()),
        agentId: mtMap30.objectField("agent_id", mtMap30.passthrough()),
        createdAt: mtMap30.objectField("created_at", mtMap30.date()),
        updatedAt: mtMap30.objectField("updated_at", mtMap30.date()),
        currentRelease: mtMap30.objectField(
          "current_release",
          mtMap30.object({
            id: mtMap30.objectField("id", mtMap30.passthrough()),
            agentId: mtMap30.objectField("agent_id", mtMap30.passthrough()),
            version: mtMap30.objectField("version", mtMap30.passthrough()),
            createdAt: mtMap30.objectField("created_at", mtMap30.date())
          })
        )
      })
    )
  ),
  pagination: mtMap30.objectField(
    "pagination",
    mtMap30.object({
      afterCursor: mtMap30.objectField("after_cursor", mtMap30.passthrough()),
      beforeCursor: mtMap30.objectField("before_cursor", mtMap30.passthrough()),
      hasMoreBefore: mtMap30.objectField(
        "has_more_before",
        mtMap30.passthrough()
      ),
      hasMoreAfter: mtMap30.objectField("has_more_after", mtMap30.passthrough()),
      pageSize: mtMap30.objectField("page_size", mtMap30.passthrough()),
      sort: mtMap30.objectField(
        "sort",
        mtMap30.array(
          mtMap30.object({
            field: mtMap30.objectField("field", mtMap30.passthrough()),
            order: mtMap30.objectField("order", mtMap30.passthrough())
          })
        )
      )
    })
  )
});
var mapManagementInstancesAgentsListQuery = mtMap30.object({
  createdAt: mtMap30.objectField(
    "created_at",
    mtMap30.union([
      mtMap30.unionOption(
        "object",
        mtMap30.object({
          eq: mtMap30.objectField("eq", mtMap30.date()),
          gt: mtMap30.objectField("gt", mtMap30.date()),
          gte: mtMap30.objectField("gte", mtMap30.date()),
          lt: mtMap30.objectField("lt", mtMap30.date()),
          lte: mtMap30.objectField("lte", mtMap30.date())
        })
      ),
      mtMap30.unionOption("date", mtMap30.passthrough())
    ])
  ),
  id: mtMap30.objectField(
    "id",
    mtMap30.union([
      mtMap30.unionOption(
        "object",
        mtMap30.object({
          in: mtMap30.objectField("in", mtMap30.array(mtMap30.passthrough())),
          eq: mtMap30.objectField("eq", mtMap30.passthrough())
        })
      ),
      mtMap30.unionOption("string", mtMap30.passthrough())
    ])
  ),
  ids: mtMap30.objectField(
    "ids",
    mtMap30.union([
      mtMap30.unionOption(
        "object",
        mtMap30.object({
          in: mtMap30.objectField("in", mtMap30.array(mtMap30.passthrough())),
          eq: mtMap30.objectField("eq", mtMap30.passthrough())
        })
      ),
      mtMap30.unionOption("string", mtMap30.passthrough())
    ])
  ),
  sort: mtMap30.objectField(
    "sort",
    mtMap30.union([
      mtMap30.unionOption("string", mtMap30.passthrough()),
      mtMap30.unionOption(
        "array",
        mtMap30.union([
          mtMap30.unionOption(
            "object",
            mtMap30.object({
              field: mtMap30.objectField("field", mtMap30.passthrough()),
              order: mtMap30.objectField("order", mtMap30.passthrough())
            })
          )
        ])
      )
    ])
  ),
  limit: mtMap30.objectField("limit", mtMap30.passthrough()),
  cursor: mtMap30.objectField("cursor", mtMap30.passthrough()),
  order: mtMap30.objectField("order", mtMap30.passthrough())
});

// src/resources/management/instances/client-tokens/jwks/list.ts
import { mtMap as mtMap31 } from "@metorial/util-resource-mapper";
var mapManagementInstancesClientTokensJwksListOutput = mtMap31.object({
  items: mtMap31.objectField(
    "items",
    mtMap31.array(
      mtMap31.object({
        kid: mtMap31.objectField("kid", mtMap31.passthrough()),
        kty: mtMap31.objectField("kty", mtMap31.passthrough()),
        alg: mtMap31.objectField("alg", mtMap31.passthrough()),
        use: mtMap31.objectField("use", mtMap31.passthrough()),
        iat: mtMap31.objectField("iat", mtMap31.passthrough()),
        exp: mtMap31.objectField("exp", mtMap31.passthrough())
      })
    )
  ),
  pagination: mtMap31.objectField(
    "pagination",
    mtMap31.object({
      afterCursor: mtMap31.objectField("after_cursor", mtMap31.passthrough()),
      beforeCursor: mtMap31.objectField("before_cursor", mtMap31.passthrough()),
      hasMoreBefore: mtMap31.objectField(
        "has_more_before",
        mtMap31.passthrough()
      ),
      hasMoreAfter: mtMap31.objectField("has_more_after", mtMap31.passthrough()),
      pageSize: mtMap31.objectField("page_size", mtMap31.passthrough()),
      sort: mtMap31.objectField(
        "sort",
        mtMap31.array(
          mtMap31.object({
            field: mtMap31.objectField("field", mtMap31.passthrough()),
            order: mtMap31.objectField("order", mtMap31.passthrough())
          })
        )
      )
    })
  )
});

// src/resources/management/instances/files/get.ts
import { mtMap as mtMap32 } from "@metorial/util-resource-mapper";
var mapManagementInstancesFilesGetOutput = mtMap32.object({
  id: mtMap32.objectField("id", mtMap32.passthrough()),
  purpose: mtMap32.objectField("purpose", mtMap32.passthrough()),
  name: mtMap32.objectField("name", mtMap32.passthrough()),
  size: mtMap32.objectField("size", mtMap32.passthrough()),
  mimeType: mtMap32.objectField("mime_type", mtMap32.passthrough()),
  createdAt: mtMap32.objectField("created_at", mtMap32.date())
});

// src/resources/management/instances/files/links/create.ts
import { mtMap as mtMap33 } from "@metorial/util-resource-mapper";
var mapManagementInstancesFilesLinksCreateOutput = mtMap33.object({
  id: mtMap33.objectField("id", mtMap33.passthrough()),
  purpose: mtMap33.objectField("purpose", mtMap33.passthrough()),
  name: mtMap33.objectField("name", mtMap33.passthrough()),
  size: mtMap33.objectField("size", mtMap33.passthrough()),
  mimeType: mtMap33.objectField("mime_type", mtMap33.passthrough()),
  createdAt: mtMap33.objectField("created_at", mtMap33.date())
});

// src/resources/management/instances/files/list.ts
import { mtMap as mtMap34 } from "@metorial/util-resource-mapper";
var mapManagementInstancesFilesListOutput = mtMap34.object({
  items: mtMap34.objectField(
    "items",
    mtMap34.array(
      mtMap34.object({
        id: mtMap34.objectField("id", mtMap34.passthrough()),
        purpose: mtMap34.objectField("purpose", mtMap34.passthrough()),
        name: mtMap34.objectField("name", mtMap34.passthrough()),
        size: mtMap34.objectField("size", mtMap34.passthrough()),
        mimeType: mtMap34.objectField("mime_type", mtMap34.passthrough()),
        createdAt: mtMap34.objectField("created_at", mtMap34.date())
      })
    )
  ),
  pagination: mtMap34.objectField(
    "pagination",
    mtMap34.object({
      afterCursor: mtMap34.objectField("after_cursor", mtMap34.passthrough()),
      beforeCursor: mtMap34.objectField("before_cursor", mtMap34.passthrough()),
      hasMoreBefore: mtMap34.objectField(
        "has_more_before",
        mtMap34.passthrough()
      ),
      hasMoreAfter: mtMap34.objectField("has_more_after", mtMap34.passthrough()),
      pageSize: mtMap34.objectField("page_size", mtMap34.passthrough()),
      sort: mtMap34.objectField(
        "sort",
        mtMap34.array(
          mtMap34.object({
            field: mtMap34.objectField("field", mtMap34.passthrough()),
            order: mtMap34.objectField("order", mtMap34.passthrough())
          })
        )
      )
    })
  )
});
var mapManagementInstancesFilesListQuery = mtMap34.object({
  id: mtMap34.objectField(
    "id",
    mtMap34.union([
      mtMap34.unionOption(
        "object",
        mtMap34.object({
          in: mtMap34.objectField("in", mtMap34.array(mtMap34.passthrough())),
          eq: mtMap34.objectField("eq", mtMap34.passthrough())
        })
      ),
      mtMap34.unionOption("string", mtMap34.passthrough())
    ])
  ),
  ids: mtMap34.objectField(
    "ids",
    mtMap34.union([
      mtMap34.unionOption(
        "object",
        mtMap34.object({
          in: mtMap34.objectField("in", mtMap34.array(mtMap34.passthrough())),
          eq: mtMap34.objectField("eq", mtMap34.passthrough())
        })
      ),
      mtMap34.unionOption("string", mtMap34.passthrough())
    ])
  ),
  createdAt: mtMap34.objectField(
    "created_at",
    mtMap34.union([
      mtMap34.unionOption(
        "object",
        mtMap34.object({
          eq: mtMap34.objectField("eq", mtMap34.date()),
          gt: mtMap34.objectField("gt", mtMap34.date()),
          gte: mtMap34.objectField("gte", mtMap34.date()),
          lt: mtMap34.objectField("lt", mtMap34.date()),
          lte: mtMap34.objectField("lte", mtMap34.date())
        })
      ),
      mtMap34.unionOption("date", mtMap34.passthrough())
    ])
  ),
  purpose: mtMap34.objectField(
    "purpose",
    mtMap34.union([
      mtMap34.unionOption(
        "object",
        mtMap34.object({
          in: mtMap34.objectField("in", mtMap34.array(mtMap34.passthrough())),
          eq: mtMap34.objectField("eq", mtMap34.passthrough())
        })
      ),
      mtMap34.unionOption("string", mtMap34.passthrough())
    ])
  ),
  sort: mtMap34.objectField(
    "sort",
    mtMap34.union([
      mtMap34.unionOption("string", mtMap34.passthrough()),
      mtMap34.unionOption(
        "array",
        mtMap34.union([
          mtMap34.unionOption(
            "object",
            mtMap34.object({
              field: mtMap34.objectField("field", mtMap34.passthrough()),
              order: mtMap34.objectField("order", mtMap34.passthrough())
            })
          )
        ])
      )
    ])
  ),
  threadId: mtMap34.objectField("thread_id", mtMap34.passthrough()),
  limit: mtMap34.objectField("limit", mtMap34.passthrough()),
  cursor: mtMap34.objectField("cursor", mtMap34.passthrough()),
  order: mtMap34.objectField("order", mtMap34.passthrough())
});

// src/resources/management/instances/groups/blocks/delete.ts
import { mtMap as mtMap35 } from "@metorial/util-resource-mapper";
var mapManagementInstancesGroupsBlocksDeleteOutput = mtMap35.object({
  id: mtMap35.objectField("id", mtMap35.passthrough()),
  status: mtMap35.objectField("status", mtMap35.passthrough()),
  expiresAt: mtMap35.objectField("expires_at", mtMap35.date()),
  policy: mtMap35.objectField(
    "policy",
    mtMap35.object({
      id: mtMap35.objectField("id", mtMap35.passthrough()),
      status: mtMap35.objectField("status", mtMap35.passthrough()),
      isDefault: mtMap35.objectField("is_default", mtMap35.passthrough()),
      slug: mtMap35.objectField("slug", mtMap35.passthrough()),
      name: mtMap35.objectField("name", mtMap35.passthrough()),
      description: mtMap35.objectField("description", mtMap35.passthrough()),
      entitlements: mtMap35.objectField(
        "entitlements",
        mtMap35.array(
          mtMap35.object({
            id: mtMap35.objectField("id", mtMap35.passthrough()),
            status: mtMap35.objectField("status", mtMap35.passthrough()),
            policyId: mtMap35.objectField("policy_id", mtMap35.passthrough()),
            type: mtMap35.objectField("type", mtMap35.passthrough()),
            amount: mtMap35.objectField("amount", mtMap35.passthrough()),
            windowDuration: mtMap35.objectField(
              "window_duration",
              mtMap35.object({
                size: mtMap35.objectField("size", mtMap35.passthrough()),
                unit: mtMap35.objectField("unit", mtMap35.passthrough())
              })
            ),
            overageBlockDuration: mtMap35.objectField(
              "overage_block_duration",
              mtMap35.object({
                size: mtMap35.objectField("size", mtMap35.passthrough()),
                unit: mtMap35.objectField("unit", mtMap35.passthrough())
              })
            ),
            agents: mtMap35.objectField(
              "agents",
              mtMap35.union([
                mtMap35.unionOption(
                  "object",
                  mtMap35.object({
                    type: mtMap35.objectField("type", mtMap35.passthrough()),
                    agentIds: mtMap35.objectField(
                      "agent_ids",
                      mtMap35.array(mtMap35.passthrough())
                    )
                  })
                )
              ])
            ),
            createdAt: mtMap35.objectField("created_at", mtMap35.date()),
            updatedAt: mtMap35.objectField("updated_at", mtMap35.date())
          })
        )
      ),
      createdAt: mtMap35.objectField("created_at", mtMap35.date()),
      updatedAt: mtMap35.objectField("updated_at", mtMap35.date())
    })
  ),
  reason: mtMap35.objectField(
    "reason",
    mtMap35.object({
      type: mtMap35.objectField("type", mtMap35.passthrough()),
      entitlementIds: mtMap35.objectField(
        "entitlement_ids",
        mtMap35.array(mtMap35.passthrough())
      )
    })
  ),
  groupId: mtMap35.objectField("group_id", mtMap35.passthrough())
});

// src/resources/management/instances/groups/blocks/get.ts
import { mtMap as mtMap36 } from "@metorial/util-resource-mapper";
var mapManagementInstancesGroupsBlocksGetOutput = mtMap36.object({
  id: mtMap36.objectField("id", mtMap36.passthrough()),
  status: mtMap36.objectField("status", mtMap36.passthrough()),
  expiresAt: mtMap36.objectField("expires_at", mtMap36.date()),
  policy: mtMap36.objectField(
    "policy",
    mtMap36.object({
      id: mtMap36.objectField("id", mtMap36.passthrough()),
      status: mtMap36.objectField("status", mtMap36.passthrough()),
      isDefault: mtMap36.objectField("is_default", mtMap36.passthrough()),
      slug: mtMap36.objectField("slug", mtMap36.passthrough()),
      name: mtMap36.objectField("name", mtMap36.passthrough()),
      description: mtMap36.objectField("description", mtMap36.passthrough()),
      entitlements: mtMap36.objectField(
        "entitlements",
        mtMap36.array(
          mtMap36.object({
            id: mtMap36.objectField("id", mtMap36.passthrough()),
            status: mtMap36.objectField("status", mtMap36.passthrough()),
            policyId: mtMap36.objectField("policy_id", mtMap36.passthrough()),
            type: mtMap36.objectField("type", mtMap36.passthrough()),
            amount: mtMap36.objectField("amount", mtMap36.passthrough()),
            windowDuration: mtMap36.objectField(
              "window_duration",
              mtMap36.object({
                size: mtMap36.objectField("size", mtMap36.passthrough()),
                unit: mtMap36.objectField("unit", mtMap36.passthrough())
              })
            ),
            overageBlockDuration: mtMap36.objectField(
              "overage_block_duration",
              mtMap36.object({
                size: mtMap36.objectField("size", mtMap36.passthrough()),
                unit: mtMap36.objectField("unit", mtMap36.passthrough())
              })
            ),
            agents: mtMap36.objectField(
              "agents",
              mtMap36.union([
                mtMap36.unionOption(
                  "object",
                  mtMap36.object({
                    type: mtMap36.objectField("type", mtMap36.passthrough()),
                    agentIds: mtMap36.objectField(
                      "agent_ids",
                      mtMap36.array(mtMap36.passthrough())
                    )
                  })
                )
              ])
            ),
            createdAt: mtMap36.objectField("created_at", mtMap36.date()),
            updatedAt: mtMap36.objectField("updated_at", mtMap36.date())
          })
        )
      ),
      createdAt: mtMap36.objectField("created_at", mtMap36.date()),
      updatedAt: mtMap36.objectField("updated_at", mtMap36.date())
    })
  ),
  reason: mtMap36.objectField(
    "reason",
    mtMap36.object({
      type: mtMap36.objectField("type", mtMap36.passthrough()),
      entitlementIds: mtMap36.objectField(
        "entitlement_ids",
        mtMap36.array(mtMap36.passthrough())
      )
    })
  ),
  groupId: mtMap36.objectField("group_id", mtMap36.passthrough())
});

// src/resources/management/instances/groups/blocks/list.ts
import { mtMap as mtMap37 } from "@metorial/util-resource-mapper";
var mapManagementInstancesGroupsBlocksListOutput = mtMap37.object({
  items: mtMap37.objectField(
    "items",
    mtMap37.array(
      mtMap37.object({
        id: mtMap37.objectField("id", mtMap37.passthrough()),
        status: mtMap37.objectField("status", mtMap37.passthrough()),
        expiresAt: mtMap37.objectField("expires_at", mtMap37.date()),
        policy: mtMap37.objectField(
          "policy",
          mtMap37.object({
            id: mtMap37.objectField("id", mtMap37.passthrough()),
            status: mtMap37.objectField("status", mtMap37.passthrough()),
            isDefault: mtMap37.objectField("is_default", mtMap37.passthrough()),
            slug: mtMap37.objectField("slug", mtMap37.passthrough()),
            name: mtMap37.objectField("name", mtMap37.passthrough()),
            description: mtMap37.objectField(
              "description",
              mtMap37.passthrough()
            ),
            entitlements: mtMap37.objectField(
              "entitlements",
              mtMap37.array(
                mtMap37.object({
                  id: mtMap37.objectField("id", mtMap37.passthrough()),
                  status: mtMap37.objectField("status", mtMap37.passthrough()),
                  policyId: mtMap37.objectField(
                    "policy_id",
                    mtMap37.passthrough()
                  ),
                  type: mtMap37.objectField("type", mtMap37.passthrough()),
                  amount: mtMap37.objectField("amount", mtMap37.passthrough()),
                  windowDuration: mtMap37.objectField(
                    "window_duration",
                    mtMap37.object({
                      size: mtMap37.objectField("size", mtMap37.passthrough()),
                      unit: mtMap37.objectField("unit", mtMap37.passthrough())
                    })
                  ),
                  overageBlockDuration: mtMap37.objectField(
                    "overage_block_duration",
                    mtMap37.object({
                      size: mtMap37.objectField("size", mtMap37.passthrough()),
                      unit: mtMap37.objectField("unit", mtMap37.passthrough())
                    })
                  ),
                  agents: mtMap37.objectField(
                    "agents",
                    mtMap37.union([
                      mtMap37.unionOption(
                        "object",
                        mtMap37.object({
                          type: mtMap37.objectField(
                            "type",
                            mtMap37.passthrough()
                          ),
                          agentIds: mtMap37.objectField(
                            "agent_ids",
                            mtMap37.array(mtMap37.passthrough())
                          )
                        })
                      )
                    ])
                  ),
                  createdAt: mtMap37.objectField("created_at", mtMap37.date()),
                  updatedAt: mtMap37.objectField("updated_at", mtMap37.date())
                })
              )
            ),
            createdAt: mtMap37.objectField("created_at", mtMap37.date()),
            updatedAt: mtMap37.objectField("updated_at", mtMap37.date())
          })
        ),
        reason: mtMap37.objectField(
          "reason",
          mtMap37.object({
            type: mtMap37.objectField("type", mtMap37.passthrough()),
            entitlementIds: mtMap37.objectField(
              "entitlement_ids",
              mtMap37.array(mtMap37.passthrough())
            )
          })
        ),
        groupId: mtMap37.objectField("group_id", mtMap37.passthrough())
      })
    )
  ),
  pagination: mtMap37.objectField(
    "pagination",
    mtMap37.object({
      afterCursor: mtMap37.objectField("after_cursor", mtMap37.passthrough()),
      beforeCursor: mtMap37.objectField("before_cursor", mtMap37.passthrough()),
      hasMoreBefore: mtMap37.objectField(
        "has_more_before",
        mtMap37.passthrough()
      ),
      hasMoreAfter: mtMap37.objectField("has_more_after", mtMap37.passthrough()),
      pageSize: mtMap37.objectField("page_size", mtMap37.passthrough()),
      sort: mtMap37.objectField(
        "sort",
        mtMap37.array(
          mtMap37.object({
            field: mtMap37.objectField("field", mtMap37.passthrough()),
            order: mtMap37.objectField("order", mtMap37.passthrough())
          })
        )
      )
    })
  )
});
var mapManagementInstancesGroupsBlocksListQuery = mtMap37.object({
  id: mtMap37.objectField(
    "id",
    mtMap37.union([
      mtMap37.unionOption(
        "object",
        mtMap37.object({
          in: mtMap37.objectField("in", mtMap37.array(mtMap37.passthrough())),
          eq: mtMap37.objectField("eq", mtMap37.passthrough())
        })
      ),
      mtMap37.unionOption("string", mtMap37.passthrough())
    ])
  ),
  ids: mtMap37.objectField(
    "ids",
    mtMap37.union([
      mtMap37.unionOption(
        "object",
        mtMap37.object({
          in: mtMap37.objectField("in", mtMap37.array(mtMap37.passthrough())),
          eq: mtMap37.objectField("eq", mtMap37.passthrough())
        })
      ),
      mtMap37.unionOption("string", mtMap37.passthrough())
    ])
  ),
  createdAt: mtMap37.objectField(
    "created_at",
    mtMap37.union([
      mtMap37.unionOption(
        "object",
        mtMap37.object({
          eq: mtMap37.objectField("eq", mtMap37.date()),
          gt: mtMap37.objectField("gt", mtMap37.date()),
          gte: mtMap37.objectField("gte", mtMap37.date()),
          lt: mtMap37.objectField("lt", mtMap37.date()),
          lte: mtMap37.objectField("lte", mtMap37.date())
        })
      ),
      mtMap37.unionOption("date", mtMap37.passthrough())
    ])
  ),
  until: mtMap37.objectField(
    "until",
    mtMap37.union([
      mtMap37.unionOption(
        "object",
        mtMap37.object({
          eq: mtMap37.objectField("eq", mtMap37.date()),
          gt: mtMap37.objectField("gt", mtMap37.date()),
          gte: mtMap37.objectField("gte", mtMap37.date()),
          lt: mtMap37.objectField("lt", mtMap37.date()),
          lte: mtMap37.objectField("lte", mtMap37.date())
        })
      ),
      mtMap37.unionOption("date", mtMap37.passthrough())
    ])
  ),
  expiresAt: mtMap37.objectField(
    "expires_at",
    mtMap37.union([
      mtMap37.unionOption(
        "object",
        mtMap37.object({
          eq: mtMap37.objectField("eq", mtMap37.date()),
          gt: mtMap37.objectField("gt", mtMap37.date()),
          gte: mtMap37.objectField("gte", mtMap37.date()),
          lt: mtMap37.objectField("lt", mtMap37.date()),
          lte: mtMap37.objectField("lte", mtMap37.date())
        })
      ),
      mtMap37.unionOption("date", mtMap37.passthrough())
    ])
  ),
  status: mtMap37.objectField(
    "status",
    mtMap37.union([
      mtMap37.unionOption(
        "object",
        mtMap37.object({
          in: mtMap37.objectField("in", mtMap37.array(mtMap37.passthrough())),
          eq: mtMap37.objectField("eq", mtMap37.passthrough())
        })
      ),
      mtMap37.unionOption("string", mtMap37.passthrough())
    ])
  ),
  sort: mtMap37.objectField(
    "sort",
    mtMap37.union([
      mtMap37.unionOption("string", mtMap37.passthrough()),
      mtMap37.unionOption(
        "array",
        mtMap37.union([
          mtMap37.unionOption(
            "object",
            mtMap37.object({
              field: mtMap37.objectField("field", mtMap37.passthrough()),
              order: mtMap37.objectField("order", mtMap37.passthrough())
            })
          )
        ])
      )
    ])
  ),
  groupId: mtMap37.objectField("group_id", mtMap37.passthrough()),
  policyId: mtMap37.objectField("policy_id", mtMap37.passthrough()),
  limit: mtMap37.objectField("limit", mtMap37.passthrough()),
  cursor: mtMap37.objectField("cursor", mtMap37.passthrough()),
  order: mtMap37.objectField("order", mtMap37.passthrough())
});

// src/resources/management/instances/groups/create.ts
import { mtMap as mtMap38 } from "@metorial/util-resource-mapper";
var mapManagementInstancesGroupsCreateOutput = mtMap38.object({
  id: mtMap38.objectField("id", mtMap38.passthrough()),
  status: mtMap38.objectField("status", mtMap38.passthrough()),
  type: mtMap38.objectField("type", mtMap38.passthrough()),
  name: mtMap38.objectField("name", mtMap38.passthrough()),
  policies: mtMap38.objectField(
    "policies",
    mtMap38.array(
      mtMap38.object({
        id: mtMap38.objectField("id", mtMap38.passthrough()),
        status: mtMap38.objectField("status", mtMap38.passthrough()),
        isDefault: mtMap38.objectField("is_default", mtMap38.passthrough()),
        slug: mtMap38.objectField("slug", mtMap38.passthrough()),
        name: mtMap38.objectField("name", mtMap38.passthrough()),
        description: mtMap38.objectField("description", mtMap38.passthrough()),
        entitlements: mtMap38.objectField(
          "entitlements",
          mtMap38.array(
            mtMap38.object({
              id: mtMap38.objectField("id", mtMap38.passthrough()),
              status: mtMap38.objectField("status", mtMap38.passthrough()),
              policyId: mtMap38.objectField("policy_id", mtMap38.passthrough()),
              type: mtMap38.objectField("type", mtMap38.passthrough()),
              amount: mtMap38.objectField("amount", mtMap38.passthrough()),
              windowDuration: mtMap38.objectField(
                "window_duration",
                mtMap38.object({
                  size: mtMap38.objectField("size", mtMap38.passthrough()),
                  unit: mtMap38.objectField("unit", mtMap38.passthrough())
                })
              ),
              overageBlockDuration: mtMap38.objectField(
                "overage_block_duration",
                mtMap38.object({
                  size: mtMap38.objectField("size", mtMap38.passthrough()),
                  unit: mtMap38.objectField("unit", mtMap38.passthrough())
                })
              ),
              agents: mtMap38.objectField(
                "agents",
                mtMap38.union([
                  mtMap38.unionOption(
                    "object",
                    mtMap38.object({
                      type: mtMap38.objectField("type", mtMap38.passthrough()),
                      agentIds: mtMap38.objectField(
                        "agent_ids",
                        mtMap38.array(mtMap38.passthrough())
                      )
                    })
                  )
                ])
              ),
              createdAt: mtMap38.objectField("created_at", mtMap38.date()),
              updatedAt: mtMap38.objectField("updated_at", mtMap38.date())
            })
          )
        ),
        createdAt: mtMap38.objectField("created_at", mtMap38.date()),
        updatedAt: mtMap38.objectField("updated_at", mtMap38.date())
      })
    )
  ),
  metadata: mtMap38.objectField("metadata", mtMap38.passthrough()),
  createdAt: mtMap38.objectField("created_at", mtMap38.date()),
  updatedAt: mtMap38.objectField("updated_at", mtMap38.date())
});
var mapManagementInstancesGroupsCreateBody = mtMap38.object({
  id: mtMap38.objectField("id", mtMap38.passthrough()),
  name: mtMap38.objectField("name", mtMap38.passthrough()),
  policyIds: mtMap38.objectField(
    "policy_ids",
    mtMap38.array(mtMap38.passthrough())
  ),
  metadata: mtMap38.objectField("metadata", mtMap38.passthrough()),
  users: mtMap38.objectField(
    "users",
    mtMap38.array(
      mtMap38.object({
        userId: mtMap38.objectField("user_id", mtMap38.passthrough()),
        roleId: mtMap38.objectField("role_id", mtMap38.passthrough())
      })
    )
  )
});

// src/resources/management/instances/groups/delete.ts
import { mtMap as mtMap39 } from "@metorial/util-resource-mapper";
var mapManagementInstancesGroupsDeleteOutput = mtMap39.object({
  id: mtMap39.objectField("id", mtMap39.passthrough()),
  status: mtMap39.objectField("status", mtMap39.passthrough()),
  type: mtMap39.objectField("type", mtMap39.passthrough()),
  name: mtMap39.objectField("name", mtMap39.passthrough()),
  policies: mtMap39.objectField(
    "policies",
    mtMap39.array(
      mtMap39.object({
        id: mtMap39.objectField("id", mtMap39.passthrough()),
        status: mtMap39.objectField("status", mtMap39.passthrough()),
        isDefault: mtMap39.objectField("is_default", mtMap39.passthrough()),
        slug: mtMap39.objectField("slug", mtMap39.passthrough()),
        name: mtMap39.objectField("name", mtMap39.passthrough()),
        description: mtMap39.objectField("description", mtMap39.passthrough()),
        entitlements: mtMap39.objectField(
          "entitlements",
          mtMap39.array(
            mtMap39.object({
              id: mtMap39.objectField("id", mtMap39.passthrough()),
              status: mtMap39.objectField("status", mtMap39.passthrough()),
              policyId: mtMap39.objectField("policy_id", mtMap39.passthrough()),
              type: mtMap39.objectField("type", mtMap39.passthrough()),
              amount: mtMap39.objectField("amount", mtMap39.passthrough()),
              windowDuration: mtMap39.objectField(
                "window_duration",
                mtMap39.object({
                  size: mtMap39.objectField("size", mtMap39.passthrough()),
                  unit: mtMap39.objectField("unit", mtMap39.passthrough())
                })
              ),
              overageBlockDuration: mtMap39.objectField(
                "overage_block_duration",
                mtMap39.object({
                  size: mtMap39.objectField("size", mtMap39.passthrough()),
                  unit: mtMap39.objectField("unit", mtMap39.passthrough())
                })
              ),
              agents: mtMap39.objectField(
                "agents",
                mtMap39.union([
                  mtMap39.unionOption(
                    "object",
                    mtMap39.object({
                      type: mtMap39.objectField("type", mtMap39.passthrough()),
                      agentIds: mtMap39.objectField(
                        "agent_ids",
                        mtMap39.array(mtMap39.passthrough())
                      )
                    })
                  )
                ])
              ),
              createdAt: mtMap39.objectField("created_at", mtMap39.date()),
              updatedAt: mtMap39.objectField("updated_at", mtMap39.date())
            })
          )
        ),
        createdAt: mtMap39.objectField("created_at", mtMap39.date()),
        updatedAt: mtMap39.objectField("updated_at", mtMap39.date())
      })
    )
  ),
  metadata: mtMap39.objectField("metadata", mtMap39.passthrough()),
  createdAt: mtMap39.objectField("created_at", mtMap39.date()),
  updatedAt: mtMap39.objectField("updated_at", mtMap39.date())
});

// src/resources/management/instances/groups/get.ts
import { mtMap as mtMap40 } from "@metorial/util-resource-mapper";
var mapManagementInstancesGroupsGetOutput = mtMap40.object({
  id: mtMap40.objectField("id", mtMap40.passthrough()),
  status: mtMap40.objectField("status", mtMap40.passthrough()),
  type: mtMap40.objectField("type", mtMap40.passthrough()),
  name: mtMap40.objectField("name", mtMap40.passthrough()),
  policies: mtMap40.objectField(
    "policies",
    mtMap40.array(
      mtMap40.object({
        id: mtMap40.objectField("id", mtMap40.passthrough()),
        status: mtMap40.objectField("status", mtMap40.passthrough()),
        isDefault: mtMap40.objectField("is_default", mtMap40.passthrough()),
        slug: mtMap40.objectField("slug", mtMap40.passthrough()),
        name: mtMap40.objectField("name", mtMap40.passthrough()),
        description: mtMap40.objectField("description", mtMap40.passthrough()),
        entitlements: mtMap40.objectField(
          "entitlements",
          mtMap40.array(
            mtMap40.object({
              id: mtMap40.objectField("id", mtMap40.passthrough()),
              status: mtMap40.objectField("status", mtMap40.passthrough()),
              policyId: mtMap40.objectField("policy_id", mtMap40.passthrough()),
              type: mtMap40.objectField("type", mtMap40.passthrough()),
              amount: mtMap40.objectField("amount", mtMap40.passthrough()),
              windowDuration: mtMap40.objectField(
                "window_duration",
                mtMap40.object({
                  size: mtMap40.objectField("size", mtMap40.passthrough()),
                  unit: mtMap40.objectField("unit", mtMap40.passthrough())
                })
              ),
              overageBlockDuration: mtMap40.objectField(
                "overage_block_duration",
                mtMap40.object({
                  size: mtMap40.objectField("size", mtMap40.passthrough()),
                  unit: mtMap40.objectField("unit", mtMap40.passthrough())
                })
              ),
              agents: mtMap40.objectField(
                "agents",
                mtMap40.union([
                  mtMap40.unionOption(
                    "object",
                    mtMap40.object({
                      type: mtMap40.objectField("type", mtMap40.passthrough()),
                      agentIds: mtMap40.objectField(
                        "agent_ids",
                        mtMap40.array(mtMap40.passthrough())
                      )
                    })
                  )
                ])
              ),
              createdAt: mtMap40.objectField("created_at", mtMap40.date()),
              updatedAt: mtMap40.objectField("updated_at", mtMap40.date())
            })
          )
        ),
        createdAt: mtMap40.objectField("created_at", mtMap40.date()),
        updatedAt: mtMap40.objectField("updated_at", mtMap40.date())
      })
    )
  ),
  metadata: mtMap40.objectField("metadata", mtMap40.passthrough()),
  createdAt: mtMap40.objectField("created_at", mtMap40.date()),
  updatedAt: mtMap40.objectField("updated_at", mtMap40.date())
});

// src/resources/management/instances/groups/list.ts
import { mtMap as mtMap41 } from "@metorial/util-resource-mapper";
var mapManagementInstancesGroupsListOutput = mtMap41.object({
  items: mtMap41.objectField(
    "items",
    mtMap41.array(
      mtMap41.object({
        id: mtMap41.objectField("id", mtMap41.passthrough()),
        status: mtMap41.objectField("status", mtMap41.passthrough()),
        type: mtMap41.objectField("type", mtMap41.passthrough()),
        name: mtMap41.objectField("name", mtMap41.passthrough()),
        policies: mtMap41.objectField(
          "policies",
          mtMap41.array(
            mtMap41.object({
              id: mtMap41.objectField("id", mtMap41.passthrough()),
              status: mtMap41.objectField("status", mtMap41.passthrough()),
              isDefault: mtMap41.objectField("is_default", mtMap41.passthrough()),
              slug: mtMap41.objectField("slug", mtMap41.passthrough()),
              name: mtMap41.objectField("name", mtMap41.passthrough()),
              description: mtMap41.objectField(
                "description",
                mtMap41.passthrough()
              ),
              entitlements: mtMap41.objectField(
                "entitlements",
                mtMap41.array(
                  mtMap41.object({
                    id: mtMap41.objectField("id", mtMap41.passthrough()),
                    status: mtMap41.objectField("status", mtMap41.passthrough()),
                    policyId: mtMap41.objectField(
                      "policy_id",
                      mtMap41.passthrough()
                    ),
                    type: mtMap41.objectField("type", mtMap41.passthrough()),
                    amount: mtMap41.objectField("amount", mtMap41.passthrough()),
                    windowDuration: mtMap41.objectField(
                      "window_duration",
                      mtMap41.object({
                        size: mtMap41.objectField("size", mtMap41.passthrough()),
                        unit: mtMap41.objectField("unit", mtMap41.passthrough())
                      })
                    ),
                    overageBlockDuration: mtMap41.objectField(
                      "overage_block_duration",
                      mtMap41.object({
                        size: mtMap41.objectField("size", mtMap41.passthrough()),
                        unit: mtMap41.objectField("unit", mtMap41.passthrough())
                      })
                    ),
                    agents: mtMap41.objectField(
                      "agents",
                      mtMap41.union([
                        mtMap41.unionOption(
                          "object",
                          mtMap41.object({
                            type: mtMap41.objectField(
                              "type",
                              mtMap41.passthrough()
                            ),
                            agentIds: mtMap41.objectField(
                              "agent_ids",
                              mtMap41.array(mtMap41.passthrough())
                            )
                          })
                        )
                      ])
                    ),
                    createdAt: mtMap41.objectField("created_at", mtMap41.date()),
                    updatedAt: mtMap41.objectField("updated_at", mtMap41.date())
                  })
                )
              ),
              createdAt: mtMap41.objectField("created_at", mtMap41.date()),
              updatedAt: mtMap41.objectField("updated_at", mtMap41.date())
            })
          )
        ),
        metadata: mtMap41.objectField("metadata", mtMap41.passthrough()),
        createdAt: mtMap41.objectField("created_at", mtMap41.date()),
        updatedAt: mtMap41.objectField("updated_at", mtMap41.date())
      })
    )
  ),
  pagination: mtMap41.objectField(
    "pagination",
    mtMap41.object({
      afterCursor: mtMap41.objectField("after_cursor", mtMap41.passthrough()),
      beforeCursor: mtMap41.objectField("before_cursor", mtMap41.passthrough()),
      hasMoreBefore: mtMap41.objectField(
        "has_more_before",
        mtMap41.passthrough()
      ),
      hasMoreAfter: mtMap41.objectField("has_more_after", mtMap41.passthrough()),
      pageSize: mtMap41.objectField("page_size", mtMap41.passthrough()),
      sort: mtMap41.objectField(
        "sort",
        mtMap41.array(
          mtMap41.object({
            field: mtMap41.objectField("field", mtMap41.passthrough()),
            order: mtMap41.objectField("order", mtMap41.passthrough())
          })
        )
      )
    })
  )
});
var mapManagementInstancesGroupsListQuery = mtMap41.object({
  id: mtMap41.objectField(
    "id",
    mtMap41.union([
      mtMap41.unionOption(
        "object",
        mtMap41.object({
          in: mtMap41.objectField("in", mtMap41.array(mtMap41.passthrough())),
          eq: mtMap41.objectField("eq", mtMap41.passthrough())
        })
      ),
      mtMap41.unionOption("string", mtMap41.passthrough())
    ])
  ),
  ids: mtMap41.objectField(
    "ids",
    mtMap41.union([
      mtMap41.unionOption(
        "object",
        mtMap41.object({
          in: mtMap41.objectField("in", mtMap41.array(mtMap41.passthrough())),
          eq: mtMap41.objectField("eq", mtMap41.passthrough())
        })
      ),
      mtMap41.unionOption("string", mtMap41.passthrough())
    ])
  ),
  createdAt: mtMap41.objectField(
    "created_at",
    mtMap41.union([
      mtMap41.unionOption(
        "object",
        mtMap41.object({
          eq: mtMap41.objectField("eq", mtMap41.date()),
          gt: mtMap41.objectField("gt", mtMap41.date()),
          gte: mtMap41.objectField("gte", mtMap41.date()),
          lt: mtMap41.objectField("lt", mtMap41.date()),
          lte: mtMap41.objectField("lte", mtMap41.date())
        })
      ),
      mtMap41.unionOption("date", mtMap41.passthrough())
    ])
  ),
  updatedAt: mtMap41.objectField(
    "updated_at",
    mtMap41.union([
      mtMap41.unionOption(
        "object",
        mtMap41.object({
          eq: mtMap41.objectField("eq", mtMap41.date()),
          gt: mtMap41.objectField("gt", mtMap41.date()),
          gte: mtMap41.objectField("gte", mtMap41.date()),
          lt: mtMap41.objectField("lt", mtMap41.date()),
          lte: mtMap41.objectField("lte", mtMap41.date())
        })
      ),
      mtMap41.unionOption("date", mtMap41.passthrough())
    ])
  ),
  sort: mtMap41.objectField(
    "sort",
    mtMap41.union([
      mtMap41.unionOption("string", mtMap41.passthrough()),
      mtMap41.unionOption(
        "array",
        mtMap41.union([
          mtMap41.unionOption(
            "object",
            mtMap41.object({
              field: mtMap41.objectField("field", mtMap41.passthrough()),
              order: mtMap41.objectField("order", mtMap41.passthrough())
            })
          )
        ])
      )
    ])
  ),
  threadId: mtMap41.objectField("thread_id", mtMap41.passthrough()),
  userId: mtMap41.objectField("user_id", mtMap41.passthrough()),
  limit: mtMap41.objectField("limit", mtMap41.passthrough()),
  cursor: mtMap41.objectField("cursor", mtMap41.passthrough()),
  order: mtMap41.objectField("order", mtMap41.passthrough())
});

// src/resources/management/instances/groups/threads/create.ts
import { mtMap as mtMap42 } from "@metorial/util-resource-mapper";
var mapManagementInstancesGroupsThreadsCreateOutput = mtMap42.object({
  id: mtMap42.objectField("id", mtMap42.passthrough()),
  status: mtMap42.objectField("status", mtMap42.passthrough()),
  groupId: mtMap42.objectField("group_id", mtMap42.passthrough()),
  thread: mtMap42.objectField(
    "thread",
    mtMap42.object({
      id: mtMap42.objectField("id", mtMap42.passthrough()),
      name: mtMap42.objectField("name", mtMap42.passthrough()),
      agentId: mtMap42.objectField("agent_id", mtMap42.passthrough()),
      instanceId: mtMap42.objectField("instance_id", mtMap42.passthrough()),
      timezone: mtMap42.objectField(
        "timezone",
        mtMap42.object({
          code: mtMap42.objectField("code", mtMap42.passthrough()),
          utc: mtMap42.objectField("utc", mtMap42.passthrough()),
          utcOffsetInMinutes: mtMap42.objectField(
            "utc_offset_in_minutes",
            mtMap42.passthrough()
          )
        })
      ),
      country: mtMap42.objectField(
        "country",
        mtMap42.object({ code: mtMap42.objectField("code", mtMap42.passthrough()) })
      ),
      language: mtMap42.objectField(
        "language",
        mtMap42.object({
          code: mtMap42.objectField("code", mtMap42.passthrough()),
          full: mtMap42.objectField("full", mtMap42.passthrough())
        })
      ),
      metadata: mtMap42.objectField("metadata", mtMap42.passthrough()),
      createdAt: mtMap42.objectField("created_at", mtMap42.date()),
      updatedAt: mtMap42.objectField("updated_at", mtMap42.date())
    })
  )
});
var mapManagementInstancesGroupsThreadsCreateBody = mtMap42.object({
  groupId: mtMap42.objectField("group_id", mtMap42.passthrough()),
  threadId: mtMap42.objectField("thread_id", mtMap42.passthrough())
});

// src/resources/management/instances/groups/threads/delete.ts
import { mtMap as mtMap43 } from "@metorial/util-resource-mapper";
var mapManagementInstancesGroupsThreadsDeleteOutput = mtMap43.object({
  id: mtMap43.objectField("id", mtMap43.passthrough()),
  status: mtMap43.objectField("status", mtMap43.passthrough()),
  groupId: mtMap43.objectField("group_id", mtMap43.passthrough()),
  thread: mtMap43.objectField(
    "thread",
    mtMap43.object({
      id: mtMap43.objectField("id", mtMap43.passthrough()),
      name: mtMap43.objectField("name", mtMap43.passthrough()),
      agentId: mtMap43.objectField("agent_id", mtMap43.passthrough()),
      instanceId: mtMap43.objectField("instance_id", mtMap43.passthrough()),
      timezone: mtMap43.objectField(
        "timezone",
        mtMap43.object({
          code: mtMap43.objectField("code", mtMap43.passthrough()),
          utc: mtMap43.objectField("utc", mtMap43.passthrough()),
          utcOffsetInMinutes: mtMap43.objectField(
            "utc_offset_in_minutes",
            mtMap43.passthrough()
          )
        })
      ),
      country: mtMap43.objectField(
        "country",
        mtMap43.object({ code: mtMap43.objectField("code", mtMap43.passthrough()) })
      ),
      language: mtMap43.objectField(
        "language",
        mtMap43.object({
          code: mtMap43.objectField("code", mtMap43.passthrough()),
          full: mtMap43.objectField("full", mtMap43.passthrough())
        })
      ),
      metadata: mtMap43.objectField("metadata", mtMap43.passthrough()),
      createdAt: mtMap43.objectField("created_at", mtMap43.date()),
      updatedAt: mtMap43.objectField("updated_at", mtMap43.date())
    })
  )
});

// src/resources/management/instances/groups/threads/get.ts
import { mtMap as mtMap44 } from "@metorial/util-resource-mapper";
var mapManagementInstancesGroupsThreadsGetOutput = mtMap44.object({
  id: mtMap44.objectField("id", mtMap44.passthrough()),
  status: mtMap44.objectField("status", mtMap44.passthrough()),
  groupId: mtMap44.objectField("group_id", mtMap44.passthrough()),
  thread: mtMap44.objectField(
    "thread",
    mtMap44.object({
      id: mtMap44.objectField("id", mtMap44.passthrough()),
      name: mtMap44.objectField("name", mtMap44.passthrough()),
      agentId: mtMap44.objectField("agent_id", mtMap44.passthrough()),
      instanceId: mtMap44.objectField("instance_id", mtMap44.passthrough()),
      timezone: mtMap44.objectField(
        "timezone",
        mtMap44.object({
          code: mtMap44.objectField("code", mtMap44.passthrough()),
          utc: mtMap44.objectField("utc", mtMap44.passthrough()),
          utcOffsetInMinutes: mtMap44.objectField(
            "utc_offset_in_minutes",
            mtMap44.passthrough()
          )
        })
      ),
      country: mtMap44.objectField(
        "country",
        mtMap44.object({ code: mtMap44.objectField("code", mtMap44.passthrough()) })
      ),
      language: mtMap44.objectField(
        "language",
        mtMap44.object({
          code: mtMap44.objectField("code", mtMap44.passthrough()),
          full: mtMap44.objectField("full", mtMap44.passthrough())
        })
      ),
      metadata: mtMap44.objectField("metadata", mtMap44.passthrough()),
      createdAt: mtMap44.objectField("created_at", mtMap44.date()),
      updatedAt: mtMap44.objectField("updated_at", mtMap44.date())
    })
  )
});

// src/resources/management/instances/groups/threads/list.ts
import { mtMap as mtMap45 } from "@metorial/util-resource-mapper";
var mapManagementInstancesGroupsThreadsListOutput = mtMap45.object({
  items: mtMap45.objectField(
    "items",
    mtMap45.array(
      mtMap45.object({
        id: mtMap45.objectField("id", mtMap45.passthrough()),
        status: mtMap45.objectField("status", mtMap45.passthrough()),
        groupId: mtMap45.objectField("group_id", mtMap45.passthrough()),
        thread: mtMap45.objectField(
          "thread",
          mtMap45.object({
            id: mtMap45.objectField("id", mtMap45.passthrough()),
            name: mtMap45.objectField("name", mtMap45.passthrough()),
            agentId: mtMap45.objectField("agent_id", mtMap45.passthrough()),
            instanceId: mtMap45.objectField("instance_id", mtMap45.passthrough()),
            timezone: mtMap45.objectField(
              "timezone",
              mtMap45.object({
                code: mtMap45.objectField("code", mtMap45.passthrough()),
                utc: mtMap45.objectField("utc", mtMap45.passthrough()),
                utcOffsetInMinutes: mtMap45.objectField(
                  "utc_offset_in_minutes",
                  mtMap45.passthrough()
                )
              })
            ),
            country: mtMap45.objectField(
              "country",
              mtMap45.object({
                code: mtMap45.objectField("code", mtMap45.passthrough())
              })
            ),
            language: mtMap45.objectField(
              "language",
              mtMap45.object({
                code: mtMap45.objectField("code", mtMap45.passthrough()),
                full: mtMap45.objectField("full", mtMap45.passthrough())
              })
            ),
            metadata: mtMap45.objectField("metadata", mtMap45.passthrough()),
            createdAt: mtMap45.objectField("created_at", mtMap45.date()),
            updatedAt: mtMap45.objectField("updated_at", mtMap45.date())
          })
        )
      })
    )
  ),
  pagination: mtMap45.objectField(
    "pagination",
    mtMap45.object({
      afterCursor: mtMap45.objectField("after_cursor", mtMap45.passthrough()),
      beforeCursor: mtMap45.objectField("before_cursor", mtMap45.passthrough()),
      hasMoreBefore: mtMap45.objectField(
        "has_more_before",
        mtMap45.passthrough()
      ),
      hasMoreAfter: mtMap45.objectField("has_more_after", mtMap45.passthrough()),
      pageSize: mtMap45.objectField("page_size", mtMap45.passthrough()),
      sort: mtMap45.objectField(
        "sort",
        mtMap45.array(
          mtMap45.object({
            field: mtMap45.objectField("field", mtMap45.passthrough()),
            order: mtMap45.objectField("order", mtMap45.passthrough())
          })
        )
      )
    })
  )
});
var mapManagementInstancesGroupsThreadsListQuery = mtMap45.object({
  id: mtMap45.objectField(
    "id",
    mtMap45.union([
      mtMap45.unionOption(
        "object",
        mtMap45.object({
          in: mtMap45.objectField("in", mtMap45.array(mtMap45.passthrough())),
          eq: mtMap45.objectField("eq", mtMap45.passthrough())
        })
      ),
      mtMap45.unionOption("string", mtMap45.passthrough())
    ])
  ),
  ids: mtMap45.objectField(
    "ids",
    mtMap45.union([
      mtMap45.unionOption(
        "object",
        mtMap45.object({
          in: mtMap45.objectField("in", mtMap45.array(mtMap45.passthrough())),
          eq: mtMap45.objectField("eq", mtMap45.passthrough())
        })
      ),
      mtMap45.unionOption("string", mtMap45.passthrough())
    ])
  ),
  createdAt: mtMap45.objectField(
    "created_at",
    mtMap45.union([
      mtMap45.unionOption(
        "object",
        mtMap45.object({
          eq: mtMap45.objectField("eq", mtMap45.date()),
          gt: mtMap45.objectField("gt", mtMap45.date()),
          gte: mtMap45.objectField("gte", mtMap45.date()),
          lt: mtMap45.objectField("lt", mtMap45.date()),
          lte: mtMap45.objectField("lte", mtMap45.date())
        })
      ),
      mtMap45.unionOption("date", mtMap45.passthrough())
    ])
  ),
  sort: mtMap45.objectField(
    "sort",
    mtMap45.union([
      mtMap45.unionOption("string", mtMap45.passthrough()),
      mtMap45.unionOption(
        "array",
        mtMap45.union([
          mtMap45.unionOption(
            "object",
            mtMap45.object({
              field: mtMap45.objectField("field", mtMap45.passthrough()),
              order: mtMap45.objectField("order", mtMap45.passthrough())
            })
          )
        ])
      )
    ])
  ),
  threadId: mtMap45.objectField("thread_id", mtMap45.passthrough()),
  groupId: mtMap45.objectField("group_id", mtMap45.passthrough()),
  limit: mtMap45.objectField("limit", mtMap45.passthrough()),
  cursor: mtMap45.objectField("cursor", mtMap45.passthrough()),
  order: mtMap45.objectField("order", mtMap45.passthrough())
});

// src/resources/management/instances/groups/update.ts
import { mtMap as mtMap46 } from "@metorial/util-resource-mapper";
var mapManagementInstancesGroupsUpdateOutput = mtMap46.object({
  id: mtMap46.objectField("id", mtMap46.passthrough()),
  status: mtMap46.objectField("status", mtMap46.passthrough()),
  type: mtMap46.objectField("type", mtMap46.passthrough()),
  name: mtMap46.objectField("name", mtMap46.passthrough()),
  policies: mtMap46.objectField(
    "policies",
    mtMap46.array(
      mtMap46.object({
        id: mtMap46.objectField("id", mtMap46.passthrough()),
        status: mtMap46.objectField("status", mtMap46.passthrough()),
        isDefault: mtMap46.objectField("is_default", mtMap46.passthrough()),
        slug: mtMap46.objectField("slug", mtMap46.passthrough()),
        name: mtMap46.objectField("name", mtMap46.passthrough()),
        description: mtMap46.objectField("description", mtMap46.passthrough()),
        entitlements: mtMap46.objectField(
          "entitlements",
          mtMap46.array(
            mtMap46.object({
              id: mtMap46.objectField("id", mtMap46.passthrough()),
              status: mtMap46.objectField("status", mtMap46.passthrough()),
              policyId: mtMap46.objectField("policy_id", mtMap46.passthrough()),
              type: mtMap46.objectField("type", mtMap46.passthrough()),
              amount: mtMap46.objectField("amount", mtMap46.passthrough()),
              windowDuration: mtMap46.objectField(
                "window_duration",
                mtMap46.object({
                  size: mtMap46.objectField("size", mtMap46.passthrough()),
                  unit: mtMap46.objectField("unit", mtMap46.passthrough())
                })
              ),
              overageBlockDuration: mtMap46.objectField(
                "overage_block_duration",
                mtMap46.object({
                  size: mtMap46.objectField("size", mtMap46.passthrough()),
                  unit: mtMap46.objectField("unit", mtMap46.passthrough())
                })
              ),
              agents: mtMap46.objectField(
                "agents",
                mtMap46.union([
                  mtMap46.unionOption(
                    "object",
                    mtMap46.object({
                      type: mtMap46.objectField("type", mtMap46.passthrough()),
                      agentIds: mtMap46.objectField(
                        "agent_ids",
                        mtMap46.array(mtMap46.passthrough())
                      )
                    })
                  )
                ])
              ),
              createdAt: mtMap46.objectField("created_at", mtMap46.date()),
              updatedAt: mtMap46.objectField("updated_at", mtMap46.date())
            })
          )
        ),
        createdAt: mtMap46.objectField("created_at", mtMap46.date()),
        updatedAt: mtMap46.objectField("updated_at", mtMap46.date())
      })
    )
  ),
  metadata: mtMap46.objectField("metadata", mtMap46.passthrough()),
  createdAt: mtMap46.objectField("created_at", mtMap46.date()),
  updatedAt: mtMap46.objectField("updated_at", mtMap46.date())
});
var mapManagementInstancesGroupsUpdateBody = mtMap46.object({
  name: mtMap46.objectField("name", mtMap46.passthrough()),
  policyIds: mtMap46.objectField(
    "policy_ids",
    mtMap46.array(mtMap46.passthrough())
  ),
  metadata: mtMap46.objectField("metadata", mtMap46.passthrough())
});

// src/resources/management/instances/groups/users/create.ts
import { mtMap as mtMap47 } from "@metorial/util-resource-mapper";
var mapManagementInstancesGroupsUsersCreateOutput = mtMap47.object({
  id: mtMap47.objectField("id", mtMap47.passthrough()),
  status: mtMap47.objectField("status", mtMap47.passthrough()),
  groupId: mtMap47.objectField("group_id", mtMap47.passthrough()),
  roles: mtMap47.objectField(
    "roles",
    mtMap47.array(
      mtMap47.object({
        id: mtMap47.objectField("id", mtMap47.passthrough()),
        status: mtMap47.objectField("status", mtMap47.passthrough()),
        isDefault: mtMap47.objectField("is_default", mtMap47.passthrough()),
        slug: mtMap47.objectField("slug", mtMap47.passthrough()),
        name: mtMap47.objectField("name", mtMap47.passthrough()),
        description: mtMap47.objectField("description", mtMap47.passthrough()),
        permissions: mtMap47.objectField(
          "permissions",
          mtMap47.array(mtMap47.passthrough())
        ),
        createdAt: mtMap47.objectField("created_at", mtMap47.date()),
        updatedAt: mtMap47.objectField("updated_at", mtMap47.date())
      })
    )
  ),
  user: mtMap47.objectField(
    "user",
    mtMap47.object({
      id: mtMap47.objectField("id", mtMap47.passthrough()),
      status: mtMap47.objectField("status", mtMap47.passthrough()),
      type: mtMap47.objectField("type", mtMap47.passthrough()),
      name: mtMap47.objectField("name", mtMap47.passthrough()),
      email: mtMap47.objectField("email", mtMap47.passthrough()),
      metadata: mtMap47.objectField("metadata", mtMap47.passthrough()),
      defaultGroupId: mtMap47.objectField(
        "default_group_id",
        mtMap47.passthrough()
      ),
      createdAt: mtMap47.objectField("created_at", mtMap47.date()),
      updatedAt: mtMap47.objectField("updated_at", mtMap47.date())
    })
  )
});
var mapManagementInstancesGroupsUsersCreateBody = mtMap47.object({
  userId: mtMap47.objectField("user_id", mtMap47.passthrough()),
  groupId: mtMap47.objectField("group_id", mtMap47.passthrough()),
  roleIds: mtMap47.objectField("role_ids", mtMap47.array(mtMap47.passthrough()))
});

// src/resources/management/instances/groups/users/delete.ts
import { mtMap as mtMap48 } from "@metorial/util-resource-mapper";
var mapManagementInstancesGroupsUsersDeleteOutput = mtMap48.object({
  id: mtMap48.objectField("id", mtMap48.passthrough()),
  status: mtMap48.objectField("status", mtMap48.passthrough()),
  groupId: mtMap48.objectField("group_id", mtMap48.passthrough()),
  roles: mtMap48.objectField(
    "roles",
    mtMap48.array(
      mtMap48.object({
        id: mtMap48.objectField("id", mtMap48.passthrough()),
        status: mtMap48.objectField("status", mtMap48.passthrough()),
        isDefault: mtMap48.objectField("is_default", mtMap48.passthrough()),
        slug: mtMap48.objectField("slug", mtMap48.passthrough()),
        name: mtMap48.objectField("name", mtMap48.passthrough()),
        description: mtMap48.objectField("description", mtMap48.passthrough()),
        permissions: mtMap48.objectField(
          "permissions",
          mtMap48.array(mtMap48.passthrough())
        ),
        createdAt: mtMap48.objectField("created_at", mtMap48.date()),
        updatedAt: mtMap48.objectField("updated_at", mtMap48.date())
      })
    )
  ),
  user: mtMap48.objectField(
    "user",
    mtMap48.object({
      id: mtMap48.objectField("id", mtMap48.passthrough()),
      status: mtMap48.objectField("status", mtMap48.passthrough()),
      type: mtMap48.objectField("type", mtMap48.passthrough()),
      name: mtMap48.objectField("name", mtMap48.passthrough()),
      email: mtMap48.objectField("email", mtMap48.passthrough()),
      metadata: mtMap48.objectField("metadata", mtMap48.passthrough()),
      defaultGroupId: mtMap48.objectField(
        "default_group_id",
        mtMap48.passthrough()
      ),
      createdAt: mtMap48.objectField("created_at", mtMap48.date()),
      updatedAt: mtMap48.objectField("updated_at", mtMap48.date())
    })
  )
});

// src/resources/management/instances/groups/users/get.ts
import { mtMap as mtMap49 } from "@metorial/util-resource-mapper";
var mapManagementInstancesGroupsUsersGetOutput = mtMap49.object({
  id: mtMap49.objectField("id", mtMap49.passthrough()),
  status: mtMap49.objectField("status", mtMap49.passthrough()),
  groupId: mtMap49.objectField("group_id", mtMap49.passthrough()),
  roles: mtMap49.objectField(
    "roles",
    mtMap49.array(
      mtMap49.object({
        id: mtMap49.objectField("id", mtMap49.passthrough()),
        status: mtMap49.objectField("status", mtMap49.passthrough()),
        isDefault: mtMap49.objectField("is_default", mtMap49.passthrough()),
        slug: mtMap49.objectField("slug", mtMap49.passthrough()),
        name: mtMap49.objectField("name", mtMap49.passthrough()),
        description: mtMap49.objectField("description", mtMap49.passthrough()),
        permissions: mtMap49.objectField(
          "permissions",
          mtMap49.array(mtMap49.passthrough())
        ),
        createdAt: mtMap49.objectField("created_at", mtMap49.date()),
        updatedAt: mtMap49.objectField("updated_at", mtMap49.date())
      })
    )
  ),
  user: mtMap49.objectField(
    "user",
    mtMap49.object({
      id: mtMap49.objectField("id", mtMap49.passthrough()),
      status: mtMap49.objectField("status", mtMap49.passthrough()),
      type: mtMap49.objectField("type", mtMap49.passthrough()),
      name: mtMap49.objectField("name", mtMap49.passthrough()),
      email: mtMap49.objectField("email", mtMap49.passthrough()),
      metadata: mtMap49.objectField("metadata", mtMap49.passthrough()),
      defaultGroupId: mtMap49.objectField(
        "default_group_id",
        mtMap49.passthrough()
      ),
      createdAt: mtMap49.objectField("created_at", mtMap49.date()),
      updatedAt: mtMap49.objectField("updated_at", mtMap49.date())
    })
  )
});

// src/resources/management/instances/groups/users/list.ts
import { mtMap as mtMap50 } from "@metorial/util-resource-mapper";
var mapManagementInstancesGroupsUsersListOutput = mtMap50.object({
  items: mtMap50.objectField(
    "items",
    mtMap50.array(
      mtMap50.object({
        id: mtMap50.objectField("id", mtMap50.passthrough()),
        status: mtMap50.objectField("status", mtMap50.passthrough()),
        groupId: mtMap50.objectField("group_id", mtMap50.passthrough()),
        roles: mtMap50.objectField(
          "roles",
          mtMap50.array(
            mtMap50.object({
              id: mtMap50.objectField("id", mtMap50.passthrough()),
              status: mtMap50.objectField("status", mtMap50.passthrough()),
              isDefault: mtMap50.objectField("is_default", mtMap50.passthrough()),
              slug: mtMap50.objectField("slug", mtMap50.passthrough()),
              name: mtMap50.objectField("name", mtMap50.passthrough()),
              description: mtMap50.objectField(
                "description",
                mtMap50.passthrough()
              ),
              permissions: mtMap50.objectField(
                "permissions",
                mtMap50.array(mtMap50.passthrough())
              ),
              createdAt: mtMap50.objectField("created_at", mtMap50.date()),
              updatedAt: mtMap50.objectField("updated_at", mtMap50.date())
            })
          )
        ),
        user: mtMap50.objectField(
          "user",
          mtMap50.object({
            id: mtMap50.objectField("id", mtMap50.passthrough()),
            status: mtMap50.objectField("status", mtMap50.passthrough()),
            type: mtMap50.objectField("type", mtMap50.passthrough()),
            name: mtMap50.objectField("name", mtMap50.passthrough()),
            email: mtMap50.objectField("email", mtMap50.passthrough()),
            metadata: mtMap50.objectField("metadata", mtMap50.passthrough()),
            defaultGroupId: mtMap50.objectField(
              "default_group_id",
              mtMap50.passthrough()
            ),
            createdAt: mtMap50.objectField("created_at", mtMap50.date()),
            updatedAt: mtMap50.objectField("updated_at", mtMap50.date())
          })
        )
      })
    )
  ),
  pagination: mtMap50.objectField(
    "pagination",
    mtMap50.object({
      afterCursor: mtMap50.objectField("after_cursor", mtMap50.passthrough()),
      beforeCursor: mtMap50.objectField("before_cursor", mtMap50.passthrough()),
      hasMoreBefore: mtMap50.objectField(
        "has_more_before",
        mtMap50.passthrough()
      ),
      hasMoreAfter: mtMap50.objectField("has_more_after", mtMap50.passthrough()),
      pageSize: mtMap50.objectField("page_size", mtMap50.passthrough()),
      sort: mtMap50.objectField(
        "sort",
        mtMap50.array(
          mtMap50.object({
            field: mtMap50.objectField("field", mtMap50.passthrough()),
            order: mtMap50.objectField("order", mtMap50.passthrough())
          })
        )
      )
    })
  )
});
var mapManagementInstancesGroupsUsersListQuery = mtMap50.object({
  id: mtMap50.objectField(
    "id",
    mtMap50.union([
      mtMap50.unionOption(
        "object",
        mtMap50.object({
          in: mtMap50.objectField("in", mtMap50.array(mtMap50.passthrough())),
          eq: mtMap50.objectField("eq", mtMap50.passthrough())
        })
      ),
      mtMap50.unionOption("string", mtMap50.passthrough())
    ])
  ),
  ids: mtMap50.objectField(
    "ids",
    mtMap50.union([
      mtMap50.unionOption(
        "object",
        mtMap50.object({
          in: mtMap50.objectField("in", mtMap50.array(mtMap50.passthrough())),
          eq: mtMap50.objectField("eq", mtMap50.passthrough())
        })
      ),
      mtMap50.unionOption("string", mtMap50.passthrough())
    ])
  ),
  createdAt: mtMap50.objectField(
    "created_at",
    mtMap50.union([
      mtMap50.unionOption(
        "object",
        mtMap50.object({
          eq: mtMap50.objectField("eq", mtMap50.date()),
          gt: mtMap50.objectField("gt", mtMap50.date()),
          gte: mtMap50.objectField("gte", mtMap50.date()),
          lt: mtMap50.objectField("lt", mtMap50.date()),
          lte: mtMap50.objectField("lte", mtMap50.date())
        })
      ),
      mtMap50.unionOption("date", mtMap50.passthrough())
    ])
  ),
  sort: mtMap50.objectField(
    "sort",
    mtMap50.union([
      mtMap50.unionOption("string", mtMap50.passthrough()),
      mtMap50.unionOption(
        "array",
        mtMap50.union([
          mtMap50.unionOption(
            "object",
            mtMap50.object({
              field: mtMap50.objectField("field", mtMap50.passthrough()),
              order: mtMap50.objectField("order", mtMap50.passthrough())
            })
          )
        ])
      )
    ])
  ),
  groupId: mtMap50.objectField("group_id", mtMap50.passthrough()),
  userId: mtMap50.objectField("user_id", mtMap50.passthrough()),
  limit: mtMap50.objectField("limit", mtMap50.passthrough()),
  cursor: mtMap50.objectField("cursor", mtMap50.passthrough()),
  order: mtMap50.objectField("order", mtMap50.passthrough())
});

// src/resources/management/instances/groups/users/update.ts
import { mtMap as mtMap51 } from "@metorial/util-resource-mapper";
var mapManagementInstancesGroupsUsersUpdateOutput = mtMap51.object({
  id: mtMap51.objectField("id", mtMap51.passthrough()),
  status: mtMap51.objectField("status", mtMap51.passthrough()),
  groupId: mtMap51.objectField("group_id", mtMap51.passthrough()),
  roles: mtMap51.objectField(
    "roles",
    mtMap51.array(
      mtMap51.object({
        id: mtMap51.objectField("id", mtMap51.passthrough()),
        status: mtMap51.objectField("status", mtMap51.passthrough()),
        isDefault: mtMap51.objectField("is_default", mtMap51.passthrough()),
        slug: mtMap51.objectField("slug", mtMap51.passthrough()),
        name: mtMap51.objectField("name", mtMap51.passthrough()),
        description: mtMap51.objectField("description", mtMap51.passthrough()),
        permissions: mtMap51.objectField(
          "permissions",
          mtMap51.array(mtMap51.passthrough())
        ),
        createdAt: mtMap51.objectField("created_at", mtMap51.date()),
        updatedAt: mtMap51.objectField("updated_at", mtMap51.date())
      })
    )
  ),
  user: mtMap51.objectField(
    "user",
    mtMap51.object({
      id: mtMap51.objectField("id", mtMap51.passthrough()),
      status: mtMap51.objectField("status", mtMap51.passthrough()),
      type: mtMap51.objectField("type", mtMap51.passthrough()),
      name: mtMap51.objectField("name", mtMap51.passthrough()),
      email: mtMap51.objectField("email", mtMap51.passthrough()),
      metadata: mtMap51.objectField("metadata", mtMap51.passthrough()),
      defaultGroupId: mtMap51.objectField(
        "default_group_id",
        mtMap51.passthrough()
      ),
      createdAt: mtMap51.objectField("created_at", mtMap51.date()),
      updatedAt: mtMap51.objectField("updated_at", mtMap51.date())
    })
  )
});
var mapManagementInstancesGroupsUsersUpdateBody = mtMap51.object({
  roleIds: mtMap51.objectField("role_ids", mtMap51.array(mtMap51.passthrough()))
});

// src/resources/management/instances/instance/get.ts
import { mtMap as mtMap52 } from "@metorial/util-resource-mapper";
var mapManagementInstancesInstanceGetOutput = mtMap52.object({
  id: mtMap52.objectField("id", mtMap52.passthrough()),
  environment: mtMap52.objectField(
    "environment",
    mtMap52.object({
      id: mtMap52.objectField("id", mtMap52.passthrough()),
      type: mtMap52.objectField("type", mtMap52.passthrough()),
      name: mtMap52.objectField("name", mtMap52.passthrough()),
      createdAt: mtMap52.objectField("created_at", mtMap52.date()),
      updatedAt: mtMap52.objectField("updated_at", mtMap52.date())
    })
  ),
  project: mtMap52.objectField(
    "project",
    mtMap52.object({
      id: mtMap52.objectField("id", mtMap52.passthrough()),
      slug: mtMap52.objectField("slug", mtMap52.passthrough()),
      name: mtMap52.objectField("name", mtMap52.passthrough()),
      organizationId: mtMap52.objectField(
        "organization_id",
        mtMap52.passthrough()
      ),
      createdAt: mtMap52.objectField("created_at", mtMap52.date()),
      updatedAt: mtMap52.objectField("updated_at", mtMap52.date())
    })
  ),
  slug: mtMap52.objectField("slug", mtMap52.passthrough()),
  name: mtMap52.objectField("name", mtMap52.passthrough()),
  projectId: mtMap52.objectField("project_id", mtMap52.passthrough()),
  organizationId: mtMap52.objectField("organization_id", mtMap52.passthrough()),
  createdAt: mtMap52.objectField("created_at", mtMap52.date()),
  updatedAt: mtMap52.objectField("updated_at", mtMap52.date())
});

// src/resources/management/instances/policies/create.ts
import { mtMap as mtMap53 } from "@metorial/util-resource-mapper";
var mapManagementInstancesPoliciesCreateOutput = mtMap53.object({
  id: mtMap53.objectField("id", mtMap53.passthrough()),
  status: mtMap53.objectField("status", mtMap53.passthrough()),
  isDefault: mtMap53.objectField("is_default", mtMap53.passthrough()),
  slug: mtMap53.objectField("slug", mtMap53.passthrough()),
  name: mtMap53.objectField("name", mtMap53.passthrough()),
  description: mtMap53.objectField("description", mtMap53.passthrough()),
  entitlements: mtMap53.objectField(
    "entitlements",
    mtMap53.array(
      mtMap53.object({
        id: mtMap53.objectField("id", mtMap53.passthrough()),
        status: mtMap53.objectField("status", mtMap53.passthrough()),
        policyId: mtMap53.objectField("policy_id", mtMap53.passthrough()),
        type: mtMap53.objectField("type", mtMap53.passthrough()),
        amount: mtMap53.objectField("amount", mtMap53.passthrough()),
        windowDuration: mtMap53.objectField(
          "window_duration",
          mtMap53.object({
            size: mtMap53.objectField("size", mtMap53.passthrough()),
            unit: mtMap53.objectField("unit", mtMap53.passthrough())
          })
        ),
        overageBlockDuration: mtMap53.objectField(
          "overage_block_duration",
          mtMap53.object({
            size: mtMap53.objectField("size", mtMap53.passthrough()),
            unit: mtMap53.objectField("unit", mtMap53.passthrough())
          })
        ),
        agents: mtMap53.objectField(
          "agents",
          mtMap53.union([
            mtMap53.unionOption(
              "object",
              mtMap53.object({
                type: mtMap53.objectField("type", mtMap53.passthrough()),
                agentIds: mtMap53.objectField(
                  "agent_ids",
                  mtMap53.array(mtMap53.passthrough())
                )
              })
            )
          ])
        ),
        createdAt: mtMap53.objectField("created_at", mtMap53.date()),
        updatedAt: mtMap53.objectField("updated_at", mtMap53.date())
      })
    )
  ),
  createdAt: mtMap53.objectField("created_at", mtMap53.date()),
  updatedAt: mtMap53.objectField("updated_at", mtMap53.date())
});
var mapManagementInstancesPoliciesCreateBody = mtMap53.object({
  name: mtMap53.objectField("name", mtMap53.passthrough()),
  slug: mtMap53.objectField("slug", mtMap53.passthrough()),
  description: mtMap53.objectField("description", mtMap53.passthrough())
});

// src/resources/management/instances/policies/entitlements/create.ts
import { mtMap as mtMap54 } from "@metorial/util-resource-mapper";
var mapManagementInstancesPoliciesEntitlementsCreateOutput = mtMap54.object({
  id: mtMap54.objectField("id", mtMap54.passthrough()),
  status: mtMap54.objectField("status", mtMap54.passthrough()),
  isDefault: mtMap54.objectField("is_default", mtMap54.passthrough()),
  slug: mtMap54.objectField("slug", mtMap54.passthrough()),
  name: mtMap54.objectField("name", mtMap54.passthrough()),
  description: mtMap54.objectField("description", mtMap54.passthrough()),
  entitlements: mtMap54.objectField(
    "entitlements",
    mtMap54.array(
      mtMap54.object({
        id: mtMap54.objectField("id", mtMap54.passthrough()),
        status: mtMap54.objectField("status", mtMap54.passthrough()),
        policyId: mtMap54.objectField("policy_id", mtMap54.passthrough()),
        type: mtMap54.objectField("type", mtMap54.passthrough()),
        amount: mtMap54.objectField("amount", mtMap54.passthrough()),
        windowDuration: mtMap54.objectField(
          "window_duration",
          mtMap54.object({
            size: mtMap54.objectField("size", mtMap54.passthrough()),
            unit: mtMap54.objectField("unit", mtMap54.passthrough())
          })
        ),
        overageBlockDuration: mtMap54.objectField(
          "overage_block_duration",
          mtMap54.object({
            size: mtMap54.objectField("size", mtMap54.passthrough()),
            unit: mtMap54.objectField("unit", mtMap54.passthrough())
          })
        ),
        agents: mtMap54.objectField(
          "agents",
          mtMap54.union([
            mtMap54.unionOption(
              "object",
              mtMap54.object({
                type: mtMap54.objectField("type", mtMap54.passthrough()),
                agentIds: mtMap54.objectField(
                  "agent_ids",
                  mtMap54.array(mtMap54.passthrough())
                )
              })
            )
          ])
        ),
        createdAt: mtMap54.objectField("created_at", mtMap54.date()),
        updatedAt: mtMap54.objectField("updated_at", mtMap54.date())
      })
    )
  ),
  createdAt: mtMap54.objectField("created_at", mtMap54.date()),
  updatedAt: mtMap54.objectField("updated_at", mtMap54.date())
});
var mapManagementInstancesPoliciesEntitlementsCreateBody = mtMap54.object({
  type: mtMap54.objectField("type", mtMap54.passthrough()),
  amount: mtMap54.objectField("amount", mtMap54.passthrough()),
  windowDuration: mtMap54.objectField(
    "window_duration",
    mtMap54.object({
      size: mtMap54.objectField("size", mtMap54.passthrough()),
      unit: mtMap54.objectField("unit", mtMap54.passthrough())
    })
  ),
  overageBlockDuration: mtMap54.objectField(
    "overage_block_duration",
    mtMap54.object({
      size: mtMap54.objectField("size", mtMap54.passthrough()),
      unit: mtMap54.objectField("unit", mtMap54.passthrough())
    })
  ),
  allowAgents: mtMap54.objectField(
    "allow_agents",
    mtMap54.union([
      mtMap54.unionOption(
        "object",
        mtMap54.object({
          type: mtMap54.objectField("type", mtMap54.passthrough()),
          agentIds: mtMap54.objectField(
            "agent_ids",
            mtMap54.array(mtMap54.passthrough())
          )
        })
      )
    ])
  )
});

// src/resources/management/instances/policies/entitlements/delete.ts
import { mtMap as mtMap55 } from "@metorial/util-resource-mapper";
var mapManagementInstancesPoliciesEntitlementsDeleteOutput = mtMap55.object({
  id: mtMap55.objectField("id", mtMap55.passthrough()),
  status: mtMap55.objectField("status", mtMap55.passthrough()),
  isDefault: mtMap55.objectField("is_default", mtMap55.passthrough()),
  slug: mtMap55.objectField("slug", mtMap55.passthrough()),
  name: mtMap55.objectField("name", mtMap55.passthrough()),
  description: mtMap55.objectField("description", mtMap55.passthrough()),
  entitlements: mtMap55.objectField(
    "entitlements",
    mtMap55.array(
      mtMap55.object({
        id: mtMap55.objectField("id", mtMap55.passthrough()),
        status: mtMap55.objectField("status", mtMap55.passthrough()),
        policyId: mtMap55.objectField("policy_id", mtMap55.passthrough()),
        type: mtMap55.objectField("type", mtMap55.passthrough()),
        amount: mtMap55.objectField("amount", mtMap55.passthrough()),
        windowDuration: mtMap55.objectField(
          "window_duration",
          mtMap55.object({
            size: mtMap55.objectField("size", mtMap55.passthrough()),
            unit: mtMap55.objectField("unit", mtMap55.passthrough())
          })
        ),
        overageBlockDuration: mtMap55.objectField(
          "overage_block_duration",
          mtMap55.object({
            size: mtMap55.objectField("size", mtMap55.passthrough()),
            unit: mtMap55.objectField("unit", mtMap55.passthrough())
          })
        ),
        agents: mtMap55.objectField(
          "agents",
          mtMap55.union([
            mtMap55.unionOption(
              "object",
              mtMap55.object({
                type: mtMap55.objectField("type", mtMap55.passthrough()),
                agentIds: mtMap55.objectField(
                  "agent_ids",
                  mtMap55.array(mtMap55.passthrough())
                )
              })
            )
          ])
        ),
        createdAt: mtMap55.objectField("created_at", mtMap55.date()),
        updatedAt: mtMap55.objectField("updated_at", mtMap55.date())
      })
    )
  ),
  createdAt: mtMap55.objectField("created_at", mtMap55.date()),
  updatedAt: mtMap55.objectField("updated_at", mtMap55.date())
});

// src/resources/management/instances/policies/entitlements/update.ts
import { mtMap as mtMap56 } from "@metorial/util-resource-mapper";
var mapManagementInstancesPoliciesEntitlementsUpdateOutput = mtMap56.object({
  id: mtMap56.objectField("id", mtMap56.passthrough()),
  status: mtMap56.objectField("status", mtMap56.passthrough()),
  isDefault: mtMap56.objectField("is_default", mtMap56.passthrough()),
  slug: mtMap56.objectField("slug", mtMap56.passthrough()),
  name: mtMap56.objectField("name", mtMap56.passthrough()),
  description: mtMap56.objectField("description", mtMap56.passthrough()),
  entitlements: mtMap56.objectField(
    "entitlements",
    mtMap56.array(
      mtMap56.object({
        id: mtMap56.objectField("id", mtMap56.passthrough()),
        status: mtMap56.objectField("status", mtMap56.passthrough()),
        policyId: mtMap56.objectField("policy_id", mtMap56.passthrough()),
        type: mtMap56.objectField("type", mtMap56.passthrough()),
        amount: mtMap56.objectField("amount", mtMap56.passthrough()),
        windowDuration: mtMap56.objectField(
          "window_duration",
          mtMap56.object({
            size: mtMap56.objectField("size", mtMap56.passthrough()),
            unit: mtMap56.objectField("unit", mtMap56.passthrough())
          })
        ),
        overageBlockDuration: mtMap56.objectField(
          "overage_block_duration",
          mtMap56.object({
            size: mtMap56.objectField("size", mtMap56.passthrough()),
            unit: mtMap56.objectField("unit", mtMap56.passthrough())
          })
        ),
        agents: mtMap56.objectField(
          "agents",
          mtMap56.union([
            mtMap56.unionOption(
              "object",
              mtMap56.object({
                type: mtMap56.objectField("type", mtMap56.passthrough()),
                agentIds: mtMap56.objectField(
                  "agent_ids",
                  mtMap56.array(mtMap56.passthrough())
                )
              })
            )
          ])
        ),
        createdAt: mtMap56.objectField("created_at", mtMap56.date()),
        updatedAt: mtMap56.objectField("updated_at", mtMap56.date())
      })
    )
  ),
  createdAt: mtMap56.objectField("created_at", mtMap56.date()),
  updatedAt: mtMap56.objectField("updated_at", mtMap56.date())
});
var mapManagementInstancesPoliciesEntitlementsUpdateBody = mtMap56.object({
  amount: mtMap56.objectField("amount", mtMap56.passthrough()),
  windowDuration: mtMap56.objectField(
    "window_duration",
    mtMap56.object({
      size: mtMap56.objectField("size", mtMap56.passthrough()),
      unit: mtMap56.objectField("unit", mtMap56.passthrough())
    })
  ),
  overageBlockDuration: mtMap56.objectField(
    "overage_block_duration",
    mtMap56.object({
      size: mtMap56.objectField("size", mtMap56.passthrough()),
      unit: mtMap56.objectField("unit", mtMap56.passthrough())
    })
  ),
  allowAgents: mtMap56.objectField(
    "allow_agents",
    mtMap56.union([
      mtMap56.unionOption(
        "object",
        mtMap56.object({
          type: mtMap56.objectField("type", mtMap56.passthrough()),
          agentIds: mtMap56.objectField(
            "agent_ids",
            mtMap56.array(mtMap56.passthrough())
          )
        })
      )
    ])
  )
});

// src/resources/management/instances/policies/get.ts
import { mtMap as mtMap57 } from "@metorial/util-resource-mapper";
var mapManagementInstancesPoliciesGetOutput = mtMap57.object({
  id: mtMap57.objectField("id", mtMap57.passthrough()),
  status: mtMap57.objectField("status", mtMap57.passthrough()),
  isDefault: mtMap57.objectField("is_default", mtMap57.passthrough()),
  slug: mtMap57.objectField("slug", mtMap57.passthrough()),
  name: mtMap57.objectField("name", mtMap57.passthrough()),
  description: mtMap57.objectField("description", mtMap57.passthrough()),
  entitlements: mtMap57.objectField(
    "entitlements",
    mtMap57.array(
      mtMap57.object({
        id: mtMap57.objectField("id", mtMap57.passthrough()),
        status: mtMap57.objectField("status", mtMap57.passthrough()),
        policyId: mtMap57.objectField("policy_id", mtMap57.passthrough()),
        type: mtMap57.objectField("type", mtMap57.passthrough()),
        amount: mtMap57.objectField("amount", mtMap57.passthrough()),
        windowDuration: mtMap57.objectField(
          "window_duration",
          mtMap57.object({
            size: mtMap57.objectField("size", mtMap57.passthrough()),
            unit: mtMap57.objectField("unit", mtMap57.passthrough())
          })
        ),
        overageBlockDuration: mtMap57.objectField(
          "overage_block_duration",
          mtMap57.object({
            size: mtMap57.objectField("size", mtMap57.passthrough()),
            unit: mtMap57.objectField("unit", mtMap57.passthrough())
          })
        ),
        agents: mtMap57.objectField(
          "agents",
          mtMap57.union([
            mtMap57.unionOption(
              "object",
              mtMap57.object({
                type: mtMap57.objectField("type", mtMap57.passthrough()),
                agentIds: mtMap57.objectField(
                  "agent_ids",
                  mtMap57.array(mtMap57.passthrough())
                )
              })
            )
          ])
        ),
        createdAt: mtMap57.objectField("created_at", mtMap57.date()),
        updatedAt: mtMap57.objectField("updated_at", mtMap57.date())
      })
    )
  ),
  createdAt: mtMap57.objectField("created_at", mtMap57.date()),
  updatedAt: mtMap57.objectField("updated_at", mtMap57.date())
});

// src/resources/management/instances/policies/list.ts
import { mtMap as mtMap58 } from "@metorial/util-resource-mapper";
var mapManagementInstancesPoliciesListOutput = mtMap58.object({
  items: mtMap58.objectField(
    "items",
    mtMap58.array(
      mtMap58.object({
        id: mtMap58.objectField("id", mtMap58.passthrough()),
        status: mtMap58.objectField("status", mtMap58.passthrough()),
        isDefault: mtMap58.objectField("is_default", mtMap58.passthrough()),
        slug: mtMap58.objectField("slug", mtMap58.passthrough()),
        name: mtMap58.objectField("name", mtMap58.passthrough()),
        description: mtMap58.objectField("description", mtMap58.passthrough()),
        entitlements: mtMap58.objectField(
          "entitlements",
          mtMap58.array(
            mtMap58.object({
              id: mtMap58.objectField("id", mtMap58.passthrough()),
              status: mtMap58.objectField("status", mtMap58.passthrough()),
              policyId: mtMap58.objectField("policy_id", mtMap58.passthrough()),
              type: mtMap58.objectField("type", mtMap58.passthrough()),
              amount: mtMap58.objectField("amount", mtMap58.passthrough()),
              windowDuration: mtMap58.objectField(
                "window_duration",
                mtMap58.object({
                  size: mtMap58.objectField("size", mtMap58.passthrough()),
                  unit: mtMap58.objectField("unit", mtMap58.passthrough())
                })
              ),
              overageBlockDuration: mtMap58.objectField(
                "overage_block_duration",
                mtMap58.object({
                  size: mtMap58.objectField("size", mtMap58.passthrough()),
                  unit: mtMap58.objectField("unit", mtMap58.passthrough())
                })
              ),
              agents: mtMap58.objectField(
                "agents",
                mtMap58.union([
                  mtMap58.unionOption(
                    "object",
                    mtMap58.object({
                      type: mtMap58.objectField("type", mtMap58.passthrough()),
                      agentIds: mtMap58.objectField(
                        "agent_ids",
                        mtMap58.array(mtMap58.passthrough())
                      )
                    })
                  )
                ])
              ),
              createdAt: mtMap58.objectField("created_at", mtMap58.date()),
              updatedAt: mtMap58.objectField("updated_at", mtMap58.date())
            })
          )
        ),
        createdAt: mtMap58.objectField("created_at", mtMap58.date()),
        updatedAt: mtMap58.objectField("updated_at", mtMap58.date())
      })
    )
  ),
  pagination: mtMap58.objectField(
    "pagination",
    mtMap58.object({
      afterCursor: mtMap58.objectField("after_cursor", mtMap58.passthrough()),
      beforeCursor: mtMap58.objectField("before_cursor", mtMap58.passthrough()),
      hasMoreBefore: mtMap58.objectField(
        "has_more_before",
        mtMap58.passthrough()
      ),
      hasMoreAfter: mtMap58.objectField("has_more_after", mtMap58.passthrough()),
      pageSize: mtMap58.objectField("page_size", mtMap58.passthrough()),
      sort: mtMap58.objectField(
        "sort",
        mtMap58.array(
          mtMap58.object({
            field: mtMap58.objectField("field", mtMap58.passthrough()),
            order: mtMap58.objectField("order", mtMap58.passthrough())
          })
        )
      )
    })
  )
});
var mapManagementInstancesPoliciesListQuery = mtMap58.object({
  id: mtMap58.objectField(
    "id",
    mtMap58.union([
      mtMap58.unionOption(
        "object",
        mtMap58.object({
          in: mtMap58.objectField("in", mtMap58.array(mtMap58.passthrough())),
          eq: mtMap58.objectField("eq", mtMap58.passthrough())
        })
      ),
      mtMap58.unionOption("string", mtMap58.passthrough())
    ])
  ),
  ids: mtMap58.objectField(
    "ids",
    mtMap58.union([
      mtMap58.unionOption(
        "object",
        mtMap58.object({
          in: mtMap58.objectField("in", mtMap58.array(mtMap58.passthrough())),
          eq: mtMap58.objectField("eq", mtMap58.passthrough())
        })
      ),
      mtMap58.unionOption("string", mtMap58.passthrough())
    ])
  ),
  slug: mtMap58.objectField(
    "slug",
    mtMap58.union([
      mtMap58.unionOption(
        "object",
        mtMap58.object({
          in: mtMap58.objectField("in", mtMap58.array(mtMap58.passthrough())),
          eq: mtMap58.objectField("eq", mtMap58.passthrough())
        })
      ),
      mtMap58.unionOption("string", mtMap58.passthrough())
    ])
  ),
  slugs: mtMap58.objectField(
    "slugs",
    mtMap58.union([
      mtMap58.unionOption(
        "object",
        mtMap58.object({
          in: mtMap58.objectField("in", mtMap58.array(mtMap58.passthrough())),
          eq: mtMap58.objectField("eq", mtMap58.passthrough())
        })
      ),
      mtMap58.unionOption("string", mtMap58.passthrough())
    ])
  ),
  sort: mtMap58.objectField(
    "sort",
    mtMap58.union([
      mtMap58.unionOption("string", mtMap58.passthrough()),
      mtMap58.unionOption(
        "array",
        mtMap58.union([
          mtMap58.unionOption(
            "object",
            mtMap58.object({
              field: mtMap58.objectField("field", mtMap58.passthrough()),
              order: mtMap58.objectField("order", mtMap58.passthrough())
            })
          )
        ])
      )
    ])
  ),
  limit: mtMap58.objectField("limit", mtMap58.passthrough()),
  cursor: mtMap58.objectField("cursor", mtMap58.passthrough()),
  order: mtMap58.objectField("order", mtMap58.passthrough())
});

// src/resources/management/instances/policies/update.ts
import { mtMap as mtMap59 } from "@metorial/util-resource-mapper";
var mapManagementInstancesPoliciesUpdateOutput = mtMap59.object({
  id: mtMap59.objectField("id", mtMap59.passthrough()),
  status: mtMap59.objectField("status", mtMap59.passthrough()),
  isDefault: mtMap59.objectField("is_default", mtMap59.passthrough()),
  slug: mtMap59.objectField("slug", mtMap59.passthrough()),
  name: mtMap59.objectField("name", mtMap59.passthrough()),
  description: mtMap59.objectField("description", mtMap59.passthrough()),
  entitlements: mtMap59.objectField(
    "entitlements",
    mtMap59.array(
      mtMap59.object({
        id: mtMap59.objectField("id", mtMap59.passthrough()),
        status: mtMap59.objectField("status", mtMap59.passthrough()),
        policyId: mtMap59.objectField("policy_id", mtMap59.passthrough()),
        type: mtMap59.objectField("type", mtMap59.passthrough()),
        amount: mtMap59.objectField("amount", mtMap59.passthrough()),
        windowDuration: mtMap59.objectField(
          "window_duration",
          mtMap59.object({
            size: mtMap59.objectField("size", mtMap59.passthrough()),
            unit: mtMap59.objectField("unit", mtMap59.passthrough())
          })
        ),
        overageBlockDuration: mtMap59.objectField(
          "overage_block_duration",
          mtMap59.object({
            size: mtMap59.objectField("size", mtMap59.passthrough()),
            unit: mtMap59.objectField("unit", mtMap59.passthrough())
          })
        ),
        agents: mtMap59.objectField(
          "agents",
          mtMap59.union([
            mtMap59.unionOption(
              "object",
              mtMap59.object({
                type: mtMap59.objectField("type", mtMap59.passthrough()),
                agentIds: mtMap59.objectField(
                  "agent_ids",
                  mtMap59.array(mtMap59.passthrough())
                )
              })
            )
          ])
        ),
        createdAt: mtMap59.objectField("created_at", mtMap59.date()),
        updatedAt: mtMap59.objectField("updated_at", mtMap59.date())
      })
    )
  ),
  createdAt: mtMap59.objectField("created_at", mtMap59.date()),
  updatedAt: mtMap59.objectField("updated_at", mtMap59.date())
});
var mapManagementInstancesPoliciesUpdateBody = mtMap59.object({
  name: mtMap59.objectField("name", mtMap59.passthrough()),
  slug: mtMap59.objectField("slug", mtMap59.passthrough()),
  description: mtMap59.objectField("description", mtMap59.passthrough()),
  isDefault: mtMap59.objectField("is_default", mtMap59.passthrough())
});

// src/resources/management/instances/portals/agents/create.ts
import { mtMap as mtMap60 } from "@metorial/util-resource-mapper";
var mapManagementInstancesPortalsAgentsCreateOutput = mtMap60.object({
  id: mtMap60.objectField("id", mtMap60.passthrough()),
  status: mtMap60.objectField("status", mtMap60.passthrough()),
  name: mtMap60.objectField("name", mtMap60.passthrough()),
  slug: mtMap60.objectField("slug", mtMap60.passthrough()),
  description: mtMap60.objectField("description", mtMap60.passthrough()),
  portalId: mtMap60.objectField("portal_id", mtMap60.passthrough()),
  agentId: mtMap60.objectField("agent_id", mtMap60.passthrough()),
  createdAt: mtMap60.objectField("created_at", mtMap60.date()),
  updatedAt: mtMap60.objectField("updated_at", mtMap60.date())
});
var mapManagementInstancesPortalsAgentsCreateBody = mtMap60.object({
  name: mtMap60.objectField("name", mtMap60.passthrough()),
  description: mtMap60.objectField("description", mtMap60.passthrough()),
  agentId: mtMap60.objectField("agent_id", mtMap60.passthrough())
});

// src/resources/management/instances/portals/agents/delete.ts
import { mtMap as mtMap61 } from "@metorial/util-resource-mapper";
var mapManagementInstancesPortalsAgentsDeleteOutput = mtMap61.object({
  id: mtMap61.objectField("id", mtMap61.passthrough()),
  status: mtMap61.objectField("status", mtMap61.passthrough()),
  name: mtMap61.objectField("name", mtMap61.passthrough()),
  slug: mtMap61.objectField("slug", mtMap61.passthrough()),
  description: mtMap61.objectField("description", mtMap61.passthrough()),
  portalId: mtMap61.objectField("portal_id", mtMap61.passthrough()),
  agentId: mtMap61.objectField("agent_id", mtMap61.passthrough()),
  createdAt: mtMap61.objectField("created_at", mtMap61.date()),
  updatedAt: mtMap61.objectField("updated_at", mtMap61.date())
});

// src/resources/management/instances/portals/agents/get.ts
import { mtMap as mtMap62 } from "@metorial/util-resource-mapper";
var mapManagementInstancesPortalsAgentsGetOutput = mtMap62.object({
  id: mtMap62.objectField("id", mtMap62.passthrough()),
  status: mtMap62.objectField("status", mtMap62.passthrough()),
  name: mtMap62.objectField("name", mtMap62.passthrough()),
  slug: mtMap62.objectField("slug", mtMap62.passthrough()),
  description: mtMap62.objectField("description", mtMap62.passthrough()),
  portalId: mtMap62.objectField("portal_id", mtMap62.passthrough()),
  agentId: mtMap62.objectField("agent_id", mtMap62.passthrough()),
  createdAt: mtMap62.objectField("created_at", mtMap62.date()),
  updatedAt: mtMap62.objectField("updated_at", mtMap62.date())
});

// src/resources/management/instances/portals/agents/list.ts
import { mtMap as mtMap63 } from "@metorial/util-resource-mapper";
var mapManagementInstancesPortalsAgentsListOutput = mtMap63.object({
  items: mtMap63.objectField(
    "items",
    mtMap63.array(
      mtMap63.object({
        id: mtMap63.objectField("id", mtMap63.passthrough()),
        status: mtMap63.objectField("status", mtMap63.passthrough()),
        name: mtMap63.objectField("name", mtMap63.passthrough()),
        slug: mtMap63.objectField("slug", mtMap63.passthrough()),
        description: mtMap63.objectField("description", mtMap63.passthrough()),
        portalId: mtMap63.objectField("portal_id", mtMap63.passthrough()),
        agentId: mtMap63.objectField("agent_id", mtMap63.passthrough()),
        createdAt: mtMap63.objectField("created_at", mtMap63.date()),
        updatedAt: mtMap63.objectField("updated_at", mtMap63.date())
      })
    )
  ),
  pagination: mtMap63.objectField(
    "pagination",
    mtMap63.object({
      afterCursor: mtMap63.objectField("after_cursor", mtMap63.passthrough()),
      beforeCursor: mtMap63.objectField("before_cursor", mtMap63.passthrough()),
      hasMoreBefore: mtMap63.objectField(
        "has_more_before",
        mtMap63.passthrough()
      ),
      hasMoreAfter: mtMap63.objectField("has_more_after", mtMap63.passthrough()),
      pageSize: mtMap63.objectField("page_size", mtMap63.passthrough()),
      sort: mtMap63.objectField(
        "sort",
        mtMap63.array(
          mtMap63.object({
            field: mtMap63.objectField("field", mtMap63.passthrough()),
            order: mtMap63.objectField("order", mtMap63.passthrough())
          })
        )
      )
    })
  )
});
var mapManagementInstancesPortalsAgentsListQuery = mtMap63.object({
  id: mtMap63.objectField(
    "id",
    mtMap63.union([
      mtMap63.unionOption(
        "object",
        mtMap63.object({
          in: mtMap63.objectField("in", mtMap63.array(mtMap63.passthrough())),
          eq: mtMap63.objectField("eq", mtMap63.passthrough())
        })
      ),
      mtMap63.unionOption("string", mtMap63.passthrough())
    ])
  ),
  ids: mtMap63.objectField(
    "ids",
    mtMap63.union([
      mtMap63.unionOption(
        "object",
        mtMap63.object({
          in: mtMap63.objectField("in", mtMap63.array(mtMap63.passthrough())),
          eq: mtMap63.objectField("eq", mtMap63.passthrough())
        })
      ),
      mtMap63.unionOption("string", mtMap63.passthrough())
    ])
  ),
  slug: mtMap63.objectField(
    "slug",
    mtMap63.union([
      mtMap63.unionOption(
        "object",
        mtMap63.object({
          in: mtMap63.objectField("in", mtMap63.array(mtMap63.passthrough())),
          eq: mtMap63.objectField("eq", mtMap63.passthrough())
        })
      ),
      mtMap63.unionOption("string", mtMap63.passthrough())
    ])
  ),
  slugs: mtMap63.objectField(
    "slugs",
    mtMap63.union([
      mtMap63.unionOption(
        "object",
        mtMap63.object({
          in: mtMap63.objectField("in", mtMap63.array(mtMap63.passthrough())),
          eq: mtMap63.objectField("eq", mtMap63.passthrough())
        })
      ),
      mtMap63.unionOption("string", mtMap63.passthrough())
    ])
  ),
  sort: mtMap63.objectField(
    "sort",
    mtMap63.union([
      mtMap63.unionOption("string", mtMap63.passthrough()),
      mtMap63.unionOption(
        "array",
        mtMap63.union([
          mtMap63.unionOption(
            "object",
            mtMap63.object({
              field: mtMap63.objectField("field", mtMap63.passthrough()),
              order: mtMap63.objectField("order", mtMap63.passthrough())
            })
          )
        ])
      )
    ])
  ),
  portalId: mtMap63.objectField("portalId", mtMap63.passthrough()),
  limit: mtMap63.objectField("limit", mtMap63.passthrough()),
  cursor: mtMap63.objectField("cursor", mtMap63.passthrough()),
  order: mtMap63.objectField("order", mtMap63.passthrough())
});

// src/resources/management/instances/portals/agents/update.ts
import { mtMap as mtMap64 } from "@metorial/util-resource-mapper";
var mapManagementInstancesPortalsAgentsUpdateOutput = mtMap64.object({
  id: mtMap64.objectField("id", mtMap64.passthrough()),
  status: mtMap64.objectField("status", mtMap64.passthrough()),
  name: mtMap64.objectField("name", mtMap64.passthrough()),
  slug: mtMap64.objectField("slug", mtMap64.passthrough()),
  description: mtMap64.objectField("description", mtMap64.passthrough()),
  portalId: mtMap64.objectField("portal_id", mtMap64.passthrough()),
  agentId: mtMap64.objectField("agent_id", mtMap64.passthrough()),
  createdAt: mtMap64.objectField("created_at", mtMap64.date()),
  updatedAt: mtMap64.objectField("updated_at", mtMap64.date())
});
var mapManagementInstancesPortalsAgentsUpdateBody = mtMap64.object({
  name: mtMap64.objectField("name", mtMap64.passthrough()),
  description: mtMap64.objectField("description", mtMap64.passthrough())
});

// src/resources/management/instances/portals/create.ts
import { mtMap as mtMap65 } from "@metorial/util-resource-mapper";
var mapManagementInstancesPortalsCreateOutput = mtMap65.object({
  id: mtMap65.objectField("id", mtMap65.passthrough()),
  type: mtMap65.objectField("type", mtMap65.passthrough()),
  status: mtMap65.objectField("status", mtMap65.passthrough()),
  organizationId: mtMap65.objectField("organization_id", mtMap65.passthrough()),
  projectId: mtMap65.objectField("project_id", mtMap65.passthrough()),
  name: mtMap65.objectField("name", mtMap65.passthrough()),
  slug: mtMap65.objectField("slug", mtMap65.passthrough()),
  publicName: mtMap65.objectField("public_name", mtMap65.passthrough()),
  createdAt: mtMap65.objectField("created_at", mtMap65.date()),
  updatedAt: mtMap65.objectField("updated_at", mtMap65.date())
});
var mapManagementInstancesPortalsCreateBody = mtMap65.object({
  name: mtMap65.objectField("name", mtMap65.passthrough()),
  type: mtMap65.objectField("type", mtMap65.passthrough())
});

// src/resources/management/instances/portals/delete.ts
import { mtMap as mtMap66 } from "@metorial/util-resource-mapper";
var mapManagementInstancesPortalsDeleteOutput = mtMap66.object({
  id: mtMap66.objectField("id", mtMap66.passthrough()),
  type: mtMap66.objectField("type", mtMap66.passthrough()),
  status: mtMap66.objectField("status", mtMap66.passthrough()),
  organizationId: mtMap66.objectField("organization_id", mtMap66.passthrough()),
  projectId: mtMap66.objectField("project_id", mtMap66.passthrough()),
  name: mtMap66.objectField("name", mtMap66.passthrough()),
  slug: mtMap66.objectField("slug", mtMap66.passthrough()),
  publicName: mtMap66.objectField("public_name", mtMap66.passthrough()),
  createdAt: mtMap66.objectField("created_at", mtMap66.date()),
  updatedAt: mtMap66.objectField("updated_at", mtMap66.date())
});

// src/resources/management/instances/portals/get.ts
import { mtMap as mtMap67 } from "@metorial/util-resource-mapper";
var mapManagementInstancesPortalsGetOutput = mtMap67.object({
  id: mtMap67.objectField("id", mtMap67.passthrough()),
  type: mtMap67.objectField("type", mtMap67.passthrough()),
  status: mtMap67.objectField("status", mtMap67.passthrough()),
  organizationId: mtMap67.objectField("organization_id", mtMap67.passthrough()),
  projectId: mtMap67.objectField("project_id", mtMap67.passthrough()),
  name: mtMap67.objectField("name", mtMap67.passthrough()),
  slug: mtMap67.objectField("slug", mtMap67.passthrough()),
  publicName: mtMap67.objectField("public_name", mtMap67.passthrough()),
  createdAt: mtMap67.objectField("created_at", mtMap67.date()),
  updatedAt: mtMap67.objectField("updated_at", mtMap67.date())
});

// src/resources/management/instances/portals/list.ts
import { mtMap as mtMap68 } from "@metorial/util-resource-mapper";
var mapManagementInstancesPortalsListOutput = mtMap68.object({
  items: mtMap68.objectField(
    "items",
    mtMap68.array(
      mtMap68.object({
        id: mtMap68.objectField("id", mtMap68.passthrough()),
        type: mtMap68.objectField("type", mtMap68.passthrough()),
        status: mtMap68.objectField("status", mtMap68.passthrough()),
        organizationId: mtMap68.objectField(
          "organization_id",
          mtMap68.passthrough()
        ),
        projectId: mtMap68.objectField("project_id", mtMap68.passthrough()),
        name: mtMap68.objectField("name", mtMap68.passthrough()),
        slug: mtMap68.objectField("slug", mtMap68.passthrough()),
        publicName: mtMap68.objectField("public_name", mtMap68.passthrough()),
        createdAt: mtMap68.objectField("created_at", mtMap68.date()),
        updatedAt: mtMap68.objectField("updated_at", mtMap68.date())
      })
    )
  ),
  pagination: mtMap68.objectField(
    "pagination",
    mtMap68.object({
      afterCursor: mtMap68.objectField("after_cursor", mtMap68.passthrough()),
      beforeCursor: mtMap68.objectField("before_cursor", mtMap68.passthrough()),
      hasMoreBefore: mtMap68.objectField(
        "has_more_before",
        mtMap68.passthrough()
      ),
      hasMoreAfter: mtMap68.objectField("has_more_after", mtMap68.passthrough()),
      pageSize: mtMap68.objectField("page_size", mtMap68.passthrough()),
      sort: mtMap68.objectField(
        "sort",
        mtMap68.array(
          mtMap68.object({
            field: mtMap68.objectField("field", mtMap68.passthrough()),
            order: mtMap68.objectField("order", mtMap68.passthrough())
          })
        )
      )
    })
  )
});
var mapManagementInstancesPortalsListQuery = mtMap68.object({
  id: mtMap68.objectField(
    "id",
    mtMap68.union([
      mtMap68.unionOption(
        "object",
        mtMap68.object({
          in: mtMap68.objectField("in", mtMap68.array(mtMap68.passthrough())),
          eq: mtMap68.objectField("eq", mtMap68.passthrough())
        })
      ),
      mtMap68.unionOption("string", mtMap68.passthrough())
    ])
  ),
  ids: mtMap68.objectField(
    "ids",
    mtMap68.union([
      mtMap68.unionOption(
        "object",
        mtMap68.object({
          in: mtMap68.objectField("in", mtMap68.array(mtMap68.passthrough())),
          eq: mtMap68.objectField("eq", mtMap68.passthrough())
        })
      ),
      mtMap68.unionOption("string", mtMap68.passthrough())
    ])
  ),
  slug: mtMap68.objectField(
    "slug",
    mtMap68.union([
      mtMap68.unionOption(
        "object",
        mtMap68.object({
          in: mtMap68.objectField("in", mtMap68.array(mtMap68.passthrough())),
          eq: mtMap68.objectField("eq", mtMap68.passthrough())
        })
      ),
      mtMap68.unionOption("string", mtMap68.passthrough())
    ])
  ),
  slugs: mtMap68.objectField(
    "slugs",
    mtMap68.union([
      mtMap68.unionOption(
        "object",
        mtMap68.object({
          in: mtMap68.objectField("in", mtMap68.array(mtMap68.passthrough())),
          eq: mtMap68.objectField("eq", mtMap68.passthrough())
        })
      ),
      mtMap68.unionOption("string", mtMap68.passthrough())
    ])
  ),
  sort: mtMap68.objectField(
    "sort",
    mtMap68.union([
      mtMap68.unionOption("string", mtMap68.passthrough()),
      mtMap68.unionOption(
        "array",
        mtMap68.union([
          mtMap68.unionOption(
            "object",
            mtMap68.object({
              field: mtMap68.objectField("field", mtMap68.passthrough()),
              order: mtMap68.objectField("order", mtMap68.passthrough())
            })
          )
        ])
      )
    ])
  ),
  limit: mtMap68.objectField("limit", mtMap68.passthrough()),
  cursor: mtMap68.objectField("cursor", mtMap68.passthrough()),
  order: mtMap68.objectField("order", mtMap68.passthrough())
});

// src/resources/management/instances/portals/update.ts
import { mtMap as mtMap69 } from "@metorial/util-resource-mapper";
var mapManagementInstancesPortalsUpdateOutput = mtMap69.object({
  id: mtMap69.objectField("id", mtMap69.passthrough()),
  type: mtMap69.objectField("type", mtMap69.passthrough()),
  status: mtMap69.objectField("status", mtMap69.passthrough()),
  organizationId: mtMap69.objectField("organization_id", mtMap69.passthrough()),
  projectId: mtMap69.objectField("project_id", mtMap69.passthrough()),
  name: mtMap69.objectField("name", mtMap69.passthrough()),
  slug: mtMap69.objectField("slug", mtMap69.passthrough()),
  publicName: mtMap69.objectField("public_name", mtMap69.passthrough()),
  createdAt: mtMap69.objectField("created_at", mtMap69.date()),
  updatedAt: mtMap69.objectField("updated_at", mtMap69.date())
});
var mapManagementInstancesPortalsUpdateBody = mtMap69.object({
  name: mtMap69.objectField("name", mtMap69.passthrough())
});

// src/resources/management/instances/roles/create.ts
import { mtMap as mtMap70 } from "@metorial/util-resource-mapper";
var mapManagementInstancesRolesCreateOutput = mtMap70.object({
  id: mtMap70.objectField("id", mtMap70.passthrough()),
  status: mtMap70.objectField("status", mtMap70.passthrough()),
  isDefault: mtMap70.objectField("is_default", mtMap70.passthrough()),
  slug: mtMap70.objectField("slug", mtMap70.passthrough()),
  name: mtMap70.objectField("name", mtMap70.passthrough()),
  description: mtMap70.objectField("description", mtMap70.passthrough()),
  permissions: mtMap70.objectField(
    "permissions",
    mtMap70.array(mtMap70.passthrough())
  ),
  createdAt: mtMap70.objectField("created_at", mtMap70.date()),
  updatedAt: mtMap70.objectField("updated_at", mtMap70.date())
});
var mapManagementInstancesRolesCreateBody = mtMap70.object({
  name: mtMap70.objectField("name", mtMap70.passthrough()),
  slug: mtMap70.objectField("slug", mtMap70.passthrough()),
  description: mtMap70.objectField("description", mtMap70.passthrough()),
  permissions: mtMap70.objectField(
    "permissions",
    mtMap70.array(mtMap70.passthrough())
  )
});

// src/resources/management/instances/roles/get.ts
import { mtMap as mtMap71 } from "@metorial/util-resource-mapper";
var mapManagementInstancesRolesGetOutput = mtMap71.object({
  id: mtMap71.objectField("id", mtMap71.passthrough()),
  status: mtMap71.objectField("status", mtMap71.passthrough()),
  isDefault: mtMap71.objectField("is_default", mtMap71.passthrough()),
  slug: mtMap71.objectField("slug", mtMap71.passthrough()),
  name: mtMap71.objectField("name", mtMap71.passthrough()),
  description: mtMap71.objectField("description", mtMap71.passthrough()),
  permissions: mtMap71.objectField(
    "permissions",
    mtMap71.array(mtMap71.passthrough())
  ),
  createdAt: mtMap71.objectField("created_at", mtMap71.date()),
  updatedAt: mtMap71.objectField("updated_at", mtMap71.date())
});

// src/resources/management/instances/roles/list.ts
import { mtMap as mtMap72 } from "@metorial/util-resource-mapper";
var mapManagementInstancesRolesListOutput = mtMap72.object({
  items: mtMap72.objectField(
    "items",
    mtMap72.array(
      mtMap72.object({
        id: mtMap72.objectField("id", mtMap72.passthrough()),
        status: mtMap72.objectField("status", mtMap72.passthrough()),
        isDefault: mtMap72.objectField("is_default", mtMap72.passthrough()),
        slug: mtMap72.objectField("slug", mtMap72.passthrough()),
        name: mtMap72.objectField("name", mtMap72.passthrough()),
        description: mtMap72.objectField("description", mtMap72.passthrough()),
        permissions: mtMap72.objectField(
          "permissions",
          mtMap72.array(mtMap72.passthrough())
        ),
        createdAt: mtMap72.objectField("created_at", mtMap72.date()),
        updatedAt: mtMap72.objectField("updated_at", mtMap72.date())
      })
    )
  ),
  pagination: mtMap72.objectField(
    "pagination",
    mtMap72.object({
      afterCursor: mtMap72.objectField("after_cursor", mtMap72.passthrough()),
      beforeCursor: mtMap72.objectField("before_cursor", mtMap72.passthrough()),
      hasMoreBefore: mtMap72.objectField(
        "has_more_before",
        mtMap72.passthrough()
      ),
      hasMoreAfter: mtMap72.objectField("has_more_after", mtMap72.passthrough()),
      pageSize: mtMap72.objectField("page_size", mtMap72.passthrough()),
      sort: mtMap72.objectField(
        "sort",
        mtMap72.array(
          mtMap72.object({
            field: mtMap72.objectField("field", mtMap72.passthrough()),
            order: mtMap72.objectField("order", mtMap72.passthrough())
          })
        )
      )
    })
  )
});
var mapManagementInstancesRolesListQuery = mtMap72.object({
  id: mtMap72.objectField(
    "id",
    mtMap72.union([
      mtMap72.unionOption(
        "object",
        mtMap72.object({
          in: mtMap72.objectField("in", mtMap72.array(mtMap72.passthrough())),
          eq: mtMap72.objectField("eq", mtMap72.passthrough())
        })
      ),
      mtMap72.unionOption("string", mtMap72.passthrough())
    ])
  ),
  ids: mtMap72.objectField(
    "ids",
    mtMap72.union([
      mtMap72.unionOption(
        "object",
        mtMap72.object({
          in: mtMap72.objectField("in", mtMap72.array(mtMap72.passthrough())),
          eq: mtMap72.objectField("eq", mtMap72.passthrough())
        })
      ),
      mtMap72.unionOption("string", mtMap72.passthrough())
    ])
  ),
  slug: mtMap72.objectField(
    "slug",
    mtMap72.union([
      mtMap72.unionOption(
        "object",
        mtMap72.object({
          in: mtMap72.objectField("in", mtMap72.array(mtMap72.passthrough())),
          eq: mtMap72.objectField("eq", mtMap72.passthrough())
        })
      ),
      mtMap72.unionOption("string", mtMap72.passthrough())
    ])
  ),
  slugs: mtMap72.objectField(
    "slugs",
    mtMap72.union([
      mtMap72.unionOption(
        "object",
        mtMap72.object({
          in: mtMap72.objectField("in", mtMap72.array(mtMap72.passthrough())),
          eq: mtMap72.objectField("eq", mtMap72.passthrough())
        })
      ),
      mtMap72.unionOption("string", mtMap72.passthrough())
    ])
  ),
  sort: mtMap72.objectField(
    "sort",
    mtMap72.union([
      mtMap72.unionOption("string", mtMap72.passthrough()),
      mtMap72.unionOption(
        "array",
        mtMap72.union([
          mtMap72.unionOption(
            "object",
            mtMap72.object({
              field: mtMap72.objectField("field", mtMap72.passthrough()),
              order: mtMap72.objectField("order", mtMap72.passthrough())
            })
          )
        ])
      )
    ])
  ),
  limit: mtMap72.objectField("limit", mtMap72.passthrough()),
  cursor: mtMap72.objectField("cursor", mtMap72.passthrough()),
  order: mtMap72.objectField("order", mtMap72.passthrough())
});

// src/resources/management/instances/roles/update.ts
import { mtMap as mtMap73 } from "@metorial/util-resource-mapper";
var mapManagementInstancesRolesUpdateOutput = mtMap73.object({
  id: mtMap73.objectField("id", mtMap73.passthrough()),
  status: mtMap73.objectField("status", mtMap73.passthrough()),
  isDefault: mtMap73.objectField("is_default", mtMap73.passthrough()),
  slug: mtMap73.objectField("slug", mtMap73.passthrough()),
  name: mtMap73.objectField("name", mtMap73.passthrough()),
  description: mtMap73.objectField("description", mtMap73.passthrough()),
  permissions: mtMap73.objectField(
    "permissions",
    mtMap73.array(mtMap73.passthrough())
  ),
  createdAt: mtMap73.objectField("created_at", mtMap73.date()),
  updatedAt: mtMap73.objectField("updated_at", mtMap73.date())
});
var mapManagementInstancesRolesUpdateBody = mtMap73.object({
  name: mtMap73.objectField("name", mtMap73.passthrough()),
  slug: mtMap73.objectField("slug", mtMap73.passthrough()),
  description: mtMap73.objectField("description", mtMap73.passthrough()),
  isDefault: mtMap73.objectField("is_default", mtMap73.passthrough()),
  permissions: mtMap73.objectField(
    "permissions",
    mtMap73.array(mtMap73.passthrough())
  )
});

// src/resources/management/instances/runs/create.ts
import { mtMap as mtMap74 } from "@metorial/util-resource-mapper";
var mapManagementInstancesRunsCreateOutput = mtMap74.object({
  id: mtMap74.objectField("id", mtMap74.passthrough()),
  status: mtMap74.objectField("status", mtMap74.passthrough()),
  agentId: mtMap74.objectField("agent_id", mtMap74.passthrough()),
  triggerMessageGroupId: mtMap74.objectField(
    "trigger_message_group_id",
    mtMap74.passthrough()
  ),
  cost: mtMap74.objectField(
    "cost",
    mtMap74.object({
      amount: mtMap74.objectField("amount", mtMap74.passthrough()),
      unit: mtMap74.objectField("unit", mtMap74.passthrough())
    })
  ),
  messageGroup: mtMap74.objectField(
    "message_group",
    mtMap74.object({
      id: mtMap74.objectField("id", mtMap74.passthrough()),
      status: mtMap74.objectField("status", mtMap74.passthrough()),
      type: mtMap74.objectField("type", mtMap74.passthrough()),
      interactionId: mtMap74.objectField("interaction_id", mtMap74.passthrough()),
      createdAt: mtMap74.objectField("created_at", mtMap74.date()),
      threadId: mtMap74.objectField("thread_id", mtMap74.passthrough()),
      parentMessageGroupId: mtMap74.objectField(
        "parent_message_group_id",
        mtMap74.passthrough()
      ),
      messages: mtMap74.objectField(
        "messages",
        mtMap74.array(
          mtMap74.object({
            id: mtMap74.objectField("id", mtMap74.passthrough()),
            type: mtMap74.objectField("type", mtMap74.passthrough()),
            status: mtMap74.objectField("status", mtMap74.passthrough()),
            messageGroupId: mtMap74.objectField(
              "message_group_id",
              mtMap74.passthrough()
            ),
            threadId: mtMap74.objectField("thread_id", mtMap74.passthrough()),
            actor: mtMap74.objectField(
              "actor",
              mtMap74.object({
                id: mtMap74.objectField("id", mtMap74.passthrough()),
                name: mtMap74.objectField("name", mtMap74.passthrough()),
                type: mtMap74.objectField("type", mtMap74.passthrough()),
                metadata: mtMap74.objectField("metadata", mtMap74.passthrough()),
                createdAt: mtMap74.objectField("created_at", mtMap74.date()),
                updatedAt: mtMap74.objectField("updated_at", mtMap74.date())
              })
            ),
            content: mtMap74.objectField(
              "content",
              mtMap74.object({
                id: mtMap74.objectField("id", mtMap74.passthrough()),
                version: mtMap74.objectField("version", mtMap74.passthrough()),
                messageItemId: mtMap74.objectField(
                  "message_item_id",
                  mtMap74.passthrough()
                ),
                attachments: mtMap74.objectField(
                  "attachments",
                  mtMap74.array(
                    mtMap74.union([
                      mtMap74.unionOption(
                        "object",
                        mtMap74.object({
                          id: mtMap74.objectField("id", mtMap74.passthrough()),
                          type: mtMap74.objectField(
                            "type",
                            mtMap74.passthrough()
                          ),
                          fileId: mtMap74.objectField(
                            "file_id",
                            mtMap74.passthrough()
                          ),
                          url: mtMap74.objectField("url", mtMap74.passthrough()),
                          caption: mtMap74.objectField(
                            "caption",
                            mtMap74.object({
                              text: mtMap74.objectField(
                                "text",
                                mtMap74.passthrough()
                              )
                            })
                          ),
                          mimeType: mtMap74.objectField(
                            "mime_type",
                            mtMap74.passthrough()
                          ),
                          entryId: mtMap74.objectField(
                            "entry_id",
                            mtMap74.passthrough()
                          )
                        })
                      )
                    ])
                  )
                ),
                parts: mtMap74.objectField(
                  "parts",
                  mtMap74.array(
                    mtMap74.union([
                      mtMap74.unionOption(
                        "object",
                        mtMap74.object({
                          id: mtMap74.objectField("id", mtMap74.passthrough()),
                          type: mtMap74.objectField(
                            "type",
                            mtMap74.passthrough()
                          ),
                          mimeType: mtMap74.objectField(
                            "mime_type",
                            mtMap74.passthrough()
                          ),
                          text: mtMap74.objectField(
                            "text",
                            mtMap74.passthrough()
                          ),
                          kind: mtMap74.objectField(
                            "kind",
                            mtMap74.passthrough()
                          ),
                          attachment: mtMap74.objectField(
                            "attachment",
                            mtMap74.union([
                              mtMap74.unionOption(
                                "object",
                                mtMap74.object({
                                  id: mtMap74.objectField(
                                    "id",
                                    mtMap74.passthrough()
                                  ),
                                  type: mtMap74.objectField(
                                    "type",
                                    mtMap74.passthrough()
                                  ),
                                  fileId: mtMap74.objectField(
                                    "file_id",
                                    mtMap74.passthrough()
                                  ),
                                  url: mtMap74.objectField(
                                    "url",
                                    mtMap74.passthrough()
                                  ),
                                  caption: mtMap74.objectField(
                                    "caption",
                                    mtMap74.object({
                                      text: mtMap74.objectField(
                                        "text",
                                        mtMap74.passthrough()
                                      )
                                    })
                                  ),
                                  mimeType: mtMap74.objectField(
                                    "mime_type",
                                    mtMap74.passthrough()
                                  ),
                                  entryId: mtMap74.objectField(
                                    "entry_id",
                                    mtMap74.passthrough()
                                  )
                                })
                              )
                            ])
                          )
                        })
                      )
                    ])
                  )
                )
              })
            ),
            error: mtMap74.objectField(
              "error",
              mtMap74.object({
                type: mtMap74.objectField("type", mtMap74.passthrough()),
                message: mtMap74.objectField("message", mtMap74.passthrough())
              })
            ),
            createdAt: mtMap74.objectField("created_at", mtMap74.date())
          })
        )
      ),
      attachedItems: mtMap74.objectField(
        "attached_items",
        mtMap74.array(
          mtMap74.object({
            id: mtMap74.objectField("id", mtMap74.passthrough()),
            actor: mtMap74.objectField(
              "actor",
              mtMap74.object({
                id: mtMap74.objectField("id", mtMap74.passthrough()),
                name: mtMap74.objectField("name", mtMap74.passthrough()),
                type: mtMap74.objectField("type", mtMap74.passthrough()),
                metadata: mtMap74.objectField("metadata", mtMap74.passthrough()),
                createdAt: mtMap74.objectField("created_at", mtMap74.date()),
                updatedAt: mtMap74.objectField("updated_at", mtMap74.date())
              })
            ),
            key: mtMap74.objectField("key", mtMap74.passthrough()),
            value: mtMap74.objectField("value", mtMap74.passthrough()),
            createdAt: mtMap74.objectField("created_at", mtMap74.date())
          })
        )
      ),
      metadata: mtMap74.objectField("metadata", mtMap74.passthrough()),
      actor: mtMap74.objectField(
        "actor",
        mtMap74.object({
          id: mtMap74.objectField("id", mtMap74.passthrough()),
          name: mtMap74.objectField("name", mtMap74.passthrough()),
          type: mtMap74.objectField("type", mtMap74.passthrough()),
          metadata: mtMap74.objectField("metadata", mtMap74.passthrough()),
          createdAt: mtMap74.objectField("created_at", mtMap74.date()),
          updatedAt: mtMap74.objectField("updated_at", mtMap74.date())
        })
      ),
      run: mtMap74.objectField(
        "run",
        mtMap74.object({
          id: mtMap74.objectField("id", mtMap74.passthrough()),
          agentId: mtMap74.objectField("agent_id", mtMap74.passthrough()),
          status: mtMap74.objectField("status", mtMap74.passthrough()),
          metadata: mtMap74.objectField("metadata", mtMap74.passthrough()),
          startedAt: mtMap74.objectField("started_at", mtMap74.date()),
          createdAt: mtMap74.objectField("created_at", mtMap74.date()),
          completedAt: mtMap74.objectField("completed_at", mtMap74.date())
        })
      )
    })
  ),
  metadata: mtMap74.objectField("metadata", mtMap74.passthrough()),
  errors: mtMap74.objectField(
    "errors",
    mtMap74.array(
      mtMap74.object({
        id: mtMap74.objectField("id", mtMap74.passthrough()),
        runId: mtMap74.objectField("run_id", mtMap74.passthrough()),
        code: mtMap74.objectField("code", mtMap74.passthrough()),
        message: mtMap74.objectField("message", mtMap74.passthrough()),
        metadata: mtMap74.objectField("metadata", mtMap74.passthrough()),
        createdAt: mtMap74.objectField("created_at", mtMap74.date())
      })
    )
  ),
  attachedItems: mtMap74.objectField(
    "attached_items",
    mtMap74.array(
      mtMap74.object({
        id: mtMap74.objectField("id", mtMap74.passthrough()),
        actor: mtMap74.objectField(
          "actor",
          mtMap74.object({
            id: mtMap74.objectField("id", mtMap74.passthrough()),
            name: mtMap74.objectField("name", mtMap74.passthrough()),
            type: mtMap74.objectField("type", mtMap74.passthrough()),
            metadata: mtMap74.objectField("metadata", mtMap74.passthrough()),
            createdAt: mtMap74.objectField("created_at", mtMap74.date()),
            updatedAt: mtMap74.objectField("updated_at", mtMap74.date())
          })
        ),
        key: mtMap74.objectField("key", mtMap74.passthrough()),
        value: mtMap74.objectField("value", mtMap74.passthrough()),
        createdAt: mtMap74.objectField("created_at", mtMap74.date())
      })
    )
  ),
  createdAt: mtMap74.objectField("created_at", mtMap74.date()),
  startedAt: mtMap74.objectField("started_at", mtMap74.date()),
  completedAt: mtMap74.objectField("completed_at", mtMap74.date())
});
var mapManagementInstancesRunsCreateBody = mtMap74.object({
  language: mtMap74.objectField("language", mtMap74.passthrough()),
  country: mtMap74.objectField("country", mtMap74.passthrough()),
  timezone: mtMap74.objectField("timezone", mtMap74.passthrough()),
  metadata: mtMap74.objectField("metadata", mtMap74.passthrough()),
  agentId: mtMap74.objectField("agent_id", mtMap74.passthrough()),
  content: mtMap74.objectField(
    "content",
    mtMap74.union([
      mtMap74.unionOption(
        "object",
        mtMap74.object({
          type: mtMap74.objectField("type", mtMap74.passthrough()),
          mimeType: mtMap74.objectField("mimeType", mtMap74.passthrough()),
          content: mtMap74.objectField("content", mtMap74.passthrough()),
          parts: mtMap74.objectField(
            "parts",
            mtMap74.array(
              mtMap74.object({
                type: mtMap74.objectField("type", mtMap74.passthrough()),
                mimeType: mtMap74.objectField("mime_type", mtMap74.passthrough()),
                content: mtMap74.objectField("content", mtMap74.passthrough())
              })
            )
          ),
          attachments: mtMap74.objectField(
            "attachments",
            mtMap74.array(
              mtMap74.object({
                type: mtMap74.objectField("type", mtMap74.passthrough()),
                fileId: mtMap74.objectField("file_id", mtMap74.passthrough()),
                caption: mtMap74.objectField(
                  "caption",
                  mtMap74.union([
                    mtMap74.unionOption(
                      "object",
                      mtMap74.object({
                        text: mtMap74.objectField("text", mtMap74.passthrough())
                      })
                    ),
                    mtMap74.unionOption("string", mtMap74.passthrough())
                  ])
                )
              })
            )
          )
        })
      ),
      mtMap74.unionOption("string", mtMap74.passthrough()),
      mtMap74.unionOption(
        "array",
        mtMap74.union([
          mtMap74.unionOption(
            "object",
            mtMap74.object({
              type: mtMap74.objectField("type", mtMap74.passthrough()),
              mimeType: mtMap74.objectField("mimeType", mtMap74.passthrough()),
              content: mtMap74.objectField("content", mtMap74.passthrough())
            })
          )
        ])
      )
    ])
  ),
  rawInputs: mtMap74.objectField("raw_inputs", mtMap74.passthrough())
});

// src/resources/management/instances/runs/get.ts
import { mtMap as mtMap75 } from "@metorial/util-resource-mapper";
var mapManagementInstancesRunsGetOutput = mtMap75.object({
  id: mtMap75.objectField("id", mtMap75.passthrough()),
  status: mtMap75.objectField("status", mtMap75.passthrough()),
  agentId: mtMap75.objectField("agent_id", mtMap75.passthrough()),
  triggerMessageGroupId: mtMap75.objectField(
    "trigger_message_group_id",
    mtMap75.passthrough()
  ),
  cost: mtMap75.objectField(
    "cost",
    mtMap75.object({
      amount: mtMap75.objectField("amount", mtMap75.passthrough()),
      unit: mtMap75.objectField("unit", mtMap75.passthrough())
    })
  ),
  messageGroup: mtMap75.objectField(
    "message_group",
    mtMap75.object({
      id: mtMap75.objectField("id", mtMap75.passthrough()),
      status: mtMap75.objectField("status", mtMap75.passthrough()),
      type: mtMap75.objectField("type", mtMap75.passthrough()),
      interactionId: mtMap75.objectField("interaction_id", mtMap75.passthrough()),
      createdAt: mtMap75.objectField("created_at", mtMap75.date()),
      threadId: mtMap75.objectField("thread_id", mtMap75.passthrough()),
      parentMessageGroupId: mtMap75.objectField(
        "parent_message_group_id",
        mtMap75.passthrough()
      ),
      messages: mtMap75.objectField(
        "messages",
        mtMap75.array(
          mtMap75.object({
            id: mtMap75.objectField("id", mtMap75.passthrough()),
            type: mtMap75.objectField("type", mtMap75.passthrough()),
            status: mtMap75.objectField("status", mtMap75.passthrough()),
            messageGroupId: mtMap75.objectField(
              "message_group_id",
              mtMap75.passthrough()
            ),
            threadId: mtMap75.objectField("thread_id", mtMap75.passthrough()),
            actor: mtMap75.objectField(
              "actor",
              mtMap75.object({
                id: mtMap75.objectField("id", mtMap75.passthrough()),
                name: mtMap75.objectField("name", mtMap75.passthrough()),
                type: mtMap75.objectField("type", mtMap75.passthrough()),
                metadata: mtMap75.objectField("metadata", mtMap75.passthrough()),
                createdAt: mtMap75.objectField("created_at", mtMap75.date()),
                updatedAt: mtMap75.objectField("updated_at", mtMap75.date())
              })
            ),
            content: mtMap75.objectField(
              "content",
              mtMap75.object({
                id: mtMap75.objectField("id", mtMap75.passthrough()),
                version: mtMap75.objectField("version", mtMap75.passthrough()),
                messageItemId: mtMap75.objectField(
                  "message_item_id",
                  mtMap75.passthrough()
                ),
                attachments: mtMap75.objectField(
                  "attachments",
                  mtMap75.array(
                    mtMap75.union([
                      mtMap75.unionOption(
                        "object",
                        mtMap75.object({
                          id: mtMap75.objectField("id", mtMap75.passthrough()),
                          type: mtMap75.objectField(
                            "type",
                            mtMap75.passthrough()
                          ),
                          fileId: mtMap75.objectField(
                            "file_id",
                            mtMap75.passthrough()
                          ),
                          url: mtMap75.objectField("url", mtMap75.passthrough()),
                          caption: mtMap75.objectField(
                            "caption",
                            mtMap75.object({
                              text: mtMap75.objectField(
                                "text",
                                mtMap75.passthrough()
                              )
                            })
                          ),
                          mimeType: mtMap75.objectField(
                            "mime_type",
                            mtMap75.passthrough()
                          ),
                          entryId: mtMap75.objectField(
                            "entry_id",
                            mtMap75.passthrough()
                          )
                        })
                      )
                    ])
                  )
                ),
                parts: mtMap75.objectField(
                  "parts",
                  mtMap75.array(
                    mtMap75.union([
                      mtMap75.unionOption(
                        "object",
                        mtMap75.object({
                          id: mtMap75.objectField("id", mtMap75.passthrough()),
                          type: mtMap75.objectField(
                            "type",
                            mtMap75.passthrough()
                          ),
                          mimeType: mtMap75.objectField(
                            "mime_type",
                            mtMap75.passthrough()
                          ),
                          text: mtMap75.objectField(
                            "text",
                            mtMap75.passthrough()
                          ),
                          kind: mtMap75.objectField(
                            "kind",
                            mtMap75.passthrough()
                          ),
                          attachment: mtMap75.objectField(
                            "attachment",
                            mtMap75.union([
                              mtMap75.unionOption(
                                "object",
                                mtMap75.object({
                                  id: mtMap75.objectField(
                                    "id",
                                    mtMap75.passthrough()
                                  ),
                                  type: mtMap75.objectField(
                                    "type",
                                    mtMap75.passthrough()
                                  ),
                                  fileId: mtMap75.objectField(
                                    "file_id",
                                    mtMap75.passthrough()
                                  ),
                                  url: mtMap75.objectField(
                                    "url",
                                    mtMap75.passthrough()
                                  ),
                                  caption: mtMap75.objectField(
                                    "caption",
                                    mtMap75.object({
                                      text: mtMap75.objectField(
                                        "text",
                                        mtMap75.passthrough()
                                      )
                                    })
                                  ),
                                  mimeType: mtMap75.objectField(
                                    "mime_type",
                                    mtMap75.passthrough()
                                  ),
                                  entryId: mtMap75.objectField(
                                    "entry_id",
                                    mtMap75.passthrough()
                                  )
                                })
                              )
                            ])
                          )
                        })
                      )
                    ])
                  )
                )
              })
            ),
            error: mtMap75.objectField(
              "error",
              mtMap75.object({
                type: mtMap75.objectField("type", mtMap75.passthrough()),
                message: mtMap75.objectField("message", mtMap75.passthrough())
              })
            ),
            createdAt: mtMap75.objectField("created_at", mtMap75.date())
          })
        )
      ),
      attachedItems: mtMap75.objectField(
        "attached_items",
        mtMap75.array(
          mtMap75.object({
            id: mtMap75.objectField("id", mtMap75.passthrough()),
            actor: mtMap75.objectField(
              "actor",
              mtMap75.object({
                id: mtMap75.objectField("id", mtMap75.passthrough()),
                name: mtMap75.objectField("name", mtMap75.passthrough()),
                type: mtMap75.objectField("type", mtMap75.passthrough()),
                metadata: mtMap75.objectField("metadata", mtMap75.passthrough()),
                createdAt: mtMap75.objectField("created_at", mtMap75.date()),
                updatedAt: mtMap75.objectField("updated_at", mtMap75.date())
              })
            ),
            key: mtMap75.objectField("key", mtMap75.passthrough()),
            value: mtMap75.objectField("value", mtMap75.passthrough()),
            createdAt: mtMap75.objectField("created_at", mtMap75.date())
          })
        )
      ),
      metadata: mtMap75.objectField("metadata", mtMap75.passthrough()),
      actor: mtMap75.objectField(
        "actor",
        mtMap75.object({
          id: mtMap75.objectField("id", mtMap75.passthrough()),
          name: mtMap75.objectField("name", mtMap75.passthrough()),
          type: mtMap75.objectField("type", mtMap75.passthrough()),
          metadata: mtMap75.objectField("metadata", mtMap75.passthrough()),
          createdAt: mtMap75.objectField("created_at", mtMap75.date()),
          updatedAt: mtMap75.objectField("updated_at", mtMap75.date())
        })
      ),
      run: mtMap75.objectField(
        "run",
        mtMap75.object({
          id: mtMap75.objectField("id", mtMap75.passthrough()),
          agentId: mtMap75.objectField("agent_id", mtMap75.passthrough()),
          status: mtMap75.objectField("status", mtMap75.passthrough()),
          metadata: mtMap75.objectField("metadata", mtMap75.passthrough()),
          startedAt: mtMap75.objectField("started_at", mtMap75.date()),
          createdAt: mtMap75.objectField("created_at", mtMap75.date()),
          completedAt: mtMap75.objectField("completed_at", mtMap75.date())
        })
      )
    })
  ),
  metadata: mtMap75.objectField("metadata", mtMap75.passthrough()),
  errors: mtMap75.objectField(
    "errors",
    mtMap75.array(
      mtMap75.object({
        id: mtMap75.objectField("id", mtMap75.passthrough()),
        runId: mtMap75.objectField("run_id", mtMap75.passthrough()),
        code: mtMap75.objectField("code", mtMap75.passthrough()),
        message: mtMap75.objectField("message", mtMap75.passthrough()),
        metadata: mtMap75.objectField("metadata", mtMap75.passthrough()),
        createdAt: mtMap75.objectField("created_at", mtMap75.date())
      })
    )
  ),
  attachedItems: mtMap75.objectField(
    "attached_items",
    mtMap75.array(
      mtMap75.object({
        id: mtMap75.objectField("id", mtMap75.passthrough()),
        actor: mtMap75.objectField(
          "actor",
          mtMap75.object({
            id: mtMap75.objectField("id", mtMap75.passthrough()),
            name: mtMap75.objectField("name", mtMap75.passthrough()),
            type: mtMap75.objectField("type", mtMap75.passthrough()),
            metadata: mtMap75.objectField("metadata", mtMap75.passthrough()),
            createdAt: mtMap75.objectField("created_at", mtMap75.date()),
            updatedAt: mtMap75.objectField("updated_at", mtMap75.date())
          })
        ),
        key: mtMap75.objectField("key", mtMap75.passthrough()),
        value: mtMap75.objectField("value", mtMap75.passthrough()),
        createdAt: mtMap75.objectField("created_at", mtMap75.date())
      })
    )
  ),
  createdAt: mtMap75.objectField("created_at", mtMap75.date()),
  startedAt: mtMap75.objectField("started_at", mtMap75.date()),
  completedAt: mtMap75.objectField("completed_at", mtMap75.date())
});

// src/resources/management/instances/runs/list.ts
import { mtMap as mtMap76 } from "@metorial/util-resource-mapper";
var mapManagementInstancesRunsListOutput = mtMap76.object({
  items: mtMap76.objectField(
    "items",
    mtMap76.array(
      mtMap76.object({
        id: mtMap76.objectField("id", mtMap76.passthrough()),
        status: mtMap76.objectField("status", mtMap76.passthrough()),
        agentId: mtMap76.objectField("agent_id", mtMap76.passthrough()),
        triggerMessageGroupId: mtMap76.objectField(
          "trigger_message_group_id",
          mtMap76.passthrough()
        ),
        cost: mtMap76.objectField(
          "cost",
          mtMap76.object({
            amount: mtMap76.objectField("amount", mtMap76.passthrough()),
            unit: mtMap76.objectField("unit", mtMap76.passthrough())
          })
        ),
        messageGroup: mtMap76.objectField(
          "message_group",
          mtMap76.object({
            id: mtMap76.objectField("id", mtMap76.passthrough()),
            status: mtMap76.objectField("status", mtMap76.passthrough()),
            type: mtMap76.objectField("type", mtMap76.passthrough()),
            interactionId: mtMap76.objectField(
              "interaction_id",
              mtMap76.passthrough()
            ),
            createdAt: mtMap76.objectField("created_at", mtMap76.date()),
            threadId: mtMap76.objectField("thread_id", mtMap76.passthrough()),
            parentMessageGroupId: mtMap76.objectField(
              "parent_message_group_id",
              mtMap76.passthrough()
            ),
            messages: mtMap76.objectField(
              "messages",
              mtMap76.array(
                mtMap76.object({
                  id: mtMap76.objectField("id", mtMap76.passthrough()),
                  type: mtMap76.objectField("type", mtMap76.passthrough()),
                  status: mtMap76.objectField("status", mtMap76.passthrough()),
                  messageGroupId: mtMap76.objectField(
                    "message_group_id",
                    mtMap76.passthrough()
                  ),
                  threadId: mtMap76.objectField(
                    "thread_id",
                    mtMap76.passthrough()
                  ),
                  actor: mtMap76.objectField(
                    "actor",
                    mtMap76.object({
                      id: mtMap76.objectField("id", mtMap76.passthrough()),
                      name: mtMap76.objectField("name", mtMap76.passthrough()),
                      type: mtMap76.objectField("type", mtMap76.passthrough()),
                      metadata: mtMap76.objectField(
                        "metadata",
                        mtMap76.passthrough()
                      ),
                      createdAt: mtMap76.objectField(
                        "created_at",
                        mtMap76.date()
                      ),
                      updatedAt: mtMap76.objectField("updated_at", mtMap76.date())
                    })
                  ),
                  content: mtMap76.objectField(
                    "content",
                    mtMap76.object({
                      id: mtMap76.objectField("id", mtMap76.passthrough()),
                      version: mtMap76.objectField(
                        "version",
                        mtMap76.passthrough()
                      ),
                      messageItemId: mtMap76.objectField(
                        "message_item_id",
                        mtMap76.passthrough()
                      ),
                      attachments: mtMap76.objectField(
                        "attachments",
                        mtMap76.array(
                          mtMap76.union([
                            mtMap76.unionOption(
                              "object",
                              mtMap76.object({
                                id: mtMap76.objectField(
                                  "id",
                                  mtMap76.passthrough()
                                ),
                                type: mtMap76.objectField(
                                  "type",
                                  mtMap76.passthrough()
                                ),
                                fileId: mtMap76.objectField(
                                  "file_id",
                                  mtMap76.passthrough()
                                ),
                                url: mtMap76.objectField(
                                  "url",
                                  mtMap76.passthrough()
                                ),
                                caption: mtMap76.objectField(
                                  "caption",
                                  mtMap76.object({
                                    text: mtMap76.objectField(
                                      "text",
                                      mtMap76.passthrough()
                                    )
                                  })
                                ),
                                mimeType: mtMap76.objectField(
                                  "mime_type",
                                  mtMap76.passthrough()
                                ),
                                entryId: mtMap76.objectField(
                                  "entry_id",
                                  mtMap76.passthrough()
                                )
                              })
                            )
                          ])
                        )
                      ),
                      parts: mtMap76.objectField(
                        "parts",
                        mtMap76.array(
                          mtMap76.union([
                            mtMap76.unionOption(
                              "object",
                              mtMap76.object({
                                id: mtMap76.objectField(
                                  "id",
                                  mtMap76.passthrough()
                                ),
                                type: mtMap76.objectField(
                                  "type",
                                  mtMap76.passthrough()
                                ),
                                mimeType: mtMap76.objectField(
                                  "mime_type",
                                  mtMap76.passthrough()
                                ),
                                text: mtMap76.objectField(
                                  "text",
                                  mtMap76.passthrough()
                                ),
                                kind: mtMap76.objectField(
                                  "kind",
                                  mtMap76.passthrough()
                                ),
                                attachment: mtMap76.objectField(
                                  "attachment",
                                  mtMap76.union([
                                    mtMap76.unionOption(
                                      "object",
                                      mtMap76.object({
                                        id: mtMap76.objectField(
                                          "id",
                                          mtMap76.passthrough()
                                        ),
                                        type: mtMap76.objectField(
                                          "type",
                                          mtMap76.passthrough()
                                        ),
                                        fileId: mtMap76.objectField(
                                          "file_id",
                                          mtMap76.passthrough()
                                        ),
                                        url: mtMap76.objectField(
                                          "url",
                                          mtMap76.passthrough()
                                        ),
                                        caption: mtMap76.objectField(
                                          "caption",
                                          mtMap76.object({
                                            text: mtMap76.objectField(
                                              "text",
                                              mtMap76.passthrough()
                                            )
                                          })
                                        ),
                                        mimeType: mtMap76.objectField(
                                          "mime_type",
                                          mtMap76.passthrough()
                                        ),
                                        entryId: mtMap76.objectField(
                                          "entry_id",
                                          mtMap76.passthrough()
                                        )
                                      })
                                    )
                                  ])
                                )
                              })
                            )
                          ])
                        )
                      )
                    })
                  ),
                  error: mtMap76.objectField(
                    "error",
                    mtMap76.object({
                      type: mtMap76.objectField("type", mtMap76.passthrough()),
                      message: mtMap76.objectField(
                        "message",
                        mtMap76.passthrough()
                      )
                    })
                  ),
                  createdAt: mtMap76.objectField("created_at", mtMap76.date())
                })
              )
            ),
            attachedItems: mtMap76.objectField(
              "attached_items",
              mtMap76.array(
                mtMap76.object({
                  id: mtMap76.objectField("id", mtMap76.passthrough()),
                  actor: mtMap76.objectField(
                    "actor",
                    mtMap76.object({
                      id: mtMap76.objectField("id", mtMap76.passthrough()),
                      name: mtMap76.objectField("name", mtMap76.passthrough()),
                      type: mtMap76.objectField("type", mtMap76.passthrough()),
                      metadata: mtMap76.objectField(
                        "metadata",
                        mtMap76.passthrough()
                      ),
                      createdAt: mtMap76.objectField(
                        "created_at",
                        mtMap76.date()
                      ),
                      updatedAt: mtMap76.objectField("updated_at", mtMap76.date())
                    })
                  ),
                  key: mtMap76.objectField("key", mtMap76.passthrough()),
                  value: mtMap76.objectField("value", mtMap76.passthrough()),
                  createdAt: mtMap76.objectField("created_at", mtMap76.date())
                })
              )
            ),
            metadata: mtMap76.objectField("metadata", mtMap76.passthrough()),
            actor: mtMap76.objectField(
              "actor",
              mtMap76.object({
                id: mtMap76.objectField("id", mtMap76.passthrough()),
                name: mtMap76.objectField("name", mtMap76.passthrough()),
                type: mtMap76.objectField("type", mtMap76.passthrough()),
                metadata: mtMap76.objectField("metadata", mtMap76.passthrough()),
                createdAt: mtMap76.objectField("created_at", mtMap76.date()),
                updatedAt: mtMap76.objectField("updated_at", mtMap76.date())
              })
            ),
            run: mtMap76.objectField(
              "run",
              mtMap76.object({
                id: mtMap76.objectField("id", mtMap76.passthrough()),
                agentId: mtMap76.objectField("agent_id", mtMap76.passthrough()),
                status: mtMap76.objectField("status", mtMap76.passthrough()),
                metadata: mtMap76.objectField("metadata", mtMap76.passthrough()),
                startedAt: mtMap76.objectField("started_at", mtMap76.date()),
                createdAt: mtMap76.objectField("created_at", mtMap76.date()),
                completedAt: mtMap76.objectField("completed_at", mtMap76.date())
              })
            )
          })
        ),
        metadata: mtMap76.objectField("metadata", mtMap76.passthrough()),
        errors: mtMap76.objectField(
          "errors",
          mtMap76.array(
            mtMap76.object({
              id: mtMap76.objectField("id", mtMap76.passthrough()),
              runId: mtMap76.objectField("run_id", mtMap76.passthrough()),
              code: mtMap76.objectField("code", mtMap76.passthrough()),
              message: mtMap76.objectField("message", mtMap76.passthrough()),
              metadata: mtMap76.objectField("metadata", mtMap76.passthrough()),
              createdAt: mtMap76.objectField("created_at", mtMap76.date())
            })
          )
        ),
        attachedItems: mtMap76.objectField(
          "attached_items",
          mtMap76.array(
            mtMap76.object({
              id: mtMap76.objectField("id", mtMap76.passthrough()),
              actor: mtMap76.objectField(
                "actor",
                mtMap76.object({
                  id: mtMap76.objectField("id", mtMap76.passthrough()),
                  name: mtMap76.objectField("name", mtMap76.passthrough()),
                  type: mtMap76.objectField("type", mtMap76.passthrough()),
                  metadata: mtMap76.objectField(
                    "metadata",
                    mtMap76.passthrough()
                  ),
                  createdAt: mtMap76.objectField("created_at", mtMap76.date()),
                  updatedAt: mtMap76.objectField("updated_at", mtMap76.date())
                })
              ),
              key: mtMap76.objectField("key", mtMap76.passthrough()),
              value: mtMap76.objectField("value", mtMap76.passthrough()),
              createdAt: mtMap76.objectField("created_at", mtMap76.date())
            })
          )
        ),
        createdAt: mtMap76.objectField("created_at", mtMap76.date()),
        startedAt: mtMap76.objectField("started_at", mtMap76.date()),
        completedAt: mtMap76.objectField("completed_at", mtMap76.date())
      })
    )
  ),
  pagination: mtMap76.objectField(
    "pagination",
    mtMap76.object({
      afterCursor: mtMap76.objectField("after_cursor", mtMap76.passthrough()),
      beforeCursor: mtMap76.objectField("before_cursor", mtMap76.passthrough()),
      hasMoreBefore: mtMap76.objectField(
        "has_more_before",
        mtMap76.passthrough()
      ),
      hasMoreAfter: mtMap76.objectField("has_more_after", mtMap76.passthrough()),
      pageSize: mtMap76.objectField("page_size", mtMap76.passthrough()),
      sort: mtMap76.objectField(
        "sort",
        mtMap76.array(
          mtMap76.object({
            field: mtMap76.objectField("field", mtMap76.passthrough()),
            order: mtMap76.objectField("order", mtMap76.passthrough())
          })
        )
      )
    })
  )
});
var mapManagementInstancesRunsListQuery = mtMap76.object({
  id: mtMap76.objectField(
    "id",
    mtMap76.union([
      mtMap76.unionOption(
        "object",
        mtMap76.object({
          in: mtMap76.objectField("in", mtMap76.array(mtMap76.passthrough())),
          eq: mtMap76.objectField("eq", mtMap76.passthrough())
        })
      ),
      mtMap76.unionOption("string", mtMap76.passthrough())
    ])
  ),
  ids: mtMap76.objectField(
    "ids",
    mtMap76.union([
      mtMap76.unionOption(
        "object",
        mtMap76.object({
          in: mtMap76.objectField("in", mtMap76.array(mtMap76.passthrough())),
          eq: mtMap76.objectField("eq", mtMap76.passthrough())
        })
      ),
      mtMap76.unionOption("string", mtMap76.passthrough())
    ])
  ),
  createdAt: mtMap76.objectField(
    "created_at",
    mtMap76.union([
      mtMap76.unionOption(
        "object",
        mtMap76.object({
          eq: mtMap76.objectField("eq", mtMap76.date()),
          gt: mtMap76.objectField("gt", mtMap76.date()),
          gte: mtMap76.objectField("gte", mtMap76.date()),
          lt: mtMap76.objectField("lt", mtMap76.date()),
          lte: mtMap76.objectField("lte", mtMap76.date())
        })
      ),
      mtMap76.unionOption("date", mtMap76.passthrough())
    ])
  ),
  startedAt: mtMap76.objectField(
    "startedAt",
    mtMap76.union([
      mtMap76.unionOption(
        "object",
        mtMap76.object({
          eq: mtMap76.objectField("eq", mtMap76.date()),
          gt: mtMap76.objectField("gt", mtMap76.date()),
          gte: mtMap76.objectField("gte", mtMap76.date()),
          lt: mtMap76.objectField("lt", mtMap76.date()),
          lte: mtMap76.objectField("lte", mtMap76.date())
        })
      ),
      mtMap76.unionOption("date", mtMap76.passthrough())
    ])
  ),
  completedAt: mtMap76.objectField(
    "completedAt",
    mtMap76.union([
      mtMap76.unionOption(
        "object",
        mtMap76.object({
          eq: mtMap76.objectField("eq", mtMap76.date()),
          gt: mtMap76.objectField("gt", mtMap76.date()),
          gte: mtMap76.objectField("gte", mtMap76.date()),
          lt: mtMap76.objectField("lt", mtMap76.date()),
          lte: mtMap76.objectField("lte", mtMap76.date())
        })
      ),
      mtMap76.unionOption("date", mtMap76.passthrough())
    ])
  ),
  status: mtMap76.objectField(
    "status",
    mtMap76.union([
      mtMap76.unionOption(
        "object",
        mtMap76.object({
          in: mtMap76.objectField("in", mtMap76.array(mtMap76.passthrough())),
          eq: mtMap76.objectField("eq", mtMap76.passthrough())
        })
      ),
      mtMap76.unionOption("string", mtMap76.passthrough())
    ])
  ),
  statuses: mtMap76.objectField(
    "statuses",
    mtMap76.union([
      mtMap76.unionOption(
        "object",
        mtMap76.object({
          in: mtMap76.objectField("in", mtMap76.array(mtMap76.passthrough())),
          eq: mtMap76.objectField("eq", mtMap76.passthrough())
        })
      ),
      mtMap76.unionOption("string", mtMap76.passthrough())
    ])
  ),
  sort: mtMap76.objectField(
    "sort",
    mtMap76.union([
      mtMap76.unionOption("string", mtMap76.passthrough()),
      mtMap76.unionOption(
        "array",
        mtMap76.union([
          mtMap76.unionOption(
            "object",
            mtMap76.object({
              field: mtMap76.objectField("field", mtMap76.passthrough()),
              order: mtMap76.objectField("order", mtMap76.passthrough())
            })
          )
        ])
      )
    ])
  ),
  agentId: mtMap76.objectField("agent_id", mtMap76.passthrough()),
  threadId: mtMap76.objectField("thread_id", mtMap76.passthrough()),
  limit: mtMap76.objectField("limit", mtMap76.passthrough()),
  cursor: mtMap76.objectField("cursor", mtMap76.passthrough()),
  order: mtMap76.objectField("order", mtMap76.passthrough())
});

// src/resources/management/instances/threads/create.ts
import { mtMap as mtMap77 } from "@metorial/util-resource-mapper";
var mapManagementInstancesThreadsCreateOutput = mtMap77.object({
  id: mtMap77.objectField("id", mtMap77.passthrough()),
  name: mtMap77.objectField("name", mtMap77.passthrough()),
  agentId: mtMap77.objectField("agent_id", mtMap77.passthrough()),
  instanceId: mtMap77.objectField("instance_id", mtMap77.passthrough()),
  timezone: mtMap77.objectField(
    "timezone",
    mtMap77.object({
      code: mtMap77.objectField("code", mtMap77.passthrough()),
      utc: mtMap77.objectField("utc", mtMap77.passthrough()),
      utcOffsetInMinutes: mtMap77.objectField(
        "utc_offset_in_minutes",
        mtMap77.passthrough()
      )
    })
  ),
  country: mtMap77.objectField(
    "country",
    mtMap77.object({ code: mtMap77.objectField("code", mtMap77.passthrough()) })
  ),
  language: mtMap77.objectField(
    "language",
    mtMap77.object({
      code: mtMap77.objectField("code", mtMap77.passthrough()),
      full: mtMap77.objectField("full", mtMap77.passthrough())
    })
  ),
  metadata: mtMap77.objectField("metadata", mtMap77.passthrough()),
  createdAt: mtMap77.objectField("created_at", mtMap77.date()),
  updatedAt: mtMap77.objectField("updated_at", mtMap77.date())
});
var mapManagementInstancesThreadsCreateBody = mtMap77.object({
  language: mtMap77.objectField("language", mtMap77.passthrough()),
  country: mtMap77.objectField("country", mtMap77.passthrough()),
  timezone: mtMap77.objectField("timezone", mtMap77.passthrough()),
  metadata: mtMap77.objectField("metadata", mtMap77.passthrough()),
  userId: mtMap77.objectField("user_id", mtMap77.passthrough()),
  agentId: mtMap77.objectField("agent_id", mtMap77.passthrough()),
  groupId: mtMap77.objectField("group_id", mtMap77.passthrough()),
  name: mtMap77.objectField("name", mtMap77.passthrough())
});

// src/resources/management/instances/threads/delete.ts
import { mtMap as mtMap78 } from "@metorial/util-resource-mapper";
var mapManagementInstancesThreadsDeleteOutput = mtMap78.object({
  id: mtMap78.objectField("id", mtMap78.passthrough()),
  name: mtMap78.objectField("name", mtMap78.passthrough()),
  agentId: mtMap78.objectField("agent_id", mtMap78.passthrough()),
  instanceId: mtMap78.objectField("instance_id", mtMap78.passthrough()),
  timezone: mtMap78.objectField(
    "timezone",
    mtMap78.object({
      code: mtMap78.objectField("code", mtMap78.passthrough()),
      utc: mtMap78.objectField("utc", mtMap78.passthrough()),
      utcOffsetInMinutes: mtMap78.objectField(
        "utc_offset_in_minutes",
        mtMap78.passthrough()
      )
    })
  ),
  country: mtMap78.objectField(
    "country",
    mtMap78.object({ code: mtMap78.objectField("code", mtMap78.passthrough()) })
  ),
  language: mtMap78.objectField(
    "language",
    mtMap78.object({
      code: mtMap78.objectField("code", mtMap78.passthrough()),
      full: mtMap78.objectField("full", mtMap78.passthrough())
    })
  ),
  metadata: mtMap78.objectField("metadata", mtMap78.passthrough()),
  createdAt: mtMap78.objectField("created_at", mtMap78.date()),
  updatedAt: mtMap78.objectField("updated_at", mtMap78.date())
});

// src/resources/management/instances/threads/get.ts
import { mtMap as mtMap79 } from "@metorial/util-resource-mapper";
var mapManagementInstancesThreadsGetOutput = mtMap79.object({
  id: mtMap79.objectField("id", mtMap79.passthrough()),
  name: mtMap79.objectField("name", mtMap79.passthrough()),
  agentId: mtMap79.objectField("agent_id", mtMap79.passthrough()),
  instanceId: mtMap79.objectField("instance_id", mtMap79.passthrough()),
  timezone: mtMap79.objectField(
    "timezone",
    mtMap79.object({
      code: mtMap79.objectField("code", mtMap79.passthrough()),
      utc: mtMap79.objectField("utc", mtMap79.passthrough()),
      utcOffsetInMinutes: mtMap79.objectField(
        "utc_offset_in_minutes",
        mtMap79.passthrough()
      )
    })
  ),
  country: mtMap79.objectField(
    "country",
    mtMap79.object({ code: mtMap79.objectField("code", mtMap79.passthrough()) })
  ),
  language: mtMap79.objectField(
    "language",
    mtMap79.object({
      code: mtMap79.objectField("code", mtMap79.passthrough()),
      full: mtMap79.objectField("full", mtMap79.passthrough())
    })
  ),
  metadata: mtMap79.objectField("metadata", mtMap79.passthrough()),
  createdAt: mtMap79.objectField("created_at", mtMap79.date()),
  updatedAt: mtMap79.objectField("updated_at", mtMap79.date())
});

// src/resources/management/instances/threads/list.ts
import { mtMap as mtMap80 } from "@metorial/util-resource-mapper";
var mapManagementInstancesThreadsListOutput = mtMap80.object({
  items: mtMap80.objectField(
    "items",
    mtMap80.array(
      mtMap80.object({
        id: mtMap80.objectField("id", mtMap80.passthrough()),
        name: mtMap80.objectField("name", mtMap80.passthrough()),
        agentId: mtMap80.objectField("agent_id", mtMap80.passthrough()),
        instanceId: mtMap80.objectField("instance_id", mtMap80.passthrough()),
        timezone: mtMap80.objectField(
          "timezone",
          mtMap80.object({
            code: mtMap80.objectField("code", mtMap80.passthrough()),
            utc: mtMap80.objectField("utc", mtMap80.passthrough()),
            utcOffsetInMinutes: mtMap80.objectField(
              "utc_offset_in_minutes",
              mtMap80.passthrough()
            )
          })
        ),
        country: mtMap80.objectField(
          "country",
          mtMap80.object({
            code: mtMap80.objectField("code", mtMap80.passthrough())
          })
        ),
        language: mtMap80.objectField(
          "language",
          mtMap80.object({
            code: mtMap80.objectField("code", mtMap80.passthrough()),
            full: mtMap80.objectField("full", mtMap80.passthrough())
          })
        ),
        metadata: mtMap80.objectField("metadata", mtMap80.passthrough()),
        createdAt: mtMap80.objectField("created_at", mtMap80.date()),
        updatedAt: mtMap80.objectField("updated_at", mtMap80.date())
      })
    )
  ),
  pagination: mtMap80.objectField(
    "pagination",
    mtMap80.object({
      afterCursor: mtMap80.objectField("after_cursor", mtMap80.passthrough()),
      beforeCursor: mtMap80.objectField("before_cursor", mtMap80.passthrough()),
      hasMoreBefore: mtMap80.objectField(
        "has_more_before",
        mtMap80.passthrough()
      ),
      hasMoreAfter: mtMap80.objectField("has_more_after", mtMap80.passthrough()),
      pageSize: mtMap80.objectField("page_size", mtMap80.passthrough()),
      sort: mtMap80.objectField(
        "sort",
        mtMap80.array(
          mtMap80.object({
            field: mtMap80.objectField("field", mtMap80.passthrough()),
            order: mtMap80.objectField("order", mtMap80.passthrough())
          })
        )
      )
    })
  )
});
var mapManagementInstancesThreadsListQuery = mtMap80.object({
  id: mtMap80.objectField(
    "id",
    mtMap80.union([
      mtMap80.unionOption(
        "object",
        mtMap80.object({
          in: mtMap80.objectField("in", mtMap80.array(mtMap80.passthrough())),
          eq: mtMap80.objectField("eq", mtMap80.passthrough())
        })
      ),
      mtMap80.unionOption("string", mtMap80.passthrough())
    ])
  ),
  ids: mtMap80.objectField(
    "ids",
    mtMap80.union([
      mtMap80.unionOption(
        "object",
        mtMap80.object({
          in: mtMap80.objectField("in", mtMap80.array(mtMap80.passthrough())),
          eq: mtMap80.objectField("eq", mtMap80.passthrough())
        })
      ),
      mtMap80.unionOption("string", mtMap80.passthrough())
    ])
  ),
  createdAt: mtMap80.objectField(
    "created_at",
    mtMap80.union([
      mtMap80.unionOption(
        "object",
        mtMap80.object({
          eq: mtMap80.objectField("eq", mtMap80.date()),
          gt: mtMap80.objectField("gt", mtMap80.date()),
          gte: mtMap80.objectField("gte", mtMap80.date()),
          lt: mtMap80.objectField("lt", mtMap80.date()),
          lte: mtMap80.objectField("lte", mtMap80.date())
        })
      ),
      mtMap80.unionOption("date", mtMap80.passthrough())
    ])
  ),
  updatedAt: mtMap80.objectField(
    "updated_at",
    mtMap80.union([
      mtMap80.unionOption(
        "object",
        mtMap80.object({
          eq: mtMap80.objectField("eq", mtMap80.date()),
          gt: mtMap80.objectField("gt", mtMap80.date()),
          gte: mtMap80.objectField("gte", mtMap80.date()),
          lt: mtMap80.objectField("lt", mtMap80.date()),
          lte: mtMap80.objectField("lte", mtMap80.date())
        })
      ),
      mtMap80.unionOption("date", mtMap80.passthrough())
    ])
  ),
  sort: mtMap80.objectField(
    "sort",
    mtMap80.union([
      mtMap80.unionOption("string", mtMap80.passthrough()),
      mtMap80.unionOption(
        "array",
        mtMap80.union([
          mtMap80.unionOption(
            "object",
            mtMap80.object({
              field: mtMap80.objectField("field", mtMap80.passthrough()),
              order: mtMap80.objectField("order", mtMap80.passthrough())
            })
          )
        ])
      )
    ])
  ),
  userId: mtMap80.objectField("user_id", mtMap80.passthrough()),
  groupId: mtMap80.objectField("group_id", mtMap80.passthrough()),
  limit: mtMap80.objectField("limit", mtMap80.passthrough()),
  cursor: mtMap80.objectField("cursor", mtMap80.passthrough()),
  order: mtMap80.objectField("order", mtMap80.passthrough())
});

// src/resources/management/instances/threads/messages/create.ts
import { mtMap as mtMap81 } from "@metorial/util-resource-mapper";
var mapManagementInstancesThreadsMessagesCreateOutput = mtMap81.object({
  id: mtMap81.objectField("id", mtMap81.passthrough()),
  status: mtMap81.objectField("status", mtMap81.passthrough()),
  type: mtMap81.objectField("type", mtMap81.passthrough()),
  interactionId: mtMap81.objectField("interaction_id", mtMap81.passthrough()),
  createdAt: mtMap81.objectField("created_at", mtMap81.date()),
  threadId: mtMap81.objectField("thread_id", mtMap81.passthrough()),
  parentMessageGroupId: mtMap81.objectField(
    "parent_message_group_id",
    mtMap81.passthrough()
  ),
  messages: mtMap81.objectField(
    "messages",
    mtMap81.array(
      mtMap81.object({
        id: mtMap81.objectField("id", mtMap81.passthrough()),
        type: mtMap81.objectField("type", mtMap81.passthrough()),
        status: mtMap81.objectField("status", mtMap81.passthrough()),
        messageGroupId: mtMap81.objectField(
          "message_group_id",
          mtMap81.passthrough()
        ),
        threadId: mtMap81.objectField("thread_id", mtMap81.passthrough()),
        actor: mtMap81.objectField(
          "actor",
          mtMap81.object({
            id: mtMap81.objectField("id", mtMap81.passthrough()),
            name: mtMap81.objectField("name", mtMap81.passthrough()),
            type: mtMap81.objectField("type", mtMap81.passthrough()),
            metadata: mtMap81.objectField("metadata", mtMap81.passthrough()),
            createdAt: mtMap81.objectField("created_at", mtMap81.date()),
            updatedAt: mtMap81.objectField("updated_at", mtMap81.date())
          })
        ),
        content: mtMap81.objectField(
          "content",
          mtMap81.object({
            id: mtMap81.objectField("id", mtMap81.passthrough()),
            version: mtMap81.objectField("version", mtMap81.passthrough()),
            messageItemId: mtMap81.objectField(
              "message_item_id",
              mtMap81.passthrough()
            ),
            attachments: mtMap81.objectField(
              "attachments",
              mtMap81.array(
                mtMap81.union([
                  mtMap81.unionOption(
                    "object",
                    mtMap81.object({
                      id: mtMap81.objectField("id", mtMap81.passthrough()),
                      type: mtMap81.objectField("type", mtMap81.passthrough()),
                      fileId: mtMap81.objectField(
                        "file_id",
                        mtMap81.passthrough()
                      ),
                      url: mtMap81.objectField("url", mtMap81.passthrough()),
                      caption: mtMap81.objectField(
                        "caption",
                        mtMap81.object({
                          text: mtMap81.objectField("text", mtMap81.passthrough())
                        })
                      ),
                      mimeType: mtMap81.objectField(
                        "mime_type",
                        mtMap81.passthrough()
                      ),
                      entryId: mtMap81.objectField(
                        "entry_id",
                        mtMap81.passthrough()
                      )
                    })
                  )
                ])
              )
            ),
            parts: mtMap81.objectField(
              "parts",
              mtMap81.array(
                mtMap81.union([
                  mtMap81.unionOption(
                    "object",
                    mtMap81.object({
                      id: mtMap81.objectField("id", mtMap81.passthrough()),
                      type: mtMap81.objectField("type", mtMap81.passthrough()),
                      mimeType: mtMap81.objectField(
                        "mime_type",
                        mtMap81.passthrough()
                      ),
                      text: mtMap81.objectField("text", mtMap81.passthrough()),
                      kind: mtMap81.objectField("kind", mtMap81.passthrough()),
                      attachment: mtMap81.objectField(
                        "attachment",
                        mtMap81.union([
                          mtMap81.unionOption(
                            "object",
                            mtMap81.object({
                              id: mtMap81.objectField(
                                "id",
                                mtMap81.passthrough()
                              ),
                              type: mtMap81.objectField(
                                "type",
                                mtMap81.passthrough()
                              ),
                              fileId: mtMap81.objectField(
                                "file_id",
                                mtMap81.passthrough()
                              ),
                              url: mtMap81.objectField(
                                "url",
                                mtMap81.passthrough()
                              ),
                              caption: mtMap81.objectField(
                                "caption",
                                mtMap81.object({
                                  text: mtMap81.objectField(
                                    "text",
                                    mtMap81.passthrough()
                                  )
                                })
                              ),
                              mimeType: mtMap81.objectField(
                                "mime_type",
                                mtMap81.passthrough()
                              ),
                              entryId: mtMap81.objectField(
                                "entry_id",
                                mtMap81.passthrough()
                              )
                            })
                          )
                        ])
                      )
                    })
                  )
                ])
              )
            )
          })
        ),
        error: mtMap81.objectField(
          "error",
          mtMap81.object({
            type: mtMap81.objectField("type", mtMap81.passthrough()),
            message: mtMap81.objectField("message", mtMap81.passthrough())
          })
        ),
        createdAt: mtMap81.objectField("created_at", mtMap81.date())
      })
    )
  ),
  attachedItems: mtMap81.objectField(
    "attached_items",
    mtMap81.array(
      mtMap81.object({
        id: mtMap81.objectField("id", mtMap81.passthrough()),
        actor: mtMap81.objectField(
          "actor",
          mtMap81.object({
            id: mtMap81.objectField("id", mtMap81.passthrough()),
            name: mtMap81.objectField("name", mtMap81.passthrough()),
            type: mtMap81.objectField("type", mtMap81.passthrough()),
            metadata: mtMap81.objectField("metadata", mtMap81.passthrough()),
            createdAt: mtMap81.objectField("created_at", mtMap81.date()),
            updatedAt: mtMap81.objectField("updated_at", mtMap81.date())
          })
        ),
        key: mtMap81.objectField("key", mtMap81.passthrough()),
        value: mtMap81.objectField("value", mtMap81.passthrough()),
        createdAt: mtMap81.objectField("created_at", mtMap81.date())
      })
    )
  ),
  metadata: mtMap81.objectField("metadata", mtMap81.passthrough()),
  actor: mtMap81.objectField(
    "actor",
    mtMap81.object({
      id: mtMap81.objectField("id", mtMap81.passthrough()),
      name: mtMap81.objectField("name", mtMap81.passthrough()),
      type: mtMap81.objectField("type", mtMap81.passthrough()),
      metadata: mtMap81.objectField("metadata", mtMap81.passthrough()),
      createdAt: mtMap81.objectField("created_at", mtMap81.date()),
      updatedAt: mtMap81.objectField("updated_at", mtMap81.date())
    })
  ),
  run: mtMap81.objectField(
    "run",
    mtMap81.object({
      id: mtMap81.objectField("id", mtMap81.passthrough()),
      agentId: mtMap81.objectField("agent_id", mtMap81.passthrough()),
      status: mtMap81.objectField("status", mtMap81.passthrough()),
      metadata: mtMap81.objectField("metadata", mtMap81.passthrough()),
      startedAt: mtMap81.objectField("started_at", mtMap81.date()),
      createdAt: mtMap81.objectField("created_at", mtMap81.date()),
      completedAt: mtMap81.objectField("completed_at", mtMap81.date())
    })
  )
});
var mapManagementInstancesThreadsMessagesCreateBody = mtMap81.object({
  userId: mtMap81.objectField("user_id", mtMap81.passthrough()),
  content: mtMap81.objectField(
    "content",
    mtMap81.union([
      mtMap81.unionOption(
        "object",
        mtMap81.object({
          type: mtMap81.objectField("type", mtMap81.passthrough()),
          mimeType: mtMap81.objectField("mimeType", mtMap81.passthrough()),
          content: mtMap81.objectField("content", mtMap81.passthrough()),
          parts: mtMap81.objectField(
            "parts",
            mtMap81.array(
              mtMap81.object({
                type: mtMap81.objectField("type", mtMap81.passthrough()),
                mimeType: mtMap81.objectField("mime_type", mtMap81.passthrough()),
                content: mtMap81.objectField("content", mtMap81.passthrough())
              })
            )
          ),
          attachments: mtMap81.objectField(
            "attachments",
            mtMap81.array(
              mtMap81.object({
                type: mtMap81.objectField("type", mtMap81.passthrough()),
                fileId: mtMap81.objectField("file_id", mtMap81.passthrough()),
                caption: mtMap81.objectField(
                  "caption",
                  mtMap81.union([
                    mtMap81.unionOption(
                      "object",
                      mtMap81.object({
                        text: mtMap81.objectField("text", mtMap81.passthrough())
                      })
                    ),
                    mtMap81.unionOption("string", mtMap81.passthrough())
                  ])
                )
              })
            )
          )
        })
      ),
      mtMap81.unionOption("string", mtMap81.passthrough()),
      mtMap81.unionOption(
        "array",
        mtMap81.union([
          mtMap81.unionOption(
            "object",
            mtMap81.object({
              type: mtMap81.objectField("type", mtMap81.passthrough()),
              mimeType: mtMap81.objectField("mimeType", mtMap81.passthrough()),
              content: mtMap81.objectField("content", mtMap81.passthrough())
            })
          )
        ])
      )
    ])
  ),
  rawInputs: mtMap81.objectField("raw_inputs", mtMap81.passthrough()),
  metadata: mtMap81.objectField("metadata", mtMap81.passthrough()),
  variantCount: mtMap81.objectField("variant_count", mtMap81.passthrough()),
  position: mtMap81.objectField(
    "position",
    mtMap81.union([
      mtMap81.unionOption(
        "object",
        mtMap81.object({
          type: mtMap81.objectField("type", mtMap81.passthrough()),
          messageGroupId: mtMap81.objectField(
            "message_group_id",
            mtMap81.passthrough()
          )
        })
      )
    ])
  )
});

// src/resources/management/instances/threads/messages/get.ts
import { mtMap as mtMap82 } from "@metorial/util-resource-mapper";
var mapManagementInstancesThreadsMessagesGetOutput = mtMap82.object({
  id: mtMap82.objectField("id", mtMap82.passthrough()),
  status: mtMap82.objectField("status", mtMap82.passthrough()),
  type: mtMap82.objectField("type", mtMap82.passthrough()),
  interactionId: mtMap82.objectField("interaction_id", mtMap82.passthrough()),
  createdAt: mtMap82.objectField("created_at", mtMap82.date()),
  threadId: mtMap82.objectField("thread_id", mtMap82.passthrough()),
  parentMessageGroupId: mtMap82.objectField(
    "parent_message_group_id",
    mtMap82.passthrough()
  ),
  messages: mtMap82.objectField(
    "messages",
    mtMap82.array(
      mtMap82.object({
        id: mtMap82.objectField("id", mtMap82.passthrough()),
        type: mtMap82.objectField("type", mtMap82.passthrough()),
        status: mtMap82.objectField("status", mtMap82.passthrough()),
        messageGroupId: mtMap82.objectField(
          "message_group_id",
          mtMap82.passthrough()
        ),
        threadId: mtMap82.objectField("thread_id", mtMap82.passthrough()),
        actor: mtMap82.objectField(
          "actor",
          mtMap82.object({
            id: mtMap82.objectField("id", mtMap82.passthrough()),
            name: mtMap82.objectField("name", mtMap82.passthrough()),
            type: mtMap82.objectField("type", mtMap82.passthrough()),
            metadata: mtMap82.objectField("metadata", mtMap82.passthrough()),
            createdAt: mtMap82.objectField("created_at", mtMap82.date()),
            updatedAt: mtMap82.objectField("updated_at", mtMap82.date())
          })
        ),
        content: mtMap82.objectField(
          "content",
          mtMap82.object({
            id: mtMap82.objectField("id", mtMap82.passthrough()),
            version: mtMap82.objectField("version", mtMap82.passthrough()),
            messageItemId: mtMap82.objectField(
              "message_item_id",
              mtMap82.passthrough()
            ),
            attachments: mtMap82.objectField(
              "attachments",
              mtMap82.array(
                mtMap82.union([
                  mtMap82.unionOption(
                    "object",
                    mtMap82.object({
                      id: mtMap82.objectField("id", mtMap82.passthrough()),
                      type: mtMap82.objectField("type", mtMap82.passthrough()),
                      fileId: mtMap82.objectField(
                        "file_id",
                        mtMap82.passthrough()
                      ),
                      url: mtMap82.objectField("url", mtMap82.passthrough()),
                      caption: mtMap82.objectField(
                        "caption",
                        mtMap82.object({
                          text: mtMap82.objectField("text", mtMap82.passthrough())
                        })
                      ),
                      mimeType: mtMap82.objectField(
                        "mime_type",
                        mtMap82.passthrough()
                      ),
                      entryId: mtMap82.objectField(
                        "entry_id",
                        mtMap82.passthrough()
                      )
                    })
                  )
                ])
              )
            ),
            parts: mtMap82.objectField(
              "parts",
              mtMap82.array(
                mtMap82.union([
                  mtMap82.unionOption(
                    "object",
                    mtMap82.object({
                      id: mtMap82.objectField("id", mtMap82.passthrough()),
                      type: mtMap82.objectField("type", mtMap82.passthrough()),
                      mimeType: mtMap82.objectField(
                        "mime_type",
                        mtMap82.passthrough()
                      ),
                      text: mtMap82.objectField("text", mtMap82.passthrough()),
                      kind: mtMap82.objectField("kind", mtMap82.passthrough()),
                      attachment: mtMap82.objectField(
                        "attachment",
                        mtMap82.union([
                          mtMap82.unionOption(
                            "object",
                            mtMap82.object({
                              id: mtMap82.objectField(
                                "id",
                                mtMap82.passthrough()
                              ),
                              type: mtMap82.objectField(
                                "type",
                                mtMap82.passthrough()
                              ),
                              fileId: mtMap82.objectField(
                                "file_id",
                                mtMap82.passthrough()
                              ),
                              url: mtMap82.objectField(
                                "url",
                                mtMap82.passthrough()
                              ),
                              caption: mtMap82.objectField(
                                "caption",
                                mtMap82.object({
                                  text: mtMap82.objectField(
                                    "text",
                                    mtMap82.passthrough()
                                  )
                                })
                              ),
                              mimeType: mtMap82.objectField(
                                "mime_type",
                                mtMap82.passthrough()
                              ),
                              entryId: mtMap82.objectField(
                                "entry_id",
                                mtMap82.passthrough()
                              )
                            })
                          )
                        ])
                      )
                    })
                  )
                ])
              )
            )
          })
        ),
        error: mtMap82.objectField(
          "error",
          mtMap82.object({
            type: mtMap82.objectField("type", mtMap82.passthrough()),
            message: mtMap82.objectField("message", mtMap82.passthrough())
          })
        ),
        createdAt: mtMap82.objectField("created_at", mtMap82.date())
      })
    )
  ),
  attachedItems: mtMap82.objectField(
    "attached_items",
    mtMap82.array(
      mtMap82.object({
        id: mtMap82.objectField("id", mtMap82.passthrough()),
        actor: mtMap82.objectField(
          "actor",
          mtMap82.object({
            id: mtMap82.objectField("id", mtMap82.passthrough()),
            name: mtMap82.objectField("name", mtMap82.passthrough()),
            type: mtMap82.objectField("type", mtMap82.passthrough()),
            metadata: mtMap82.objectField("metadata", mtMap82.passthrough()),
            createdAt: mtMap82.objectField("created_at", mtMap82.date()),
            updatedAt: mtMap82.objectField("updated_at", mtMap82.date())
          })
        ),
        key: mtMap82.objectField("key", mtMap82.passthrough()),
        value: mtMap82.objectField("value", mtMap82.passthrough()),
        createdAt: mtMap82.objectField("created_at", mtMap82.date())
      })
    )
  ),
  metadata: mtMap82.objectField("metadata", mtMap82.passthrough()),
  actor: mtMap82.objectField(
    "actor",
    mtMap82.object({
      id: mtMap82.objectField("id", mtMap82.passthrough()),
      name: mtMap82.objectField("name", mtMap82.passthrough()),
      type: mtMap82.objectField("type", mtMap82.passthrough()),
      metadata: mtMap82.objectField("metadata", mtMap82.passthrough()),
      createdAt: mtMap82.objectField("created_at", mtMap82.date()),
      updatedAt: mtMap82.objectField("updated_at", mtMap82.date())
    })
  ),
  run: mtMap82.objectField(
    "run",
    mtMap82.object({
      id: mtMap82.objectField("id", mtMap82.passthrough()),
      agentId: mtMap82.objectField("agent_id", mtMap82.passthrough()),
      status: mtMap82.objectField("status", mtMap82.passthrough()),
      metadata: mtMap82.objectField("metadata", mtMap82.passthrough()),
      startedAt: mtMap82.objectField("started_at", mtMap82.date()),
      createdAt: mtMap82.objectField("created_at", mtMap82.date()),
      completedAt: mtMap82.objectField("completed_at", mtMap82.date())
    })
  )
});

// src/resources/management/instances/threads/messages/list.ts
import { mtMap as mtMap83 } from "@metorial/util-resource-mapper";
var mapManagementInstancesThreadsMessagesListOutput = mtMap83.object({
  items: mtMap83.objectField(
    "items",
    mtMap83.array(
      mtMap83.object({
        id: mtMap83.objectField("id", mtMap83.passthrough()),
        status: mtMap83.objectField("status", mtMap83.passthrough()),
        type: mtMap83.objectField("type", mtMap83.passthrough()),
        interactionId: mtMap83.objectField(
          "interaction_id",
          mtMap83.passthrough()
        ),
        createdAt: mtMap83.objectField("created_at", mtMap83.date()),
        threadId: mtMap83.objectField("thread_id", mtMap83.passthrough()),
        parentMessageGroupId: mtMap83.objectField(
          "parent_message_group_id",
          mtMap83.passthrough()
        ),
        messages: mtMap83.objectField(
          "messages",
          mtMap83.array(
            mtMap83.object({
              id: mtMap83.objectField("id", mtMap83.passthrough()),
              type: mtMap83.objectField("type", mtMap83.passthrough()),
              status: mtMap83.objectField("status", mtMap83.passthrough()),
              messageGroupId: mtMap83.objectField(
                "message_group_id",
                mtMap83.passthrough()
              ),
              threadId: mtMap83.objectField("thread_id", mtMap83.passthrough()),
              actor: mtMap83.objectField(
                "actor",
                mtMap83.object({
                  id: mtMap83.objectField("id", mtMap83.passthrough()),
                  name: mtMap83.objectField("name", mtMap83.passthrough()),
                  type: mtMap83.objectField("type", mtMap83.passthrough()),
                  metadata: mtMap83.objectField(
                    "metadata",
                    mtMap83.passthrough()
                  ),
                  createdAt: mtMap83.objectField("created_at", mtMap83.date()),
                  updatedAt: mtMap83.objectField("updated_at", mtMap83.date())
                })
              ),
              content: mtMap83.objectField(
                "content",
                mtMap83.object({
                  id: mtMap83.objectField("id", mtMap83.passthrough()),
                  version: mtMap83.objectField("version", mtMap83.passthrough()),
                  messageItemId: mtMap83.objectField(
                    "message_item_id",
                    mtMap83.passthrough()
                  ),
                  attachments: mtMap83.objectField(
                    "attachments",
                    mtMap83.array(
                      mtMap83.union([
                        mtMap83.unionOption(
                          "object",
                          mtMap83.object({
                            id: mtMap83.objectField("id", mtMap83.passthrough()),
                            type: mtMap83.objectField(
                              "type",
                              mtMap83.passthrough()
                            ),
                            fileId: mtMap83.objectField(
                              "file_id",
                              mtMap83.passthrough()
                            ),
                            url: mtMap83.objectField(
                              "url",
                              mtMap83.passthrough()
                            ),
                            caption: mtMap83.objectField(
                              "caption",
                              mtMap83.object({
                                text: mtMap83.objectField(
                                  "text",
                                  mtMap83.passthrough()
                                )
                              })
                            ),
                            mimeType: mtMap83.objectField(
                              "mime_type",
                              mtMap83.passthrough()
                            ),
                            entryId: mtMap83.objectField(
                              "entry_id",
                              mtMap83.passthrough()
                            )
                          })
                        )
                      ])
                    )
                  ),
                  parts: mtMap83.objectField(
                    "parts",
                    mtMap83.array(
                      mtMap83.union([
                        mtMap83.unionOption(
                          "object",
                          mtMap83.object({
                            id: mtMap83.objectField("id", mtMap83.passthrough()),
                            type: mtMap83.objectField(
                              "type",
                              mtMap83.passthrough()
                            ),
                            mimeType: mtMap83.objectField(
                              "mime_type",
                              mtMap83.passthrough()
                            ),
                            text: mtMap83.objectField(
                              "text",
                              mtMap83.passthrough()
                            ),
                            kind: mtMap83.objectField(
                              "kind",
                              mtMap83.passthrough()
                            ),
                            attachment: mtMap83.objectField(
                              "attachment",
                              mtMap83.union([
                                mtMap83.unionOption(
                                  "object",
                                  mtMap83.object({
                                    id: mtMap83.objectField(
                                      "id",
                                      mtMap83.passthrough()
                                    ),
                                    type: mtMap83.objectField(
                                      "type",
                                      mtMap83.passthrough()
                                    ),
                                    fileId: mtMap83.objectField(
                                      "file_id",
                                      mtMap83.passthrough()
                                    ),
                                    url: mtMap83.objectField(
                                      "url",
                                      mtMap83.passthrough()
                                    ),
                                    caption: mtMap83.objectField(
                                      "caption",
                                      mtMap83.object({
                                        text: mtMap83.objectField(
                                          "text",
                                          mtMap83.passthrough()
                                        )
                                      })
                                    ),
                                    mimeType: mtMap83.objectField(
                                      "mime_type",
                                      mtMap83.passthrough()
                                    ),
                                    entryId: mtMap83.objectField(
                                      "entry_id",
                                      mtMap83.passthrough()
                                    )
                                  })
                                )
                              ])
                            )
                          })
                        )
                      ])
                    )
                  )
                })
              ),
              error: mtMap83.objectField(
                "error",
                mtMap83.object({
                  type: mtMap83.objectField("type", mtMap83.passthrough()),
                  message: mtMap83.objectField("message", mtMap83.passthrough())
                })
              ),
              createdAt: mtMap83.objectField("created_at", mtMap83.date())
            })
          )
        ),
        attachedItems: mtMap83.objectField(
          "attached_items",
          mtMap83.array(
            mtMap83.object({
              id: mtMap83.objectField("id", mtMap83.passthrough()),
              actor: mtMap83.objectField(
                "actor",
                mtMap83.object({
                  id: mtMap83.objectField("id", mtMap83.passthrough()),
                  name: mtMap83.objectField("name", mtMap83.passthrough()),
                  type: mtMap83.objectField("type", mtMap83.passthrough()),
                  metadata: mtMap83.objectField(
                    "metadata",
                    mtMap83.passthrough()
                  ),
                  createdAt: mtMap83.objectField("created_at", mtMap83.date()),
                  updatedAt: mtMap83.objectField("updated_at", mtMap83.date())
                })
              ),
              key: mtMap83.objectField("key", mtMap83.passthrough()),
              value: mtMap83.objectField("value", mtMap83.passthrough()),
              createdAt: mtMap83.objectField("created_at", mtMap83.date())
            })
          )
        ),
        metadata: mtMap83.objectField("metadata", mtMap83.passthrough()),
        actor: mtMap83.objectField(
          "actor",
          mtMap83.object({
            id: mtMap83.objectField("id", mtMap83.passthrough()),
            name: mtMap83.objectField("name", mtMap83.passthrough()),
            type: mtMap83.objectField("type", mtMap83.passthrough()),
            metadata: mtMap83.objectField("metadata", mtMap83.passthrough()),
            createdAt: mtMap83.objectField("created_at", mtMap83.date()),
            updatedAt: mtMap83.objectField("updated_at", mtMap83.date())
          })
        ),
        run: mtMap83.objectField(
          "run",
          mtMap83.object({
            id: mtMap83.objectField("id", mtMap83.passthrough()),
            agentId: mtMap83.objectField("agent_id", mtMap83.passthrough()),
            status: mtMap83.objectField("status", mtMap83.passthrough()),
            metadata: mtMap83.objectField("metadata", mtMap83.passthrough()),
            startedAt: mtMap83.objectField("started_at", mtMap83.date()),
            createdAt: mtMap83.objectField("created_at", mtMap83.date()),
            completedAt: mtMap83.objectField("completed_at", mtMap83.date())
          })
        )
      })
    )
  ),
  pagination: mtMap83.objectField(
    "pagination",
    mtMap83.object({
      afterCursor: mtMap83.objectField("after_cursor", mtMap83.passthrough()),
      beforeCursor: mtMap83.objectField("before_cursor", mtMap83.passthrough()),
      hasMoreBefore: mtMap83.objectField(
        "has_more_before",
        mtMap83.passthrough()
      ),
      hasMoreAfter: mtMap83.objectField("has_more_after", mtMap83.passthrough()),
      pageSize: mtMap83.objectField("page_size", mtMap83.passthrough()),
      sort: mtMap83.objectField(
        "sort",
        mtMap83.array(
          mtMap83.object({
            field: mtMap83.objectField("field", mtMap83.passthrough()),
            order: mtMap83.objectField("order", mtMap83.passthrough())
          })
        )
      )
    })
  )
});
var mapManagementInstancesThreadsMessagesListQuery = mtMap83.object({
  id: mtMap83.objectField(
    "id",
    mtMap83.union([
      mtMap83.unionOption(
        "object",
        mtMap83.object({
          in: mtMap83.objectField("in", mtMap83.array(mtMap83.passthrough())),
          eq: mtMap83.objectField("eq", mtMap83.passthrough())
        })
      ),
      mtMap83.unionOption("string", mtMap83.passthrough())
    ])
  ),
  ids: mtMap83.objectField(
    "ids",
    mtMap83.union([
      mtMap83.unionOption(
        "object",
        mtMap83.object({
          in: mtMap83.objectField("in", mtMap83.array(mtMap83.passthrough())),
          eq: mtMap83.objectField("eq", mtMap83.passthrough())
        })
      ),
      mtMap83.unionOption("string", mtMap83.passthrough())
    ])
  ),
  createdAt: mtMap83.objectField(
    "created_at",
    mtMap83.union([
      mtMap83.unionOption(
        "object",
        mtMap83.object({
          eq: mtMap83.objectField("eq", mtMap83.date()),
          gt: mtMap83.objectField("gt", mtMap83.date()),
          gte: mtMap83.objectField("gte", mtMap83.date()),
          lt: mtMap83.objectField("lt", mtMap83.date()),
          lte: mtMap83.objectField("lte", mtMap83.date())
        })
      ),
      mtMap83.unionOption("date", mtMap83.passthrough())
    ])
  ),
  status: mtMap83.objectField(
    "status",
    mtMap83.union([
      mtMap83.unionOption(
        "object",
        mtMap83.object({
          in: mtMap83.objectField("in", mtMap83.array(mtMap83.passthrough())),
          eq: mtMap83.objectField("eq", mtMap83.passthrough())
        })
      ),
      mtMap83.unionOption("string", mtMap83.passthrough())
    ])
  ),
  statuses: mtMap83.objectField(
    "statuses",
    mtMap83.union([
      mtMap83.unionOption(
        "object",
        mtMap83.object({
          in: mtMap83.objectField("in", mtMap83.array(mtMap83.passthrough())),
          eq: mtMap83.objectField("eq", mtMap83.passthrough())
        })
      ),
      mtMap83.unionOption("string", mtMap83.passthrough())
    ])
  ),
  type: mtMap83.objectField(
    "type",
    mtMap83.union([
      mtMap83.unionOption(
        "object",
        mtMap83.object({
          in: mtMap83.objectField("in", mtMap83.array(mtMap83.passthrough())),
          eq: mtMap83.objectField("eq", mtMap83.passthrough())
        })
      ),
      mtMap83.unionOption("string", mtMap83.passthrough())
    ])
  ),
  types: mtMap83.objectField(
    "types",
    mtMap83.union([
      mtMap83.unionOption(
        "object",
        mtMap83.object({
          in: mtMap83.objectField("in", mtMap83.array(mtMap83.passthrough())),
          eq: mtMap83.objectField("eq", mtMap83.passthrough())
        })
      ),
      mtMap83.unionOption("string", mtMap83.passthrough())
    ])
  ),
  sort: mtMap83.objectField(
    "sort",
    mtMap83.union([
      mtMap83.unionOption("string", mtMap83.passthrough()),
      mtMap83.unionOption(
        "array",
        mtMap83.union([
          mtMap83.unionOption(
            "object",
            mtMap83.object({
              field: mtMap83.objectField("field", mtMap83.passthrough()),
              order: mtMap83.objectField("order", mtMap83.passthrough())
            })
          )
        ])
      )
    ])
  ),
  limit: mtMap83.objectField("limit", mtMap83.passthrough()),
  cursor: mtMap83.objectField("cursor", mtMap83.passthrough()),
  order: mtMap83.objectField("order", mtMap83.passthrough())
});

// src/resources/management/instances/threads/participants/list.ts
import { mtMap as mtMap84 } from "@metorial/util-resource-mapper";
var mapManagementInstancesThreadsParticipantsListOutput = mtMap84.object({
  items: mtMap84.objectField(
    "items",
    mtMap84.array(
      mtMap84.object({
        id: mtMap84.objectField("id", mtMap84.passthrough()),
        name: mtMap84.objectField("name", mtMap84.passthrough()),
        type: mtMap84.objectField("type", mtMap84.passthrough()),
        metadata: mtMap84.objectField("metadata", mtMap84.passthrough()),
        createdAt: mtMap84.objectField("created_at", mtMap84.date()),
        updatedAt: mtMap84.objectField("updated_at", mtMap84.date()),
        joinedAt: mtMap84.objectField("joined_at", mtMap84.date()),
        threadId: mtMap84.objectField("thread_id", mtMap84.passthrough())
      })
    )
  ),
  pagination: mtMap84.objectField(
    "pagination",
    mtMap84.object({
      afterCursor: mtMap84.objectField("after_cursor", mtMap84.passthrough()),
      beforeCursor: mtMap84.objectField("before_cursor", mtMap84.passthrough()),
      hasMoreBefore: mtMap84.objectField(
        "has_more_before",
        mtMap84.passthrough()
      ),
      hasMoreAfter: mtMap84.objectField("has_more_after", mtMap84.passthrough()),
      pageSize: mtMap84.objectField("page_size", mtMap84.passthrough()),
      sort: mtMap84.objectField(
        "sort",
        mtMap84.array(
          mtMap84.object({
            field: mtMap84.objectField("field", mtMap84.passthrough()),
            order: mtMap84.objectField("order", mtMap84.passthrough())
          })
        )
      )
    })
  )
});
var mapManagementInstancesThreadsParticipantsListQuery = mtMap84.object({
  id: mtMap84.objectField(
    "id",
    mtMap84.union([
      mtMap84.unionOption(
        "object",
        mtMap84.object({
          in: mtMap84.objectField("in", mtMap84.array(mtMap84.passthrough())),
          eq: mtMap84.objectField("eq", mtMap84.passthrough())
        })
      ),
      mtMap84.unionOption("string", mtMap84.passthrough())
    ])
  ),
  ids: mtMap84.objectField(
    "ids",
    mtMap84.union([
      mtMap84.unionOption(
        "object",
        mtMap84.object({
          in: mtMap84.objectField("in", mtMap84.array(mtMap84.passthrough())),
          eq: mtMap84.objectField("eq", mtMap84.passthrough())
        })
      ),
      mtMap84.unionOption("string", mtMap84.passthrough())
    ])
  ),
  createdAt: mtMap84.objectField(
    "created_at",
    mtMap84.union([
      mtMap84.unionOption(
        "object",
        mtMap84.object({
          eq: mtMap84.objectField("eq", mtMap84.date()),
          gt: mtMap84.objectField("gt", mtMap84.date()),
          gte: mtMap84.objectField("gte", mtMap84.date()),
          lt: mtMap84.objectField("lt", mtMap84.date()),
          lte: mtMap84.objectField("lte", mtMap84.date())
        })
      ),
      mtMap84.unionOption("date", mtMap84.passthrough())
    ])
  ),
  updatedAt: mtMap84.objectField(
    "updated_at",
    mtMap84.union([
      mtMap84.unionOption(
        "object",
        mtMap84.object({
          eq: mtMap84.objectField("eq", mtMap84.date()),
          gt: mtMap84.objectField("gt", mtMap84.date()),
          gte: mtMap84.objectField("gte", mtMap84.date()),
          lt: mtMap84.objectField("lt", mtMap84.date()),
          lte: mtMap84.objectField("lte", mtMap84.date())
        })
      ),
      mtMap84.unionOption("date", mtMap84.passthrough())
    ])
  ),
  type: mtMap84.objectField(
    "type",
    mtMap84.union([
      mtMap84.unionOption(
        "object",
        mtMap84.object({
          in: mtMap84.objectField("in", mtMap84.array(mtMap84.passthrough())),
          eq: mtMap84.objectField("eq", mtMap84.passthrough())
        })
      ),
      mtMap84.unionOption("string", mtMap84.passthrough())
    ])
  ),
  types: mtMap84.objectField(
    "types",
    mtMap84.union([
      mtMap84.unionOption(
        "object",
        mtMap84.object({
          in: mtMap84.objectField("in", mtMap84.array(mtMap84.passthrough())),
          eq: mtMap84.objectField("eq", mtMap84.passthrough())
        })
      ),
      mtMap84.unionOption("string", mtMap84.passthrough())
    ])
  ),
  sort: mtMap84.objectField(
    "sort",
    mtMap84.union([
      mtMap84.unionOption("string", mtMap84.passthrough()),
      mtMap84.unionOption(
        "array",
        mtMap84.union([
          mtMap84.unionOption(
            "object",
            mtMap84.object({
              field: mtMap84.objectField("field", mtMap84.passthrough()),
              order: mtMap84.objectField("order", mtMap84.passthrough())
            })
          )
        ])
      )
    ])
  ),
  limit: mtMap84.objectField("limit", mtMap84.passthrough()),
  cursor: mtMap84.objectField("cursor", mtMap84.passthrough()),
  order: mtMap84.objectField("order", mtMap84.passthrough())
});

// src/resources/management/instances/threads/update.ts
import { mtMap as mtMap85 } from "@metorial/util-resource-mapper";
var mapManagementInstancesThreadsUpdateOutput = mtMap85.object({
  id: mtMap85.objectField("id", mtMap85.passthrough()),
  name: mtMap85.objectField("name", mtMap85.passthrough()),
  agentId: mtMap85.objectField("agent_id", mtMap85.passthrough()),
  instanceId: mtMap85.objectField("instance_id", mtMap85.passthrough()),
  timezone: mtMap85.objectField(
    "timezone",
    mtMap85.object({
      code: mtMap85.objectField("code", mtMap85.passthrough()),
      utc: mtMap85.objectField("utc", mtMap85.passthrough()),
      utcOffsetInMinutes: mtMap85.objectField(
        "utc_offset_in_minutes",
        mtMap85.passthrough()
      )
    })
  ),
  country: mtMap85.objectField(
    "country",
    mtMap85.object({ code: mtMap85.objectField("code", mtMap85.passthrough()) })
  ),
  language: mtMap85.objectField(
    "language",
    mtMap85.object({
      code: mtMap85.objectField("code", mtMap85.passthrough()),
      full: mtMap85.objectField("full", mtMap85.passthrough())
    })
  ),
  metadata: mtMap85.objectField("metadata", mtMap85.passthrough()),
  createdAt: mtMap85.objectField("created_at", mtMap85.date()),
  updatedAt: mtMap85.objectField("updated_at", mtMap85.date())
});
var mapManagementInstancesThreadsUpdateBody = mtMap85.object({
  metadata: mtMap85.objectField("metadata", mtMap85.passthrough()),
  name: mtMap85.objectField("name", mtMap85.passthrough())
});

// src/resources/management/instances/users/create.ts
import { mtMap as mtMap86 } from "@metorial/util-resource-mapper";
var mapManagementInstancesUsersCreateOutput = mtMap86.object({
  id: mtMap86.objectField("id", mtMap86.passthrough()),
  status: mtMap86.objectField("status", mtMap86.passthrough()),
  type: mtMap86.objectField("type", mtMap86.passthrough()),
  name: mtMap86.objectField("name", mtMap86.passthrough()),
  email: mtMap86.objectField("email", mtMap86.passthrough()),
  metadata: mtMap86.objectField("metadata", mtMap86.passthrough()),
  defaultGroupId: mtMap86.objectField("default_group_id", mtMap86.passthrough()),
  createdAt: mtMap86.objectField("created_at", mtMap86.date()),
  updatedAt: mtMap86.objectField("updated_at", mtMap86.date())
});
var mapManagementInstancesUsersCreateBody = mtMap86.object({
  id: mtMap86.objectField("id", mtMap86.passthrough()),
  name: mtMap86.objectField("name", mtMap86.passthrough()),
  email: mtMap86.objectField("email", mtMap86.passthrough()),
  metadata: mtMap86.objectField("metadata", mtMap86.passthrough())
});

// src/resources/management/instances/users/delete.ts
import { mtMap as mtMap87 } from "@metorial/util-resource-mapper";
var mapManagementInstancesUsersDeleteOutput = mtMap87.object({
  id: mtMap87.objectField("id", mtMap87.passthrough()),
  status: mtMap87.objectField("status", mtMap87.passthrough()),
  type: mtMap87.objectField("type", mtMap87.passthrough()),
  name: mtMap87.objectField("name", mtMap87.passthrough()),
  email: mtMap87.objectField("email", mtMap87.passthrough()),
  metadata: mtMap87.objectField("metadata", mtMap87.passthrough()),
  defaultGroupId: mtMap87.objectField("default_group_id", mtMap87.passthrough()),
  createdAt: mtMap87.objectField("created_at", mtMap87.date()),
  updatedAt: mtMap87.objectField("updated_at", mtMap87.date())
});

// src/resources/management/instances/users/get.ts
import { mtMap as mtMap88 } from "@metorial/util-resource-mapper";
var mapManagementInstancesUsersGetOutput = mtMap88.object({
  id: mtMap88.objectField("id", mtMap88.passthrough()),
  status: mtMap88.objectField("status", mtMap88.passthrough()),
  type: mtMap88.objectField("type", mtMap88.passthrough()),
  name: mtMap88.objectField("name", mtMap88.passthrough()),
  email: mtMap88.objectField("email", mtMap88.passthrough()),
  metadata: mtMap88.objectField("metadata", mtMap88.passthrough()),
  defaultGroupId: mtMap88.objectField("default_group_id", mtMap88.passthrough()),
  createdAt: mtMap88.objectField("created_at", mtMap88.date()),
  updatedAt: mtMap88.objectField("updated_at", mtMap88.date())
});

// src/resources/management/instances/users/list.ts
import { mtMap as mtMap89 } from "@metorial/util-resource-mapper";
var mapManagementInstancesUsersListOutput = mtMap89.object({
  items: mtMap89.objectField(
    "items",
    mtMap89.array(
      mtMap89.object({
        id: mtMap89.objectField("id", mtMap89.passthrough()),
        status: mtMap89.objectField("status", mtMap89.passthrough()),
        type: mtMap89.objectField("type", mtMap89.passthrough()),
        name: mtMap89.objectField("name", mtMap89.passthrough()),
        email: mtMap89.objectField("email", mtMap89.passthrough()),
        metadata: mtMap89.objectField("metadata", mtMap89.passthrough()),
        defaultGroupId: mtMap89.objectField(
          "default_group_id",
          mtMap89.passthrough()
        ),
        createdAt: mtMap89.objectField("created_at", mtMap89.date()),
        updatedAt: mtMap89.objectField("updated_at", mtMap89.date())
      })
    )
  ),
  pagination: mtMap89.objectField(
    "pagination",
    mtMap89.object({
      afterCursor: mtMap89.objectField("after_cursor", mtMap89.passthrough()),
      beforeCursor: mtMap89.objectField("before_cursor", mtMap89.passthrough()),
      hasMoreBefore: mtMap89.objectField(
        "has_more_before",
        mtMap89.passthrough()
      ),
      hasMoreAfter: mtMap89.objectField("has_more_after", mtMap89.passthrough()),
      pageSize: mtMap89.objectField("page_size", mtMap89.passthrough()),
      sort: mtMap89.objectField(
        "sort",
        mtMap89.array(
          mtMap89.object({
            field: mtMap89.objectField("field", mtMap89.passthrough()),
            order: mtMap89.objectField("order", mtMap89.passthrough())
          })
        )
      )
    })
  )
});
var mapManagementInstancesUsersListQuery = mtMap89.object({
  id: mtMap89.objectField(
    "id",
    mtMap89.union([
      mtMap89.unionOption(
        "object",
        mtMap89.object({
          in: mtMap89.objectField("in", mtMap89.array(mtMap89.passthrough())),
          eq: mtMap89.objectField("eq", mtMap89.passthrough())
        })
      ),
      mtMap89.unionOption("string", mtMap89.passthrough())
    ])
  ),
  ids: mtMap89.objectField(
    "ids",
    mtMap89.union([
      mtMap89.unionOption(
        "object",
        mtMap89.object({
          in: mtMap89.objectField("in", mtMap89.array(mtMap89.passthrough())),
          eq: mtMap89.objectField("eq", mtMap89.passthrough())
        })
      ),
      mtMap89.unionOption("string", mtMap89.passthrough())
    ])
  ),
  createdAt: mtMap89.objectField(
    "created_at",
    mtMap89.union([
      mtMap89.unionOption(
        "object",
        mtMap89.object({
          eq: mtMap89.objectField("eq", mtMap89.date()),
          gt: mtMap89.objectField("gt", mtMap89.date()),
          gte: mtMap89.objectField("gte", mtMap89.date()),
          lt: mtMap89.objectField("lt", mtMap89.date()),
          lte: mtMap89.objectField("lte", mtMap89.date())
        })
      ),
      mtMap89.unionOption("date", mtMap89.passthrough())
    ])
  ),
  updatedAt: mtMap89.objectField(
    "updated_at",
    mtMap89.union([
      mtMap89.unionOption(
        "object",
        mtMap89.object({
          eq: mtMap89.objectField("eq", mtMap89.date()),
          gt: mtMap89.objectField("gt", mtMap89.date()),
          gte: mtMap89.objectField("gte", mtMap89.date()),
          lt: mtMap89.objectField("lt", mtMap89.date()),
          lte: mtMap89.objectField("lte", mtMap89.date())
        })
      ),
      mtMap89.unionOption("date", mtMap89.passthrough())
    ])
  ),
  sort: mtMap89.objectField(
    "sort",
    mtMap89.union([
      mtMap89.unionOption("string", mtMap89.passthrough()),
      mtMap89.unionOption(
        "array",
        mtMap89.union([
          mtMap89.unionOption(
            "object",
            mtMap89.object({
              field: mtMap89.objectField("field", mtMap89.passthrough()),
              order: mtMap89.objectField("order", mtMap89.passthrough())
            })
          )
        ])
      )
    ])
  ),
  threadId: mtMap89.objectField("thread_id", mtMap89.passthrough()),
  groupId: mtMap89.objectField("group_id", mtMap89.passthrough()),
  limit: mtMap89.objectField("limit", mtMap89.passthrough()),
  cursor: mtMap89.objectField("cursor", mtMap89.passthrough()),
  order: mtMap89.objectField("order", mtMap89.passthrough())
});

// src/resources/management/instances/users/update.ts
import { mtMap as mtMap90 } from "@metorial/util-resource-mapper";
var mapManagementInstancesUsersUpdateOutput = mtMap90.object({
  id: mtMap90.objectField("id", mtMap90.passthrough()),
  status: mtMap90.objectField("status", mtMap90.passthrough()),
  type: mtMap90.objectField("type", mtMap90.passthrough()),
  name: mtMap90.objectField("name", mtMap90.passthrough()),
  email: mtMap90.objectField("email", mtMap90.passthrough()),
  metadata: mtMap90.objectField("metadata", mtMap90.passthrough()),
  defaultGroupId: mtMap90.objectField("default_group_id", mtMap90.passthrough()),
  createdAt: mtMap90.objectField("created_at", mtMap90.date()),
  updatedAt: mtMap90.objectField("updated_at", mtMap90.date())
});
var mapManagementInstancesUsersUpdateBody = mtMap90.object({
  name: mtMap90.objectField("name", mtMap90.passthrough()),
  email: mtMap90.objectField("email", mtMap90.passthrough()),
  metadata: mtMap90.objectField("metadata", mtMap90.passthrough())
});

// src/resources/management/projects/agents/create.ts
import { mtMap as mtMap91 } from "@metorial/util-resource-mapper";
var mapManagementProjectsAgentsCreateOutput = mtMap91.object({
  id: mtMap91.objectField("id", mtMap91.passthrough()),
  status: mtMap91.objectField("status", mtMap91.passthrough()),
  slug: mtMap91.objectField("slug", mtMap91.passthrough()),
  name: mtMap91.objectField("name", mtMap91.passthrough()),
  publicName: mtMap91.objectField("public_name", mtMap91.passthrough()),
  projectId: mtMap91.objectField("project_id", mtMap91.passthrough()),
  organizationId: mtMap91.objectField("organization_id", mtMap91.passthrough()),
  createdAt: mtMap91.objectField("created_at", mtMap91.date()),
  updatedAt: mtMap91.objectField("updated_at", mtMap91.date()),
  instanceAgents: mtMap91.objectField(
    "instance_agents",
    mtMap91.array(
      mtMap91.object({
        id: mtMap91.objectField("id", mtMap91.passthrough()),
        slug: mtMap91.objectField("slug", mtMap91.passthrough()),
        name: mtMap91.objectField("name", mtMap91.passthrough()),
        status: mtMap91.objectField("status", mtMap91.passthrough()),
        instanceId: mtMap91.objectField("instance_id", mtMap91.passthrough()),
        agentId: mtMap91.objectField("agent_id", mtMap91.passthrough()),
        createdAt: mtMap91.objectField("created_at", mtMap91.date()),
        updatedAt: mtMap91.objectField("updated_at", mtMap91.date()),
        currentRelease: mtMap91.objectField(
          "current_release",
          mtMap91.object({
            id: mtMap91.objectField("id", mtMap91.passthrough()),
            agentId: mtMap91.objectField("agent_id", mtMap91.passthrough()),
            version: mtMap91.objectField("version", mtMap91.passthrough()),
            createdAt: mtMap91.objectField("created_at", mtMap91.date())
          })
        )
      })
    )
  )
});
var mapManagementProjectsAgentsCreateBody = mtMap91.object({
  name: mtMap91.objectField("name", mtMap91.passthrough()),
  slug: mtMap91.objectField("slug", mtMap91.passthrough())
});

// src/resources/management/projects/agents/delete.ts
import { mtMap as mtMap92 } from "@metorial/util-resource-mapper";
var mapManagementProjectsAgentsDeleteOutput = mtMap92.object({
  id: mtMap92.objectField("id", mtMap92.passthrough()),
  status: mtMap92.objectField("status", mtMap92.passthrough()),
  slug: mtMap92.objectField("slug", mtMap92.passthrough()),
  name: mtMap92.objectField("name", mtMap92.passthrough()),
  publicName: mtMap92.objectField("public_name", mtMap92.passthrough()),
  projectId: mtMap92.objectField("project_id", mtMap92.passthrough()),
  organizationId: mtMap92.objectField("organization_id", mtMap92.passthrough()),
  createdAt: mtMap92.objectField("created_at", mtMap92.date()),
  updatedAt: mtMap92.objectField("updated_at", mtMap92.date()),
  instanceAgents: mtMap92.objectField(
    "instance_agents",
    mtMap92.array(
      mtMap92.object({
        id: mtMap92.objectField("id", mtMap92.passthrough()),
        slug: mtMap92.objectField("slug", mtMap92.passthrough()),
        name: mtMap92.objectField("name", mtMap92.passthrough()),
        status: mtMap92.objectField("status", mtMap92.passthrough()),
        instanceId: mtMap92.objectField("instance_id", mtMap92.passthrough()),
        agentId: mtMap92.objectField("agent_id", mtMap92.passthrough()),
        createdAt: mtMap92.objectField("created_at", mtMap92.date()),
        updatedAt: mtMap92.objectField("updated_at", mtMap92.date()),
        currentRelease: mtMap92.objectField(
          "current_release",
          mtMap92.object({
            id: mtMap92.objectField("id", mtMap92.passthrough()),
            agentId: mtMap92.objectField("agent_id", mtMap92.passthrough()),
            version: mtMap92.objectField("version", mtMap92.passthrough()),
            createdAt: mtMap92.objectField("created_at", mtMap92.date())
          })
        )
      })
    )
  )
});

// src/resources/management/projects/agents/get.ts
import { mtMap as mtMap93 } from "@metorial/util-resource-mapper";
var mapManagementProjectsAgentsGetOutput = mtMap93.object({
  id: mtMap93.objectField("id", mtMap93.passthrough()),
  status: mtMap93.objectField("status", mtMap93.passthrough()),
  slug: mtMap93.objectField("slug", mtMap93.passthrough()),
  name: mtMap93.objectField("name", mtMap93.passthrough()),
  publicName: mtMap93.objectField("public_name", mtMap93.passthrough()),
  projectId: mtMap93.objectField("project_id", mtMap93.passthrough()),
  organizationId: mtMap93.objectField("organization_id", mtMap93.passthrough()),
  createdAt: mtMap93.objectField("created_at", mtMap93.date()),
  updatedAt: mtMap93.objectField("updated_at", mtMap93.date()),
  instanceAgents: mtMap93.objectField(
    "instance_agents",
    mtMap93.array(
      mtMap93.object({
        id: mtMap93.objectField("id", mtMap93.passthrough()),
        slug: mtMap93.objectField("slug", mtMap93.passthrough()),
        name: mtMap93.objectField("name", mtMap93.passthrough()),
        status: mtMap93.objectField("status", mtMap93.passthrough()),
        instanceId: mtMap93.objectField("instance_id", mtMap93.passthrough()),
        agentId: mtMap93.objectField("agent_id", mtMap93.passthrough()),
        createdAt: mtMap93.objectField("created_at", mtMap93.date()),
        updatedAt: mtMap93.objectField("updated_at", mtMap93.date()),
        currentRelease: mtMap93.objectField(
          "current_release",
          mtMap93.object({
            id: mtMap93.objectField("id", mtMap93.passthrough()),
            agentId: mtMap93.objectField("agent_id", mtMap93.passthrough()),
            version: mtMap93.objectField("version", mtMap93.passthrough()),
            createdAt: mtMap93.objectField("created_at", mtMap93.date())
          })
        )
      })
    )
  )
});

// src/resources/management/projects/agents/instance-agents/get.ts
import { mtMap as mtMap94 } from "@metorial/util-resource-mapper";
var mapManagementProjectsAgentsInstanceAgentsGetOutput = mtMap94.object({
  id: mtMap94.objectField("id", mtMap94.passthrough()),
  slug: mtMap94.objectField("slug", mtMap94.passthrough()),
  name: mtMap94.objectField("name", mtMap94.passthrough()),
  status: mtMap94.objectField("status", mtMap94.passthrough()),
  instanceId: mtMap94.objectField("instance_id", mtMap94.passthrough()),
  agentId: mtMap94.objectField("agent_id", mtMap94.passthrough()),
  createdAt: mtMap94.objectField("created_at", mtMap94.date()),
  updatedAt: mtMap94.objectField("updated_at", mtMap94.date()),
  currentRelease: mtMap94.objectField(
    "current_release",
    mtMap94.object({
      id: mtMap94.objectField("id", mtMap94.passthrough()),
      agentId: mtMap94.objectField("agent_id", mtMap94.passthrough()),
      version: mtMap94.objectField("version", mtMap94.passthrough()),
      createdAt: mtMap94.objectField("created_at", mtMap94.date())
    })
  )
});

// src/resources/management/projects/agents/instance-agents/list.ts
import { mtMap as mtMap95 } from "@metorial/util-resource-mapper";
var mapManagementProjectsAgentsInstanceAgentsListOutput = mtMap95.object({
  items: mtMap95.objectField(
    "items",
    mtMap95.array(
      mtMap95.object({
        id: mtMap95.objectField("id", mtMap95.passthrough()),
        slug: mtMap95.objectField("slug", mtMap95.passthrough()),
        name: mtMap95.objectField("name", mtMap95.passthrough()),
        status: mtMap95.objectField("status", mtMap95.passthrough()),
        instanceId: mtMap95.objectField("instance_id", mtMap95.passthrough()),
        agentId: mtMap95.objectField("agent_id", mtMap95.passthrough()),
        createdAt: mtMap95.objectField("created_at", mtMap95.date()),
        updatedAt: mtMap95.objectField("updated_at", mtMap95.date()),
        currentRelease: mtMap95.objectField(
          "current_release",
          mtMap95.object({
            id: mtMap95.objectField("id", mtMap95.passthrough()),
            agentId: mtMap95.objectField("agent_id", mtMap95.passthrough()),
            version: mtMap95.objectField("version", mtMap95.passthrough()),
            createdAt: mtMap95.objectField("created_at", mtMap95.date())
          })
        )
      })
    )
  ),
  pagination: mtMap95.objectField(
    "pagination",
    mtMap95.object({
      afterCursor: mtMap95.objectField("after_cursor", mtMap95.passthrough()),
      beforeCursor: mtMap95.objectField("before_cursor", mtMap95.passthrough()),
      hasMoreBefore: mtMap95.objectField(
        "has_more_before",
        mtMap95.passthrough()
      ),
      hasMoreAfter: mtMap95.objectField("has_more_after", mtMap95.passthrough()),
      pageSize: mtMap95.objectField("page_size", mtMap95.passthrough()),
      sort: mtMap95.objectField(
        "sort",
        mtMap95.array(
          mtMap95.object({
            field: mtMap95.objectField("field", mtMap95.passthrough()),
            order: mtMap95.objectField("order", mtMap95.passthrough())
          })
        )
      )
    })
  )
});
var mapManagementProjectsAgentsInstanceAgentsListQuery = mtMap95.object({
  createdAt: mtMap95.objectField(
    "created_at",
    mtMap95.union([
      mtMap95.unionOption(
        "object",
        mtMap95.object({
          eq: mtMap95.objectField("eq", mtMap95.date()),
          gt: mtMap95.objectField("gt", mtMap95.date()),
          gte: mtMap95.objectField("gte", mtMap95.date()),
          lt: mtMap95.objectField("lt", mtMap95.date()),
          lte: mtMap95.objectField("lte", mtMap95.date())
        })
      ),
      mtMap95.unionOption("date", mtMap95.passthrough())
    ])
  ),
  id: mtMap95.objectField(
    "id",
    mtMap95.union([
      mtMap95.unionOption(
        "object",
        mtMap95.object({
          in: mtMap95.objectField("in", mtMap95.array(mtMap95.passthrough())),
          eq: mtMap95.objectField("eq", mtMap95.passthrough())
        })
      ),
      mtMap95.unionOption("string", mtMap95.passthrough())
    ])
  ),
  ids: mtMap95.objectField(
    "ids",
    mtMap95.union([
      mtMap95.unionOption(
        "object",
        mtMap95.object({
          in: mtMap95.objectField("in", mtMap95.array(mtMap95.passthrough())),
          eq: mtMap95.objectField("eq", mtMap95.passthrough())
        })
      ),
      mtMap95.unionOption("string", mtMap95.passthrough())
    ])
  ),
  sort: mtMap95.objectField(
    "sort",
    mtMap95.union([
      mtMap95.unionOption("string", mtMap95.passthrough()),
      mtMap95.unionOption(
        "array",
        mtMap95.union([
          mtMap95.unionOption(
            "object",
            mtMap95.object({
              field: mtMap95.objectField("field", mtMap95.passthrough()),
              order: mtMap95.objectField("order", mtMap95.passthrough())
            })
          )
        ])
      )
    ])
  ),
  limit: mtMap95.objectField("limit", mtMap95.passthrough()),
  cursor: mtMap95.objectField("cursor", mtMap95.passthrough()),
  order: mtMap95.objectField("order", mtMap95.passthrough())
});

// src/resources/management/projects/agents/list.ts
import { mtMap as mtMap96 } from "@metorial/util-resource-mapper";
var mapManagementProjectsAgentsListOutput = mtMap96.object({
  items: mtMap96.objectField(
    "items",
    mtMap96.array(
      mtMap96.object({
        id: mtMap96.objectField("id", mtMap96.passthrough()),
        status: mtMap96.objectField("status", mtMap96.passthrough()),
        slug: mtMap96.objectField("slug", mtMap96.passthrough()),
        name: mtMap96.objectField("name", mtMap96.passthrough()),
        publicName: mtMap96.objectField("public_name", mtMap96.passthrough()),
        projectId: mtMap96.objectField("project_id", mtMap96.passthrough()),
        organizationId: mtMap96.objectField(
          "organization_id",
          mtMap96.passthrough()
        ),
        createdAt: mtMap96.objectField("created_at", mtMap96.date()),
        updatedAt: mtMap96.objectField("updated_at", mtMap96.date()),
        instanceAgents: mtMap96.objectField(
          "instance_agents",
          mtMap96.array(
            mtMap96.object({
              id: mtMap96.objectField("id", mtMap96.passthrough()),
              slug: mtMap96.objectField("slug", mtMap96.passthrough()),
              name: mtMap96.objectField("name", mtMap96.passthrough()),
              status: mtMap96.objectField("status", mtMap96.passthrough()),
              instanceId: mtMap96.objectField(
                "instance_id",
                mtMap96.passthrough()
              ),
              agentId: mtMap96.objectField("agent_id", mtMap96.passthrough()),
              createdAt: mtMap96.objectField("created_at", mtMap96.date()),
              updatedAt: mtMap96.objectField("updated_at", mtMap96.date()),
              currentRelease: mtMap96.objectField(
                "current_release",
                mtMap96.object({
                  id: mtMap96.objectField("id", mtMap96.passthrough()),
                  agentId: mtMap96.objectField("agent_id", mtMap96.passthrough()),
                  version: mtMap96.objectField("version", mtMap96.passthrough()),
                  createdAt: mtMap96.objectField("created_at", mtMap96.date())
                })
              )
            })
          )
        )
      })
    )
  ),
  pagination: mtMap96.objectField(
    "pagination",
    mtMap96.object({
      afterCursor: mtMap96.objectField("after_cursor", mtMap96.passthrough()),
      beforeCursor: mtMap96.objectField("before_cursor", mtMap96.passthrough()),
      hasMoreBefore: mtMap96.objectField(
        "has_more_before",
        mtMap96.passthrough()
      ),
      hasMoreAfter: mtMap96.objectField("has_more_after", mtMap96.passthrough()),
      pageSize: mtMap96.objectField("page_size", mtMap96.passthrough()),
      sort: mtMap96.objectField(
        "sort",
        mtMap96.array(
          mtMap96.object({
            field: mtMap96.objectField("field", mtMap96.passthrough()),
            order: mtMap96.objectField("order", mtMap96.passthrough())
          })
        )
      )
    })
  )
});
var mapManagementProjectsAgentsListQuery = mtMap96.object({
  createdAt: mtMap96.objectField(
    "created_at",
    mtMap96.union([
      mtMap96.unionOption(
        "object",
        mtMap96.object({
          eq: mtMap96.objectField("eq", mtMap96.date()),
          gt: mtMap96.objectField("gt", mtMap96.date()),
          gte: mtMap96.objectField("gte", mtMap96.date()),
          lt: mtMap96.objectField("lt", mtMap96.date()),
          lte: mtMap96.objectField("lte", mtMap96.date())
        })
      ),
      mtMap96.unionOption("date", mtMap96.passthrough())
    ])
  ),
  id: mtMap96.objectField(
    "id",
    mtMap96.union([
      mtMap96.unionOption(
        "object",
        mtMap96.object({
          in: mtMap96.objectField("in", mtMap96.array(mtMap96.passthrough())),
          eq: mtMap96.objectField("eq", mtMap96.passthrough())
        })
      ),
      mtMap96.unionOption("string", mtMap96.passthrough())
    ])
  ),
  ids: mtMap96.objectField(
    "ids",
    mtMap96.union([
      mtMap96.unionOption(
        "object",
        mtMap96.object({
          in: mtMap96.objectField("in", mtMap96.array(mtMap96.passthrough())),
          eq: mtMap96.objectField("eq", mtMap96.passthrough())
        })
      ),
      mtMap96.unionOption("string", mtMap96.passthrough())
    ])
  ),
  sort: mtMap96.objectField(
    "sort",
    mtMap96.union([
      mtMap96.unionOption("string", mtMap96.passthrough()),
      mtMap96.unionOption(
        "array",
        mtMap96.union([
          mtMap96.unionOption(
            "object",
            mtMap96.object({
              field: mtMap96.objectField("field", mtMap96.passthrough()),
              order: mtMap96.objectField("order", mtMap96.passthrough())
            })
          )
        ])
      )
    ])
  ),
  limit: mtMap96.objectField("limit", mtMap96.passthrough()),
  cursor: mtMap96.objectField("cursor", mtMap96.passthrough()),
  order: mtMap96.objectField("order", mtMap96.passthrough())
});

// src/resources/management/projects/agents/releases/get.ts
import { mtMap as mtMap97 } from "@metorial/util-resource-mapper";
var mapManagementProjectsAgentsReleasesGetOutput = mtMap97.object({
  id: mtMap97.objectField("id", mtMap97.passthrough()),
  version: mtMap97.objectField("version", mtMap97.passthrough()),
  agentId: mtMap97.objectField("agent_id", mtMap97.passthrough()),
  isLatest: mtMap97.objectField("is_latest", mtMap97.passthrough()),
  createdAt: mtMap97.objectField("created_at", mtMap97.date()),
  flowId: mtMap97.objectField("flow_id", mtMap97.passthrough()),
  commit: mtMap97.objectField(
    "commit",
    mtMap97.object({
      id: mtMap97.objectField("id", mtMap97.passthrough()),
      message: mtMap97.objectField("message", mtMap97.passthrough()),
      releaseId: mtMap97.objectField("release_id", mtMap97.passthrough()),
      createdAt: mtMap97.objectField("created_at", mtMap97.date())
    })
  ),
  update: mtMap97.objectField(
    "update",
    mtMap97.object({
      id: mtMap97.objectField("id", mtMap97.passthrough()),
      agentId: mtMap97.objectField("agent_id", mtMap97.passthrough()),
      isReleased: mtMap97.objectField("is_released", mtMap97.passthrough()),
      createdAt: mtMap97.objectField("created_at", mtMap97.date())
    })
  ),
  fromInstanceAgent: mtMap97.objectField(
    "from_instance_agent",
    mtMap97.object({
      id: mtMap97.objectField("id", mtMap97.passthrough()),
      instanceId: mtMap97.objectField("instance_id", mtMap97.passthrough()),
      agentId: mtMap97.objectField("agent_id", mtMap97.passthrough()),
      createdAt: mtMap97.objectField("created_at", mtMap97.date()),
      updatedAt: mtMap97.objectField("updated_at", mtMap97.date())
    })
  ),
  toInstanceAgent: mtMap97.objectField(
    "to_instance_agent",
    mtMap97.object({
      id: mtMap97.objectField("id", mtMap97.passthrough()),
      instanceId: mtMap97.objectField("instance_id", mtMap97.passthrough()),
      agentId: mtMap97.objectField("agent_id", mtMap97.passthrough()),
      createdAt: mtMap97.objectField("created_at", mtMap97.date()),
      updatedAt: mtMap97.objectField("updated_at", mtMap97.date())
    })
  )
});

// src/resources/management/projects/agents/releases/list.ts
import { mtMap as mtMap98 } from "@metorial/util-resource-mapper";
var mapManagementProjectsAgentsReleasesListOutput = mtMap98.object({
  items: mtMap98.objectField(
    "items",
    mtMap98.array(
      mtMap98.object({
        id: mtMap98.objectField("id", mtMap98.passthrough()),
        version: mtMap98.objectField("version", mtMap98.passthrough()),
        agentId: mtMap98.objectField("agent_id", mtMap98.passthrough()),
        isLatest: mtMap98.objectField("is_latest", mtMap98.passthrough()),
        createdAt: mtMap98.objectField("created_at", mtMap98.date()),
        flowId: mtMap98.objectField("flow_id", mtMap98.passthrough()),
        commit: mtMap98.objectField(
          "commit",
          mtMap98.object({
            id: mtMap98.objectField("id", mtMap98.passthrough()),
            message: mtMap98.objectField("message", mtMap98.passthrough()),
            releaseId: mtMap98.objectField("release_id", mtMap98.passthrough()),
            createdAt: mtMap98.objectField("created_at", mtMap98.date())
          })
        ),
        update: mtMap98.objectField(
          "update",
          mtMap98.object({
            id: mtMap98.objectField("id", mtMap98.passthrough()),
            agentId: mtMap98.objectField("agent_id", mtMap98.passthrough()),
            isReleased: mtMap98.objectField("is_released", mtMap98.passthrough()),
            createdAt: mtMap98.objectField("created_at", mtMap98.date())
          })
        ),
        fromInstanceAgent: mtMap98.objectField(
          "from_instance_agent",
          mtMap98.object({
            id: mtMap98.objectField("id", mtMap98.passthrough()),
            instanceId: mtMap98.objectField("instance_id", mtMap98.passthrough()),
            agentId: mtMap98.objectField("agent_id", mtMap98.passthrough()),
            createdAt: mtMap98.objectField("created_at", mtMap98.date()),
            updatedAt: mtMap98.objectField("updated_at", mtMap98.date())
          })
        ),
        toInstanceAgent: mtMap98.objectField(
          "to_instance_agent",
          mtMap98.object({
            id: mtMap98.objectField("id", mtMap98.passthrough()),
            instanceId: mtMap98.objectField("instance_id", mtMap98.passthrough()),
            agentId: mtMap98.objectField("agent_id", mtMap98.passthrough()),
            createdAt: mtMap98.objectField("created_at", mtMap98.date()),
            updatedAt: mtMap98.objectField("updated_at", mtMap98.date())
          })
        )
      })
    )
  ),
  pagination: mtMap98.objectField(
    "pagination",
    mtMap98.object({
      afterCursor: mtMap98.objectField("after_cursor", mtMap98.passthrough()),
      beforeCursor: mtMap98.objectField("before_cursor", mtMap98.passthrough()),
      hasMoreBefore: mtMap98.objectField(
        "has_more_before",
        mtMap98.passthrough()
      ),
      hasMoreAfter: mtMap98.objectField("has_more_after", mtMap98.passthrough()),
      pageSize: mtMap98.objectField("page_size", mtMap98.passthrough()),
      sort: mtMap98.objectField(
        "sort",
        mtMap98.array(
          mtMap98.object({
            field: mtMap98.objectField("field", mtMap98.passthrough()),
            order: mtMap98.objectField("order", mtMap98.passthrough())
          })
        )
      )
    })
  )
});
var mapManagementProjectsAgentsReleasesListQuery = mtMap98.object({
  createdAt: mtMap98.objectField(
    "created_at",
    mtMap98.union([
      mtMap98.unionOption(
        "object",
        mtMap98.object({
          eq: mtMap98.objectField("eq", mtMap98.date()),
          gt: mtMap98.objectField("gt", mtMap98.date()),
          gte: mtMap98.objectField("gte", mtMap98.date()),
          lt: mtMap98.objectField("lt", mtMap98.date()),
          lte: mtMap98.objectField("lte", mtMap98.date())
        })
      ),
      mtMap98.unionOption("date", mtMap98.passthrough())
    ])
  ),
  id: mtMap98.objectField(
    "id",
    mtMap98.union([
      mtMap98.unionOption(
        "object",
        mtMap98.object({
          in: mtMap98.objectField("in", mtMap98.array(mtMap98.passthrough())),
          eq: mtMap98.objectField("eq", mtMap98.passthrough())
        })
      ),
      mtMap98.unionOption("string", mtMap98.passthrough())
    ])
  ),
  ids: mtMap98.objectField(
    "ids",
    mtMap98.union([
      mtMap98.unionOption(
        "object",
        mtMap98.object({
          in: mtMap98.objectField("in", mtMap98.array(mtMap98.passthrough())),
          eq: mtMap98.objectField("eq", mtMap98.passthrough())
        })
      ),
      mtMap98.unionOption("string", mtMap98.passthrough())
    ])
  ),
  sort: mtMap98.objectField(
    "sort",
    mtMap98.union([
      mtMap98.unionOption("string", mtMap98.passthrough()),
      mtMap98.unionOption(
        "array",
        mtMap98.union([
          mtMap98.unionOption(
            "object",
            mtMap98.object({
              field: mtMap98.objectField("field", mtMap98.passthrough()),
              order: mtMap98.objectField("order", mtMap98.passthrough())
            })
          )
        ])
      )
    ])
  ),
  limit: mtMap98.objectField("limit", mtMap98.passthrough()),
  cursor: mtMap98.objectField("cursor", mtMap98.passthrough()),
  order: mtMap98.objectField("order", mtMap98.passthrough())
});

// src/resources/management/projects/agents/update.ts
import { mtMap as mtMap99 } from "@metorial/util-resource-mapper";
var mapManagementProjectsAgentsUpdateOutput = mtMap99.object({
  id: mtMap99.objectField("id", mtMap99.passthrough()),
  status: mtMap99.objectField("status", mtMap99.passthrough()),
  slug: mtMap99.objectField("slug", mtMap99.passthrough()),
  name: mtMap99.objectField("name", mtMap99.passthrough()),
  publicName: mtMap99.objectField("public_name", mtMap99.passthrough()),
  projectId: mtMap99.objectField("project_id", mtMap99.passthrough()),
  organizationId: mtMap99.objectField("organization_id", mtMap99.passthrough()),
  createdAt: mtMap99.objectField("created_at", mtMap99.date()),
  updatedAt: mtMap99.objectField("updated_at", mtMap99.date()),
  instanceAgents: mtMap99.objectField(
    "instance_agents",
    mtMap99.array(
      mtMap99.object({
        id: mtMap99.objectField("id", mtMap99.passthrough()),
        slug: mtMap99.objectField("slug", mtMap99.passthrough()),
        name: mtMap99.objectField("name", mtMap99.passthrough()),
        status: mtMap99.objectField("status", mtMap99.passthrough()),
        instanceId: mtMap99.objectField("instance_id", mtMap99.passthrough()),
        agentId: mtMap99.objectField("agent_id", mtMap99.passthrough()),
        createdAt: mtMap99.objectField("created_at", mtMap99.date()),
        updatedAt: mtMap99.objectField("updated_at", mtMap99.date()),
        currentRelease: mtMap99.objectField(
          "current_release",
          mtMap99.object({
            id: mtMap99.objectField("id", mtMap99.passthrough()),
            agentId: mtMap99.objectField("agent_id", mtMap99.passthrough()),
            version: mtMap99.objectField("version", mtMap99.passthrough()),
            createdAt: mtMap99.objectField("created_at", mtMap99.date())
          })
        )
      })
    )
  )
});
var mapManagementProjectsAgentsUpdateBody = mtMap99.object({
  name: mtMap99.objectField("name", mtMap99.passthrough()),
  slug: mtMap99.objectField("slug", mtMap99.passthrough())
});

// src/resources/management/projects/create.ts
import { mtMap as mtMap100 } from "@metorial/util-resource-mapper";
var mapManagementProjectsCreateOutput = mtMap100.object({
  id: mtMap100.objectField("id", mtMap100.passthrough()),
  slug: mtMap100.objectField("slug", mtMap100.passthrough()),
  name: mtMap100.objectField("name", mtMap100.passthrough()),
  organizationId: mtMap100.objectField("organization_id", mtMap100.passthrough()),
  createdAt: mtMap100.objectField("created_at", mtMap100.date()),
  updatedAt: mtMap100.objectField("updated_at", mtMap100.date())
});
var mapManagementProjectsCreateBody = mtMap100.object({
  name: mtMap100.objectField("name", mtMap100.passthrough())
});

// src/resources/management/projects/get.ts
import { mtMap as mtMap101 } from "@metorial/util-resource-mapper";
var mapManagementProjectsGetOutput = mtMap101.object({
  id: mtMap101.objectField("id", mtMap101.passthrough()),
  slug: mtMap101.objectField("slug", mtMap101.passthrough()),
  name: mtMap101.objectField("name", mtMap101.passthrough()),
  organizationId: mtMap101.objectField("organization_id", mtMap101.passthrough()),
  createdAt: mtMap101.objectField("created_at", mtMap101.date()),
  updatedAt: mtMap101.objectField("updated_at", mtMap101.date())
});

// src/resources/management/projects/list.ts
import { mtMap as mtMap102 } from "@metorial/util-resource-mapper";
var mapManagementProjectsListOutput = mtMap102.object({
  items: mtMap102.objectField(
    "items",
    mtMap102.array(
      mtMap102.object({
        id: mtMap102.objectField("id", mtMap102.passthrough()),
        slug: mtMap102.objectField("slug", mtMap102.passthrough()),
        name: mtMap102.objectField("name", mtMap102.passthrough()),
        organizationId: mtMap102.objectField(
          "organization_id",
          mtMap102.passthrough()
        ),
        createdAt: mtMap102.objectField("created_at", mtMap102.date()),
        updatedAt: mtMap102.objectField("updated_at", mtMap102.date())
      })
    )
  ),
  pagination: mtMap102.objectField(
    "pagination",
    mtMap102.object({
      afterCursor: mtMap102.objectField("after_cursor", mtMap102.passthrough()),
      beforeCursor: mtMap102.objectField("before_cursor", mtMap102.passthrough()),
      hasMoreBefore: mtMap102.objectField(
        "has_more_before",
        mtMap102.passthrough()
      ),
      hasMoreAfter: mtMap102.objectField("has_more_after", mtMap102.passthrough()),
      pageSize: mtMap102.objectField("page_size", mtMap102.passthrough()),
      sort: mtMap102.objectField(
        "sort",
        mtMap102.array(
          mtMap102.object({
            field: mtMap102.objectField("field", mtMap102.passthrough()),
            order: mtMap102.objectField("order", mtMap102.passthrough())
          })
        )
      )
    })
  )
});
var mapManagementProjectsListQuery = mtMap102.object({
  createdAt: mtMap102.objectField(
    "created_at",
    mtMap102.union([
      mtMap102.unionOption(
        "object",
        mtMap102.object({
          eq: mtMap102.objectField("eq", mtMap102.date()),
          gt: mtMap102.objectField("gt", mtMap102.date()),
          gte: mtMap102.objectField("gte", mtMap102.date()),
          lt: mtMap102.objectField("lt", mtMap102.date()),
          lte: mtMap102.objectField("lte", mtMap102.date())
        })
      ),
      mtMap102.unionOption("date", mtMap102.passthrough())
    ])
  ),
  id: mtMap102.objectField(
    "id",
    mtMap102.union([
      mtMap102.unionOption(
        "object",
        mtMap102.object({
          in: mtMap102.objectField("in", mtMap102.array(mtMap102.passthrough())),
          eq: mtMap102.objectField("eq", mtMap102.passthrough())
        })
      ),
      mtMap102.unionOption("string", mtMap102.passthrough())
    ])
  ),
  ids: mtMap102.objectField(
    "ids",
    mtMap102.union([
      mtMap102.unionOption(
        "object",
        mtMap102.object({
          in: mtMap102.objectField("in", mtMap102.array(mtMap102.passthrough())),
          eq: mtMap102.objectField("eq", mtMap102.passthrough())
        })
      ),
      mtMap102.unionOption("string", mtMap102.passthrough())
    ])
  ),
  sort: mtMap102.objectField(
    "sort",
    mtMap102.union([
      mtMap102.unionOption("string", mtMap102.passthrough()),
      mtMap102.unionOption(
        "array",
        mtMap102.union([
          mtMap102.unionOption(
            "object",
            mtMap102.object({
              field: mtMap102.objectField("field", mtMap102.passthrough()),
              order: mtMap102.objectField("order", mtMap102.passthrough())
            })
          )
        ])
      )
    ])
  ),
  limit: mtMap102.objectField("limit", mtMap102.passthrough()),
  cursor: mtMap102.objectField("cursor", mtMap102.passthrough()),
  order: mtMap102.objectField("order", mtMap102.passthrough())
});

// src/resources/management/projects/portals/create.ts
import { mtMap as mtMap103 } from "@metorial/util-resource-mapper";
var mapManagementProjectsPortalsCreateOutput = mtMap103.object({
  id: mtMap103.objectField("id", mtMap103.passthrough()),
  type: mtMap103.objectField("type", mtMap103.passthrough()),
  status: mtMap103.objectField("status", mtMap103.passthrough()),
  organizationId: mtMap103.objectField("organization_id", mtMap103.passthrough()),
  projectId: mtMap103.objectField("project_id", mtMap103.passthrough()),
  name: mtMap103.objectField("name", mtMap103.passthrough()),
  slug: mtMap103.objectField("slug", mtMap103.passthrough()),
  publicName: mtMap103.objectField("public_name", mtMap103.passthrough()),
  createdAt: mtMap103.objectField("created_at", mtMap103.date()),
  updatedAt: mtMap103.objectField("updated_at", mtMap103.date())
});
var mapManagementProjectsPortalsCreateBody = mtMap103.object({
  name: mtMap103.objectField("name", mtMap103.passthrough()),
  publicName: mtMap103.objectField("public_name", mtMap103.passthrough()),
  type: mtMap103.objectField("type", mtMap103.passthrough())
});

// src/resources/management/projects/portals/delete.ts
import { mtMap as mtMap104 } from "@metorial/util-resource-mapper";
var mapManagementProjectsPortalsDeleteOutput = mtMap104.object({
  id: mtMap104.objectField("id", mtMap104.passthrough()),
  type: mtMap104.objectField("type", mtMap104.passthrough()),
  status: mtMap104.objectField("status", mtMap104.passthrough()),
  organizationId: mtMap104.objectField("organization_id", mtMap104.passthrough()),
  projectId: mtMap104.objectField("project_id", mtMap104.passthrough()),
  name: mtMap104.objectField("name", mtMap104.passthrough()),
  slug: mtMap104.objectField("slug", mtMap104.passthrough()),
  publicName: mtMap104.objectField("public_name", mtMap104.passthrough()),
  createdAt: mtMap104.objectField("created_at", mtMap104.date()),
  updatedAt: mtMap104.objectField("updated_at", mtMap104.date())
});

// src/resources/management/projects/portals/get.ts
import { mtMap as mtMap105 } from "@metorial/util-resource-mapper";
var mapManagementProjectsPortalsGetOutput = mtMap105.object({
  id: mtMap105.objectField("id", mtMap105.passthrough()),
  type: mtMap105.objectField("type", mtMap105.passthrough()),
  status: mtMap105.objectField("status", mtMap105.passthrough()),
  organizationId: mtMap105.objectField("organization_id", mtMap105.passthrough()),
  projectId: mtMap105.objectField("project_id", mtMap105.passthrough()),
  name: mtMap105.objectField("name", mtMap105.passthrough()),
  slug: mtMap105.objectField("slug", mtMap105.passthrough()),
  publicName: mtMap105.objectField("public_name", mtMap105.passthrough()),
  createdAt: mtMap105.objectField("created_at", mtMap105.date()),
  updatedAt: mtMap105.objectField("updated_at", mtMap105.date())
});

// src/resources/management/projects/portals/list.ts
import { mtMap as mtMap106 } from "@metorial/util-resource-mapper";
var mapManagementProjectsPortalsListOutput = mtMap106.object({
  items: mtMap106.objectField(
    "items",
    mtMap106.array(
      mtMap106.object({
        id: mtMap106.objectField("id", mtMap106.passthrough()),
        type: mtMap106.objectField("type", mtMap106.passthrough()),
        status: mtMap106.objectField("status", mtMap106.passthrough()),
        organizationId: mtMap106.objectField(
          "organization_id",
          mtMap106.passthrough()
        ),
        projectId: mtMap106.objectField("project_id", mtMap106.passthrough()),
        name: mtMap106.objectField("name", mtMap106.passthrough()),
        slug: mtMap106.objectField("slug", mtMap106.passthrough()),
        publicName: mtMap106.objectField("public_name", mtMap106.passthrough()),
        createdAt: mtMap106.objectField("created_at", mtMap106.date()),
        updatedAt: mtMap106.objectField("updated_at", mtMap106.date())
      })
    )
  ),
  pagination: mtMap106.objectField(
    "pagination",
    mtMap106.object({
      afterCursor: mtMap106.objectField("after_cursor", mtMap106.passthrough()),
      beforeCursor: mtMap106.objectField("before_cursor", mtMap106.passthrough()),
      hasMoreBefore: mtMap106.objectField(
        "has_more_before",
        mtMap106.passthrough()
      ),
      hasMoreAfter: mtMap106.objectField("has_more_after", mtMap106.passthrough()),
      pageSize: mtMap106.objectField("page_size", mtMap106.passthrough()),
      sort: mtMap106.objectField(
        "sort",
        mtMap106.array(
          mtMap106.object({
            field: mtMap106.objectField("field", mtMap106.passthrough()),
            order: mtMap106.objectField("order", mtMap106.passthrough())
          })
        )
      )
    })
  )
});
var mapManagementProjectsPortalsListQuery = mtMap106.object({
  id: mtMap106.objectField(
    "id",
    mtMap106.union([
      mtMap106.unionOption(
        "object",
        mtMap106.object({
          in: mtMap106.objectField("in", mtMap106.array(mtMap106.passthrough())),
          eq: mtMap106.objectField("eq", mtMap106.passthrough())
        })
      ),
      mtMap106.unionOption("string", mtMap106.passthrough())
    ])
  ),
  ids: mtMap106.objectField(
    "ids",
    mtMap106.union([
      mtMap106.unionOption(
        "object",
        mtMap106.object({
          in: mtMap106.objectField("in", mtMap106.array(mtMap106.passthrough())),
          eq: mtMap106.objectField("eq", mtMap106.passthrough())
        })
      ),
      mtMap106.unionOption("string", mtMap106.passthrough())
    ])
  ),
  slug: mtMap106.objectField(
    "slug",
    mtMap106.union([
      mtMap106.unionOption(
        "object",
        mtMap106.object({
          in: mtMap106.objectField("in", mtMap106.array(mtMap106.passthrough())),
          eq: mtMap106.objectField("eq", mtMap106.passthrough())
        })
      ),
      mtMap106.unionOption("string", mtMap106.passthrough())
    ])
  ),
  slugs: mtMap106.objectField(
    "slugs",
    mtMap106.union([
      mtMap106.unionOption(
        "object",
        mtMap106.object({
          in: mtMap106.objectField("in", mtMap106.array(mtMap106.passthrough())),
          eq: mtMap106.objectField("eq", mtMap106.passthrough())
        })
      ),
      mtMap106.unionOption("string", mtMap106.passthrough())
    ])
  ),
  sort: mtMap106.objectField(
    "sort",
    mtMap106.union([
      mtMap106.unionOption("string", mtMap106.passthrough()),
      mtMap106.unionOption(
        "array",
        mtMap106.union([
          mtMap106.unionOption(
            "object",
            mtMap106.object({
              field: mtMap106.objectField("field", mtMap106.passthrough()),
              order: mtMap106.objectField("order", mtMap106.passthrough())
            })
          )
        ])
      )
    ])
  ),
  limit: mtMap106.objectField("limit", mtMap106.passthrough()),
  cursor: mtMap106.objectField("cursor", mtMap106.passthrough()),
  order: mtMap106.objectField("order", mtMap106.passthrough())
});

// src/resources/management/projects/portals/portal-agents/create.ts
import { mtMap as mtMap107 } from "@metorial/util-resource-mapper";
var mapManagementProjectsPortalsPortalAgentsCreateOutput = mtMap107.object({
  id: mtMap107.objectField("id", mtMap107.passthrough()),
  status: mtMap107.objectField("status", mtMap107.passthrough()),
  name: mtMap107.objectField("name", mtMap107.passthrough()),
  slug: mtMap107.objectField("slug", mtMap107.passthrough()),
  description: mtMap107.objectField("description", mtMap107.passthrough()),
  portalId: mtMap107.objectField("portal_id", mtMap107.passthrough()),
  agentId: mtMap107.objectField("agent_id", mtMap107.passthrough()),
  createdAt: mtMap107.objectField("created_at", mtMap107.date()),
  updatedAt: mtMap107.objectField("updated_at", mtMap107.date())
});
var mapManagementProjectsPortalsPortalAgentsCreateBody = mtMap107.object({
  name: mtMap107.objectField("name", mtMap107.passthrough()),
  description: mtMap107.objectField("description", mtMap107.passthrough()),
  agentId: mtMap107.objectField("agent_id", mtMap107.passthrough())
});

// src/resources/management/projects/portals/portal-agents/delete.ts
import { mtMap as mtMap108 } from "@metorial/util-resource-mapper";
var mapManagementProjectsPortalsPortalAgentsDeleteOutput = mtMap108.object({
  id: mtMap108.objectField("id", mtMap108.passthrough()),
  status: mtMap108.objectField("status", mtMap108.passthrough()),
  name: mtMap108.objectField("name", mtMap108.passthrough()),
  slug: mtMap108.objectField("slug", mtMap108.passthrough()),
  description: mtMap108.objectField("description", mtMap108.passthrough()),
  portalId: mtMap108.objectField("portal_id", mtMap108.passthrough()),
  agentId: mtMap108.objectField("agent_id", mtMap108.passthrough()),
  createdAt: mtMap108.objectField("created_at", mtMap108.date()),
  updatedAt: mtMap108.objectField("updated_at", mtMap108.date())
});

// src/resources/management/projects/portals/portal-agents/get.ts
import { mtMap as mtMap109 } from "@metorial/util-resource-mapper";
var mapManagementProjectsPortalsPortalAgentsGetOutput = mtMap109.object({
  id: mtMap109.objectField("id", mtMap109.passthrough()),
  status: mtMap109.objectField("status", mtMap109.passthrough()),
  name: mtMap109.objectField("name", mtMap109.passthrough()),
  slug: mtMap109.objectField("slug", mtMap109.passthrough()),
  description: mtMap109.objectField("description", mtMap109.passthrough()),
  portalId: mtMap109.objectField("portal_id", mtMap109.passthrough()),
  agentId: mtMap109.objectField("agent_id", mtMap109.passthrough()),
  createdAt: mtMap109.objectField("created_at", mtMap109.date()),
  updatedAt: mtMap109.objectField("updated_at", mtMap109.date())
});

// src/resources/management/projects/portals/portal-agents/list.ts
import { mtMap as mtMap110 } from "@metorial/util-resource-mapper";
var mapManagementProjectsPortalsPortalAgentsListOutput = mtMap110.object({
  items: mtMap110.objectField(
    "items",
    mtMap110.array(
      mtMap110.object({
        id: mtMap110.objectField("id", mtMap110.passthrough()),
        status: mtMap110.objectField("status", mtMap110.passthrough()),
        name: mtMap110.objectField("name", mtMap110.passthrough()),
        slug: mtMap110.objectField("slug", mtMap110.passthrough()),
        description: mtMap110.objectField("description", mtMap110.passthrough()),
        portalId: mtMap110.objectField("portal_id", mtMap110.passthrough()),
        agentId: mtMap110.objectField("agent_id", mtMap110.passthrough()),
        createdAt: mtMap110.objectField("created_at", mtMap110.date()),
        updatedAt: mtMap110.objectField("updated_at", mtMap110.date())
      })
    )
  ),
  pagination: mtMap110.objectField(
    "pagination",
    mtMap110.object({
      afterCursor: mtMap110.objectField("after_cursor", mtMap110.passthrough()),
      beforeCursor: mtMap110.objectField("before_cursor", mtMap110.passthrough()),
      hasMoreBefore: mtMap110.objectField(
        "has_more_before",
        mtMap110.passthrough()
      ),
      hasMoreAfter: mtMap110.objectField("has_more_after", mtMap110.passthrough()),
      pageSize: mtMap110.objectField("page_size", mtMap110.passthrough()),
      sort: mtMap110.objectField(
        "sort",
        mtMap110.array(
          mtMap110.object({
            field: mtMap110.objectField("field", mtMap110.passthrough()),
            order: mtMap110.objectField("order", mtMap110.passthrough())
          })
        )
      )
    })
  )
});
var mapManagementProjectsPortalsPortalAgentsListQuery = mtMap110.object({
  id: mtMap110.objectField(
    "id",
    mtMap110.union([
      mtMap110.unionOption(
        "object",
        mtMap110.object({
          in: mtMap110.objectField("in", mtMap110.array(mtMap110.passthrough())),
          eq: mtMap110.objectField("eq", mtMap110.passthrough())
        })
      ),
      mtMap110.unionOption("string", mtMap110.passthrough())
    ])
  ),
  ids: mtMap110.objectField(
    "ids",
    mtMap110.union([
      mtMap110.unionOption(
        "object",
        mtMap110.object({
          in: mtMap110.objectField("in", mtMap110.array(mtMap110.passthrough())),
          eq: mtMap110.objectField("eq", mtMap110.passthrough())
        })
      ),
      mtMap110.unionOption("string", mtMap110.passthrough())
    ])
  ),
  slug: mtMap110.objectField(
    "slug",
    mtMap110.union([
      mtMap110.unionOption(
        "object",
        mtMap110.object({
          in: mtMap110.objectField("in", mtMap110.array(mtMap110.passthrough())),
          eq: mtMap110.objectField("eq", mtMap110.passthrough())
        })
      ),
      mtMap110.unionOption("string", mtMap110.passthrough())
    ])
  ),
  slugs: mtMap110.objectField(
    "slugs",
    mtMap110.union([
      mtMap110.unionOption(
        "object",
        mtMap110.object({
          in: mtMap110.objectField("in", mtMap110.array(mtMap110.passthrough())),
          eq: mtMap110.objectField("eq", mtMap110.passthrough())
        })
      ),
      mtMap110.unionOption("string", mtMap110.passthrough())
    ])
  ),
  sort: mtMap110.objectField(
    "sort",
    mtMap110.union([
      mtMap110.unionOption("string", mtMap110.passthrough()),
      mtMap110.unionOption(
        "array",
        mtMap110.union([
          mtMap110.unionOption(
            "object",
            mtMap110.object({
              field: mtMap110.objectField("field", mtMap110.passthrough()),
              order: mtMap110.objectField("order", mtMap110.passthrough())
            })
          )
        ])
      )
    ])
  ),
  limit: mtMap110.objectField("limit", mtMap110.passthrough()),
  cursor: mtMap110.objectField("cursor", mtMap110.passthrough()),
  order: mtMap110.objectField("order", mtMap110.passthrough())
});

// src/resources/management/projects/portals/portal-agents/update.ts
import { mtMap as mtMap111 } from "@metorial/util-resource-mapper";
var mapManagementProjectsPortalsPortalAgentsUpdateOutput = mtMap111.object({
  id: mtMap111.objectField("id", mtMap111.passthrough()),
  status: mtMap111.objectField("status", mtMap111.passthrough()),
  name: mtMap111.objectField("name", mtMap111.passthrough()),
  slug: mtMap111.objectField("slug", mtMap111.passthrough()),
  description: mtMap111.objectField("description", mtMap111.passthrough()),
  portalId: mtMap111.objectField("portal_id", mtMap111.passthrough()),
  agentId: mtMap111.objectField("agent_id", mtMap111.passthrough()),
  createdAt: mtMap111.objectField("created_at", mtMap111.date()),
  updatedAt: mtMap111.objectField("updated_at", mtMap111.date())
});
var mapManagementProjectsPortalsPortalAgentsUpdateBody = mtMap111.object({
  name: mtMap111.objectField("name", mtMap111.passthrough()),
  description: mtMap111.objectField("description", mtMap111.passthrough())
});

// src/resources/management/projects/portals/portal-domains/create.ts
import { mtMap as mtMap112 } from "@metorial/util-resource-mapper";
var mapManagementProjectsPortalsPortalDomainsCreateOutput = mtMap112.object({
  id: mtMap112.objectField("id", mtMap112.passthrough()),
  status: mtMap112.objectField("status", mtMap112.passthrough()),
  type: mtMap112.objectField("type", mtMap112.passthrough()),
  domain: mtMap112.objectField("domain", mtMap112.passthrough()),
  portalId: mtMap112.objectField("portal_id", mtMap112.passthrough()),
  portalEnvironmentId: mtMap112.objectField(
    "portal_environment_id",
    mtMap112.passthrough()
  ),
  verification: mtMap112.objectField(
    "verification",
    mtMap112.object({
      status: mtMap112.objectField("status", mtMap112.passthrough()),
      verificationTasks: mtMap112.objectField(
        "verification_tasks",
        mtMap112.array(
          mtMap112.object({
            id: mtMap112.objectField("id", mtMap112.passthrough()),
            action: mtMap112.objectField("action", mtMap112.passthrough()),
            name: mtMap112.objectField("name", mtMap112.passthrough()),
            type: mtMap112.objectField("type", mtMap112.passthrough()),
            value: mtMap112.objectField("value", mtMap112.passthrough()),
            status: mtMap112.objectField("status", mtMap112.passthrough()),
            createdAt: mtMap112.objectField("created_at", mtMap112.date())
          })
        )
      )
    })
  ),
  createdAt: mtMap112.objectField("created_at", mtMap112.date()),
  updatedAt: mtMap112.objectField("updated_at", mtMap112.date())
});
var mapManagementProjectsPortalsPortalDomainsCreateBody = mtMap112.object({
  portalEnvironmentId: mtMap112.objectField(
    "portal_environment_id",
    mtMap112.passthrough()
  ),
  domain: mtMap112.objectField("domain", mtMap112.passthrough())
});

// src/resources/management/projects/portals/portal-domains/delete.ts
import { mtMap as mtMap113 } from "@metorial/util-resource-mapper";
var mapManagementProjectsPortalsPortalDomainsDeleteOutput = mtMap113.object({
  id: mtMap113.objectField("id", mtMap113.passthrough()),
  status: mtMap113.objectField("status", mtMap113.passthrough()),
  type: mtMap113.objectField("type", mtMap113.passthrough()),
  domain: mtMap113.objectField("domain", mtMap113.passthrough()),
  portalId: mtMap113.objectField("portal_id", mtMap113.passthrough()),
  portalEnvironmentId: mtMap113.objectField(
    "portal_environment_id",
    mtMap113.passthrough()
  ),
  verification: mtMap113.objectField(
    "verification",
    mtMap113.object({
      status: mtMap113.objectField("status", mtMap113.passthrough()),
      verificationTasks: mtMap113.objectField(
        "verification_tasks",
        mtMap113.array(
          mtMap113.object({
            id: mtMap113.objectField("id", mtMap113.passthrough()),
            action: mtMap113.objectField("action", mtMap113.passthrough()),
            name: mtMap113.objectField("name", mtMap113.passthrough()),
            type: mtMap113.objectField("type", mtMap113.passthrough()),
            value: mtMap113.objectField("value", mtMap113.passthrough()),
            status: mtMap113.objectField("status", mtMap113.passthrough()),
            createdAt: mtMap113.objectField("created_at", mtMap113.date())
          })
        )
      )
    })
  ),
  createdAt: mtMap113.objectField("created_at", mtMap113.date()),
  updatedAt: mtMap113.objectField("updated_at", mtMap113.date())
});

// src/resources/management/projects/portals/portal-domains/get.ts
import { mtMap as mtMap114 } from "@metorial/util-resource-mapper";
var mapManagementProjectsPortalsPortalDomainsGetOutput = mtMap114.object({
  id: mtMap114.objectField("id", mtMap114.passthrough()),
  status: mtMap114.objectField("status", mtMap114.passthrough()),
  type: mtMap114.objectField("type", mtMap114.passthrough()),
  domain: mtMap114.objectField("domain", mtMap114.passthrough()),
  portalId: mtMap114.objectField("portal_id", mtMap114.passthrough()),
  portalEnvironmentId: mtMap114.objectField(
    "portal_environment_id",
    mtMap114.passthrough()
  ),
  verification: mtMap114.objectField(
    "verification",
    mtMap114.object({
      status: mtMap114.objectField("status", mtMap114.passthrough()),
      verificationTasks: mtMap114.objectField(
        "verification_tasks",
        mtMap114.array(
          mtMap114.object({
            id: mtMap114.objectField("id", mtMap114.passthrough()),
            action: mtMap114.objectField("action", mtMap114.passthrough()),
            name: mtMap114.objectField("name", mtMap114.passthrough()),
            type: mtMap114.objectField("type", mtMap114.passthrough()),
            value: mtMap114.objectField("value", mtMap114.passthrough()),
            status: mtMap114.objectField("status", mtMap114.passthrough()),
            createdAt: mtMap114.objectField("created_at", mtMap114.date())
          })
        )
      )
    })
  ),
  createdAt: mtMap114.objectField("created_at", mtMap114.date()),
  updatedAt: mtMap114.objectField("updated_at", mtMap114.date())
});

// src/resources/management/projects/portals/portal-domains/list.ts
import { mtMap as mtMap115 } from "@metorial/util-resource-mapper";
var mapManagementProjectsPortalsPortalDomainsListOutput = mtMap115.object({
  items: mtMap115.objectField(
    "items",
    mtMap115.array(
      mtMap115.object({
        id: mtMap115.objectField("id", mtMap115.passthrough()),
        status: mtMap115.objectField("status", mtMap115.passthrough()),
        type: mtMap115.objectField("type", mtMap115.passthrough()),
        domain: mtMap115.objectField("domain", mtMap115.passthrough()),
        portalId: mtMap115.objectField("portal_id", mtMap115.passthrough()),
        portalEnvironmentId: mtMap115.objectField(
          "portal_environment_id",
          mtMap115.passthrough()
        ),
        verification: mtMap115.objectField(
          "verification",
          mtMap115.object({
            status: mtMap115.objectField("status", mtMap115.passthrough()),
            verificationTasks: mtMap115.objectField(
              "verification_tasks",
              mtMap115.array(
                mtMap115.object({
                  id: mtMap115.objectField("id", mtMap115.passthrough()),
                  action: mtMap115.objectField("action", mtMap115.passthrough()),
                  name: mtMap115.objectField("name", mtMap115.passthrough()),
                  type: mtMap115.objectField("type", mtMap115.passthrough()),
                  value: mtMap115.objectField("value", mtMap115.passthrough()),
                  status: mtMap115.objectField("status", mtMap115.passthrough()),
                  createdAt: mtMap115.objectField("created_at", mtMap115.date())
                })
              )
            )
          })
        ),
        createdAt: mtMap115.objectField("created_at", mtMap115.date()),
        updatedAt: mtMap115.objectField("updated_at", mtMap115.date())
      })
    )
  ),
  pagination: mtMap115.objectField(
    "pagination",
    mtMap115.object({
      afterCursor: mtMap115.objectField("after_cursor", mtMap115.passthrough()),
      beforeCursor: mtMap115.objectField("before_cursor", mtMap115.passthrough()),
      hasMoreBefore: mtMap115.objectField(
        "has_more_before",
        mtMap115.passthrough()
      ),
      hasMoreAfter: mtMap115.objectField("has_more_after", mtMap115.passthrough()),
      pageSize: mtMap115.objectField("page_size", mtMap115.passthrough()),
      sort: mtMap115.objectField(
        "sort",
        mtMap115.array(
          mtMap115.object({
            field: mtMap115.objectField("field", mtMap115.passthrough()),
            order: mtMap115.objectField("order", mtMap115.passthrough())
          })
        )
      )
    })
  )
});
var mapManagementProjectsPortalsPortalDomainsListQuery = mtMap115.object({
  id: mtMap115.objectField(
    "id",
    mtMap115.union([
      mtMap115.unionOption(
        "object",
        mtMap115.object({
          in: mtMap115.objectField("in", mtMap115.array(mtMap115.passthrough())),
          eq: mtMap115.objectField("eq", mtMap115.passthrough())
        })
      ),
      mtMap115.unionOption("string", mtMap115.passthrough())
    ])
  ),
  ids: mtMap115.objectField(
    "ids",
    mtMap115.union([
      mtMap115.unionOption(
        "object",
        mtMap115.object({
          in: mtMap115.objectField("in", mtMap115.array(mtMap115.passthrough())),
          eq: mtMap115.objectField("eq", mtMap115.passthrough())
        })
      ),
      mtMap115.unionOption("string", mtMap115.passthrough())
    ])
  ),
  slug: mtMap115.objectField(
    "slug",
    mtMap115.union([
      mtMap115.unionOption(
        "object",
        mtMap115.object({
          in: mtMap115.objectField("in", mtMap115.array(mtMap115.passthrough())),
          eq: mtMap115.objectField("eq", mtMap115.passthrough())
        })
      ),
      mtMap115.unionOption("string", mtMap115.passthrough())
    ])
  ),
  slugs: mtMap115.objectField(
    "slugs",
    mtMap115.union([
      mtMap115.unionOption(
        "object",
        mtMap115.object({
          in: mtMap115.objectField("in", mtMap115.array(mtMap115.passthrough())),
          eq: mtMap115.objectField("eq", mtMap115.passthrough())
        })
      ),
      mtMap115.unionOption("string", mtMap115.passthrough())
    ])
  ),
  sort: mtMap115.objectField(
    "sort",
    mtMap115.union([
      mtMap115.unionOption("string", mtMap115.passthrough()),
      mtMap115.unionOption(
        "array",
        mtMap115.union([
          mtMap115.unionOption(
            "object",
            mtMap115.object({
              field: mtMap115.objectField("field", mtMap115.passthrough()),
              order: mtMap115.objectField("order", mtMap115.passthrough())
            })
          )
        ])
      )
    ])
  ),
  limit: mtMap115.objectField("limit", mtMap115.passthrough()),
  cursor: mtMap115.objectField("cursor", mtMap115.passthrough()),
  order: mtMap115.objectField("order", mtMap115.passthrough())
});

// src/resources/management/projects/portals/portal-domains/recheck.ts
import { mtMap as mtMap116 } from "@metorial/util-resource-mapper";
var mapManagementProjectsPortalsPortalDomainsRecheckOutput = mtMap116.object({
  id: mtMap116.objectField("id", mtMap116.passthrough()),
  status: mtMap116.objectField("status", mtMap116.passthrough()),
  type: mtMap116.objectField("type", mtMap116.passthrough()),
  domain: mtMap116.objectField("domain", mtMap116.passthrough()),
  portalId: mtMap116.objectField("portal_id", mtMap116.passthrough()),
  portalEnvironmentId: mtMap116.objectField(
    "portal_environment_id",
    mtMap116.passthrough()
  ),
  verification: mtMap116.objectField(
    "verification",
    mtMap116.object({
      status: mtMap116.objectField("status", mtMap116.passthrough()),
      verificationTasks: mtMap116.objectField(
        "verification_tasks",
        mtMap116.array(
          mtMap116.object({
            id: mtMap116.objectField("id", mtMap116.passthrough()),
            action: mtMap116.objectField("action", mtMap116.passthrough()),
            name: mtMap116.objectField("name", mtMap116.passthrough()),
            type: mtMap116.objectField("type", mtMap116.passthrough()),
            value: mtMap116.objectField("value", mtMap116.passthrough()),
            status: mtMap116.objectField("status", mtMap116.passthrough()),
            createdAt: mtMap116.objectField("created_at", mtMap116.date())
          })
        )
      )
    })
  ),
  createdAt: mtMap116.objectField("created_at", mtMap116.date()),
  updatedAt: mtMap116.objectField("updated_at", mtMap116.date())
});

// src/resources/management/projects/portals/portal-domains/update.ts
import { mtMap as mtMap117 } from "@metorial/util-resource-mapper";
var mapManagementProjectsPortalsPortalDomainsUpdateOutput = mtMap117.object({
  id: mtMap117.objectField("id", mtMap117.passthrough()),
  status: mtMap117.objectField("status", mtMap117.passthrough()),
  type: mtMap117.objectField("type", mtMap117.passthrough()),
  domain: mtMap117.objectField("domain", mtMap117.passthrough()),
  portalId: mtMap117.objectField("portal_id", mtMap117.passthrough()),
  portalEnvironmentId: mtMap117.objectField(
    "portal_environment_id",
    mtMap117.passthrough()
  ),
  verification: mtMap117.objectField(
    "verification",
    mtMap117.object({
      status: mtMap117.objectField("status", mtMap117.passthrough()),
      verificationTasks: mtMap117.objectField(
        "verification_tasks",
        mtMap117.array(
          mtMap117.object({
            id: mtMap117.objectField("id", mtMap117.passthrough()),
            action: mtMap117.objectField("action", mtMap117.passthrough()),
            name: mtMap117.objectField("name", mtMap117.passthrough()),
            type: mtMap117.objectField("type", mtMap117.passthrough()),
            value: mtMap117.objectField("value", mtMap117.passthrough()),
            status: mtMap117.objectField("status", mtMap117.passthrough()),
            createdAt: mtMap117.objectField("created_at", mtMap117.date())
          })
        )
      )
    })
  ),
  createdAt: mtMap117.objectField("created_at", mtMap117.date()),
  updatedAt: mtMap117.objectField("updated_at", mtMap117.date())
});
var mapManagementProjectsPortalsPortalDomainsUpdateBody = mtMap117.object({
  portalEnvironmentId: mtMap117.objectField(
    "portal_environment_id",
    mtMap117.passthrough()
  )
});

// src/resources/management/projects/portals/portal-environments/create.ts
import { mtMap as mtMap118 } from "@metorial/util-resource-mapper";
var mapManagementProjectsPortalsPortalEnvironmentsCreateOutput = mtMap118.object({
  id: mtMap118.objectField("id", mtMap118.passthrough()),
  type: mtMap118.objectField("type", mtMap118.passthrough()),
  status: mtMap118.objectField("status", mtMap118.passthrough()),
  name: mtMap118.objectField("name", mtMap118.passthrough()),
  slug: mtMap118.objectField("slug", mtMap118.passthrough()),
  instanceId: mtMap118.objectField("instance_id", mtMap118.passthrough()),
  portal: mtMap118.objectField(
    "portal",
    mtMap118.object({
      id: mtMap118.objectField("id", mtMap118.passthrough()),
      type: mtMap118.objectField("type", mtMap118.passthrough()),
      status: mtMap118.objectField("status", mtMap118.passthrough()),
      organizationId: mtMap118.objectField(
        "organization_id",
        mtMap118.passthrough()
      ),
      projectId: mtMap118.objectField("project_id", mtMap118.passthrough()),
      name: mtMap118.objectField("name", mtMap118.passthrough()),
      slug: mtMap118.objectField("slug", mtMap118.passthrough()),
      publicName: mtMap118.objectField("public_name", mtMap118.passthrough()),
      createdAt: mtMap118.objectField("created_at", mtMap118.date()),
      updatedAt: mtMap118.objectField("updated_at", mtMap118.date())
    })
  ),
  createdAt: mtMap118.objectField("created_at", mtMap118.date()),
  updatedAt: mtMap118.objectField("updated_at", mtMap118.date())
});
var mapManagementProjectsPortalsPortalEnvironmentsCreateBody = mtMap118.object({
  name: mtMap118.objectField("name", mtMap118.passthrough()),
  instanceId: mtMap118.objectField("instance_id", mtMap118.passthrough())
});

// src/resources/management/projects/portals/portal-environments/get.ts
import { mtMap as mtMap119 } from "@metorial/util-resource-mapper";
var mapManagementProjectsPortalsPortalEnvironmentsGetOutput = mtMap119.object({
  id: mtMap119.objectField("id", mtMap119.passthrough()),
  type: mtMap119.objectField("type", mtMap119.passthrough()),
  status: mtMap119.objectField("status", mtMap119.passthrough()),
  name: mtMap119.objectField("name", mtMap119.passthrough()),
  slug: mtMap119.objectField("slug", mtMap119.passthrough()),
  instanceId: mtMap119.objectField("instance_id", mtMap119.passthrough()),
  portal: mtMap119.objectField(
    "portal",
    mtMap119.object({
      id: mtMap119.objectField("id", mtMap119.passthrough()),
      type: mtMap119.objectField("type", mtMap119.passthrough()),
      status: mtMap119.objectField("status", mtMap119.passthrough()),
      organizationId: mtMap119.objectField(
        "organization_id",
        mtMap119.passthrough()
      ),
      projectId: mtMap119.objectField("project_id", mtMap119.passthrough()),
      name: mtMap119.objectField("name", mtMap119.passthrough()),
      slug: mtMap119.objectField("slug", mtMap119.passthrough()),
      publicName: mtMap119.objectField("public_name", mtMap119.passthrough()),
      createdAt: mtMap119.objectField("created_at", mtMap119.date()),
      updatedAt: mtMap119.objectField("updated_at", mtMap119.date())
    })
  ),
  createdAt: mtMap119.objectField("created_at", mtMap119.date()),
  updatedAt: mtMap119.objectField("updated_at", mtMap119.date())
});

// src/resources/management/projects/portals/portal-environments/list.ts
import { mtMap as mtMap120 } from "@metorial/util-resource-mapper";
var mapManagementProjectsPortalsPortalEnvironmentsListOutput = mtMap120.object({
  items: mtMap120.objectField(
    "items",
    mtMap120.array(
      mtMap120.object({
        id: mtMap120.objectField("id", mtMap120.passthrough()),
        type: mtMap120.objectField("type", mtMap120.passthrough()),
        status: mtMap120.objectField("status", mtMap120.passthrough()),
        name: mtMap120.objectField("name", mtMap120.passthrough()),
        slug: mtMap120.objectField("slug", mtMap120.passthrough()),
        instanceId: mtMap120.objectField("instance_id", mtMap120.passthrough()),
        portal: mtMap120.objectField(
          "portal",
          mtMap120.object({
            id: mtMap120.objectField("id", mtMap120.passthrough()),
            type: mtMap120.objectField("type", mtMap120.passthrough()),
            status: mtMap120.objectField("status", mtMap120.passthrough()),
            organizationId: mtMap120.objectField(
              "organization_id",
              mtMap120.passthrough()
            ),
            projectId: mtMap120.objectField("project_id", mtMap120.passthrough()),
            name: mtMap120.objectField("name", mtMap120.passthrough()),
            slug: mtMap120.objectField("slug", mtMap120.passthrough()),
            publicName: mtMap120.objectField("public_name", mtMap120.passthrough()),
            createdAt: mtMap120.objectField("created_at", mtMap120.date()),
            updatedAt: mtMap120.objectField("updated_at", mtMap120.date())
          })
        ),
        createdAt: mtMap120.objectField("created_at", mtMap120.date()),
        updatedAt: mtMap120.objectField("updated_at", mtMap120.date())
      })
    )
  ),
  pagination: mtMap120.objectField(
    "pagination",
    mtMap120.object({
      afterCursor: mtMap120.objectField("after_cursor", mtMap120.passthrough()),
      beforeCursor: mtMap120.objectField("before_cursor", mtMap120.passthrough()),
      hasMoreBefore: mtMap120.objectField(
        "has_more_before",
        mtMap120.passthrough()
      ),
      hasMoreAfter: mtMap120.objectField("has_more_after", mtMap120.passthrough()),
      pageSize: mtMap120.objectField("page_size", mtMap120.passthrough()),
      sort: mtMap120.objectField(
        "sort",
        mtMap120.array(
          mtMap120.object({
            field: mtMap120.objectField("field", mtMap120.passthrough()),
            order: mtMap120.objectField("order", mtMap120.passthrough())
          })
        )
      )
    })
  )
});
var mapManagementProjectsPortalsPortalEnvironmentsListQuery = mtMap120.object({
  id: mtMap120.objectField(
    "id",
    mtMap120.union([
      mtMap120.unionOption(
        "object",
        mtMap120.object({
          in: mtMap120.objectField("in", mtMap120.array(mtMap120.passthrough())),
          eq: mtMap120.objectField("eq", mtMap120.passthrough())
        })
      ),
      mtMap120.unionOption("string", mtMap120.passthrough())
    ])
  ),
  ids: mtMap120.objectField(
    "ids",
    mtMap120.union([
      mtMap120.unionOption(
        "object",
        mtMap120.object({
          in: mtMap120.objectField("in", mtMap120.array(mtMap120.passthrough())),
          eq: mtMap120.objectField("eq", mtMap120.passthrough())
        })
      ),
      mtMap120.unionOption("string", mtMap120.passthrough())
    ])
  ),
  slug: mtMap120.objectField(
    "slug",
    mtMap120.union([
      mtMap120.unionOption(
        "object",
        mtMap120.object({
          in: mtMap120.objectField("in", mtMap120.array(mtMap120.passthrough())),
          eq: mtMap120.objectField("eq", mtMap120.passthrough())
        })
      ),
      mtMap120.unionOption("string", mtMap120.passthrough())
    ])
  ),
  slugs: mtMap120.objectField(
    "slugs",
    mtMap120.union([
      mtMap120.unionOption(
        "object",
        mtMap120.object({
          in: mtMap120.objectField("in", mtMap120.array(mtMap120.passthrough())),
          eq: mtMap120.objectField("eq", mtMap120.passthrough())
        })
      ),
      mtMap120.unionOption("string", mtMap120.passthrough())
    ])
  ),
  sort: mtMap120.objectField(
    "sort",
    mtMap120.union([
      mtMap120.unionOption("string", mtMap120.passthrough()),
      mtMap120.unionOption(
        "array",
        mtMap120.union([
          mtMap120.unionOption(
            "object",
            mtMap120.object({
              field: mtMap120.objectField("field", mtMap120.passthrough()),
              order: mtMap120.objectField("order", mtMap120.passthrough())
            })
          )
        ])
      )
    ])
  ),
  limit: mtMap120.objectField("limit", mtMap120.passthrough()),
  cursor: mtMap120.objectField("cursor", mtMap120.passthrough()),
  order: mtMap120.objectField("order", mtMap120.passthrough())
});

// src/resources/management/projects/portals/portal-environments/update.ts
import { mtMap as mtMap121 } from "@metorial/util-resource-mapper";
var mapManagementProjectsPortalsPortalEnvironmentsUpdateOutput = mtMap121.object({
  id: mtMap121.objectField("id", mtMap121.passthrough()),
  type: mtMap121.objectField("type", mtMap121.passthrough()),
  status: mtMap121.objectField("status", mtMap121.passthrough()),
  name: mtMap121.objectField("name", mtMap121.passthrough()),
  slug: mtMap121.objectField("slug", mtMap121.passthrough()),
  instanceId: mtMap121.objectField("instance_id", mtMap121.passthrough()),
  portal: mtMap121.objectField(
    "portal",
    mtMap121.object({
      id: mtMap121.objectField("id", mtMap121.passthrough()),
      type: mtMap121.objectField("type", mtMap121.passthrough()),
      status: mtMap121.objectField("status", mtMap121.passthrough()),
      organizationId: mtMap121.objectField(
        "organization_id",
        mtMap121.passthrough()
      ),
      projectId: mtMap121.objectField("project_id", mtMap121.passthrough()),
      name: mtMap121.objectField("name", mtMap121.passthrough()),
      slug: mtMap121.objectField("slug", mtMap121.passthrough()),
      publicName: mtMap121.objectField("public_name", mtMap121.passthrough()),
      createdAt: mtMap121.objectField("created_at", mtMap121.date()),
      updatedAt: mtMap121.objectField("updated_at", mtMap121.date())
    })
  ),
  createdAt: mtMap121.objectField("created_at", mtMap121.date()),
  updatedAt: mtMap121.objectField("updated_at", mtMap121.date())
});
var mapManagementProjectsPortalsPortalEnvironmentsUpdateBody = mtMap121.object({
  name: mtMap121.objectField("name", mtMap121.passthrough())
});

// src/resources/management/projects/portals/update.ts
import { mtMap as mtMap122 } from "@metorial/util-resource-mapper";
var mapManagementProjectsPortalsUpdateOutput = mtMap122.object({
  id: mtMap122.objectField("id", mtMap122.passthrough()),
  type: mtMap122.objectField("type", mtMap122.passthrough()),
  status: mtMap122.objectField("status", mtMap122.passthrough()),
  organizationId: mtMap122.objectField("organization_id", mtMap122.passthrough()),
  projectId: mtMap122.objectField("project_id", mtMap122.passthrough()),
  name: mtMap122.objectField("name", mtMap122.passthrough()),
  slug: mtMap122.objectField("slug", mtMap122.passthrough()),
  publicName: mtMap122.objectField("public_name", mtMap122.passthrough()),
  createdAt: mtMap122.objectField("created_at", mtMap122.date()),
  updatedAt: mtMap122.objectField("updated_at", mtMap122.date())
});
var mapManagementProjectsPortalsUpdateBody = mtMap122.object({
  name: mtMap122.objectField("name", mtMap122.passthrough()),
  publicName: mtMap122.objectField("public_name", mtMap122.passthrough())
});

// src/resources/management/projects/update.ts
import { mtMap as mtMap123 } from "@metorial/util-resource-mapper";
var mapManagementProjectsUpdateOutput = mtMap123.object({
  id: mtMap123.objectField("id", mtMap123.passthrough()),
  slug: mtMap123.objectField("slug", mtMap123.passthrough()),
  name: mtMap123.objectField("name", mtMap123.passthrough()),
  organizationId: mtMap123.objectField("organization_id", mtMap123.passthrough()),
  createdAt: mtMap123.objectField("created_at", mtMap123.date()),
  updatedAt: mtMap123.objectField("updated_at", mtMap123.date())
});
var mapManagementProjectsUpdateBody = mtMap123.object({
  name: mtMap123.objectField("name", mtMap123.passthrough())
});

// src/resources/policies/create.ts
import { mtMap as mtMap124 } from "@metorial/util-resource-mapper";
var mapPoliciesCreateOutput = mtMap124.object({
  id: mtMap124.objectField("id", mtMap124.passthrough()),
  status: mtMap124.objectField("status", mtMap124.passthrough()),
  isDefault: mtMap124.objectField("is_default", mtMap124.passthrough()),
  slug: mtMap124.objectField("slug", mtMap124.passthrough()),
  name: mtMap124.objectField("name", mtMap124.passthrough()),
  description: mtMap124.objectField("description", mtMap124.passthrough()),
  entitlements: mtMap124.objectField(
    "entitlements",
    mtMap124.array(
      mtMap124.object({
        id: mtMap124.objectField("id", mtMap124.passthrough()),
        status: mtMap124.objectField("status", mtMap124.passthrough()),
        policyId: mtMap124.objectField("policy_id", mtMap124.passthrough()),
        type: mtMap124.objectField("type", mtMap124.passthrough()),
        amount: mtMap124.objectField("amount", mtMap124.passthrough()),
        windowDuration: mtMap124.objectField(
          "window_duration",
          mtMap124.object({
            size: mtMap124.objectField("size", mtMap124.passthrough()),
            unit: mtMap124.objectField("unit", mtMap124.passthrough())
          })
        ),
        overageBlockDuration: mtMap124.objectField(
          "overage_block_duration",
          mtMap124.object({
            size: mtMap124.objectField("size", mtMap124.passthrough()),
            unit: mtMap124.objectField("unit", mtMap124.passthrough())
          })
        ),
        agents: mtMap124.objectField(
          "agents",
          mtMap124.union([
            mtMap124.unionOption(
              "object",
              mtMap124.object({
                type: mtMap124.objectField("type", mtMap124.passthrough()),
                agentIds: mtMap124.objectField(
                  "agent_ids",
                  mtMap124.array(mtMap124.passthrough())
                )
              })
            )
          ])
        ),
        createdAt: mtMap124.objectField("created_at", mtMap124.date()),
        updatedAt: mtMap124.objectField("updated_at", mtMap124.date())
      })
    )
  ),
  createdAt: mtMap124.objectField("created_at", mtMap124.date()),
  updatedAt: mtMap124.objectField("updated_at", mtMap124.date())
});
var mapPoliciesCreateBody = mtMap124.object({
  name: mtMap124.objectField("name", mtMap124.passthrough()),
  slug: mtMap124.objectField("slug", mtMap124.passthrough()),
  description: mtMap124.objectField("description", mtMap124.passthrough())
});

// src/resources/policies/entitlements/create.ts
import { mtMap as mtMap125 } from "@metorial/util-resource-mapper";
var mapPoliciesEntitlementsCreateOutput = mtMap125.object({
  id: mtMap125.objectField("id", mtMap125.passthrough()),
  status: mtMap125.objectField("status", mtMap125.passthrough()),
  isDefault: mtMap125.objectField("is_default", mtMap125.passthrough()),
  slug: mtMap125.objectField("slug", mtMap125.passthrough()),
  name: mtMap125.objectField("name", mtMap125.passthrough()),
  description: mtMap125.objectField("description", mtMap125.passthrough()),
  entitlements: mtMap125.objectField(
    "entitlements",
    mtMap125.array(
      mtMap125.object({
        id: mtMap125.objectField("id", mtMap125.passthrough()),
        status: mtMap125.objectField("status", mtMap125.passthrough()),
        policyId: mtMap125.objectField("policy_id", mtMap125.passthrough()),
        type: mtMap125.objectField("type", mtMap125.passthrough()),
        amount: mtMap125.objectField("amount", mtMap125.passthrough()),
        windowDuration: mtMap125.objectField(
          "window_duration",
          mtMap125.object({
            size: mtMap125.objectField("size", mtMap125.passthrough()),
            unit: mtMap125.objectField("unit", mtMap125.passthrough())
          })
        ),
        overageBlockDuration: mtMap125.objectField(
          "overage_block_duration",
          mtMap125.object({
            size: mtMap125.objectField("size", mtMap125.passthrough()),
            unit: mtMap125.objectField("unit", mtMap125.passthrough())
          })
        ),
        agents: mtMap125.objectField(
          "agents",
          mtMap125.union([
            mtMap125.unionOption(
              "object",
              mtMap125.object({
                type: mtMap125.objectField("type", mtMap125.passthrough()),
                agentIds: mtMap125.objectField(
                  "agent_ids",
                  mtMap125.array(mtMap125.passthrough())
                )
              })
            )
          ])
        ),
        createdAt: mtMap125.objectField("created_at", mtMap125.date()),
        updatedAt: mtMap125.objectField("updated_at", mtMap125.date())
      })
    )
  ),
  createdAt: mtMap125.objectField("created_at", mtMap125.date()),
  updatedAt: mtMap125.objectField("updated_at", mtMap125.date())
});
var mapPoliciesEntitlementsCreateBody = mtMap125.object({
  type: mtMap125.objectField("type", mtMap125.passthrough()),
  amount: mtMap125.objectField("amount", mtMap125.passthrough()),
  windowDuration: mtMap125.objectField(
    "window_duration",
    mtMap125.object({
      size: mtMap125.objectField("size", mtMap125.passthrough()),
      unit: mtMap125.objectField("unit", mtMap125.passthrough())
    })
  ),
  overageBlockDuration: mtMap125.objectField(
    "overage_block_duration",
    mtMap125.object({
      size: mtMap125.objectField("size", mtMap125.passthrough()),
      unit: mtMap125.objectField("unit", mtMap125.passthrough())
    })
  ),
  allowAgents: mtMap125.objectField(
    "allow_agents",
    mtMap125.union([
      mtMap125.unionOption(
        "object",
        mtMap125.object({
          type: mtMap125.objectField("type", mtMap125.passthrough()),
          agentIds: mtMap125.objectField(
            "agent_ids",
            mtMap125.array(mtMap125.passthrough())
          )
        })
      )
    ])
  )
});

// src/resources/policies/entitlements/delete.ts
import { mtMap as mtMap126 } from "@metorial/util-resource-mapper";
var mapPoliciesEntitlementsDeleteOutput = mtMap126.object({
  id: mtMap126.objectField("id", mtMap126.passthrough()),
  status: mtMap126.objectField("status", mtMap126.passthrough()),
  isDefault: mtMap126.objectField("is_default", mtMap126.passthrough()),
  slug: mtMap126.objectField("slug", mtMap126.passthrough()),
  name: mtMap126.objectField("name", mtMap126.passthrough()),
  description: mtMap126.objectField("description", mtMap126.passthrough()),
  entitlements: mtMap126.objectField(
    "entitlements",
    mtMap126.array(
      mtMap126.object({
        id: mtMap126.objectField("id", mtMap126.passthrough()),
        status: mtMap126.objectField("status", mtMap126.passthrough()),
        policyId: mtMap126.objectField("policy_id", mtMap126.passthrough()),
        type: mtMap126.objectField("type", mtMap126.passthrough()),
        amount: mtMap126.objectField("amount", mtMap126.passthrough()),
        windowDuration: mtMap126.objectField(
          "window_duration",
          mtMap126.object({
            size: mtMap126.objectField("size", mtMap126.passthrough()),
            unit: mtMap126.objectField("unit", mtMap126.passthrough())
          })
        ),
        overageBlockDuration: mtMap126.objectField(
          "overage_block_duration",
          mtMap126.object({
            size: mtMap126.objectField("size", mtMap126.passthrough()),
            unit: mtMap126.objectField("unit", mtMap126.passthrough())
          })
        ),
        agents: mtMap126.objectField(
          "agents",
          mtMap126.union([
            mtMap126.unionOption(
              "object",
              mtMap126.object({
                type: mtMap126.objectField("type", mtMap126.passthrough()),
                agentIds: mtMap126.objectField(
                  "agent_ids",
                  mtMap126.array(mtMap126.passthrough())
                )
              })
            )
          ])
        ),
        createdAt: mtMap126.objectField("created_at", mtMap126.date()),
        updatedAt: mtMap126.objectField("updated_at", mtMap126.date())
      })
    )
  ),
  createdAt: mtMap126.objectField("created_at", mtMap126.date()),
  updatedAt: mtMap126.objectField("updated_at", mtMap126.date())
});

// src/resources/policies/entitlements/update.ts
import { mtMap as mtMap127 } from "@metorial/util-resource-mapper";
var mapPoliciesEntitlementsUpdateOutput = mtMap127.object({
  id: mtMap127.objectField("id", mtMap127.passthrough()),
  status: mtMap127.objectField("status", mtMap127.passthrough()),
  isDefault: mtMap127.objectField("is_default", mtMap127.passthrough()),
  slug: mtMap127.objectField("slug", mtMap127.passthrough()),
  name: mtMap127.objectField("name", mtMap127.passthrough()),
  description: mtMap127.objectField("description", mtMap127.passthrough()),
  entitlements: mtMap127.objectField(
    "entitlements",
    mtMap127.array(
      mtMap127.object({
        id: mtMap127.objectField("id", mtMap127.passthrough()),
        status: mtMap127.objectField("status", mtMap127.passthrough()),
        policyId: mtMap127.objectField("policy_id", mtMap127.passthrough()),
        type: mtMap127.objectField("type", mtMap127.passthrough()),
        amount: mtMap127.objectField("amount", mtMap127.passthrough()),
        windowDuration: mtMap127.objectField(
          "window_duration",
          mtMap127.object({
            size: mtMap127.objectField("size", mtMap127.passthrough()),
            unit: mtMap127.objectField("unit", mtMap127.passthrough())
          })
        ),
        overageBlockDuration: mtMap127.objectField(
          "overage_block_duration",
          mtMap127.object({
            size: mtMap127.objectField("size", mtMap127.passthrough()),
            unit: mtMap127.objectField("unit", mtMap127.passthrough())
          })
        ),
        agents: mtMap127.objectField(
          "agents",
          mtMap127.union([
            mtMap127.unionOption(
              "object",
              mtMap127.object({
                type: mtMap127.objectField("type", mtMap127.passthrough()),
                agentIds: mtMap127.objectField(
                  "agent_ids",
                  mtMap127.array(mtMap127.passthrough())
                )
              })
            )
          ])
        ),
        createdAt: mtMap127.objectField("created_at", mtMap127.date()),
        updatedAt: mtMap127.objectField("updated_at", mtMap127.date())
      })
    )
  ),
  createdAt: mtMap127.objectField("created_at", mtMap127.date()),
  updatedAt: mtMap127.objectField("updated_at", mtMap127.date())
});
var mapPoliciesEntitlementsUpdateBody = mtMap127.object({
  amount: mtMap127.objectField("amount", mtMap127.passthrough()),
  windowDuration: mtMap127.objectField(
    "window_duration",
    mtMap127.object({
      size: mtMap127.objectField("size", mtMap127.passthrough()),
      unit: mtMap127.objectField("unit", mtMap127.passthrough())
    })
  ),
  overageBlockDuration: mtMap127.objectField(
    "overage_block_duration",
    mtMap127.object({
      size: mtMap127.objectField("size", mtMap127.passthrough()),
      unit: mtMap127.objectField("unit", mtMap127.passthrough())
    })
  ),
  allowAgents: mtMap127.objectField(
    "allow_agents",
    mtMap127.union([
      mtMap127.unionOption(
        "object",
        mtMap127.object({
          type: mtMap127.objectField("type", mtMap127.passthrough()),
          agentIds: mtMap127.objectField(
            "agent_ids",
            mtMap127.array(mtMap127.passthrough())
          )
        })
      )
    ])
  )
});

// src/resources/policies/get.ts
import { mtMap as mtMap128 } from "@metorial/util-resource-mapper";
var mapPoliciesGetOutput = mtMap128.object({
  id: mtMap128.objectField("id", mtMap128.passthrough()),
  status: mtMap128.objectField("status", mtMap128.passthrough()),
  isDefault: mtMap128.objectField("is_default", mtMap128.passthrough()),
  slug: mtMap128.objectField("slug", mtMap128.passthrough()),
  name: mtMap128.objectField("name", mtMap128.passthrough()),
  description: mtMap128.objectField("description", mtMap128.passthrough()),
  entitlements: mtMap128.objectField(
    "entitlements",
    mtMap128.array(
      mtMap128.object({
        id: mtMap128.objectField("id", mtMap128.passthrough()),
        status: mtMap128.objectField("status", mtMap128.passthrough()),
        policyId: mtMap128.objectField("policy_id", mtMap128.passthrough()),
        type: mtMap128.objectField("type", mtMap128.passthrough()),
        amount: mtMap128.objectField("amount", mtMap128.passthrough()),
        windowDuration: mtMap128.objectField(
          "window_duration",
          mtMap128.object({
            size: mtMap128.objectField("size", mtMap128.passthrough()),
            unit: mtMap128.objectField("unit", mtMap128.passthrough())
          })
        ),
        overageBlockDuration: mtMap128.objectField(
          "overage_block_duration",
          mtMap128.object({
            size: mtMap128.objectField("size", mtMap128.passthrough()),
            unit: mtMap128.objectField("unit", mtMap128.passthrough())
          })
        ),
        agents: mtMap128.objectField(
          "agents",
          mtMap128.union([
            mtMap128.unionOption(
              "object",
              mtMap128.object({
                type: mtMap128.objectField("type", mtMap128.passthrough()),
                agentIds: mtMap128.objectField(
                  "agent_ids",
                  mtMap128.array(mtMap128.passthrough())
                )
              })
            )
          ])
        ),
        createdAt: mtMap128.objectField("created_at", mtMap128.date()),
        updatedAt: mtMap128.objectField("updated_at", mtMap128.date())
      })
    )
  ),
  createdAt: mtMap128.objectField("created_at", mtMap128.date()),
  updatedAt: mtMap128.objectField("updated_at", mtMap128.date())
});

// src/resources/policies/list.ts
import { mtMap as mtMap129 } from "@metorial/util-resource-mapper";
var mapPoliciesListOutput = mtMap129.object({
  items: mtMap129.objectField(
    "items",
    mtMap129.array(
      mtMap129.object({
        id: mtMap129.objectField("id", mtMap129.passthrough()),
        status: mtMap129.objectField("status", mtMap129.passthrough()),
        isDefault: mtMap129.objectField("is_default", mtMap129.passthrough()),
        slug: mtMap129.objectField("slug", mtMap129.passthrough()),
        name: mtMap129.objectField("name", mtMap129.passthrough()),
        description: mtMap129.objectField("description", mtMap129.passthrough()),
        entitlements: mtMap129.objectField(
          "entitlements",
          mtMap129.array(
            mtMap129.object({
              id: mtMap129.objectField("id", mtMap129.passthrough()),
              status: mtMap129.objectField("status", mtMap129.passthrough()),
              policyId: mtMap129.objectField("policy_id", mtMap129.passthrough()),
              type: mtMap129.objectField("type", mtMap129.passthrough()),
              amount: mtMap129.objectField("amount", mtMap129.passthrough()),
              windowDuration: mtMap129.objectField(
                "window_duration",
                mtMap129.object({
                  size: mtMap129.objectField("size", mtMap129.passthrough()),
                  unit: mtMap129.objectField("unit", mtMap129.passthrough())
                })
              ),
              overageBlockDuration: mtMap129.objectField(
                "overage_block_duration",
                mtMap129.object({
                  size: mtMap129.objectField("size", mtMap129.passthrough()),
                  unit: mtMap129.objectField("unit", mtMap129.passthrough())
                })
              ),
              agents: mtMap129.objectField(
                "agents",
                mtMap129.union([
                  mtMap129.unionOption(
                    "object",
                    mtMap129.object({
                      type: mtMap129.objectField("type", mtMap129.passthrough()),
                      agentIds: mtMap129.objectField(
                        "agent_ids",
                        mtMap129.array(mtMap129.passthrough())
                      )
                    })
                  )
                ])
              ),
              createdAt: mtMap129.objectField("created_at", mtMap129.date()),
              updatedAt: mtMap129.objectField("updated_at", mtMap129.date())
            })
          )
        ),
        createdAt: mtMap129.objectField("created_at", mtMap129.date()),
        updatedAt: mtMap129.objectField("updated_at", mtMap129.date())
      })
    )
  ),
  pagination: mtMap129.objectField(
    "pagination",
    mtMap129.object({
      afterCursor: mtMap129.objectField("after_cursor", mtMap129.passthrough()),
      beforeCursor: mtMap129.objectField("before_cursor", mtMap129.passthrough()),
      hasMoreBefore: mtMap129.objectField("has_more_before", mtMap129.passthrough()),
      hasMoreAfter: mtMap129.objectField("has_more_after", mtMap129.passthrough()),
      pageSize: mtMap129.objectField("page_size", mtMap129.passthrough()),
      sort: mtMap129.objectField(
        "sort",
        mtMap129.array(
          mtMap129.object({
            field: mtMap129.objectField("field", mtMap129.passthrough()),
            order: mtMap129.objectField("order", mtMap129.passthrough())
          })
        )
      )
    })
  )
});
var mapPoliciesListQuery = mtMap129.object({
  id: mtMap129.objectField(
    "id",
    mtMap129.union([
      mtMap129.unionOption(
        "object",
        mtMap129.object({
          in: mtMap129.objectField("in", mtMap129.array(mtMap129.passthrough())),
          eq: mtMap129.objectField("eq", mtMap129.passthrough())
        })
      ),
      mtMap129.unionOption("string", mtMap129.passthrough())
    ])
  ),
  ids: mtMap129.objectField(
    "ids",
    mtMap129.union([
      mtMap129.unionOption(
        "object",
        mtMap129.object({
          in: mtMap129.objectField("in", mtMap129.array(mtMap129.passthrough())),
          eq: mtMap129.objectField("eq", mtMap129.passthrough())
        })
      ),
      mtMap129.unionOption("string", mtMap129.passthrough())
    ])
  ),
  slug: mtMap129.objectField(
    "slug",
    mtMap129.union([
      mtMap129.unionOption(
        "object",
        mtMap129.object({
          in: mtMap129.objectField("in", mtMap129.array(mtMap129.passthrough())),
          eq: mtMap129.objectField("eq", mtMap129.passthrough())
        })
      ),
      mtMap129.unionOption("string", mtMap129.passthrough())
    ])
  ),
  slugs: mtMap129.objectField(
    "slugs",
    mtMap129.union([
      mtMap129.unionOption(
        "object",
        mtMap129.object({
          in: mtMap129.objectField("in", mtMap129.array(mtMap129.passthrough())),
          eq: mtMap129.objectField("eq", mtMap129.passthrough())
        })
      ),
      mtMap129.unionOption("string", mtMap129.passthrough())
    ])
  ),
  sort: mtMap129.objectField(
    "sort",
    mtMap129.union([
      mtMap129.unionOption("string", mtMap129.passthrough()),
      mtMap129.unionOption(
        "array",
        mtMap129.union([
          mtMap129.unionOption(
            "object",
            mtMap129.object({
              field: mtMap129.objectField("field", mtMap129.passthrough()),
              order: mtMap129.objectField("order", mtMap129.passthrough())
            })
          )
        ])
      )
    ])
  ),
  limit: mtMap129.objectField("limit", mtMap129.passthrough()),
  cursor: mtMap129.objectField("cursor", mtMap129.passthrough()),
  order: mtMap129.objectField("order", mtMap129.passthrough())
});

// src/resources/policies/update.ts
import { mtMap as mtMap130 } from "@metorial/util-resource-mapper";
var mapPoliciesUpdateOutput = mtMap130.object({
  id: mtMap130.objectField("id", mtMap130.passthrough()),
  status: mtMap130.objectField("status", mtMap130.passthrough()),
  isDefault: mtMap130.objectField("is_default", mtMap130.passthrough()),
  slug: mtMap130.objectField("slug", mtMap130.passthrough()),
  name: mtMap130.objectField("name", mtMap130.passthrough()),
  description: mtMap130.objectField("description", mtMap130.passthrough()),
  entitlements: mtMap130.objectField(
    "entitlements",
    mtMap130.array(
      mtMap130.object({
        id: mtMap130.objectField("id", mtMap130.passthrough()),
        status: mtMap130.objectField("status", mtMap130.passthrough()),
        policyId: mtMap130.objectField("policy_id", mtMap130.passthrough()),
        type: mtMap130.objectField("type", mtMap130.passthrough()),
        amount: mtMap130.objectField("amount", mtMap130.passthrough()),
        windowDuration: mtMap130.objectField(
          "window_duration",
          mtMap130.object({
            size: mtMap130.objectField("size", mtMap130.passthrough()),
            unit: mtMap130.objectField("unit", mtMap130.passthrough())
          })
        ),
        overageBlockDuration: mtMap130.objectField(
          "overage_block_duration",
          mtMap130.object({
            size: mtMap130.objectField("size", mtMap130.passthrough()),
            unit: mtMap130.objectField("unit", mtMap130.passthrough())
          })
        ),
        agents: mtMap130.objectField(
          "agents",
          mtMap130.union([
            mtMap130.unionOption(
              "object",
              mtMap130.object({
                type: mtMap130.objectField("type", mtMap130.passthrough()),
                agentIds: mtMap130.objectField(
                  "agent_ids",
                  mtMap130.array(mtMap130.passthrough())
                )
              })
            )
          ])
        ),
        createdAt: mtMap130.objectField("created_at", mtMap130.date()),
        updatedAt: mtMap130.objectField("updated_at", mtMap130.date())
      })
    )
  ),
  createdAt: mtMap130.objectField("created_at", mtMap130.date()),
  updatedAt: mtMap130.objectField("updated_at", mtMap130.date())
});
var mapPoliciesUpdateBody = mtMap130.object({
  name: mtMap130.objectField("name", mtMap130.passthrough()),
  slug: mtMap130.objectField("slug", mtMap130.passthrough()),
  description: mtMap130.objectField("description", mtMap130.passthrough()),
  isDefault: mtMap130.objectField("is_default", mtMap130.passthrough())
});

// src/resources/portals/agents/create.ts
import { mtMap as mtMap131 } from "@metorial/util-resource-mapper";
var mapPortalsAgentsCreateOutput = mtMap131.object({
  id: mtMap131.objectField("id", mtMap131.passthrough()),
  status: mtMap131.objectField("status", mtMap131.passthrough()),
  name: mtMap131.objectField("name", mtMap131.passthrough()),
  slug: mtMap131.objectField("slug", mtMap131.passthrough()),
  description: mtMap131.objectField("description", mtMap131.passthrough()),
  portalId: mtMap131.objectField("portal_id", mtMap131.passthrough()),
  agentId: mtMap131.objectField("agent_id", mtMap131.passthrough()),
  createdAt: mtMap131.objectField("created_at", mtMap131.date()),
  updatedAt: mtMap131.objectField("updated_at", mtMap131.date())
});
var mapPortalsAgentsCreateBody = mtMap131.object({
  name: mtMap131.objectField("name", mtMap131.passthrough()),
  description: mtMap131.objectField("description", mtMap131.passthrough()),
  agentId: mtMap131.objectField("agent_id", mtMap131.passthrough())
});

// src/resources/portals/agents/delete.ts
import { mtMap as mtMap132 } from "@metorial/util-resource-mapper";
var mapPortalsAgentsDeleteOutput = mtMap132.object({
  id: mtMap132.objectField("id", mtMap132.passthrough()),
  status: mtMap132.objectField("status", mtMap132.passthrough()),
  name: mtMap132.objectField("name", mtMap132.passthrough()),
  slug: mtMap132.objectField("slug", mtMap132.passthrough()),
  description: mtMap132.objectField("description", mtMap132.passthrough()),
  portalId: mtMap132.objectField("portal_id", mtMap132.passthrough()),
  agentId: mtMap132.objectField("agent_id", mtMap132.passthrough()),
  createdAt: mtMap132.objectField("created_at", mtMap132.date()),
  updatedAt: mtMap132.objectField("updated_at", mtMap132.date())
});

// src/resources/portals/agents/get.ts
import { mtMap as mtMap133 } from "@metorial/util-resource-mapper";
var mapPortalsAgentsGetOutput = mtMap133.object({
  id: mtMap133.objectField("id", mtMap133.passthrough()),
  status: mtMap133.objectField("status", mtMap133.passthrough()),
  name: mtMap133.objectField("name", mtMap133.passthrough()),
  slug: mtMap133.objectField("slug", mtMap133.passthrough()),
  description: mtMap133.objectField("description", mtMap133.passthrough()),
  portalId: mtMap133.objectField("portal_id", mtMap133.passthrough()),
  agentId: mtMap133.objectField("agent_id", mtMap133.passthrough()),
  createdAt: mtMap133.objectField("created_at", mtMap133.date()),
  updatedAt: mtMap133.objectField("updated_at", mtMap133.date())
});

// src/resources/portals/agents/list.ts
import { mtMap as mtMap134 } from "@metorial/util-resource-mapper";
var mapPortalsAgentsListOutput = mtMap134.object({
  items: mtMap134.objectField(
    "items",
    mtMap134.array(
      mtMap134.object({
        id: mtMap134.objectField("id", mtMap134.passthrough()),
        status: mtMap134.objectField("status", mtMap134.passthrough()),
        name: mtMap134.objectField("name", mtMap134.passthrough()),
        slug: mtMap134.objectField("slug", mtMap134.passthrough()),
        description: mtMap134.objectField("description", mtMap134.passthrough()),
        portalId: mtMap134.objectField("portal_id", mtMap134.passthrough()),
        agentId: mtMap134.objectField("agent_id", mtMap134.passthrough()),
        createdAt: mtMap134.objectField("created_at", mtMap134.date()),
        updatedAt: mtMap134.objectField("updated_at", mtMap134.date())
      })
    )
  ),
  pagination: mtMap134.objectField(
    "pagination",
    mtMap134.object({
      afterCursor: mtMap134.objectField("after_cursor", mtMap134.passthrough()),
      beforeCursor: mtMap134.objectField("before_cursor", mtMap134.passthrough()),
      hasMoreBefore: mtMap134.objectField("has_more_before", mtMap134.passthrough()),
      hasMoreAfter: mtMap134.objectField("has_more_after", mtMap134.passthrough()),
      pageSize: mtMap134.objectField("page_size", mtMap134.passthrough()),
      sort: mtMap134.objectField(
        "sort",
        mtMap134.array(
          mtMap134.object({
            field: mtMap134.objectField("field", mtMap134.passthrough()),
            order: mtMap134.objectField("order", mtMap134.passthrough())
          })
        )
      )
    })
  )
});
var mapPortalsAgentsListQuery = mtMap134.object({
  id: mtMap134.objectField(
    "id",
    mtMap134.union([
      mtMap134.unionOption(
        "object",
        mtMap134.object({
          in: mtMap134.objectField("in", mtMap134.array(mtMap134.passthrough())),
          eq: mtMap134.objectField("eq", mtMap134.passthrough())
        })
      ),
      mtMap134.unionOption("string", mtMap134.passthrough())
    ])
  ),
  ids: mtMap134.objectField(
    "ids",
    mtMap134.union([
      mtMap134.unionOption(
        "object",
        mtMap134.object({
          in: mtMap134.objectField("in", mtMap134.array(mtMap134.passthrough())),
          eq: mtMap134.objectField("eq", mtMap134.passthrough())
        })
      ),
      mtMap134.unionOption("string", mtMap134.passthrough())
    ])
  ),
  slug: mtMap134.objectField(
    "slug",
    mtMap134.union([
      mtMap134.unionOption(
        "object",
        mtMap134.object({
          in: mtMap134.objectField("in", mtMap134.array(mtMap134.passthrough())),
          eq: mtMap134.objectField("eq", mtMap134.passthrough())
        })
      ),
      mtMap134.unionOption("string", mtMap134.passthrough())
    ])
  ),
  slugs: mtMap134.objectField(
    "slugs",
    mtMap134.union([
      mtMap134.unionOption(
        "object",
        mtMap134.object({
          in: mtMap134.objectField("in", mtMap134.array(mtMap134.passthrough())),
          eq: mtMap134.objectField("eq", mtMap134.passthrough())
        })
      ),
      mtMap134.unionOption("string", mtMap134.passthrough())
    ])
  ),
  sort: mtMap134.objectField(
    "sort",
    mtMap134.union([
      mtMap134.unionOption("string", mtMap134.passthrough()),
      mtMap134.unionOption(
        "array",
        mtMap134.union([
          mtMap134.unionOption(
            "object",
            mtMap134.object({
              field: mtMap134.objectField("field", mtMap134.passthrough()),
              order: mtMap134.objectField("order", mtMap134.passthrough())
            })
          )
        ])
      )
    ])
  ),
  portalId: mtMap134.objectField("portalId", mtMap134.passthrough()),
  limit: mtMap134.objectField("limit", mtMap134.passthrough()),
  cursor: mtMap134.objectField("cursor", mtMap134.passthrough()),
  order: mtMap134.objectField("order", mtMap134.passthrough())
});

// src/resources/portals/agents/update.ts
import { mtMap as mtMap135 } from "@metorial/util-resource-mapper";
var mapPortalsAgentsUpdateOutput = mtMap135.object({
  id: mtMap135.objectField("id", mtMap135.passthrough()),
  status: mtMap135.objectField("status", mtMap135.passthrough()),
  name: mtMap135.objectField("name", mtMap135.passthrough()),
  slug: mtMap135.objectField("slug", mtMap135.passthrough()),
  description: mtMap135.objectField("description", mtMap135.passthrough()),
  portalId: mtMap135.objectField("portal_id", mtMap135.passthrough()),
  agentId: mtMap135.objectField("agent_id", mtMap135.passthrough()),
  createdAt: mtMap135.objectField("created_at", mtMap135.date()),
  updatedAt: mtMap135.objectField("updated_at", mtMap135.date())
});
var mapPortalsAgentsUpdateBody = mtMap135.object({
  name: mtMap135.objectField("name", mtMap135.passthrough()),
  description: mtMap135.objectField("description", mtMap135.passthrough())
});

// src/resources/portals/create.ts
import { mtMap as mtMap136 } from "@metorial/util-resource-mapper";
var mapPortalsCreateOutput = mtMap136.object({
  id: mtMap136.objectField("id", mtMap136.passthrough()),
  type: mtMap136.objectField("type", mtMap136.passthrough()),
  status: mtMap136.objectField("status", mtMap136.passthrough()),
  organizationId: mtMap136.objectField("organization_id", mtMap136.passthrough()),
  projectId: mtMap136.objectField("project_id", mtMap136.passthrough()),
  name: mtMap136.objectField("name", mtMap136.passthrough()),
  slug: mtMap136.objectField("slug", mtMap136.passthrough()),
  publicName: mtMap136.objectField("public_name", mtMap136.passthrough()),
  createdAt: mtMap136.objectField("created_at", mtMap136.date()),
  updatedAt: mtMap136.objectField("updated_at", mtMap136.date())
});
var mapPortalsCreateBody = mtMap136.object({
  name: mtMap136.objectField("name", mtMap136.passthrough()),
  type: mtMap136.objectField("type", mtMap136.passthrough())
});

// src/resources/portals/delete.ts
import { mtMap as mtMap137 } from "@metorial/util-resource-mapper";
var mapPortalsDeleteOutput = mtMap137.object({
  id: mtMap137.objectField("id", mtMap137.passthrough()),
  type: mtMap137.objectField("type", mtMap137.passthrough()),
  status: mtMap137.objectField("status", mtMap137.passthrough()),
  organizationId: mtMap137.objectField("organization_id", mtMap137.passthrough()),
  projectId: mtMap137.objectField("project_id", mtMap137.passthrough()),
  name: mtMap137.objectField("name", mtMap137.passthrough()),
  slug: mtMap137.objectField("slug", mtMap137.passthrough()),
  publicName: mtMap137.objectField("public_name", mtMap137.passthrough()),
  createdAt: mtMap137.objectField("created_at", mtMap137.date()),
  updatedAt: mtMap137.objectField("updated_at", mtMap137.date())
});

// src/resources/portals/get.ts
import { mtMap as mtMap138 } from "@metorial/util-resource-mapper";
var mapPortalsGetOutput = mtMap138.object({
  id: mtMap138.objectField("id", mtMap138.passthrough()),
  type: mtMap138.objectField("type", mtMap138.passthrough()),
  status: mtMap138.objectField("status", mtMap138.passthrough()),
  organizationId: mtMap138.objectField("organization_id", mtMap138.passthrough()),
  projectId: mtMap138.objectField("project_id", mtMap138.passthrough()),
  name: mtMap138.objectField("name", mtMap138.passthrough()),
  slug: mtMap138.objectField("slug", mtMap138.passthrough()),
  publicName: mtMap138.objectField("public_name", mtMap138.passthrough()),
  createdAt: mtMap138.objectField("created_at", mtMap138.date()),
  updatedAt: mtMap138.objectField("updated_at", mtMap138.date())
});

// src/resources/portals/list.ts
import { mtMap as mtMap139 } from "@metorial/util-resource-mapper";
var mapPortalsListOutput = mtMap139.object({
  items: mtMap139.objectField(
    "items",
    mtMap139.array(
      mtMap139.object({
        id: mtMap139.objectField("id", mtMap139.passthrough()),
        type: mtMap139.objectField("type", mtMap139.passthrough()),
        status: mtMap139.objectField("status", mtMap139.passthrough()),
        organizationId: mtMap139.objectField(
          "organization_id",
          mtMap139.passthrough()
        ),
        projectId: mtMap139.objectField("project_id", mtMap139.passthrough()),
        name: mtMap139.objectField("name", mtMap139.passthrough()),
        slug: mtMap139.objectField("slug", mtMap139.passthrough()),
        publicName: mtMap139.objectField("public_name", mtMap139.passthrough()),
        createdAt: mtMap139.objectField("created_at", mtMap139.date()),
        updatedAt: mtMap139.objectField("updated_at", mtMap139.date())
      })
    )
  ),
  pagination: mtMap139.objectField(
    "pagination",
    mtMap139.object({
      afterCursor: mtMap139.objectField("after_cursor", mtMap139.passthrough()),
      beforeCursor: mtMap139.objectField("before_cursor", mtMap139.passthrough()),
      hasMoreBefore: mtMap139.objectField("has_more_before", mtMap139.passthrough()),
      hasMoreAfter: mtMap139.objectField("has_more_after", mtMap139.passthrough()),
      pageSize: mtMap139.objectField("page_size", mtMap139.passthrough()),
      sort: mtMap139.objectField(
        "sort",
        mtMap139.array(
          mtMap139.object({
            field: mtMap139.objectField("field", mtMap139.passthrough()),
            order: mtMap139.objectField("order", mtMap139.passthrough())
          })
        )
      )
    })
  )
});
var mapPortalsListQuery = mtMap139.object({
  id: mtMap139.objectField(
    "id",
    mtMap139.union([
      mtMap139.unionOption(
        "object",
        mtMap139.object({
          in: mtMap139.objectField("in", mtMap139.array(mtMap139.passthrough())),
          eq: mtMap139.objectField("eq", mtMap139.passthrough())
        })
      ),
      mtMap139.unionOption("string", mtMap139.passthrough())
    ])
  ),
  ids: mtMap139.objectField(
    "ids",
    mtMap139.union([
      mtMap139.unionOption(
        "object",
        mtMap139.object({
          in: mtMap139.objectField("in", mtMap139.array(mtMap139.passthrough())),
          eq: mtMap139.objectField("eq", mtMap139.passthrough())
        })
      ),
      mtMap139.unionOption("string", mtMap139.passthrough())
    ])
  ),
  slug: mtMap139.objectField(
    "slug",
    mtMap139.union([
      mtMap139.unionOption(
        "object",
        mtMap139.object({
          in: mtMap139.objectField("in", mtMap139.array(mtMap139.passthrough())),
          eq: mtMap139.objectField("eq", mtMap139.passthrough())
        })
      ),
      mtMap139.unionOption("string", mtMap139.passthrough())
    ])
  ),
  slugs: mtMap139.objectField(
    "slugs",
    mtMap139.union([
      mtMap139.unionOption(
        "object",
        mtMap139.object({
          in: mtMap139.objectField("in", mtMap139.array(mtMap139.passthrough())),
          eq: mtMap139.objectField("eq", mtMap139.passthrough())
        })
      ),
      mtMap139.unionOption("string", mtMap139.passthrough())
    ])
  ),
  sort: mtMap139.objectField(
    "sort",
    mtMap139.union([
      mtMap139.unionOption("string", mtMap139.passthrough()),
      mtMap139.unionOption(
        "array",
        mtMap139.union([
          mtMap139.unionOption(
            "object",
            mtMap139.object({
              field: mtMap139.objectField("field", mtMap139.passthrough()),
              order: mtMap139.objectField("order", mtMap139.passthrough())
            })
          )
        ])
      )
    ])
  ),
  limit: mtMap139.objectField("limit", mtMap139.passthrough()),
  cursor: mtMap139.objectField("cursor", mtMap139.passthrough()),
  order: mtMap139.objectField("order", mtMap139.passthrough())
});

// src/resources/portals/update.ts
import { mtMap as mtMap140 } from "@metorial/util-resource-mapper";
var mapPortalsUpdateOutput = mtMap140.object({
  id: mtMap140.objectField("id", mtMap140.passthrough()),
  type: mtMap140.objectField("type", mtMap140.passthrough()),
  status: mtMap140.objectField("status", mtMap140.passthrough()),
  organizationId: mtMap140.objectField("organization_id", mtMap140.passthrough()),
  projectId: mtMap140.objectField("project_id", mtMap140.passthrough()),
  name: mtMap140.objectField("name", mtMap140.passthrough()),
  slug: mtMap140.objectField("slug", mtMap140.passthrough()),
  publicName: mtMap140.objectField("public_name", mtMap140.passthrough()),
  createdAt: mtMap140.objectField("created_at", mtMap140.date()),
  updatedAt: mtMap140.objectField("updated_at", mtMap140.date())
});
var mapPortalsUpdateBody = mtMap140.object({
  name: mtMap140.objectField("name", mtMap140.passthrough())
});

// src/resources/roles/create.ts
import { mtMap as mtMap141 } from "@metorial/util-resource-mapper";
var mapRolesCreateOutput = mtMap141.object({
  id: mtMap141.objectField("id", mtMap141.passthrough()),
  status: mtMap141.objectField("status", mtMap141.passthrough()),
  isDefault: mtMap141.objectField("is_default", mtMap141.passthrough()),
  slug: mtMap141.objectField("slug", mtMap141.passthrough()),
  name: mtMap141.objectField("name", mtMap141.passthrough()),
  description: mtMap141.objectField("description", mtMap141.passthrough()),
  permissions: mtMap141.objectField(
    "permissions",
    mtMap141.array(mtMap141.passthrough())
  ),
  createdAt: mtMap141.objectField("created_at", mtMap141.date()),
  updatedAt: mtMap141.objectField("updated_at", mtMap141.date())
});
var mapRolesCreateBody = mtMap141.object({
  name: mtMap141.objectField("name", mtMap141.passthrough()),
  slug: mtMap141.objectField("slug", mtMap141.passthrough()),
  description: mtMap141.objectField("description", mtMap141.passthrough()),
  permissions: mtMap141.objectField(
    "permissions",
    mtMap141.array(mtMap141.passthrough())
  )
});

// src/resources/roles/get.ts
import { mtMap as mtMap142 } from "@metorial/util-resource-mapper";
var mapRolesGetOutput = mtMap142.object({
  id: mtMap142.objectField("id", mtMap142.passthrough()),
  status: mtMap142.objectField("status", mtMap142.passthrough()),
  isDefault: mtMap142.objectField("is_default", mtMap142.passthrough()),
  slug: mtMap142.objectField("slug", mtMap142.passthrough()),
  name: mtMap142.objectField("name", mtMap142.passthrough()),
  description: mtMap142.objectField("description", mtMap142.passthrough()),
  permissions: mtMap142.objectField(
    "permissions",
    mtMap142.array(mtMap142.passthrough())
  ),
  createdAt: mtMap142.objectField("created_at", mtMap142.date()),
  updatedAt: mtMap142.objectField("updated_at", mtMap142.date())
});

// src/resources/roles/list.ts
import { mtMap as mtMap143 } from "@metorial/util-resource-mapper";
var mapRolesListOutput = mtMap143.object({
  items: mtMap143.objectField(
    "items",
    mtMap143.array(
      mtMap143.object({
        id: mtMap143.objectField("id", mtMap143.passthrough()),
        status: mtMap143.objectField("status", mtMap143.passthrough()),
        isDefault: mtMap143.objectField("is_default", mtMap143.passthrough()),
        slug: mtMap143.objectField("slug", mtMap143.passthrough()),
        name: mtMap143.objectField("name", mtMap143.passthrough()),
        description: mtMap143.objectField("description", mtMap143.passthrough()),
        permissions: mtMap143.objectField(
          "permissions",
          mtMap143.array(mtMap143.passthrough())
        ),
        createdAt: mtMap143.objectField("created_at", mtMap143.date()),
        updatedAt: mtMap143.objectField("updated_at", mtMap143.date())
      })
    )
  ),
  pagination: mtMap143.objectField(
    "pagination",
    mtMap143.object({
      afterCursor: mtMap143.objectField("after_cursor", mtMap143.passthrough()),
      beforeCursor: mtMap143.objectField("before_cursor", mtMap143.passthrough()),
      hasMoreBefore: mtMap143.objectField("has_more_before", mtMap143.passthrough()),
      hasMoreAfter: mtMap143.objectField("has_more_after", mtMap143.passthrough()),
      pageSize: mtMap143.objectField("page_size", mtMap143.passthrough()),
      sort: mtMap143.objectField(
        "sort",
        mtMap143.array(
          mtMap143.object({
            field: mtMap143.objectField("field", mtMap143.passthrough()),
            order: mtMap143.objectField("order", mtMap143.passthrough())
          })
        )
      )
    })
  )
});
var mapRolesListQuery = mtMap143.object({
  id: mtMap143.objectField(
    "id",
    mtMap143.union([
      mtMap143.unionOption(
        "object",
        mtMap143.object({
          in: mtMap143.objectField("in", mtMap143.array(mtMap143.passthrough())),
          eq: mtMap143.objectField("eq", mtMap143.passthrough())
        })
      ),
      mtMap143.unionOption("string", mtMap143.passthrough())
    ])
  ),
  ids: mtMap143.objectField(
    "ids",
    mtMap143.union([
      mtMap143.unionOption(
        "object",
        mtMap143.object({
          in: mtMap143.objectField("in", mtMap143.array(mtMap143.passthrough())),
          eq: mtMap143.objectField("eq", mtMap143.passthrough())
        })
      ),
      mtMap143.unionOption("string", mtMap143.passthrough())
    ])
  ),
  slug: mtMap143.objectField(
    "slug",
    mtMap143.union([
      mtMap143.unionOption(
        "object",
        mtMap143.object({
          in: mtMap143.objectField("in", mtMap143.array(mtMap143.passthrough())),
          eq: mtMap143.objectField("eq", mtMap143.passthrough())
        })
      ),
      mtMap143.unionOption("string", mtMap143.passthrough())
    ])
  ),
  slugs: mtMap143.objectField(
    "slugs",
    mtMap143.union([
      mtMap143.unionOption(
        "object",
        mtMap143.object({
          in: mtMap143.objectField("in", mtMap143.array(mtMap143.passthrough())),
          eq: mtMap143.objectField("eq", mtMap143.passthrough())
        })
      ),
      mtMap143.unionOption("string", mtMap143.passthrough())
    ])
  ),
  sort: mtMap143.objectField(
    "sort",
    mtMap143.union([
      mtMap143.unionOption("string", mtMap143.passthrough()),
      mtMap143.unionOption(
        "array",
        mtMap143.union([
          mtMap143.unionOption(
            "object",
            mtMap143.object({
              field: mtMap143.objectField("field", mtMap143.passthrough()),
              order: mtMap143.objectField("order", mtMap143.passthrough())
            })
          )
        ])
      )
    ])
  ),
  limit: mtMap143.objectField("limit", mtMap143.passthrough()),
  cursor: mtMap143.objectField("cursor", mtMap143.passthrough()),
  order: mtMap143.objectField("order", mtMap143.passthrough())
});

// src/resources/roles/update.ts
import { mtMap as mtMap144 } from "@metorial/util-resource-mapper";
var mapRolesUpdateOutput = mtMap144.object({
  id: mtMap144.objectField("id", mtMap144.passthrough()),
  status: mtMap144.objectField("status", mtMap144.passthrough()),
  isDefault: mtMap144.objectField("is_default", mtMap144.passthrough()),
  slug: mtMap144.objectField("slug", mtMap144.passthrough()),
  name: mtMap144.objectField("name", mtMap144.passthrough()),
  description: mtMap144.objectField("description", mtMap144.passthrough()),
  permissions: mtMap144.objectField(
    "permissions",
    mtMap144.array(mtMap144.passthrough())
  ),
  createdAt: mtMap144.objectField("created_at", mtMap144.date()),
  updatedAt: mtMap144.objectField("updated_at", mtMap144.date())
});
var mapRolesUpdateBody = mtMap144.object({
  name: mtMap144.objectField("name", mtMap144.passthrough()),
  slug: mtMap144.objectField("slug", mtMap144.passthrough()),
  description: mtMap144.objectField("description", mtMap144.passthrough()),
  isDefault: mtMap144.objectField("is_default", mtMap144.passthrough()),
  permissions: mtMap144.objectField(
    "permissions",
    mtMap144.array(mtMap144.passthrough())
  )
});

// src/resources/runs/create.ts
import { mtMap as mtMap145 } from "@metorial/util-resource-mapper";
var mapRunsCreateOutput = mtMap145.object({
  id: mtMap145.objectField("id", mtMap145.passthrough()),
  status: mtMap145.objectField("status", mtMap145.passthrough()),
  agentId: mtMap145.objectField("agent_id", mtMap145.passthrough()),
  triggerMessageGroupId: mtMap145.objectField(
    "trigger_message_group_id",
    mtMap145.passthrough()
  ),
  cost: mtMap145.objectField(
    "cost",
    mtMap145.object({
      amount: mtMap145.objectField("amount", mtMap145.passthrough()),
      unit: mtMap145.objectField("unit", mtMap145.passthrough())
    })
  ),
  messageGroup: mtMap145.objectField(
    "message_group",
    mtMap145.object({
      id: mtMap145.objectField("id", mtMap145.passthrough()),
      status: mtMap145.objectField("status", mtMap145.passthrough()),
      type: mtMap145.objectField("type", mtMap145.passthrough()),
      interactionId: mtMap145.objectField("interaction_id", mtMap145.passthrough()),
      createdAt: mtMap145.objectField("created_at", mtMap145.date()),
      threadId: mtMap145.objectField("thread_id", mtMap145.passthrough()),
      parentMessageGroupId: mtMap145.objectField(
        "parent_message_group_id",
        mtMap145.passthrough()
      ),
      messages: mtMap145.objectField(
        "messages",
        mtMap145.array(
          mtMap145.object({
            id: mtMap145.objectField("id", mtMap145.passthrough()),
            type: mtMap145.objectField("type", mtMap145.passthrough()),
            status: mtMap145.objectField("status", mtMap145.passthrough()),
            messageGroupId: mtMap145.objectField(
              "message_group_id",
              mtMap145.passthrough()
            ),
            threadId: mtMap145.objectField("thread_id", mtMap145.passthrough()),
            actor: mtMap145.objectField(
              "actor",
              mtMap145.object({
                id: mtMap145.objectField("id", mtMap145.passthrough()),
                name: mtMap145.objectField("name", mtMap145.passthrough()),
                type: mtMap145.objectField("type", mtMap145.passthrough()),
                metadata: mtMap145.objectField("metadata", mtMap145.passthrough()),
                createdAt: mtMap145.objectField("created_at", mtMap145.date()),
                updatedAt: mtMap145.objectField("updated_at", mtMap145.date())
              })
            ),
            content: mtMap145.objectField(
              "content",
              mtMap145.object({
                id: mtMap145.objectField("id", mtMap145.passthrough()),
                version: mtMap145.objectField("version", mtMap145.passthrough()),
                messageItemId: mtMap145.objectField(
                  "message_item_id",
                  mtMap145.passthrough()
                ),
                attachments: mtMap145.objectField(
                  "attachments",
                  mtMap145.array(
                    mtMap145.union([
                      mtMap145.unionOption(
                        "object",
                        mtMap145.object({
                          id: mtMap145.objectField("id", mtMap145.passthrough()),
                          type: mtMap145.objectField("type", mtMap145.passthrough()),
                          fileId: mtMap145.objectField(
                            "file_id",
                            mtMap145.passthrough()
                          ),
                          url: mtMap145.objectField("url", mtMap145.passthrough()),
                          caption: mtMap145.objectField(
                            "caption",
                            mtMap145.object({
                              text: mtMap145.objectField(
                                "text",
                                mtMap145.passthrough()
                              )
                            })
                          ),
                          mimeType: mtMap145.objectField(
                            "mime_type",
                            mtMap145.passthrough()
                          ),
                          entryId: mtMap145.objectField(
                            "entry_id",
                            mtMap145.passthrough()
                          )
                        })
                      )
                    ])
                  )
                ),
                parts: mtMap145.objectField(
                  "parts",
                  mtMap145.array(
                    mtMap145.union([
                      mtMap145.unionOption(
                        "object",
                        mtMap145.object({
                          id: mtMap145.objectField("id", mtMap145.passthrough()),
                          type: mtMap145.objectField("type", mtMap145.passthrough()),
                          mimeType: mtMap145.objectField(
                            "mime_type",
                            mtMap145.passthrough()
                          ),
                          text: mtMap145.objectField("text", mtMap145.passthrough()),
                          kind: mtMap145.objectField("kind", mtMap145.passthrough()),
                          attachment: mtMap145.objectField(
                            "attachment",
                            mtMap145.union([
                              mtMap145.unionOption(
                                "object",
                                mtMap145.object({
                                  id: mtMap145.objectField(
                                    "id",
                                    mtMap145.passthrough()
                                  ),
                                  type: mtMap145.objectField(
                                    "type",
                                    mtMap145.passthrough()
                                  ),
                                  fileId: mtMap145.objectField(
                                    "file_id",
                                    mtMap145.passthrough()
                                  ),
                                  url: mtMap145.objectField(
                                    "url",
                                    mtMap145.passthrough()
                                  ),
                                  caption: mtMap145.objectField(
                                    "caption",
                                    mtMap145.object({
                                      text: mtMap145.objectField(
                                        "text",
                                        mtMap145.passthrough()
                                      )
                                    })
                                  ),
                                  mimeType: mtMap145.objectField(
                                    "mime_type",
                                    mtMap145.passthrough()
                                  ),
                                  entryId: mtMap145.objectField(
                                    "entry_id",
                                    mtMap145.passthrough()
                                  )
                                })
                              )
                            ])
                          )
                        })
                      )
                    ])
                  )
                )
              })
            ),
            error: mtMap145.objectField(
              "error",
              mtMap145.object({
                type: mtMap145.objectField("type", mtMap145.passthrough()),
                message: mtMap145.objectField("message", mtMap145.passthrough())
              })
            ),
            createdAt: mtMap145.objectField("created_at", mtMap145.date())
          })
        )
      ),
      attachedItems: mtMap145.objectField(
        "attached_items",
        mtMap145.array(
          mtMap145.object({
            id: mtMap145.objectField("id", mtMap145.passthrough()),
            actor: mtMap145.objectField(
              "actor",
              mtMap145.object({
                id: mtMap145.objectField("id", mtMap145.passthrough()),
                name: mtMap145.objectField("name", mtMap145.passthrough()),
                type: mtMap145.objectField("type", mtMap145.passthrough()),
                metadata: mtMap145.objectField("metadata", mtMap145.passthrough()),
                createdAt: mtMap145.objectField("created_at", mtMap145.date()),
                updatedAt: mtMap145.objectField("updated_at", mtMap145.date())
              })
            ),
            key: mtMap145.objectField("key", mtMap145.passthrough()),
            value: mtMap145.objectField("value", mtMap145.passthrough()),
            createdAt: mtMap145.objectField("created_at", mtMap145.date())
          })
        )
      ),
      metadata: mtMap145.objectField("metadata", mtMap145.passthrough()),
      actor: mtMap145.objectField(
        "actor",
        mtMap145.object({
          id: mtMap145.objectField("id", mtMap145.passthrough()),
          name: mtMap145.objectField("name", mtMap145.passthrough()),
          type: mtMap145.objectField("type", mtMap145.passthrough()),
          metadata: mtMap145.objectField("metadata", mtMap145.passthrough()),
          createdAt: mtMap145.objectField("created_at", mtMap145.date()),
          updatedAt: mtMap145.objectField("updated_at", mtMap145.date())
        })
      ),
      run: mtMap145.objectField(
        "run",
        mtMap145.object({
          id: mtMap145.objectField("id", mtMap145.passthrough()),
          agentId: mtMap145.objectField("agent_id", mtMap145.passthrough()),
          status: mtMap145.objectField("status", mtMap145.passthrough()),
          metadata: mtMap145.objectField("metadata", mtMap145.passthrough()),
          startedAt: mtMap145.objectField("started_at", mtMap145.date()),
          createdAt: mtMap145.objectField("created_at", mtMap145.date()),
          completedAt: mtMap145.objectField("completed_at", mtMap145.date())
        })
      )
    })
  ),
  metadata: mtMap145.objectField("metadata", mtMap145.passthrough()),
  errors: mtMap145.objectField(
    "errors",
    mtMap145.array(
      mtMap145.object({
        id: mtMap145.objectField("id", mtMap145.passthrough()),
        runId: mtMap145.objectField("run_id", mtMap145.passthrough()),
        code: mtMap145.objectField("code", mtMap145.passthrough()),
        message: mtMap145.objectField("message", mtMap145.passthrough()),
        metadata: mtMap145.objectField("metadata", mtMap145.passthrough()),
        createdAt: mtMap145.objectField("created_at", mtMap145.date())
      })
    )
  ),
  attachedItems: mtMap145.objectField(
    "attached_items",
    mtMap145.array(
      mtMap145.object({
        id: mtMap145.objectField("id", mtMap145.passthrough()),
        actor: mtMap145.objectField(
          "actor",
          mtMap145.object({
            id: mtMap145.objectField("id", mtMap145.passthrough()),
            name: mtMap145.objectField("name", mtMap145.passthrough()),
            type: mtMap145.objectField("type", mtMap145.passthrough()),
            metadata: mtMap145.objectField("metadata", mtMap145.passthrough()),
            createdAt: mtMap145.objectField("created_at", mtMap145.date()),
            updatedAt: mtMap145.objectField("updated_at", mtMap145.date())
          })
        ),
        key: mtMap145.objectField("key", mtMap145.passthrough()),
        value: mtMap145.objectField("value", mtMap145.passthrough()),
        createdAt: mtMap145.objectField("created_at", mtMap145.date())
      })
    )
  ),
  createdAt: mtMap145.objectField("created_at", mtMap145.date()),
  startedAt: mtMap145.objectField("started_at", mtMap145.date()),
  completedAt: mtMap145.objectField("completed_at", mtMap145.date())
});
var mapRunsCreateBody = mtMap145.object({
  language: mtMap145.objectField("language", mtMap145.passthrough()),
  country: mtMap145.objectField("country", mtMap145.passthrough()),
  timezone: mtMap145.objectField("timezone", mtMap145.passthrough()),
  metadata: mtMap145.objectField("metadata", mtMap145.passthrough()),
  agentId: mtMap145.objectField("agent_id", mtMap145.passthrough()),
  content: mtMap145.objectField(
    "content",
    mtMap145.union([
      mtMap145.unionOption(
        "object",
        mtMap145.object({
          type: mtMap145.objectField("type", mtMap145.passthrough()),
          mimeType: mtMap145.objectField("mimeType", mtMap145.passthrough()),
          content: mtMap145.objectField("content", mtMap145.passthrough()),
          parts: mtMap145.objectField(
            "parts",
            mtMap145.array(
              mtMap145.object({
                type: mtMap145.objectField("type", mtMap145.passthrough()),
                mimeType: mtMap145.objectField("mime_type", mtMap145.passthrough()),
                content: mtMap145.objectField("content", mtMap145.passthrough())
              })
            )
          ),
          attachments: mtMap145.objectField(
            "attachments",
            mtMap145.array(
              mtMap145.object({
                type: mtMap145.objectField("type", mtMap145.passthrough()),
                fileId: mtMap145.objectField("file_id", mtMap145.passthrough()),
                caption: mtMap145.objectField(
                  "caption",
                  mtMap145.union([
                    mtMap145.unionOption(
                      "object",
                      mtMap145.object({
                        text: mtMap145.objectField("text", mtMap145.passthrough())
                      })
                    ),
                    mtMap145.unionOption("string", mtMap145.passthrough())
                  ])
                )
              })
            )
          )
        })
      ),
      mtMap145.unionOption("string", mtMap145.passthrough()),
      mtMap145.unionOption(
        "array",
        mtMap145.union([
          mtMap145.unionOption(
            "object",
            mtMap145.object({
              type: mtMap145.objectField("type", mtMap145.passthrough()),
              mimeType: mtMap145.objectField("mimeType", mtMap145.passthrough()),
              content: mtMap145.objectField("content", mtMap145.passthrough())
            })
          )
        ])
      )
    ])
  ),
  rawInputs: mtMap145.objectField("raw_inputs", mtMap145.passthrough())
});

// src/resources/runs/get.ts
import { mtMap as mtMap146 } from "@metorial/util-resource-mapper";
var mapRunsGetOutput = mtMap146.object({
  id: mtMap146.objectField("id", mtMap146.passthrough()),
  status: mtMap146.objectField("status", mtMap146.passthrough()),
  agentId: mtMap146.objectField("agent_id", mtMap146.passthrough()),
  triggerMessageGroupId: mtMap146.objectField(
    "trigger_message_group_id",
    mtMap146.passthrough()
  ),
  cost: mtMap146.objectField(
    "cost",
    mtMap146.object({
      amount: mtMap146.objectField("amount", mtMap146.passthrough()),
      unit: mtMap146.objectField("unit", mtMap146.passthrough())
    })
  ),
  messageGroup: mtMap146.objectField(
    "message_group",
    mtMap146.object({
      id: mtMap146.objectField("id", mtMap146.passthrough()),
      status: mtMap146.objectField("status", mtMap146.passthrough()),
      type: mtMap146.objectField("type", mtMap146.passthrough()),
      interactionId: mtMap146.objectField("interaction_id", mtMap146.passthrough()),
      createdAt: mtMap146.objectField("created_at", mtMap146.date()),
      threadId: mtMap146.objectField("thread_id", mtMap146.passthrough()),
      parentMessageGroupId: mtMap146.objectField(
        "parent_message_group_id",
        mtMap146.passthrough()
      ),
      messages: mtMap146.objectField(
        "messages",
        mtMap146.array(
          mtMap146.object({
            id: mtMap146.objectField("id", mtMap146.passthrough()),
            type: mtMap146.objectField("type", mtMap146.passthrough()),
            status: mtMap146.objectField("status", mtMap146.passthrough()),
            messageGroupId: mtMap146.objectField(
              "message_group_id",
              mtMap146.passthrough()
            ),
            threadId: mtMap146.objectField("thread_id", mtMap146.passthrough()),
            actor: mtMap146.objectField(
              "actor",
              mtMap146.object({
                id: mtMap146.objectField("id", mtMap146.passthrough()),
                name: mtMap146.objectField("name", mtMap146.passthrough()),
                type: mtMap146.objectField("type", mtMap146.passthrough()),
                metadata: mtMap146.objectField("metadata", mtMap146.passthrough()),
                createdAt: mtMap146.objectField("created_at", mtMap146.date()),
                updatedAt: mtMap146.objectField("updated_at", mtMap146.date())
              })
            ),
            content: mtMap146.objectField(
              "content",
              mtMap146.object({
                id: mtMap146.objectField("id", mtMap146.passthrough()),
                version: mtMap146.objectField("version", mtMap146.passthrough()),
                messageItemId: mtMap146.objectField(
                  "message_item_id",
                  mtMap146.passthrough()
                ),
                attachments: mtMap146.objectField(
                  "attachments",
                  mtMap146.array(
                    mtMap146.union([
                      mtMap146.unionOption(
                        "object",
                        mtMap146.object({
                          id: mtMap146.objectField("id", mtMap146.passthrough()),
                          type: mtMap146.objectField("type", mtMap146.passthrough()),
                          fileId: mtMap146.objectField(
                            "file_id",
                            mtMap146.passthrough()
                          ),
                          url: mtMap146.objectField("url", mtMap146.passthrough()),
                          caption: mtMap146.objectField(
                            "caption",
                            mtMap146.object({
                              text: mtMap146.objectField(
                                "text",
                                mtMap146.passthrough()
                              )
                            })
                          ),
                          mimeType: mtMap146.objectField(
                            "mime_type",
                            mtMap146.passthrough()
                          ),
                          entryId: mtMap146.objectField(
                            "entry_id",
                            mtMap146.passthrough()
                          )
                        })
                      )
                    ])
                  )
                ),
                parts: mtMap146.objectField(
                  "parts",
                  mtMap146.array(
                    mtMap146.union([
                      mtMap146.unionOption(
                        "object",
                        mtMap146.object({
                          id: mtMap146.objectField("id", mtMap146.passthrough()),
                          type: mtMap146.objectField("type", mtMap146.passthrough()),
                          mimeType: mtMap146.objectField(
                            "mime_type",
                            mtMap146.passthrough()
                          ),
                          text: mtMap146.objectField("text", mtMap146.passthrough()),
                          kind: mtMap146.objectField("kind", mtMap146.passthrough()),
                          attachment: mtMap146.objectField(
                            "attachment",
                            mtMap146.union([
                              mtMap146.unionOption(
                                "object",
                                mtMap146.object({
                                  id: mtMap146.objectField(
                                    "id",
                                    mtMap146.passthrough()
                                  ),
                                  type: mtMap146.objectField(
                                    "type",
                                    mtMap146.passthrough()
                                  ),
                                  fileId: mtMap146.objectField(
                                    "file_id",
                                    mtMap146.passthrough()
                                  ),
                                  url: mtMap146.objectField(
                                    "url",
                                    mtMap146.passthrough()
                                  ),
                                  caption: mtMap146.objectField(
                                    "caption",
                                    mtMap146.object({
                                      text: mtMap146.objectField(
                                        "text",
                                        mtMap146.passthrough()
                                      )
                                    })
                                  ),
                                  mimeType: mtMap146.objectField(
                                    "mime_type",
                                    mtMap146.passthrough()
                                  ),
                                  entryId: mtMap146.objectField(
                                    "entry_id",
                                    mtMap146.passthrough()
                                  )
                                })
                              )
                            ])
                          )
                        })
                      )
                    ])
                  )
                )
              })
            ),
            error: mtMap146.objectField(
              "error",
              mtMap146.object({
                type: mtMap146.objectField("type", mtMap146.passthrough()),
                message: mtMap146.objectField("message", mtMap146.passthrough())
              })
            ),
            createdAt: mtMap146.objectField("created_at", mtMap146.date())
          })
        )
      ),
      attachedItems: mtMap146.objectField(
        "attached_items",
        mtMap146.array(
          mtMap146.object({
            id: mtMap146.objectField("id", mtMap146.passthrough()),
            actor: mtMap146.objectField(
              "actor",
              mtMap146.object({
                id: mtMap146.objectField("id", mtMap146.passthrough()),
                name: mtMap146.objectField("name", mtMap146.passthrough()),
                type: mtMap146.objectField("type", mtMap146.passthrough()),
                metadata: mtMap146.objectField("metadata", mtMap146.passthrough()),
                createdAt: mtMap146.objectField("created_at", mtMap146.date()),
                updatedAt: mtMap146.objectField("updated_at", mtMap146.date())
              })
            ),
            key: mtMap146.objectField("key", mtMap146.passthrough()),
            value: mtMap146.objectField("value", mtMap146.passthrough()),
            createdAt: mtMap146.objectField("created_at", mtMap146.date())
          })
        )
      ),
      metadata: mtMap146.objectField("metadata", mtMap146.passthrough()),
      actor: mtMap146.objectField(
        "actor",
        mtMap146.object({
          id: mtMap146.objectField("id", mtMap146.passthrough()),
          name: mtMap146.objectField("name", mtMap146.passthrough()),
          type: mtMap146.objectField("type", mtMap146.passthrough()),
          metadata: mtMap146.objectField("metadata", mtMap146.passthrough()),
          createdAt: mtMap146.objectField("created_at", mtMap146.date()),
          updatedAt: mtMap146.objectField("updated_at", mtMap146.date())
        })
      ),
      run: mtMap146.objectField(
        "run",
        mtMap146.object({
          id: mtMap146.objectField("id", mtMap146.passthrough()),
          agentId: mtMap146.objectField("agent_id", mtMap146.passthrough()),
          status: mtMap146.objectField("status", mtMap146.passthrough()),
          metadata: mtMap146.objectField("metadata", mtMap146.passthrough()),
          startedAt: mtMap146.objectField("started_at", mtMap146.date()),
          createdAt: mtMap146.objectField("created_at", mtMap146.date()),
          completedAt: mtMap146.objectField("completed_at", mtMap146.date())
        })
      )
    })
  ),
  metadata: mtMap146.objectField("metadata", mtMap146.passthrough()),
  errors: mtMap146.objectField(
    "errors",
    mtMap146.array(
      mtMap146.object({
        id: mtMap146.objectField("id", mtMap146.passthrough()),
        runId: mtMap146.objectField("run_id", mtMap146.passthrough()),
        code: mtMap146.objectField("code", mtMap146.passthrough()),
        message: mtMap146.objectField("message", mtMap146.passthrough()),
        metadata: mtMap146.objectField("metadata", mtMap146.passthrough()),
        createdAt: mtMap146.objectField("created_at", mtMap146.date())
      })
    )
  ),
  attachedItems: mtMap146.objectField(
    "attached_items",
    mtMap146.array(
      mtMap146.object({
        id: mtMap146.objectField("id", mtMap146.passthrough()),
        actor: mtMap146.objectField(
          "actor",
          mtMap146.object({
            id: mtMap146.objectField("id", mtMap146.passthrough()),
            name: mtMap146.objectField("name", mtMap146.passthrough()),
            type: mtMap146.objectField("type", mtMap146.passthrough()),
            metadata: mtMap146.objectField("metadata", mtMap146.passthrough()),
            createdAt: mtMap146.objectField("created_at", mtMap146.date()),
            updatedAt: mtMap146.objectField("updated_at", mtMap146.date())
          })
        ),
        key: mtMap146.objectField("key", mtMap146.passthrough()),
        value: mtMap146.objectField("value", mtMap146.passthrough()),
        createdAt: mtMap146.objectField("created_at", mtMap146.date())
      })
    )
  ),
  createdAt: mtMap146.objectField("created_at", mtMap146.date()),
  startedAt: mtMap146.objectField("started_at", mtMap146.date()),
  completedAt: mtMap146.objectField("completed_at", mtMap146.date())
});

// src/resources/runs/list.ts
import { mtMap as mtMap147 } from "@metorial/util-resource-mapper";
var mapRunsListOutput = mtMap147.object({
  items: mtMap147.objectField(
    "items",
    mtMap147.array(
      mtMap147.object({
        id: mtMap147.objectField("id", mtMap147.passthrough()),
        status: mtMap147.objectField("status", mtMap147.passthrough()),
        agentId: mtMap147.objectField("agent_id", mtMap147.passthrough()),
        triggerMessageGroupId: mtMap147.objectField(
          "trigger_message_group_id",
          mtMap147.passthrough()
        ),
        cost: mtMap147.objectField(
          "cost",
          mtMap147.object({
            amount: mtMap147.objectField("amount", mtMap147.passthrough()),
            unit: mtMap147.objectField("unit", mtMap147.passthrough())
          })
        ),
        messageGroup: mtMap147.objectField(
          "message_group",
          mtMap147.object({
            id: mtMap147.objectField("id", mtMap147.passthrough()),
            status: mtMap147.objectField("status", mtMap147.passthrough()),
            type: mtMap147.objectField("type", mtMap147.passthrough()),
            interactionId: mtMap147.objectField(
              "interaction_id",
              mtMap147.passthrough()
            ),
            createdAt: mtMap147.objectField("created_at", mtMap147.date()),
            threadId: mtMap147.objectField("thread_id", mtMap147.passthrough()),
            parentMessageGroupId: mtMap147.objectField(
              "parent_message_group_id",
              mtMap147.passthrough()
            ),
            messages: mtMap147.objectField(
              "messages",
              mtMap147.array(
                mtMap147.object({
                  id: mtMap147.objectField("id", mtMap147.passthrough()),
                  type: mtMap147.objectField("type", mtMap147.passthrough()),
                  status: mtMap147.objectField("status", mtMap147.passthrough()),
                  messageGroupId: mtMap147.objectField(
                    "message_group_id",
                    mtMap147.passthrough()
                  ),
                  threadId: mtMap147.objectField("thread_id", mtMap147.passthrough()),
                  actor: mtMap147.objectField(
                    "actor",
                    mtMap147.object({
                      id: mtMap147.objectField("id", mtMap147.passthrough()),
                      name: mtMap147.objectField("name", mtMap147.passthrough()),
                      type: mtMap147.objectField("type", mtMap147.passthrough()),
                      metadata: mtMap147.objectField(
                        "metadata",
                        mtMap147.passthrough()
                      ),
                      createdAt: mtMap147.objectField("created_at", mtMap147.date()),
                      updatedAt: mtMap147.objectField("updated_at", mtMap147.date())
                    })
                  ),
                  content: mtMap147.objectField(
                    "content",
                    mtMap147.object({
                      id: mtMap147.objectField("id", mtMap147.passthrough()),
                      version: mtMap147.objectField(
                        "version",
                        mtMap147.passthrough()
                      ),
                      messageItemId: mtMap147.objectField(
                        "message_item_id",
                        mtMap147.passthrough()
                      ),
                      attachments: mtMap147.objectField(
                        "attachments",
                        mtMap147.array(
                          mtMap147.union([
                            mtMap147.unionOption(
                              "object",
                              mtMap147.object({
                                id: mtMap147.objectField(
                                  "id",
                                  mtMap147.passthrough()
                                ),
                                type: mtMap147.objectField(
                                  "type",
                                  mtMap147.passthrough()
                                ),
                                fileId: mtMap147.objectField(
                                  "file_id",
                                  mtMap147.passthrough()
                                ),
                                url: mtMap147.objectField(
                                  "url",
                                  mtMap147.passthrough()
                                ),
                                caption: mtMap147.objectField(
                                  "caption",
                                  mtMap147.object({
                                    text: mtMap147.objectField(
                                      "text",
                                      mtMap147.passthrough()
                                    )
                                  })
                                ),
                                mimeType: mtMap147.objectField(
                                  "mime_type",
                                  mtMap147.passthrough()
                                ),
                                entryId: mtMap147.objectField(
                                  "entry_id",
                                  mtMap147.passthrough()
                                )
                              })
                            )
                          ])
                        )
                      ),
                      parts: mtMap147.objectField(
                        "parts",
                        mtMap147.array(
                          mtMap147.union([
                            mtMap147.unionOption(
                              "object",
                              mtMap147.object({
                                id: mtMap147.objectField(
                                  "id",
                                  mtMap147.passthrough()
                                ),
                                type: mtMap147.objectField(
                                  "type",
                                  mtMap147.passthrough()
                                ),
                                mimeType: mtMap147.objectField(
                                  "mime_type",
                                  mtMap147.passthrough()
                                ),
                                text: mtMap147.objectField(
                                  "text",
                                  mtMap147.passthrough()
                                ),
                                kind: mtMap147.objectField(
                                  "kind",
                                  mtMap147.passthrough()
                                ),
                                attachment: mtMap147.objectField(
                                  "attachment",
                                  mtMap147.union([
                                    mtMap147.unionOption(
                                      "object",
                                      mtMap147.object({
                                        id: mtMap147.objectField(
                                          "id",
                                          mtMap147.passthrough()
                                        ),
                                        type: mtMap147.objectField(
                                          "type",
                                          mtMap147.passthrough()
                                        ),
                                        fileId: mtMap147.objectField(
                                          "file_id",
                                          mtMap147.passthrough()
                                        ),
                                        url: mtMap147.objectField(
                                          "url",
                                          mtMap147.passthrough()
                                        ),
                                        caption: mtMap147.objectField(
                                          "caption",
                                          mtMap147.object({
                                            text: mtMap147.objectField(
                                              "text",
                                              mtMap147.passthrough()
                                            )
                                          })
                                        ),
                                        mimeType: mtMap147.objectField(
                                          "mime_type",
                                          mtMap147.passthrough()
                                        ),
                                        entryId: mtMap147.objectField(
                                          "entry_id",
                                          mtMap147.passthrough()
                                        )
                                      })
                                    )
                                  ])
                                )
                              })
                            )
                          ])
                        )
                      )
                    })
                  ),
                  error: mtMap147.objectField(
                    "error",
                    mtMap147.object({
                      type: mtMap147.objectField("type", mtMap147.passthrough()),
                      message: mtMap147.objectField("message", mtMap147.passthrough())
                    })
                  ),
                  createdAt: mtMap147.objectField("created_at", mtMap147.date())
                })
              )
            ),
            attachedItems: mtMap147.objectField(
              "attached_items",
              mtMap147.array(
                mtMap147.object({
                  id: mtMap147.objectField("id", mtMap147.passthrough()),
                  actor: mtMap147.objectField(
                    "actor",
                    mtMap147.object({
                      id: mtMap147.objectField("id", mtMap147.passthrough()),
                      name: mtMap147.objectField("name", mtMap147.passthrough()),
                      type: mtMap147.objectField("type", mtMap147.passthrough()),
                      metadata: mtMap147.objectField(
                        "metadata",
                        mtMap147.passthrough()
                      ),
                      createdAt: mtMap147.objectField("created_at", mtMap147.date()),
                      updatedAt: mtMap147.objectField("updated_at", mtMap147.date())
                    })
                  ),
                  key: mtMap147.objectField("key", mtMap147.passthrough()),
                  value: mtMap147.objectField("value", mtMap147.passthrough()),
                  createdAt: mtMap147.objectField("created_at", mtMap147.date())
                })
              )
            ),
            metadata: mtMap147.objectField("metadata", mtMap147.passthrough()),
            actor: mtMap147.objectField(
              "actor",
              mtMap147.object({
                id: mtMap147.objectField("id", mtMap147.passthrough()),
                name: mtMap147.objectField("name", mtMap147.passthrough()),
                type: mtMap147.objectField("type", mtMap147.passthrough()),
                metadata: mtMap147.objectField("metadata", mtMap147.passthrough()),
                createdAt: mtMap147.objectField("created_at", mtMap147.date()),
                updatedAt: mtMap147.objectField("updated_at", mtMap147.date())
              })
            ),
            run: mtMap147.objectField(
              "run",
              mtMap147.object({
                id: mtMap147.objectField("id", mtMap147.passthrough()),
                agentId: mtMap147.objectField("agent_id", mtMap147.passthrough()),
                status: mtMap147.objectField("status", mtMap147.passthrough()),
                metadata: mtMap147.objectField("metadata", mtMap147.passthrough()),
                startedAt: mtMap147.objectField("started_at", mtMap147.date()),
                createdAt: mtMap147.objectField("created_at", mtMap147.date()),
                completedAt: mtMap147.objectField("completed_at", mtMap147.date())
              })
            )
          })
        ),
        metadata: mtMap147.objectField("metadata", mtMap147.passthrough()),
        errors: mtMap147.objectField(
          "errors",
          mtMap147.array(
            mtMap147.object({
              id: mtMap147.objectField("id", mtMap147.passthrough()),
              runId: mtMap147.objectField("run_id", mtMap147.passthrough()),
              code: mtMap147.objectField("code", mtMap147.passthrough()),
              message: mtMap147.objectField("message", mtMap147.passthrough()),
              metadata: mtMap147.objectField("metadata", mtMap147.passthrough()),
              createdAt: mtMap147.objectField("created_at", mtMap147.date())
            })
          )
        ),
        attachedItems: mtMap147.objectField(
          "attached_items",
          mtMap147.array(
            mtMap147.object({
              id: mtMap147.objectField("id", mtMap147.passthrough()),
              actor: mtMap147.objectField(
                "actor",
                mtMap147.object({
                  id: mtMap147.objectField("id", mtMap147.passthrough()),
                  name: mtMap147.objectField("name", mtMap147.passthrough()),
                  type: mtMap147.objectField("type", mtMap147.passthrough()),
                  metadata: mtMap147.objectField("metadata", mtMap147.passthrough()),
                  createdAt: mtMap147.objectField("created_at", mtMap147.date()),
                  updatedAt: mtMap147.objectField("updated_at", mtMap147.date())
                })
              ),
              key: mtMap147.objectField("key", mtMap147.passthrough()),
              value: mtMap147.objectField("value", mtMap147.passthrough()),
              createdAt: mtMap147.objectField("created_at", mtMap147.date())
            })
          )
        ),
        createdAt: mtMap147.objectField("created_at", mtMap147.date()),
        startedAt: mtMap147.objectField("started_at", mtMap147.date()),
        completedAt: mtMap147.objectField("completed_at", mtMap147.date())
      })
    )
  ),
  pagination: mtMap147.objectField(
    "pagination",
    mtMap147.object({
      afterCursor: mtMap147.objectField("after_cursor", mtMap147.passthrough()),
      beforeCursor: mtMap147.objectField("before_cursor", mtMap147.passthrough()),
      hasMoreBefore: mtMap147.objectField("has_more_before", mtMap147.passthrough()),
      hasMoreAfter: mtMap147.objectField("has_more_after", mtMap147.passthrough()),
      pageSize: mtMap147.objectField("page_size", mtMap147.passthrough()),
      sort: mtMap147.objectField(
        "sort",
        mtMap147.array(
          mtMap147.object({
            field: mtMap147.objectField("field", mtMap147.passthrough()),
            order: mtMap147.objectField("order", mtMap147.passthrough())
          })
        )
      )
    })
  )
});
var mapRunsListQuery = mtMap147.object({
  id: mtMap147.objectField(
    "id",
    mtMap147.union([
      mtMap147.unionOption(
        "object",
        mtMap147.object({
          in: mtMap147.objectField("in", mtMap147.array(mtMap147.passthrough())),
          eq: mtMap147.objectField("eq", mtMap147.passthrough())
        })
      ),
      mtMap147.unionOption("string", mtMap147.passthrough())
    ])
  ),
  ids: mtMap147.objectField(
    "ids",
    mtMap147.union([
      mtMap147.unionOption(
        "object",
        mtMap147.object({
          in: mtMap147.objectField("in", mtMap147.array(mtMap147.passthrough())),
          eq: mtMap147.objectField("eq", mtMap147.passthrough())
        })
      ),
      mtMap147.unionOption("string", mtMap147.passthrough())
    ])
  ),
  createdAt: mtMap147.objectField(
    "created_at",
    mtMap147.union([
      mtMap147.unionOption(
        "object",
        mtMap147.object({
          eq: mtMap147.objectField("eq", mtMap147.date()),
          gt: mtMap147.objectField("gt", mtMap147.date()),
          gte: mtMap147.objectField("gte", mtMap147.date()),
          lt: mtMap147.objectField("lt", mtMap147.date()),
          lte: mtMap147.objectField("lte", mtMap147.date())
        })
      ),
      mtMap147.unionOption("date", mtMap147.passthrough())
    ])
  ),
  startedAt: mtMap147.objectField(
    "startedAt",
    mtMap147.union([
      mtMap147.unionOption(
        "object",
        mtMap147.object({
          eq: mtMap147.objectField("eq", mtMap147.date()),
          gt: mtMap147.objectField("gt", mtMap147.date()),
          gte: mtMap147.objectField("gte", mtMap147.date()),
          lt: mtMap147.objectField("lt", mtMap147.date()),
          lte: mtMap147.objectField("lte", mtMap147.date())
        })
      ),
      mtMap147.unionOption("date", mtMap147.passthrough())
    ])
  ),
  completedAt: mtMap147.objectField(
    "completedAt",
    mtMap147.union([
      mtMap147.unionOption(
        "object",
        mtMap147.object({
          eq: mtMap147.objectField("eq", mtMap147.date()),
          gt: mtMap147.objectField("gt", mtMap147.date()),
          gte: mtMap147.objectField("gte", mtMap147.date()),
          lt: mtMap147.objectField("lt", mtMap147.date()),
          lte: mtMap147.objectField("lte", mtMap147.date())
        })
      ),
      mtMap147.unionOption("date", mtMap147.passthrough())
    ])
  ),
  status: mtMap147.objectField(
    "status",
    mtMap147.union([
      mtMap147.unionOption(
        "object",
        mtMap147.object({
          in: mtMap147.objectField("in", mtMap147.array(mtMap147.passthrough())),
          eq: mtMap147.objectField("eq", mtMap147.passthrough())
        })
      ),
      mtMap147.unionOption("string", mtMap147.passthrough())
    ])
  ),
  statuses: mtMap147.objectField(
    "statuses",
    mtMap147.union([
      mtMap147.unionOption(
        "object",
        mtMap147.object({
          in: mtMap147.objectField("in", mtMap147.array(mtMap147.passthrough())),
          eq: mtMap147.objectField("eq", mtMap147.passthrough())
        })
      ),
      mtMap147.unionOption("string", mtMap147.passthrough())
    ])
  ),
  sort: mtMap147.objectField(
    "sort",
    mtMap147.union([
      mtMap147.unionOption("string", mtMap147.passthrough()),
      mtMap147.unionOption(
        "array",
        mtMap147.union([
          mtMap147.unionOption(
            "object",
            mtMap147.object({
              field: mtMap147.objectField("field", mtMap147.passthrough()),
              order: mtMap147.objectField("order", mtMap147.passthrough())
            })
          )
        ])
      )
    ])
  ),
  agentId: mtMap147.objectField("agent_id", mtMap147.passthrough()),
  threadId: mtMap147.objectField("thread_id", mtMap147.passthrough()),
  limit: mtMap147.objectField("limit", mtMap147.passthrough()),
  cursor: mtMap147.objectField("cursor", mtMap147.passthrough()),
  order: mtMap147.objectField("order", mtMap147.passthrough())
});

// src/resources/threads/create.ts
import { mtMap as mtMap148 } from "@metorial/util-resource-mapper";
var mapThreadsCreateOutput = mtMap148.object({
  id: mtMap148.objectField("id", mtMap148.passthrough()),
  name: mtMap148.objectField("name", mtMap148.passthrough()),
  agentId: mtMap148.objectField("agent_id", mtMap148.passthrough()),
  instanceId: mtMap148.objectField("instance_id", mtMap148.passthrough()),
  timezone: mtMap148.objectField(
    "timezone",
    mtMap148.object({
      code: mtMap148.objectField("code", mtMap148.passthrough()),
      utc: mtMap148.objectField("utc", mtMap148.passthrough()),
      utcOffsetInMinutes: mtMap148.objectField(
        "utc_offset_in_minutes",
        mtMap148.passthrough()
      )
    })
  ),
  country: mtMap148.objectField(
    "country",
    mtMap148.object({ code: mtMap148.objectField("code", mtMap148.passthrough()) })
  ),
  language: mtMap148.objectField(
    "language",
    mtMap148.object({
      code: mtMap148.objectField("code", mtMap148.passthrough()),
      full: mtMap148.objectField("full", mtMap148.passthrough())
    })
  ),
  metadata: mtMap148.objectField("metadata", mtMap148.passthrough()),
  createdAt: mtMap148.objectField("created_at", mtMap148.date()),
  updatedAt: mtMap148.objectField("updated_at", mtMap148.date())
});
var mapThreadsCreateBody = mtMap148.object({
  language: mtMap148.objectField("language", mtMap148.passthrough()),
  country: mtMap148.objectField("country", mtMap148.passthrough()),
  timezone: mtMap148.objectField("timezone", mtMap148.passthrough()),
  metadata: mtMap148.objectField("metadata", mtMap148.passthrough()),
  userId: mtMap148.objectField("user_id", mtMap148.passthrough()),
  agentId: mtMap148.objectField("agent_id", mtMap148.passthrough()),
  groupId: mtMap148.objectField("group_id", mtMap148.passthrough()),
  name: mtMap148.objectField("name", mtMap148.passthrough())
});

// src/resources/threads/delete.ts
import { mtMap as mtMap149 } from "@metorial/util-resource-mapper";
var mapThreadsDeleteOutput = mtMap149.object({
  id: mtMap149.objectField("id", mtMap149.passthrough()),
  name: mtMap149.objectField("name", mtMap149.passthrough()),
  agentId: mtMap149.objectField("agent_id", mtMap149.passthrough()),
  instanceId: mtMap149.objectField("instance_id", mtMap149.passthrough()),
  timezone: mtMap149.objectField(
    "timezone",
    mtMap149.object({
      code: mtMap149.objectField("code", mtMap149.passthrough()),
      utc: mtMap149.objectField("utc", mtMap149.passthrough()),
      utcOffsetInMinutes: mtMap149.objectField(
        "utc_offset_in_minutes",
        mtMap149.passthrough()
      )
    })
  ),
  country: mtMap149.objectField(
    "country",
    mtMap149.object({ code: mtMap149.objectField("code", mtMap149.passthrough()) })
  ),
  language: mtMap149.objectField(
    "language",
    mtMap149.object({
      code: mtMap149.objectField("code", mtMap149.passthrough()),
      full: mtMap149.objectField("full", mtMap149.passthrough())
    })
  ),
  metadata: mtMap149.objectField("metadata", mtMap149.passthrough()),
  createdAt: mtMap149.objectField("created_at", mtMap149.date()),
  updatedAt: mtMap149.objectField("updated_at", mtMap149.date())
});

// src/resources/threads/get.ts
import { mtMap as mtMap150 } from "@metorial/util-resource-mapper";
var mapThreadsGetOutput = mtMap150.object({
  id: mtMap150.objectField("id", mtMap150.passthrough()),
  name: mtMap150.objectField("name", mtMap150.passthrough()),
  agentId: mtMap150.objectField("agent_id", mtMap150.passthrough()),
  instanceId: mtMap150.objectField("instance_id", mtMap150.passthrough()),
  timezone: mtMap150.objectField(
    "timezone",
    mtMap150.object({
      code: mtMap150.objectField("code", mtMap150.passthrough()),
      utc: mtMap150.objectField("utc", mtMap150.passthrough()),
      utcOffsetInMinutes: mtMap150.objectField(
        "utc_offset_in_minutes",
        mtMap150.passthrough()
      )
    })
  ),
  country: mtMap150.objectField(
    "country",
    mtMap150.object({ code: mtMap150.objectField("code", mtMap150.passthrough()) })
  ),
  language: mtMap150.objectField(
    "language",
    mtMap150.object({
      code: mtMap150.objectField("code", mtMap150.passthrough()),
      full: mtMap150.objectField("full", mtMap150.passthrough())
    })
  ),
  metadata: mtMap150.objectField("metadata", mtMap150.passthrough()),
  createdAt: mtMap150.objectField("created_at", mtMap150.date()),
  updatedAt: mtMap150.objectField("updated_at", mtMap150.date())
});

// src/resources/threads/list.ts
import { mtMap as mtMap151 } from "@metorial/util-resource-mapper";
var mapThreadsListOutput = mtMap151.object({
  items: mtMap151.objectField(
    "items",
    mtMap151.array(
      mtMap151.object({
        id: mtMap151.objectField("id", mtMap151.passthrough()),
        name: mtMap151.objectField("name", mtMap151.passthrough()),
        agentId: mtMap151.objectField("agent_id", mtMap151.passthrough()),
        instanceId: mtMap151.objectField("instance_id", mtMap151.passthrough()),
        timezone: mtMap151.objectField(
          "timezone",
          mtMap151.object({
            code: mtMap151.objectField("code", mtMap151.passthrough()),
            utc: mtMap151.objectField("utc", mtMap151.passthrough()),
            utcOffsetInMinutes: mtMap151.objectField(
              "utc_offset_in_minutes",
              mtMap151.passthrough()
            )
          })
        ),
        country: mtMap151.objectField(
          "country",
          mtMap151.object({ code: mtMap151.objectField("code", mtMap151.passthrough()) })
        ),
        language: mtMap151.objectField(
          "language",
          mtMap151.object({
            code: mtMap151.objectField("code", mtMap151.passthrough()),
            full: mtMap151.objectField("full", mtMap151.passthrough())
          })
        ),
        metadata: mtMap151.objectField("metadata", mtMap151.passthrough()),
        createdAt: mtMap151.objectField("created_at", mtMap151.date()),
        updatedAt: mtMap151.objectField("updated_at", mtMap151.date())
      })
    )
  ),
  pagination: mtMap151.objectField(
    "pagination",
    mtMap151.object({
      afterCursor: mtMap151.objectField("after_cursor", mtMap151.passthrough()),
      beforeCursor: mtMap151.objectField("before_cursor", mtMap151.passthrough()),
      hasMoreBefore: mtMap151.objectField("has_more_before", mtMap151.passthrough()),
      hasMoreAfter: mtMap151.objectField("has_more_after", mtMap151.passthrough()),
      pageSize: mtMap151.objectField("page_size", mtMap151.passthrough()),
      sort: mtMap151.objectField(
        "sort",
        mtMap151.array(
          mtMap151.object({
            field: mtMap151.objectField("field", mtMap151.passthrough()),
            order: mtMap151.objectField("order", mtMap151.passthrough())
          })
        )
      )
    })
  )
});
var mapThreadsListQuery = mtMap151.object({
  id: mtMap151.objectField(
    "id",
    mtMap151.union([
      mtMap151.unionOption(
        "object",
        mtMap151.object({
          in: mtMap151.objectField("in", mtMap151.array(mtMap151.passthrough())),
          eq: mtMap151.objectField("eq", mtMap151.passthrough())
        })
      ),
      mtMap151.unionOption("string", mtMap151.passthrough())
    ])
  ),
  ids: mtMap151.objectField(
    "ids",
    mtMap151.union([
      mtMap151.unionOption(
        "object",
        mtMap151.object({
          in: mtMap151.objectField("in", mtMap151.array(mtMap151.passthrough())),
          eq: mtMap151.objectField("eq", mtMap151.passthrough())
        })
      ),
      mtMap151.unionOption("string", mtMap151.passthrough())
    ])
  ),
  createdAt: mtMap151.objectField(
    "created_at",
    mtMap151.union([
      mtMap151.unionOption(
        "object",
        mtMap151.object({
          eq: mtMap151.objectField("eq", mtMap151.date()),
          gt: mtMap151.objectField("gt", mtMap151.date()),
          gte: mtMap151.objectField("gte", mtMap151.date()),
          lt: mtMap151.objectField("lt", mtMap151.date()),
          lte: mtMap151.objectField("lte", mtMap151.date())
        })
      ),
      mtMap151.unionOption("date", mtMap151.passthrough())
    ])
  ),
  updatedAt: mtMap151.objectField(
    "updated_at",
    mtMap151.union([
      mtMap151.unionOption(
        "object",
        mtMap151.object({
          eq: mtMap151.objectField("eq", mtMap151.date()),
          gt: mtMap151.objectField("gt", mtMap151.date()),
          gte: mtMap151.objectField("gte", mtMap151.date()),
          lt: mtMap151.objectField("lt", mtMap151.date()),
          lte: mtMap151.objectField("lte", mtMap151.date())
        })
      ),
      mtMap151.unionOption("date", mtMap151.passthrough())
    ])
  ),
  sort: mtMap151.objectField(
    "sort",
    mtMap151.union([
      mtMap151.unionOption("string", mtMap151.passthrough()),
      mtMap151.unionOption(
        "array",
        mtMap151.union([
          mtMap151.unionOption(
            "object",
            mtMap151.object({
              field: mtMap151.objectField("field", mtMap151.passthrough()),
              order: mtMap151.objectField("order", mtMap151.passthrough())
            })
          )
        ])
      )
    ])
  ),
  userId: mtMap151.objectField("user_id", mtMap151.passthrough()),
  groupId: mtMap151.objectField("group_id", mtMap151.passthrough()),
  limit: mtMap151.objectField("limit", mtMap151.passthrough()),
  cursor: mtMap151.objectField("cursor", mtMap151.passthrough()),
  order: mtMap151.objectField("order", mtMap151.passthrough())
});

// src/resources/threads/messages/create.ts
import { mtMap as mtMap152 } from "@metorial/util-resource-mapper";
var mapThreadsMessagesCreateOutput = mtMap152.object({
  id: mtMap152.objectField("id", mtMap152.passthrough()),
  status: mtMap152.objectField("status", mtMap152.passthrough()),
  type: mtMap152.objectField("type", mtMap152.passthrough()),
  interactionId: mtMap152.objectField("interaction_id", mtMap152.passthrough()),
  createdAt: mtMap152.objectField("created_at", mtMap152.date()),
  threadId: mtMap152.objectField("thread_id", mtMap152.passthrough()),
  parentMessageGroupId: mtMap152.objectField(
    "parent_message_group_id",
    mtMap152.passthrough()
  ),
  messages: mtMap152.objectField(
    "messages",
    mtMap152.array(
      mtMap152.object({
        id: mtMap152.objectField("id", mtMap152.passthrough()),
        type: mtMap152.objectField("type", mtMap152.passthrough()),
        status: mtMap152.objectField("status", mtMap152.passthrough()),
        messageGroupId: mtMap152.objectField(
          "message_group_id",
          mtMap152.passthrough()
        ),
        threadId: mtMap152.objectField("thread_id", mtMap152.passthrough()),
        actor: mtMap152.objectField(
          "actor",
          mtMap152.object({
            id: mtMap152.objectField("id", mtMap152.passthrough()),
            name: mtMap152.objectField("name", mtMap152.passthrough()),
            type: mtMap152.objectField("type", mtMap152.passthrough()),
            metadata: mtMap152.objectField("metadata", mtMap152.passthrough()),
            createdAt: mtMap152.objectField("created_at", mtMap152.date()),
            updatedAt: mtMap152.objectField("updated_at", mtMap152.date())
          })
        ),
        content: mtMap152.objectField(
          "content",
          mtMap152.object({
            id: mtMap152.objectField("id", mtMap152.passthrough()),
            version: mtMap152.objectField("version", mtMap152.passthrough()),
            messageItemId: mtMap152.objectField(
              "message_item_id",
              mtMap152.passthrough()
            ),
            attachments: mtMap152.objectField(
              "attachments",
              mtMap152.array(
                mtMap152.union([
                  mtMap152.unionOption(
                    "object",
                    mtMap152.object({
                      id: mtMap152.objectField("id", mtMap152.passthrough()),
                      type: mtMap152.objectField("type", mtMap152.passthrough()),
                      fileId: mtMap152.objectField(
                        "file_id",
                        mtMap152.passthrough()
                      ),
                      url: mtMap152.objectField("url", mtMap152.passthrough()),
                      caption: mtMap152.objectField(
                        "caption",
                        mtMap152.object({
                          text: mtMap152.objectField("text", mtMap152.passthrough())
                        })
                      ),
                      mimeType: mtMap152.objectField(
                        "mime_type",
                        mtMap152.passthrough()
                      ),
                      entryId: mtMap152.objectField(
                        "entry_id",
                        mtMap152.passthrough()
                      )
                    })
                  )
                ])
              )
            ),
            parts: mtMap152.objectField(
              "parts",
              mtMap152.array(
                mtMap152.union([
                  mtMap152.unionOption(
                    "object",
                    mtMap152.object({
                      id: mtMap152.objectField("id", mtMap152.passthrough()),
                      type: mtMap152.objectField("type", mtMap152.passthrough()),
                      mimeType: mtMap152.objectField(
                        "mime_type",
                        mtMap152.passthrough()
                      ),
                      text: mtMap152.objectField("text", mtMap152.passthrough()),
                      kind: mtMap152.objectField("kind", mtMap152.passthrough()),
                      attachment: mtMap152.objectField(
                        "attachment",
                        mtMap152.union([
                          mtMap152.unionOption(
                            "object",
                            mtMap152.object({
                              id: mtMap152.objectField(
                                "id",
                                mtMap152.passthrough()
                              ),
                              type: mtMap152.objectField(
                                "type",
                                mtMap152.passthrough()
                              ),
                              fileId: mtMap152.objectField(
                                "file_id",
                                mtMap152.passthrough()
                              ),
                              url: mtMap152.objectField(
                                "url",
                                mtMap152.passthrough()
                              ),
                              caption: mtMap152.objectField(
                                "caption",
                                mtMap152.object({
                                  text: mtMap152.objectField(
                                    "text",
                                    mtMap152.passthrough()
                                  )
                                })
                              ),
                              mimeType: mtMap152.objectField(
                                "mime_type",
                                mtMap152.passthrough()
                              ),
                              entryId: mtMap152.objectField(
                                "entry_id",
                                mtMap152.passthrough()
                              )
                            })
                          )
                        ])
                      )
                    })
                  )
                ])
              )
            )
          })
        ),
        error: mtMap152.objectField(
          "error",
          mtMap152.object({
            type: mtMap152.objectField("type", mtMap152.passthrough()),
            message: mtMap152.objectField("message", mtMap152.passthrough())
          })
        ),
        createdAt: mtMap152.objectField("created_at", mtMap152.date())
      })
    )
  ),
  attachedItems: mtMap152.objectField(
    "attached_items",
    mtMap152.array(
      mtMap152.object({
        id: mtMap152.objectField("id", mtMap152.passthrough()),
        actor: mtMap152.objectField(
          "actor",
          mtMap152.object({
            id: mtMap152.objectField("id", mtMap152.passthrough()),
            name: mtMap152.objectField("name", mtMap152.passthrough()),
            type: mtMap152.objectField("type", mtMap152.passthrough()),
            metadata: mtMap152.objectField("metadata", mtMap152.passthrough()),
            createdAt: mtMap152.objectField("created_at", mtMap152.date()),
            updatedAt: mtMap152.objectField("updated_at", mtMap152.date())
          })
        ),
        key: mtMap152.objectField("key", mtMap152.passthrough()),
        value: mtMap152.objectField("value", mtMap152.passthrough()),
        createdAt: mtMap152.objectField("created_at", mtMap152.date())
      })
    )
  ),
  metadata: mtMap152.objectField("metadata", mtMap152.passthrough()),
  actor: mtMap152.objectField(
    "actor",
    mtMap152.object({
      id: mtMap152.objectField("id", mtMap152.passthrough()),
      name: mtMap152.objectField("name", mtMap152.passthrough()),
      type: mtMap152.objectField("type", mtMap152.passthrough()),
      metadata: mtMap152.objectField("metadata", mtMap152.passthrough()),
      createdAt: mtMap152.objectField("created_at", mtMap152.date()),
      updatedAt: mtMap152.objectField("updated_at", mtMap152.date())
    })
  ),
  run: mtMap152.objectField(
    "run",
    mtMap152.object({
      id: mtMap152.objectField("id", mtMap152.passthrough()),
      agentId: mtMap152.objectField("agent_id", mtMap152.passthrough()),
      status: mtMap152.objectField("status", mtMap152.passthrough()),
      metadata: mtMap152.objectField("metadata", mtMap152.passthrough()),
      startedAt: mtMap152.objectField("started_at", mtMap152.date()),
      createdAt: mtMap152.objectField("created_at", mtMap152.date()),
      completedAt: mtMap152.objectField("completed_at", mtMap152.date())
    })
  )
});
var mapThreadsMessagesCreateBody = mtMap152.object({
  userId: mtMap152.objectField("user_id", mtMap152.passthrough()),
  content: mtMap152.objectField(
    "content",
    mtMap152.union([
      mtMap152.unionOption(
        "object",
        mtMap152.object({
          type: mtMap152.objectField("type", mtMap152.passthrough()),
          mimeType: mtMap152.objectField("mimeType", mtMap152.passthrough()),
          content: mtMap152.objectField("content", mtMap152.passthrough()),
          parts: mtMap152.objectField(
            "parts",
            mtMap152.array(
              mtMap152.object({
                type: mtMap152.objectField("type", mtMap152.passthrough()),
                mimeType: mtMap152.objectField("mime_type", mtMap152.passthrough()),
                content: mtMap152.objectField("content", mtMap152.passthrough())
              })
            )
          ),
          attachments: mtMap152.objectField(
            "attachments",
            mtMap152.array(
              mtMap152.object({
                type: mtMap152.objectField("type", mtMap152.passthrough()),
                fileId: mtMap152.objectField("file_id", mtMap152.passthrough()),
                caption: mtMap152.objectField(
                  "caption",
                  mtMap152.union([
                    mtMap152.unionOption(
                      "object",
                      mtMap152.object({
                        text: mtMap152.objectField("text", mtMap152.passthrough())
                      })
                    ),
                    mtMap152.unionOption("string", mtMap152.passthrough())
                  ])
                )
              })
            )
          )
        })
      ),
      mtMap152.unionOption("string", mtMap152.passthrough()),
      mtMap152.unionOption(
        "array",
        mtMap152.union([
          mtMap152.unionOption(
            "object",
            mtMap152.object({
              type: mtMap152.objectField("type", mtMap152.passthrough()),
              mimeType: mtMap152.objectField("mimeType", mtMap152.passthrough()),
              content: mtMap152.objectField("content", mtMap152.passthrough())
            })
          )
        ])
      )
    ])
  ),
  rawInputs: mtMap152.objectField("raw_inputs", mtMap152.passthrough()),
  metadata: mtMap152.objectField("metadata", mtMap152.passthrough()),
  variantCount: mtMap152.objectField("variant_count", mtMap152.passthrough()),
  position: mtMap152.objectField(
    "position",
    mtMap152.union([
      mtMap152.unionOption(
        "object",
        mtMap152.object({
          type: mtMap152.objectField("type", mtMap152.passthrough()),
          messageGroupId: mtMap152.objectField(
            "message_group_id",
            mtMap152.passthrough()
          )
        })
      )
    ])
  )
});

// src/resources/threads/messages/get.ts
import { mtMap as mtMap153 } from "@metorial/util-resource-mapper";
var mapThreadsMessagesGetOutput = mtMap153.object(
  {
    id: mtMap153.objectField("id", mtMap153.passthrough()),
    status: mtMap153.objectField("status", mtMap153.passthrough()),
    type: mtMap153.objectField("type", mtMap153.passthrough()),
    interactionId: mtMap153.objectField("interaction_id", mtMap153.passthrough()),
    createdAt: mtMap153.objectField("created_at", mtMap153.date()),
    threadId: mtMap153.objectField("thread_id", mtMap153.passthrough()),
    parentMessageGroupId: mtMap153.objectField(
      "parent_message_group_id",
      mtMap153.passthrough()
    ),
    messages: mtMap153.objectField(
      "messages",
      mtMap153.array(
        mtMap153.object({
          id: mtMap153.objectField("id", mtMap153.passthrough()),
          type: mtMap153.objectField("type", mtMap153.passthrough()),
          status: mtMap153.objectField("status", mtMap153.passthrough()),
          messageGroupId: mtMap153.objectField(
            "message_group_id",
            mtMap153.passthrough()
          ),
          threadId: mtMap153.objectField("thread_id", mtMap153.passthrough()),
          actor: mtMap153.objectField(
            "actor",
            mtMap153.object({
              id: mtMap153.objectField("id", mtMap153.passthrough()),
              name: mtMap153.objectField("name", mtMap153.passthrough()),
              type: mtMap153.objectField("type", mtMap153.passthrough()),
              metadata: mtMap153.objectField("metadata", mtMap153.passthrough()),
              createdAt: mtMap153.objectField("created_at", mtMap153.date()),
              updatedAt: mtMap153.objectField("updated_at", mtMap153.date())
            })
          ),
          content: mtMap153.objectField(
            "content",
            mtMap153.object({
              id: mtMap153.objectField("id", mtMap153.passthrough()),
              version: mtMap153.objectField("version", mtMap153.passthrough()),
              messageItemId: mtMap153.objectField(
                "message_item_id",
                mtMap153.passthrough()
              ),
              attachments: mtMap153.objectField(
                "attachments",
                mtMap153.array(
                  mtMap153.union([
                    mtMap153.unionOption(
                      "object",
                      mtMap153.object({
                        id: mtMap153.objectField("id", mtMap153.passthrough()),
                        type: mtMap153.objectField("type", mtMap153.passthrough()),
                        fileId: mtMap153.objectField(
                          "file_id",
                          mtMap153.passthrough()
                        ),
                        url: mtMap153.objectField("url", mtMap153.passthrough()),
                        caption: mtMap153.objectField(
                          "caption",
                          mtMap153.object({
                            text: mtMap153.objectField("text", mtMap153.passthrough())
                          })
                        ),
                        mimeType: mtMap153.objectField(
                          "mime_type",
                          mtMap153.passthrough()
                        ),
                        entryId: mtMap153.objectField(
                          "entry_id",
                          mtMap153.passthrough()
                        )
                      })
                    )
                  ])
                )
              ),
              parts: mtMap153.objectField(
                "parts",
                mtMap153.array(
                  mtMap153.union([
                    mtMap153.unionOption(
                      "object",
                      mtMap153.object({
                        id: mtMap153.objectField("id", mtMap153.passthrough()),
                        type: mtMap153.objectField("type", mtMap153.passthrough()),
                        mimeType: mtMap153.objectField(
                          "mime_type",
                          mtMap153.passthrough()
                        ),
                        text: mtMap153.objectField("text", mtMap153.passthrough()),
                        kind: mtMap153.objectField("kind", mtMap153.passthrough()),
                        attachment: mtMap153.objectField(
                          "attachment",
                          mtMap153.union([
                            mtMap153.unionOption(
                              "object",
                              mtMap153.object({
                                id: mtMap153.objectField(
                                  "id",
                                  mtMap153.passthrough()
                                ),
                                type: mtMap153.objectField(
                                  "type",
                                  mtMap153.passthrough()
                                ),
                                fileId: mtMap153.objectField(
                                  "file_id",
                                  mtMap153.passthrough()
                                ),
                                url: mtMap153.objectField(
                                  "url",
                                  mtMap153.passthrough()
                                ),
                                caption: mtMap153.objectField(
                                  "caption",
                                  mtMap153.object({
                                    text: mtMap153.objectField(
                                      "text",
                                      mtMap153.passthrough()
                                    )
                                  })
                                ),
                                mimeType: mtMap153.objectField(
                                  "mime_type",
                                  mtMap153.passthrough()
                                ),
                                entryId: mtMap153.objectField(
                                  "entry_id",
                                  mtMap153.passthrough()
                                )
                              })
                            )
                          ])
                        )
                      })
                    )
                  ])
                )
              )
            })
          ),
          error: mtMap153.objectField(
            "error",
            mtMap153.object({
              type: mtMap153.objectField("type", mtMap153.passthrough()),
              message: mtMap153.objectField("message", mtMap153.passthrough())
            })
          ),
          createdAt: mtMap153.objectField("created_at", mtMap153.date())
        })
      )
    ),
    attachedItems: mtMap153.objectField(
      "attached_items",
      mtMap153.array(
        mtMap153.object({
          id: mtMap153.objectField("id", mtMap153.passthrough()),
          actor: mtMap153.objectField(
            "actor",
            mtMap153.object({
              id: mtMap153.objectField("id", mtMap153.passthrough()),
              name: mtMap153.objectField("name", mtMap153.passthrough()),
              type: mtMap153.objectField("type", mtMap153.passthrough()),
              metadata: mtMap153.objectField("metadata", mtMap153.passthrough()),
              createdAt: mtMap153.objectField("created_at", mtMap153.date()),
              updatedAt: mtMap153.objectField("updated_at", mtMap153.date())
            })
          ),
          key: mtMap153.objectField("key", mtMap153.passthrough()),
          value: mtMap153.objectField("value", mtMap153.passthrough()),
          createdAt: mtMap153.objectField("created_at", mtMap153.date())
        })
      )
    ),
    metadata: mtMap153.objectField("metadata", mtMap153.passthrough()),
    actor: mtMap153.objectField(
      "actor",
      mtMap153.object({
        id: mtMap153.objectField("id", mtMap153.passthrough()),
        name: mtMap153.objectField("name", mtMap153.passthrough()),
        type: mtMap153.objectField("type", mtMap153.passthrough()),
        metadata: mtMap153.objectField("metadata", mtMap153.passthrough()),
        createdAt: mtMap153.objectField("created_at", mtMap153.date()),
        updatedAt: mtMap153.objectField("updated_at", mtMap153.date())
      })
    ),
    run: mtMap153.objectField(
      "run",
      mtMap153.object({
        id: mtMap153.objectField("id", mtMap153.passthrough()),
        agentId: mtMap153.objectField("agent_id", mtMap153.passthrough()),
        status: mtMap153.objectField("status", mtMap153.passthrough()),
        metadata: mtMap153.objectField("metadata", mtMap153.passthrough()),
        startedAt: mtMap153.objectField("started_at", mtMap153.date()),
        createdAt: mtMap153.objectField("created_at", mtMap153.date()),
        completedAt: mtMap153.objectField("completed_at", mtMap153.date())
      })
    )
  }
);

// src/resources/threads/messages/list.ts
import { mtMap as mtMap154 } from "@metorial/util-resource-mapper";
var mapThreadsMessagesListOutput = mtMap154.object({
  items: mtMap154.objectField(
    "items",
    mtMap154.array(
      mtMap154.object({
        id: mtMap154.objectField("id", mtMap154.passthrough()),
        status: mtMap154.objectField("status", mtMap154.passthrough()),
        type: mtMap154.objectField("type", mtMap154.passthrough()),
        interactionId: mtMap154.objectField(
          "interaction_id",
          mtMap154.passthrough()
        ),
        createdAt: mtMap154.objectField("created_at", mtMap154.date()),
        threadId: mtMap154.objectField("thread_id", mtMap154.passthrough()),
        parentMessageGroupId: mtMap154.objectField(
          "parent_message_group_id",
          mtMap154.passthrough()
        ),
        messages: mtMap154.objectField(
          "messages",
          mtMap154.array(
            mtMap154.object({
              id: mtMap154.objectField("id", mtMap154.passthrough()),
              type: mtMap154.objectField("type", mtMap154.passthrough()),
              status: mtMap154.objectField("status", mtMap154.passthrough()),
              messageGroupId: mtMap154.objectField(
                "message_group_id",
                mtMap154.passthrough()
              ),
              threadId: mtMap154.objectField("thread_id", mtMap154.passthrough()),
              actor: mtMap154.objectField(
                "actor",
                mtMap154.object({
                  id: mtMap154.objectField("id", mtMap154.passthrough()),
                  name: mtMap154.objectField("name", mtMap154.passthrough()),
                  type: mtMap154.objectField("type", mtMap154.passthrough()),
                  metadata: mtMap154.objectField(
                    "metadata",
                    mtMap154.passthrough()
                  ),
                  createdAt: mtMap154.objectField("created_at", mtMap154.date()),
                  updatedAt: mtMap154.objectField("updated_at", mtMap154.date())
                })
              ),
              content: mtMap154.objectField(
                "content",
                mtMap154.object({
                  id: mtMap154.objectField("id", mtMap154.passthrough()),
                  version: mtMap154.objectField("version", mtMap154.passthrough()),
                  messageItemId: mtMap154.objectField(
                    "message_item_id",
                    mtMap154.passthrough()
                  ),
                  attachments: mtMap154.objectField(
                    "attachments",
                    mtMap154.array(
                      mtMap154.union([
                        mtMap154.unionOption(
                          "object",
                          mtMap154.object({
                            id: mtMap154.objectField("id", mtMap154.passthrough()),
                            type: mtMap154.objectField(
                              "type",
                              mtMap154.passthrough()
                            ),
                            fileId: mtMap154.objectField(
                              "file_id",
                              mtMap154.passthrough()
                            ),
                            url: mtMap154.objectField(
                              "url",
                              mtMap154.passthrough()
                            ),
                            caption: mtMap154.objectField(
                              "caption",
                              mtMap154.object({
                                text: mtMap154.objectField(
                                  "text",
                                  mtMap154.passthrough()
                                )
                              })
                            ),
                            mimeType: mtMap154.objectField(
                              "mime_type",
                              mtMap154.passthrough()
                            ),
                            entryId: mtMap154.objectField(
                              "entry_id",
                              mtMap154.passthrough()
                            )
                          })
                        )
                      ])
                    )
                  ),
                  parts: mtMap154.objectField(
                    "parts",
                    mtMap154.array(
                      mtMap154.union([
                        mtMap154.unionOption(
                          "object",
                          mtMap154.object({
                            id: mtMap154.objectField("id", mtMap154.passthrough()),
                            type: mtMap154.objectField(
                              "type",
                              mtMap154.passthrough()
                            ),
                            mimeType: mtMap154.objectField(
                              "mime_type",
                              mtMap154.passthrough()
                            ),
                            text: mtMap154.objectField(
                              "text",
                              mtMap154.passthrough()
                            ),
                            kind: mtMap154.objectField(
                              "kind",
                              mtMap154.passthrough()
                            ),
                            attachment: mtMap154.objectField(
                              "attachment",
                              mtMap154.union([
                                mtMap154.unionOption(
                                  "object",
                                  mtMap154.object({
                                    id: mtMap154.objectField(
                                      "id",
                                      mtMap154.passthrough()
                                    ),
                                    type: mtMap154.objectField(
                                      "type",
                                      mtMap154.passthrough()
                                    ),
                                    fileId: mtMap154.objectField(
                                      "file_id",
                                      mtMap154.passthrough()
                                    ),
                                    url: mtMap154.objectField(
                                      "url",
                                      mtMap154.passthrough()
                                    ),
                                    caption: mtMap154.objectField(
                                      "caption",
                                      mtMap154.object({
                                        text: mtMap154.objectField(
                                          "text",
                                          mtMap154.passthrough()
                                        )
                                      })
                                    ),
                                    mimeType: mtMap154.objectField(
                                      "mime_type",
                                      mtMap154.passthrough()
                                    ),
                                    entryId: mtMap154.objectField(
                                      "entry_id",
                                      mtMap154.passthrough()
                                    )
                                  })
                                )
                              ])
                            )
                          })
                        )
                      ])
                    )
                  )
                })
              ),
              error: mtMap154.objectField(
                "error",
                mtMap154.object({
                  type: mtMap154.objectField("type", mtMap154.passthrough()),
                  message: mtMap154.objectField("message", mtMap154.passthrough())
                })
              ),
              createdAt: mtMap154.objectField("created_at", mtMap154.date())
            })
          )
        ),
        attachedItems: mtMap154.objectField(
          "attached_items",
          mtMap154.array(
            mtMap154.object({
              id: mtMap154.objectField("id", mtMap154.passthrough()),
              actor: mtMap154.objectField(
                "actor",
                mtMap154.object({
                  id: mtMap154.objectField("id", mtMap154.passthrough()),
                  name: mtMap154.objectField("name", mtMap154.passthrough()),
                  type: mtMap154.objectField("type", mtMap154.passthrough()),
                  metadata: mtMap154.objectField(
                    "metadata",
                    mtMap154.passthrough()
                  ),
                  createdAt: mtMap154.objectField("created_at", mtMap154.date()),
                  updatedAt: mtMap154.objectField("updated_at", mtMap154.date())
                })
              ),
              key: mtMap154.objectField("key", mtMap154.passthrough()),
              value: mtMap154.objectField("value", mtMap154.passthrough()),
              createdAt: mtMap154.objectField("created_at", mtMap154.date())
            })
          )
        ),
        metadata: mtMap154.objectField("metadata", mtMap154.passthrough()),
        actor: mtMap154.objectField(
          "actor",
          mtMap154.object({
            id: mtMap154.objectField("id", mtMap154.passthrough()),
            name: mtMap154.objectField("name", mtMap154.passthrough()),
            type: mtMap154.objectField("type", mtMap154.passthrough()),
            metadata: mtMap154.objectField("metadata", mtMap154.passthrough()),
            createdAt: mtMap154.objectField("created_at", mtMap154.date()),
            updatedAt: mtMap154.objectField("updated_at", mtMap154.date())
          })
        ),
        run: mtMap154.objectField(
          "run",
          mtMap154.object({
            id: mtMap154.objectField("id", mtMap154.passthrough()),
            agentId: mtMap154.objectField("agent_id", mtMap154.passthrough()),
            status: mtMap154.objectField("status", mtMap154.passthrough()),
            metadata: mtMap154.objectField("metadata", mtMap154.passthrough()),
            startedAt: mtMap154.objectField("started_at", mtMap154.date()),
            createdAt: mtMap154.objectField("created_at", mtMap154.date()),
            completedAt: mtMap154.objectField("completed_at", mtMap154.date())
          })
        )
      })
    )
  ),
  pagination: mtMap154.objectField(
    "pagination",
    mtMap154.object({
      afterCursor: mtMap154.objectField("after_cursor", mtMap154.passthrough()),
      beforeCursor: mtMap154.objectField("before_cursor", mtMap154.passthrough()),
      hasMoreBefore: mtMap154.objectField(
        "has_more_before",
        mtMap154.passthrough()
      ),
      hasMoreAfter: mtMap154.objectField("has_more_after", mtMap154.passthrough()),
      pageSize: mtMap154.objectField("page_size", mtMap154.passthrough()),
      sort: mtMap154.objectField(
        "sort",
        mtMap154.array(
          mtMap154.object({
            field: mtMap154.objectField("field", mtMap154.passthrough()),
            order: mtMap154.objectField("order", mtMap154.passthrough())
          })
        )
      )
    })
  )
});
var mapThreadsMessagesListQuery = mtMap154.object(
  {
    id: mtMap154.objectField(
      "id",
      mtMap154.union([
        mtMap154.unionOption(
          "object",
          mtMap154.object({
            in: mtMap154.objectField("in", mtMap154.array(mtMap154.passthrough())),
            eq: mtMap154.objectField("eq", mtMap154.passthrough())
          })
        ),
        mtMap154.unionOption("string", mtMap154.passthrough())
      ])
    ),
    ids: mtMap154.objectField(
      "ids",
      mtMap154.union([
        mtMap154.unionOption(
          "object",
          mtMap154.object({
            in: mtMap154.objectField("in", mtMap154.array(mtMap154.passthrough())),
            eq: mtMap154.objectField("eq", mtMap154.passthrough())
          })
        ),
        mtMap154.unionOption("string", mtMap154.passthrough())
      ])
    ),
    createdAt: mtMap154.objectField(
      "created_at",
      mtMap154.union([
        mtMap154.unionOption(
          "object",
          mtMap154.object({
            eq: mtMap154.objectField("eq", mtMap154.date()),
            gt: mtMap154.objectField("gt", mtMap154.date()),
            gte: mtMap154.objectField("gte", mtMap154.date()),
            lt: mtMap154.objectField("lt", mtMap154.date()),
            lte: mtMap154.objectField("lte", mtMap154.date())
          })
        ),
        mtMap154.unionOption("date", mtMap154.passthrough())
      ])
    ),
    status: mtMap154.objectField(
      "status",
      mtMap154.union([
        mtMap154.unionOption(
          "object",
          mtMap154.object({
            in: mtMap154.objectField("in", mtMap154.array(mtMap154.passthrough())),
            eq: mtMap154.objectField("eq", mtMap154.passthrough())
          })
        ),
        mtMap154.unionOption("string", mtMap154.passthrough())
      ])
    ),
    statuses: mtMap154.objectField(
      "statuses",
      mtMap154.union([
        mtMap154.unionOption(
          "object",
          mtMap154.object({
            in: mtMap154.objectField("in", mtMap154.array(mtMap154.passthrough())),
            eq: mtMap154.objectField("eq", mtMap154.passthrough())
          })
        ),
        mtMap154.unionOption("string", mtMap154.passthrough())
      ])
    ),
    type: mtMap154.objectField(
      "type",
      mtMap154.union([
        mtMap154.unionOption(
          "object",
          mtMap154.object({
            in: mtMap154.objectField("in", mtMap154.array(mtMap154.passthrough())),
            eq: mtMap154.objectField("eq", mtMap154.passthrough())
          })
        ),
        mtMap154.unionOption("string", mtMap154.passthrough())
      ])
    ),
    types: mtMap154.objectField(
      "types",
      mtMap154.union([
        mtMap154.unionOption(
          "object",
          mtMap154.object({
            in: mtMap154.objectField("in", mtMap154.array(mtMap154.passthrough())),
            eq: mtMap154.objectField("eq", mtMap154.passthrough())
          })
        ),
        mtMap154.unionOption("string", mtMap154.passthrough())
      ])
    ),
    sort: mtMap154.objectField(
      "sort",
      mtMap154.union([
        mtMap154.unionOption("string", mtMap154.passthrough()),
        mtMap154.unionOption(
          "array",
          mtMap154.union([
            mtMap154.unionOption(
              "object",
              mtMap154.object({
                field: mtMap154.objectField("field", mtMap154.passthrough()),
                order: mtMap154.objectField("order", mtMap154.passthrough())
              })
            )
          ])
        )
      ])
    ),
    limit: mtMap154.objectField("limit", mtMap154.passthrough()),
    cursor: mtMap154.objectField("cursor", mtMap154.passthrough()),
    order: mtMap154.objectField("order", mtMap154.passthrough())
  }
);

// src/resources/threads/participants/list.ts
import { mtMap as mtMap155 } from "@metorial/util-resource-mapper";
var mapThreadsParticipantsListOutput = mtMap155.object({
  items: mtMap155.objectField(
    "items",
    mtMap155.array(
      mtMap155.object({
        id: mtMap155.objectField("id", mtMap155.passthrough()),
        name: mtMap155.objectField("name", mtMap155.passthrough()),
        type: mtMap155.objectField("type", mtMap155.passthrough()),
        metadata: mtMap155.objectField("metadata", mtMap155.passthrough()),
        createdAt: mtMap155.objectField("created_at", mtMap155.date()),
        updatedAt: mtMap155.objectField("updated_at", mtMap155.date()),
        joinedAt: mtMap155.objectField("joined_at", mtMap155.date()),
        threadId: mtMap155.objectField("thread_id", mtMap155.passthrough())
      })
    )
  ),
  pagination: mtMap155.objectField(
    "pagination",
    mtMap155.object({
      afterCursor: mtMap155.objectField("after_cursor", mtMap155.passthrough()),
      beforeCursor: mtMap155.objectField("before_cursor", mtMap155.passthrough()),
      hasMoreBefore: mtMap155.objectField(
        "has_more_before",
        mtMap155.passthrough()
      ),
      hasMoreAfter: mtMap155.objectField("has_more_after", mtMap155.passthrough()),
      pageSize: mtMap155.objectField("page_size", mtMap155.passthrough()),
      sort: mtMap155.objectField(
        "sort",
        mtMap155.array(
          mtMap155.object({
            field: mtMap155.objectField("field", mtMap155.passthrough()),
            order: mtMap155.objectField("order", mtMap155.passthrough())
          })
        )
      )
    })
  )
});
var mapThreadsParticipantsListQuery = mtMap155.object({
  id: mtMap155.objectField(
    "id",
    mtMap155.union([
      mtMap155.unionOption(
        "object",
        mtMap155.object({
          in: mtMap155.objectField("in", mtMap155.array(mtMap155.passthrough())),
          eq: mtMap155.objectField("eq", mtMap155.passthrough())
        })
      ),
      mtMap155.unionOption("string", mtMap155.passthrough())
    ])
  ),
  ids: mtMap155.objectField(
    "ids",
    mtMap155.union([
      mtMap155.unionOption(
        "object",
        mtMap155.object({
          in: mtMap155.objectField("in", mtMap155.array(mtMap155.passthrough())),
          eq: mtMap155.objectField("eq", mtMap155.passthrough())
        })
      ),
      mtMap155.unionOption("string", mtMap155.passthrough())
    ])
  ),
  createdAt: mtMap155.objectField(
    "created_at",
    mtMap155.union([
      mtMap155.unionOption(
        "object",
        mtMap155.object({
          eq: mtMap155.objectField("eq", mtMap155.date()),
          gt: mtMap155.objectField("gt", mtMap155.date()),
          gte: mtMap155.objectField("gte", mtMap155.date()),
          lt: mtMap155.objectField("lt", mtMap155.date()),
          lte: mtMap155.objectField("lte", mtMap155.date())
        })
      ),
      mtMap155.unionOption("date", mtMap155.passthrough())
    ])
  ),
  updatedAt: mtMap155.objectField(
    "updated_at",
    mtMap155.union([
      mtMap155.unionOption(
        "object",
        mtMap155.object({
          eq: mtMap155.objectField("eq", mtMap155.date()),
          gt: mtMap155.objectField("gt", mtMap155.date()),
          gte: mtMap155.objectField("gte", mtMap155.date()),
          lt: mtMap155.objectField("lt", mtMap155.date()),
          lte: mtMap155.objectField("lte", mtMap155.date())
        })
      ),
      mtMap155.unionOption("date", mtMap155.passthrough())
    ])
  ),
  type: mtMap155.objectField(
    "type",
    mtMap155.union([
      mtMap155.unionOption(
        "object",
        mtMap155.object({
          in: mtMap155.objectField("in", mtMap155.array(mtMap155.passthrough())),
          eq: mtMap155.objectField("eq", mtMap155.passthrough())
        })
      ),
      mtMap155.unionOption("string", mtMap155.passthrough())
    ])
  ),
  types: mtMap155.objectField(
    "types",
    mtMap155.union([
      mtMap155.unionOption(
        "object",
        mtMap155.object({
          in: mtMap155.objectField("in", mtMap155.array(mtMap155.passthrough())),
          eq: mtMap155.objectField("eq", mtMap155.passthrough())
        })
      ),
      mtMap155.unionOption("string", mtMap155.passthrough())
    ])
  ),
  sort: mtMap155.objectField(
    "sort",
    mtMap155.union([
      mtMap155.unionOption("string", mtMap155.passthrough()),
      mtMap155.unionOption(
        "array",
        mtMap155.union([
          mtMap155.unionOption(
            "object",
            mtMap155.object({
              field: mtMap155.objectField("field", mtMap155.passthrough()),
              order: mtMap155.objectField("order", mtMap155.passthrough())
            })
          )
        ])
      )
    ])
  ),
  limit: mtMap155.objectField("limit", mtMap155.passthrough()),
  cursor: mtMap155.objectField("cursor", mtMap155.passthrough()),
  order: mtMap155.objectField("order", mtMap155.passthrough())
});

// src/resources/threads/update.ts
import { mtMap as mtMap156 } from "@metorial/util-resource-mapper";
var mapThreadsUpdateOutput = mtMap156.object({
  id: mtMap156.objectField("id", mtMap156.passthrough()),
  name: mtMap156.objectField("name", mtMap156.passthrough()),
  agentId: mtMap156.objectField("agent_id", mtMap156.passthrough()),
  instanceId: mtMap156.objectField("instance_id", mtMap156.passthrough()),
  timezone: mtMap156.objectField(
    "timezone",
    mtMap156.object({
      code: mtMap156.objectField("code", mtMap156.passthrough()),
      utc: mtMap156.objectField("utc", mtMap156.passthrough()),
      utcOffsetInMinutes: mtMap156.objectField(
        "utc_offset_in_minutes",
        mtMap156.passthrough()
      )
    })
  ),
  country: mtMap156.objectField(
    "country",
    mtMap156.object({ code: mtMap156.objectField("code", mtMap156.passthrough()) })
  ),
  language: mtMap156.objectField(
    "language",
    mtMap156.object({
      code: mtMap156.objectField("code", mtMap156.passthrough()),
      full: mtMap156.objectField("full", mtMap156.passthrough())
    })
  ),
  metadata: mtMap156.objectField("metadata", mtMap156.passthrough()),
  createdAt: mtMap156.objectField("created_at", mtMap156.date()),
  updatedAt: mtMap156.objectField("updated_at", mtMap156.date())
});
var mapThreadsUpdateBody = mtMap156.object({
  metadata: mtMap156.objectField("metadata", mtMap156.passthrough()),
  name: mtMap156.objectField("name", mtMap156.passthrough())
});

// src/resources/users/create.ts
import { mtMap as mtMap157 } from "@metorial/util-resource-mapper";
var mapUsersCreateOutput = mtMap157.object({
  id: mtMap157.objectField("id", mtMap157.passthrough()),
  status: mtMap157.objectField("status", mtMap157.passthrough()),
  type: mtMap157.objectField("type", mtMap157.passthrough()),
  name: mtMap157.objectField("name", mtMap157.passthrough()),
  email: mtMap157.objectField("email", mtMap157.passthrough()),
  metadata: mtMap157.objectField("metadata", mtMap157.passthrough()),
  defaultGroupId: mtMap157.objectField("default_group_id", mtMap157.passthrough()),
  createdAt: mtMap157.objectField("created_at", mtMap157.date()),
  updatedAt: mtMap157.objectField("updated_at", mtMap157.date())
});
var mapUsersCreateBody = mtMap157.object({
  id: mtMap157.objectField("id", mtMap157.passthrough()),
  name: mtMap157.objectField("name", mtMap157.passthrough()),
  email: mtMap157.objectField("email", mtMap157.passthrough()),
  metadata: mtMap157.objectField("metadata", mtMap157.passthrough())
});

// src/resources/users/delete.ts
import { mtMap as mtMap158 } from "@metorial/util-resource-mapper";
var mapUsersDeleteOutput = mtMap158.object({
  id: mtMap158.objectField("id", mtMap158.passthrough()),
  status: mtMap158.objectField("status", mtMap158.passthrough()),
  type: mtMap158.objectField("type", mtMap158.passthrough()),
  name: mtMap158.objectField("name", mtMap158.passthrough()),
  email: mtMap158.objectField("email", mtMap158.passthrough()),
  metadata: mtMap158.objectField("metadata", mtMap158.passthrough()),
  defaultGroupId: mtMap158.objectField("default_group_id", mtMap158.passthrough()),
  createdAt: mtMap158.objectField("created_at", mtMap158.date()),
  updatedAt: mtMap158.objectField("updated_at", mtMap158.date())
});

// src/resources/users/get.ts
import { mtMap as mtMap159 } from "@metorial/util-resource-mapper";
var mapUsersGetOutput = mtMap159.object({
  id: mtMap159.objectField("id", mtMap159.passthrough()),
  status: mtMap159.objectField("status", mtMap159.passthrough()),
  type: mtMap159.objectField("type", mtMap159.passthrough()),
  name: mtMap159.objectField("name", mtMap159.passthrough()),
  email: mtMap159.objectField("email", mtMap159.passthrough()),
  metadata: mtMap159.objectField("metadata", mtMap159.passthrough()),
  defaultGroupId: mtMap159.objectField("default_group_id", mtMap159.passthrough()),
  createdAt: mtMap159.objectField("created_at", mtMap159.date()),
  updatedAt: mtMap159.objectField("updated_at", mtMap159.date())
});

// src/resources/users/list.ts
import { mtMap as mtMap160 } from "@metorial/util-resource-mapper";
var mapUsersListOutput = mtMap160.object({
  items: mtMap160.objectField(
    "items",
    mtMap160.array(
      mtMap160.object({
        id: mtMap160.objectField("id", mtMap160.passthrough()),
        status: mtMap160.objectField("status", mtMap160.passthrough()),
        type: mtMap160.objectField("type", mtMap160.passthrough()),
        name: mtMap160.objectField("name", mtMap160.passthrough()),
        email: mtMap160.objectField("email", mtMap160.passthrough()),
        metadata: mtMap160.objectField("metadata", mtMap160.passthrough()),
        defaultGroupId: mtMap160.objectField(
          "default_group_id",
          mtMap160.passthrough()
        ),
        createdAt: mtMap160.objectField("created_at", mtMap160.date()),
        updatedAt: mtMap160.objectField("updated_at", mtMap160.date())
      })
    )
  ),
  pagination: mtMap160.objectField(
    "pagination",
    mtMap160.object({
      afterCursor: mtMap160.objectField("after_cursor", mtMap160.passthrough()),
      beforeCursor: mtMap160.objectField("before_cursor", mtMap160.passthrough()),
      hasMoreBefore: mtMap160.objectField("has_more_before", mtMap160.passthrough()),
      hasMoreAfter: mtMap160.objectField("has_more_after", mtMap160.passthrough()),
      pageSize: mtMap160.objectField("page_size", mtMap160.passthrough()),
      sort: mtMap160.objectField(
        "sort",
        mtMap160.array(
          mtMap160.object({
            field: mtMap160.objectField("field", mtMap160.passthrough()),
            order: mtMap160.objectField("order", mtMap160.passthrough())
          })
        )
      )
    })
  )
});
var mapUsersListQuery = mtMap160.object({
  id: mtMap160.objectField(
    "id",
    mtMap160.union([
      mtMap160.unionOption(
        "object",
        mtMap160.object({
          in: mtMap160.objectField("in", mtMap160.array(mtMap160.passthrough())),
          eq: mtMap160.objectField("eq", mtMap160.passthrough())
        })
      ),
      mtMap160.unionOption("string", mtMap160.passthrough())
    ])
  ),
  ids: mtMap160.objectField(
    "ids",
    mtMap160.union([
      mtMap160.unionOption(
        "object",
        mtMap160.object({
          in: mtMap160.objectField("in", mtMap160.array(mtMap160.passthrough())),
          eq: mtMap160.objectField("eq", mtMap160.passthrough())
        })
      ),
      mtMap160.unionOption("string", mtMap160.passthrough())
    ])
  ),
  createdAt: mtMap160.objectField(
    "created_at",
    mtMap160.union([
      mtMap160.unionOption(
        "object",
        mtMap160.object({
          eq: mtMap160.objectField("eq", mtMap160.date()),
          gt: mtMap160.objectField("gt", mtMap160.date()),
          gte: mtMap160.objectField("gte", mtMap160.date()),
          lt: mtMap160.objectField("lt", mtMap160.date()),
          lte: mtMap160.objectField("lte", mtMap160.date())
        })
      ),
      mtMap160.unionOption("date", mtMap160.passthrough())
    ])
  ),
  updatedAt: mtMap160.objectField(
    "updated_at",
    mtMap160.union([
      mtMap160.unionOption(
        "object",
        mtMap160.object({
          eq: mtMap160.objectField("eq", mtMap160.date()),
          gt: mtMap160.objectField("gt", mtMap160.date()),
          gte: mtMap160.objectField("gte", mtMap160.date()),
          lt: mtMap160.objectField("lt", mtMap160.date()),
          lte: mtMap160.objectField("lte", mtMap160.date())
        })
      ),
      mtMap160.unionOption("date", mtMap160.passthrough())
    ])
  ),
  sort: mtMap160.objectField(
    "sort",
    mtMap160.union([
      mtMap160.unionOption("string", mtMap160.passthrough()),
      mtMap160.unionOption(
        "array",
        mtMap160.union([
          mtMap160.unionOption(
            "object",
            mtMap160.object({
              field: mtMap160.objectField("field", mtMap160.passthrough()),
              order: mtMap160.objectField("order", mtMap160.passthrough())
            })
          )
        ])
      )
    ])
  ),
  threadId: mtMap160.objectField("thread_id", mtMap160.passthrough()),
  groupId: mtMap160.objectField("group_id", mtMap160.passthrough()),
  limit: mtMap160.objectField("limit", mtMap160.passthrough()),
  cursor: mtMap160.objectField("cursor", mtMap160.passthrough()),
  order: mtMap160.objectField("order", mtMap160.passthrough())
});

// src/resources/users/update.ts
import { mtMap as mtMap161 } from "@metorial/util-resource-mapper";
var mapUsersUpdateOutput = mtMap161.object({
  id: mtMap161.objectField("id", mtMap161.passthrough()),
  status: mtMap161.objectField("status", mtMap161.passthrough()),
  type: mtMap161.objectField("type", mtMap161.passthrough()),
  name: mtMap161.objectField("name", mtMap161.passthrough()),
  email: mtMap161.objectField("email", mtMap161.passthrough()),
  metadata: mtMap161.objectField("metadata", mtMap161.passthrough()),
  defaultGroupId: mtMap161.objectField("default_group_id", mtMap161.passthrough()),
  createdAt: mtMap161.objectField("created_at", mtMap161.date()),
  updatedAt: mtMap161.objectField("updated_at", mtMap161.date())
});
var mapUsersUpdateBody = mtMap161.object({
  name: mtMap161.objectField("name", mtMap161.passthrough()),
  email: mtMap161.objectField("email", mtMap161.passthrough()),
  metadata: mtMap161.objectField("metadata", mtMap161.passthrough())
});

// src/endpoints/actors.ts
import {
  BaseMetorialEndpoint
} from "@metorial/util-endpoint";
var MetorialActorsEndpoint = class extends BaseMetorialEndpoint {
  constructor(config) {
    super(config);
  }
  /**
   * @name List actors
   * @description Retrieve a list of all actors currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `query` - ManagementInstancesActorsListQuery
   *
   * @returns ManagementInstancesActorsListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query) {
    return this._get({
      path: ["actors"],
      query: query ? mapManagementInstancesActorsListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesActorsListOutput);
  }
  /**
   * @name Get actor
   * @description Retrieve a specific actor by its ID.
   *
   * @param `actorId` - string
   *
   * @returns ManagementInstancesActorsGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(actorId) {
    return this._get({
      path: ["actors", actorId]
    }).transform(mapManagementInstancesActorsGetOutput);
  }
};

// src/endpoints/agents.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint2
} from "@metorial/util-endpoint";
var MetorialAgentsEndpoint = class extends BaseMetorialEndpoint2 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List agents
   * @description Retrieve a list of all agents currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `query` - ManagementInstancesAgentsListQuery
   *
   * @returns ManagementInstancesAgentsListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query) {
    return this._get({
      path: ["agents"],
      query: query ? mapManagementInstancesAgentsListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesAgentsListOutput);
  }
  /**
   * @name Get agent
   * @description Retrieve a specific agent by its ID.
   *
   * @param `agentId` - string
   *
   * @returns ManagementInstancesAgentsGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(agentId) {
    return this._get({
      path: ["agents", agentId]
    }).transform(mapManagementInstancesAgentsGetOutput);
  }
};

// src/endpoints/client-tokens-jwks.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint3
} from "@metorial/util-endpoint";
var MetorialClientTokensJwksEndpoint = class extends BaseMetorialEndpoint3 {
  constructor(config) {
    super(config);
  }
  /**
   * @name Get JWKs
   * @description Retrieve the JWKs you can use to sign your own client tokens.
   *
   * @param
   *
   * @returns ManagementInstancesClientTokensJwksListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list() {
    return this._get({
      path: ["client_tokens", "jwks"]
    }).transform(mapManagementInstancesClientTokensJwksListOutput);
  }
};

// src/endpoints/files-links.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint4
} from "@metorial/util-endpoint";
var MetorialFilesLinksEndpoint = class extends BaseMetorialEndpoint4 {
  constructor(config) {
    super(config);
  }
  /**
   * @name Create file link
   * @description Create a link to a specific file.
   *
   * @param `fileId` - string
   *
   * @returns ManagementInstancesFilesLinksCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(fileId) {
    return this._post({
      path: ["files", fileId, "links"]
    }).transform(mapManagementInstancesFilesLinksCreateOutput);
  }
};

// src/endpoints/files.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint5
} from "@metorial/util-endpoint";
var MetorialFilesEndpoint = class extends BaseMetorialEndpoint5 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List files
   * @description Retrieve a list of all files currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `query` - ManagementInstancesFilesListQuery
   *
   * @returns ManagementInstancesFilesListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query) {
    return this._get({
      path: ["files"],
      query: query ? mapManagementInstancesFilesListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesFilesListOutput);
  }
  /**
   * @name Get file
   * @description Retrieve a specific file by its ID.
   *
   * @param `fileId` - string
   *
   * @returns ManagementInstancesFilesGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(fileId) {
    return this._get({
      path: ["files", fileId]
    }).transform(mapManagementInstancesFilesGetOutput);
  }
};

// src/endpoints/groups-blocks.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint6
} from "@metorial/util-endpoint";
var MetorialGroupsBlocksEndpoint = class extends BaseMetorialEndpoint6 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List group blocks
   * @description Retrieve a list of all group blocks currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `query` - ManagementInstancesGroupsBlocksListQuery
   *
   * @returns ManagementInstancesGroupsBlocksListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query) {
    return this._delete({
      path: ["group_blocks"],
      query: query ? mapManagementInstancesGroupsBlocksListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesGroupsBlocksListOutput);
  }
  /**
   * @name Get group block
   * @description Retrieve a specific group block by its ID.
   *
   * @param `groupBlockId` - string
   *
   * @returns ManagementInstancesGroupsBlocksGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(groupBlockId) {
    return this._get({
      path: ["group_blocks", groupBlockId]
    }).transform(mapManagementInstancesGroupsBlocksGetOutput);
  }
  /**
   * @name Delete group block
   * @description Delete a specific group block by its ID.
   *
   * @param `groupBlockId` - string
   *
   * @returns ManagementInstancesGroupsBlocksDeleteOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(groupBlockId) {
    return this._delete({
      path: ["group_blocks", groupBlockId]
    }).transform(mapManagementInstancesGroupsBlocksDeleteOutput);
  }
};

// src/endpoints/groups-threads.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint7
} from "@metorial/util-endpoint";
var MetorialGroupsThreadsEndpoint = class extends BaseMetorialEndpoint7 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List group threads
   * @description Retrieve a list of all group threads currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `query` - ManagementInstancesGroupsThreadsListQuery
   *
   * @returns ManagementInstancesGroupsThreadsListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query) {
    return this._get({
      path: ["group_threads"],
      query: query ? mapManagementInstancesGroupsThreadsListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesGroupsThreadsListOutput);
  }
  /**
   * @name Get group thread
   * @description Retrieve a specific group thread by its ID.
   *
   * @param `groupThreadId` - string
   *
   * @returns ManagementInstancesGroupsThreadsGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(groupThreadId) {
    return this._get({
      path: ["group_threads", groupThreadId]
    }).transform(mapManagementInstancesGroupsThreadsGetOutput);
  }
  /**
   * @name Create group thread
   * @description Create a new group thread.
   *
   * @param `body` - ManagementInstancesGroupsThreadsCreateBody
   *
   * @returns ManagementInstancesGroupsThreadsCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body) {
    return this._post({
      path: ["group_threads"],
      body: mapManagementInstancesGroupsThreadsCreateBody.transformTo(body)
    }).transform(mapManagementInstancesGroupsThreadsCreateOutput);
  }
  /**
   * @name Delete group thread
   * @description Delete a specific group thread by its ID.
   *
   * @param `groupThreadId` - string
   *
   * @returns ManagementInstancesGroupsThreadsDeleteOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(groupThreadId) {
    return this._delete({
      path: ["group_threads", groupThreadId]
    }).transform(mapManagementInstancesGroupsThreadsDeleteOutput);
  }
};

// src/endpoints/groups-users.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint8
} from "@metorial/util-endpoint";
var MetorialGroupsUsersEndpoint = class extends BaseMetorialEndpoint8 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List group users
   * @description Retrieve a list of all group users currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `query` - ManagementInstancesGroupsUsersListQuery
   *
   * @returns ManagementInstancesGroupsUsersListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query) {
    return this._get({
      path: ["groups_users"],
      query: query ? mapManagementInstancesGroupsUsersListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesGroupsUsersListOutput);
  }
  /**
   * @name Get group user
   * @description Retrieve a specific group user by its ID.
   *
   * @param `groupUserId` - string
   *
   * @returns ManagementInstancesGroupsUsersGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(groupUserId) {
    return this._get({
      path: ["groups_users", groupUserId]
    }).transform(mapManagementInstancesGroupsUsersGetOutput);
  }
  /**
   * @name Create group user
   * @description Create a new group user.
   *
   * @param `body` - ManagementInstancesGroupsUsersCreateBody
   *
   * @returns ManagementInstancesGroupsUsersCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body) {
    return this._post({
      path: ["groups_users"],
      body: mapManagementInstancesGroupsUsersCreateBody.transformTo(body)
    }).transform(mapManagementInstancesGroupsUsersCreateOutput);
  }
  /**
   * @name Update group user
   * @description Update an existing group user.
   *
   * @param `groupUserId` - string
   * @param `body` - ManagementInstancesGroupsUsersUpdateBody
   *
   * @returns ManagementInstancesGroupsUsersUpdateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(groupUserId, body) {
    return this._patch({
      path: ["groups_users", groupUserId],
      body: mapManagementInstancesGroupsUsersUpdateBody.transformTo(body)
    }).transform(mapManagementInstancesGroupsUsersUpdateOutput);
  }
  /**
   * @name Delete group user
   * @description Delete a specific group user by its ID.
   *
   * @param `groupUserId` - string
   *
   * @returns ManagementInstancesGroupsUsersDeleteOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(groupUserId) {
    return this._delete({
      path: ["groups_users", groupUserId]
    }).transform(mapManagementInstancesGroupsUsersDeleteOutput);
  }
};

// src/endpoints/groups.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint9
} from "@metorial/util-endpoint";
var MetorialGroupsEndpoint = class extends BaseMetorialEndpoint9 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List groups
   * @description Retrieve a list of all groups currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `query` - ManagementInstancesGroupsListQuery
   *
   * @returns ManagementInstancesGroupsListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query) {
    return this._get({
      path: ["groups"],
      query: query ? mapManagementInstancesGroupsListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesGroupsListOutput);
  }
  /**
   * @name Get group
   * @description Retrieve a specific group by its ID.
   *
   * @param `groupId` - string
   *
   * @returns ManagementInstancesGroupsGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(groupId) {
    return this._get({
      path: ["groups", groupId]
    }).transform(mapManagementInstancesGroupsGetOutput);
  }
  /**
   * @name Create group
   * @description Create a new group.
   *
   * @param `body` - ManagementInstancesGroupsCreateBody
   *
   * @returns ManagementInstancesGroupsCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body) {
    return this._post({
      path: ["groups"],
      body: mapManagementInstancesGroupsCreateBody.transformTo(body)
    }).transform(mapManagementInstancesGroupsCreateOutput);
  }
  /**
   * @name Update group
   * @description Update an existing group.
   *
   * @param `groupId` - string
   * @param `body` - ManagementInstancesGroupsUpdateBody
   *
   * @returns ManagementInstancesGroupsUpdateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(groupId, body) {
    return this._patch({
      path: ["groups", groupId],
      body: mapManagementInstancesGroupsUpdateBody.transformTo(body)
    }).transform(mapManagementInstancesGroupsUpdateOutput);
  }
  /**
   * @name Delete group
   * @description Delete a specific group by its ID.
   *
   * @param `groupId` - string
   *
   * @returns ManagementInstancesGroupsDeleteOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(groupId) {
    return this._delete({
      path: ["groups", groupId]
    }).transform(mapManagementInstancesGroupsDeleteOutput);
  }
};

// src/endpoints/instance.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint10
} from "@metorial/util-endpoint";
var MetorialInstanceEndpoint = class extends BaseMetorialEndpoint10 {
  constructor(config) {
    super(config);
  }
  /**
   * @name Get instance
   * @description Retrieve the current instance information.
   *
   * @param
   *
   * @returns ManagementInstancesInstanceGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get() {
    return this._get({
      path: ["instance"]
    }).transform(mapManagementInstancesInstanceGetOutput);
  }
};

// src/endpoints/management-instances-actors.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint11
} from "@metorial/util-endpoint";
var MetorialManagementInstancesActorsEndpoint = class extends BaseMetorialEndpoint11 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List actors
   * @description Retrieve a list of all actors currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `instanceId` - string
   * @param `query` - ManagementInstancesActorsListQuery
   *
   * @returns ManagementInstancesActorsListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query) {
    return this._get({
      path: ["management", "instances", instanceId, "actors"],
      query: query ? mapManagementInstancesActorsListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesActorsListOutput);
  }
  /**
   * @name Get actor
   * @description Retrieve a specific actor by its ID.
   *
   * @param `instanceId` - string
   * @param `actorId` - string
   *
   * @returns ManagementInstancesActorsGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, actorId) {
    return this._get({
      path: ["management", "instances", instanceId, "actors", actorId]
    }).transform(mapManagementInstancesActorsGetOutput);
  }
};

// src/endpoints/management-instances-agents.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint12
} from "@metorial/util-endpoint";
var MetorialManagementInstancesAgentsEndpoint = class extends BaseMetorialEndpoint12 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List agents
   * @description Retrieve a list of all agents currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `instanceId` - string
   * @param `query` - ManagementInstancesAgentsListQuery
   *
   * @returns ManagementInstancesAgentsListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query) {
    return this._get({
      path: ["management", "instances", instanceId, "agents"],
      query: query ? mapManagementInstancesAgentsListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesAgentsListOutput);
  }
  /**
   * @name Get agent
   * @description Retrieve a specific agent by its ID.
   *
   * @param `instanceId` - string
   * @param `agentId` - string
   *
   * @returns ManagementInstancesAgentsGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, agentId) {
    return this._get({
      path: ["management", "instances", instanceId, "agents", agentId]
    }).transform(mapManagementInstancesAgentsGetOutput);
  }
};

// src/endpoints/management-instances-client-tokens-jwks.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint13
} from "@metorial/util-endpoint";
var MetorialManagementInstancesClientTokensJwksEndpoint = class extends BaseMetorialEndpoint13 {
  constructor(config) {
    super(config);
  }
  /**
   * @name Get JWKs
   * @description Retrieve the JWKs you can use to sign your own client tokens.
   *
   * @param `instanceId` - string
   *
   * @returns ManagementInstancesClientTokensJwksListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId) {
    return this._get({
      path: ["management", "instances", instanceId, "client_tokens", "jwks"]
    }).transform(mapManagementInstancesClientTokensJwksListOutput);
  }
};

// src/endpoints/management-instances-files-links.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint14
} from "@metorial/util-endpoint";
var MetorialManagementInstancesFilesLinksEndpoint = class extends BaseMetorialEndpoint14 {
  constructor(config) {
    super(config);
  }
  /**
   * @name Create file link
   * @description Create a link to a specific file.
   *
   * @param `instanceId` - string
   * @param `fileId` - string
   *
   * @returns ManagementInstancesFilesLinksCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, fileId) {
    return this._post({
      path: ["management", "instances", instanceId, "files", fileId, "links"]
    }).transform(mapManagementInstancesFilesLinksCreateOutput);
  }
};

// src/endpoints/management-instances-files.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint15
} from "@metorial/util-endpoint";
var MetorialManagementInstancesFilesEndpoint = class extends BaseMetorialEndpoint15 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List files
   * @description Retrieve a list of all files currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `instanceId` - string
   * @param `query` - ManagementInstancesFilesListQuery
   *
   * @returns ManagementInstancesFilesListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query) {
    return this._get({
      path: ["management", "instances", instanceId, "files"],
      query: query ? mapManagementInstancesFilesListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesFilesListOutput);
  }
  /**
   * @name Get file
   * @description Retrieve a specific file by its ID.
   *
   * @param `instanceId` - string
   * @param `fileId` - string
   *
   * @returns ManagementInstancesFilesGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, fileId) {
    return this._get({
      path: ["management", "instances", instanceId, "files", fileId]
    }).transform(mapManagementInstancesFilesGetOutput);
  }
};

// src/endpoints/management-instances-groups-blocks.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint16
} from "@metorial/util-endpoint";
var MetorialManagementInstancesGroupsBlocksEndpoint = class extends BaseMetorialEndpoint16 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List group blocks
   * @description Retrieve a list of all group blocks currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `instanceId` - string
   * @param `query` - ManagementInstancesGroupsBlocksListQuery
   *
   * @returns ManagementInstancesGroupsBlocksListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query) {
    return this._delete({
      path: ["management", "instances", instanceId, "group_blocks"],
      query: query ? mapManagementInstancesGroupsBlocksListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesGroupsBlocksListOutput);
  }
  /**
   * @name Get group block
   * @description Retrieve a specific group block by its ID.
   *
   * @param `instanceId` - string
   * @param `groupBlockId` - string
   *
   * @returns ManagementInstancesGroupsBlocksGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, groupBlockId) {
    return this._get({
      path: [
        "management",
        "instances",
        instanceId,
        "group_blocks",
        groupBlockId
      ]
    }).transform(mapManagementInstancesGroupsBlocksGetOutput);
  }
  /**
   * @name Delete group block
   * @description Delete a specific group block by its ID.
   *
   * @param `instanceId` - string
   * @param `groupBlockId` - string
   *
   * @returns ManagementInstancesGroupsBlocksDeleteOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, groupBlockId) {
    return this._delete({
      path: [
        "management",
        "instances",
        instanceId,
        "group_blocks",
        groupBlockId
      ]
    }).transform(mapManagementInstancesGroupsBlocksDeleteOutput);
  }
};

// src/endpoints/management-instances-groups-threads.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint17
} from "@metorial/util-endpoint";
var MetorialManagementInstancesGroupsThreadsEndpoint = class extends BaseMetorialEndpoint17 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List group threads
   * @description Retrieve a list of all group threads currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `instanceId` - string
   * @param `query` - ManagementInstancesGroupsThreadsListQuery
   *
   * @returns ManagementInstancesGroupsThreadsListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query) {
    return this._get({
      path: ["management", "instances", instanceId, "group_threads"],
      query: query ? mapManagementInstancesGroupsThreadsListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesGroupsThreadsListOutput);
  }
  /**
   * @name Get group thread
   * @description Retrieve a specific group thread by its ID.
   *
   * @param `instanceId` - string
   * @param `groupThreadId` - string
   *
   * @returns ManagementInstancesGroupsThreadsGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, groupThreadId) {
    return this._get({
      path: [
        "management",
        "instances",
        instanceId,
        "group_threads",
        groupThreadId
      ]
    }).transform(mapManagementInstancesGroupsThreadsGetOutput);
  }
  /**
   * @name Create group thread
   * @description Create a new group thread.
   *
   * @param `instanceId` - string
   * @param `body` - ManagementInstancesGroupsThreadsCreateBody
   *
   * @returns ManagementInstancesGroupsThreadsCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body) {
    return this._post({
      path: ["management", "instances", instanceId, "group_threads"],
      body: mapManagementInstancesGroupsThreadsCreateBody.transformTo(body)
    }).transform(mapManagementInstancesGroupsThreadsCreateOutput);
  }
  /**
   * @name Delete group thread
   * @description Delete a specific group thread by its ID.
   *
   * @param `instanceId` - string
   * @param `groupThreadId` - string
   *
   * @returns ManagementInstancesGroupsThreadsDeleteOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, groupThreadId) {
    return this._delete({
      path: [
        "management",
        "instances",
        instanceId,
        "group_threads",
        groupThreadId
      ]
    }).transform(mapManagementInstancesGroupsThreadsDeleteOutput);
  }
};

// src/endpoints/management-instances-groups-users.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint18
} from "@metorial/util-endpoint";
var MetorialManagementInstancesGroupsUsersEndpoint = class extends BaseMetorialEndpoint18 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List group users
   * @description Retrieve a list of all group users currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `instanceId` - string
   * @param `query` - ManagementInstancesGroupsUsersListQuery
   *
   * @returns ManagementInstancesGroupsUsersListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query) {
    return this._get({
      path: ["management", "instances", instanceId, "groups_users"],
      query: query ? mapManagementInstancesGroupsUsersListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesGroupsUsersListOutput);
  }
  /**
   * @name Get group user
   * @description Retrieve a specific group user by its ID.
   *
   * @param `instanceId` - string
   * @param `groupUserId` - string
   *
   * @returns ManagementInstancesGroupsUsersGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, groupUserId) {
    return this._get({
      path: ["management", "instances", instanceId, "groups_users", groupUserId]
    }).transform(mapManagementInstancesGroupsUsersGetOutput);
  }
  /**
   * @name Create group user
   * @description Create a new group user.
   *
   * @param `instanceId` - string
   * @param `body` - ManagementInstancesGroupsUsersCreateBody
   *
   * @returns ManagementInstancesGroupsUsersCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body) {
    return this._post({
      path: ["management", "instances", instanceId, "groups_users"],
      body: mapManagementInstancesGroupsUsersCreateBody.transformTo(body)
    }).transform(mapManagementInstancesGroupsUsersCreateOutput);
  }
  /**
   * @name Update group user
   * @description Update an existing group user.
   *
   * @param `instanceId` - string
   * @param `groupUserId` - string
   * @param `body` - ManagementInstancesGroupsUsersUpdateBody
   *
   * @returns ManagementInstancesGroupsUsersUpdateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, groupUserId, body) {
    return this._patch({
      path: [
        "management",
        "instances",
        instanceId,
        "groups_users",
        groupUserId
      ],
      body: mapManagementInstancesGroupsUsersUpdateBody.transformTo(body)
    }).transform(mapManagementInstancesGroupsUsersUpdateOutput);
  }
  /**
   * @name Delete group user
   * @description Delete a specific group user by its ID.
   *
   * @param `instanceId` - string
   * @param `groupUserId` - string
   *
   * @returns ManagementInstancesGroupsUsersDeleteOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, groupUserId) {
    return this._delete({
      path: ["management", "instances", instanceId, "groups_users", groupUserId]
    }).transform(mapManagementInstancesGroupsUsersDeleteOutput);
  }
};

// src/endpoints/management-instances-groups.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint19
} from "@metorial/util-endpoint";
var MetorialManagementInstancesGroupsEndpoint = class extends BaseMetorialEndpoint19 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List groups
   * @description Retrieve a list of all groups currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `instanceId` - string
   * @param `query` - ManagementInstancesGroupsListQuery
   *
   * @returns ManagementInstancesGroupsListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query) {
    return this._get({
      path: ["management", "instances", instanceId, "groups"],
      query: query ? mapManagementInstancesGroupsListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesGroupsListOutput);
  }
  /**
   * @name Get group
   * @description Retrieve a specific group by its ID.
   *
   * @param `instanceId` - string
   * @param `groupId` - string
   *
   * @returns ManagementInstancesGroupsGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, groupId) {
    return this._get({
      path: ["management", "instances", instanceId, "groups", groupId]
    }).transform(mapManagementInstancesGroupsGetOutput);
  }
  /**
   * @name Create group
   * @description Create a new group.
   *
   * @param `instanceId` - string
   * @param `body` - ManagementInstancesGroupsCreateBody
   *
   * @returns ManagementInstancesGroupsCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body) {
    return this._post({
      path: ["management", "instances", instanceId, "groups"],
      body: mapManagementInstancesGroupsCreateBody.transformTo(body)
    }).transform(mapManagementInstancesGroupsCreateOutput);
  }
  /**
   * @name Update group
   * @description Update an existing group.
   *
   * @param `instanceId` - string
   * @param `groupId` - string
   * @param `body` - ManagementInstancesGroupsUpdateBody
   *
   * @returns ManagementInstancesGroupsUpdateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, groupId, body) {
    return this._patch({
      path: ["management", "instances", instanceId, "groups", groupId],
      body: mapManagementInstancesGroupsUpdateBody.transformTo(body)
    }).transform(mapManagementInstancesGroupsUpdateOutput);
  }
  /**
   * @name Delete group
   * @description Delete a specific group by its ID.
   *
   * @param `instanceId` - string
   * @param `groupId` - string
   *
   * @returns ManagementInstancesGroupsDeleteOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, groupId) {
    return this._delete({
      path: ["management", "instances", instanceId, "groups", groupId]
    }).transform(mapManagementInstancesGroupsDeleteOutput);
  }
};

// src/endpoints/management-instances-instance.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint20
} from "@metorial/util-endpoint";
var MetorialManagementInstancesInstanceEndpoint = class extends BaseMetorialEndpoint20 {
  constructor(config) {
    super(config);
  }
  /**
   * @name Get instance
   * @description Retrieve the current instance information.
   *
   * @param `instanceId` - string
   *
   * @returns ManagementInstancesInstanceGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId) {
    return this._get({
      path: ["management", "instances", instanceId, "instance"]
    }).transform(mapManagementInstancesInstanceGetOutput);
  }
};

// src/endpoints/management-instances-policies-entitlements.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint21
} from "@metorial/util-endpoint";
var MetorialManagementInstancesPoliciesEntitlementsEndpoint = class extends BaseMetorialEndpoint21 {
  constructor(config) {
    super(config);
  }
  /**
   * @name Create policy entitlement
   * @description Create a new policy entitlement.
   *
   * @param `instanceId` - string
   * @param `policyId` - string
   * @param `body` - ManagementInstancesPoliciesEntitlementsCreateBody
   *
   * @returns ManagementInstancesPoliciesEntitlementsCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, policyId, body) {
    return this._post({
      path: [
        "management",
        "instances",
        instanceId,
        "policies",
        policyId,
        "entitlement"
      ],
      body: mapManagementInstancesPoliciesEntitlementsCreateBody.transformTo(
        body
      )
    }).transform(mapManagementInstancesPoliciesEntitlementsCreateOutput);
  }
  /**
   * @name Update policy entitlement
   * @description Update an existing policy entitlement.
   *
   * @param `instanceId` - string
   * @param `policyId` - string
   * @param `entitlementId` - string
   * @param `body` - ManagementInstancesPoliciesEntitlementsUpdateBody
   *
   * @returns ManagementInstancesPoliciesEntitlementsUpdateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, policyId, entitlementId, body) {
    return this._patch({
      path: [
        "management",
        "instances",
        instanceId,
        "policies",
        policyId,
        "entitlements",
        entitlementId
      ],
      body: mapManagementInstancesPoliciesEntitlementsUpdateBody.transformTo(
        body
      )
    }).transform(mapManagementInstancesPoliciesEntitlementsUpdateOutput);
  }
  /**
   * @name Delete policy entitlement
   * @description Delete a specific policy entitlement by its ID.
   *
   * @param `instanceId` - string
   * @param `policyId` - string
   * @param `entitlementId` - string
   *
   * @returns ManagementInstancesPoliciesEntitlementsDeleteOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, policyId, entitlementId) {
    return this._delete({
      path: [
        "management",
        "instances",
        instanceId,
        "policies",
        policyId,
        "entitlement",
        entitlementId
      ]
    }).transform(mapManagementInstancesPoliciesEntitlementsDeleteOutput);
  }
};

// src/endpoints/management-instances-policies.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint22
} from "@metorial/util-endpoint";
var MetorialManagementInstancesPoliciesEndpoint = class extends BaseMetorialEndpoint22 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List policies
   * @description Retrieve a list of all policies currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `instanceId` - string
   * @param `query` - ManagementInstancesPoliciesListQuery
   *
   * @returns ManagementInstancesPoliciesListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query) {
    return this._get({
      path: ["management", "instances", instanceId, "policies"],
      query: query ? mapManagementInstancesPoliciesListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesPoliciesListOutput);
  }
  /**
   * @name Get policy
   * @description Retrieve a specific policy by its ID.
   *
   * @param `instanceId` - string
   * @param `policyId` - string
   *
   * @returns ManagementInstancesPoliciesGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, policyId) {
    return this._get({
      path: ["management", "instances", instanceId, "policies", policyId]
    }).transform(mapManagementInstancesPoliciesGetOutput);
  }
  /**
   * @name Create policy
   * @description Create a new policy.
   *
   * @param `instanceId` - string
   * @param `body` - ManagementInstancesPoliciesCreateBody
   *
   * @returns ManagementInstancesPoliciesCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body) {
    return this._post({
      path: ["management", "instances", instanceId, "policies"],
      body: mapManagementInstancesPoliciesCreateBody.transformTo(body)
    }).transform(mapManagementInstancesPoliciesCreateOutput);
  }
  /**
   * @name Update policy
   * @description Update an existing policy.
   *
   * @param `instanceId` - string
   * @param `policyId` - string
   * @param `body` - ManagementInstancesPoliciesUpdateBody
   *
   * @returns ManagementInstancesPoliciesUpdateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, policyId, body) {
    return this._patch({
      path: ["management", "instances", instanceId, "policies", policyId],
      body: mapManagementInstancesPoliciesUpdateBody.transformTo(body)
    }).transform(mapManagementInstancesPoliciesUpdateOutput);
  }
};

// src/endpoints/management-instances-portals-agents.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint23
} from "@metorial/util-endpoint";
var MetorialManagementInstancesPortalsAgentsEndpoint = class extends BaseMetorialEndpoint23 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List portal agents
   * @description Retrieve a list of all portal agents currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `query` - ManagementInstancesPortalsAgentsListQuery
   *
   * @returns ManagementInstancesPortalsAgentsListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, portalId, query) {
    return this._get({
      path: [
        "management",
        "instances",
        instanceId,
        "portals",
        portalId,
        "portal-agents"
      ],
      query: query ? mapManagementInstancesPortalsAgentsListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesPortalsAgentsListOutput);
  }
  /**
   * @name Get portal agent
   * @description Retrieve a specific portal agent by its ID.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `portalAgentId` - string
   *
   * @returns ManagementInstancesPortalsAgentsGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, portalId, portalAgentId) {
    return this._get({
      path: [
        "management",
        "instances",
        instanceId,
        "portals",
        portalId,
        "portal-agents",
        portalAgentId
      ]
    }).transform(mapManagementInstancesPortalsAgentsGetOutput);
  }
  /**
   * @name Create portal agent
   * @description Create a new portal agent.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `body` - ManagementInstancesPortalsAgentsCreateBody
   *
   * @returns ManagementInstancesPortalsAgentsCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, portalId, body) {
    return this._post({
      path: [
        "management",
        "instances",
        instanceId,
        "portals",
        portalId,
        "portal-agents"
      ],
      body: mapManagementInstancesPortalsAgentsCreateBody.transformTo(body)
    }).transform(mapManagementInstancesPortalsAgentsCreateOutput);
  }
  /**
   * @name Update portal agent
   * @description Update an existing portal agent.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `portalAgentId` - string
   * @param `body` - ManagementInstancesPortalsAgentsUpdateBody
   *
   * @returns ManagementInstancesPortalsAgentsUpdateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, portalId, portalAgentId, body) {
    return this._patch({
      path: [
        "management",
        "instances",
        instanceId,
        "portals",
        portalId,
        "portal-agents",
        portalAgentId
      ],
      body: mapManagementInstancesPortalsAgentsUpdateBody.transformTo(body)
    }).transform(mapManagementInstancesPortalsAgentsUpdateOutput);
  }
  /**
   * @name Delete portal agent
   * @description Delete a specific portal agent by its ID.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `portalAgentId` - string
   *
   * @returns ManagementInstancesPortalsAgentsDeleteOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, portalId, portalAgentId) {
    return this._delete({
      path: [
        "management",
        "instances",
        instanceId,
        "portals",
        portalId,
        "portal-agents",
        portalAgentId
      ]
    }).transform(mapManagementInstancesPortalsAgentsDeleteOutput);
  }
};

// src/endpoints/management-instances-portals.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint24
} from "@metorial/util-endpoint";
var MetorialManagementInstancesPortalsEndpoint = class extends BaseMetorialEndpoint24 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List portals
   * @description Retrieve a list of all portals currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `instanceId` - string
   * @param `query` - ManagementInstancesPortalsListQuery
   *
   * @returns ManagementInstancesPortalsListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query) {
    return this._get({
      path: ["management", "instances", instanceId, "portals"],
      query: query ? mapManagementInstancesPortalsListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesPortalsListOutput);
  }
  /**
   * @name Get portal
   * @description Retrieve a specific portal by its ID.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   *
   * @returns ManagementInstancesPortalsGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, portalId) {
    return this._get({
      path: ["management", "instances", instanceId, "portals", portalId]
    }).transform(mapManagementInstancesPortalsGetOutput);
  }
  /**
   * @name Create portal
   * @description Create a new portal.
   *
   * @param `instanceId` - string
   * @param `body` - ManagementInstancesPortalsCreateBody
   *
   * @returns ManagementInstancesPortalsCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body) {
    return this._post({
      path: ["management", "instances", instanceId, "portals"],
      body: mapManagementInstancesPortalsCreateBody.transformTo(body)
    }).transform(mapManagementInstancesPortalsCreateOutput);
  }
  /**
   * @name Update portal
   * @description Update an existing portal.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   * @param `body` - ManagementInstancesPortalsUpdateBody
   *
   * @returns ManagementInstancesPortalsUpdateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, portalId, body) {
    return this._patch({
      path: ["management", "instances", instanceId, "portals", portalId],
      body: mapManagementInstancesPortalsUpdateBody.transformTo(body)
    }).transform(mapManagementInstancesPortalsUpdateOutput);
  }
  /**
   * @name Delete portal
   * @description Delete a specific portal by its ID.
   *
   * @param `instanceId` - string
   * @param `portalId` - string
   *
   * @returns ManagementInstancesPortalsDeleteOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, portalId) {
    return this._delete({
      path: ["management", "instances", instanceId, "portals", portalId]
    }).transform(mapManagementInstancesPortalsDeleteOutput);
  }
};

// src/endpoints/management-instances-roles.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint25
} from "@metorial/util-endpoint";
var MetorialManagementInstancesRolesEndpoint = class extends BaseMetorialEndpoint25 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List roles
   * @description Retrieve a list of all roles currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `instanceId` - string
   * @param `query` - ManagementInstancesRolesListQuery
   *
   * @returns ManagementInstancesRolesListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query) {
    return this._get({
      path: ["management", "instances", instanceId, "roles"],
      query: query ? mapManagementInstancesRolesListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesRolesListOutput);
  }
  /**
   * @name Get role
   * @description Retrieve a specific role by its ID.
   *
   * @param `instanceId` - string
   * @param `roleId` - string
   *
   * @returns ManagementInstancesRolesGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, roleId) {
    return this._get({
      path: ["management", "instances", instanceId, "roles", roleId]
    }).transform(mapManagementInstancesRolesGetOutput);
  }
  /**
   * @name Create role
   * @description Create a new role.
   *
   * @param `instanceId` - string
   * @param `body` - ManagementInstancesRolesCreateBody
   *
   * @returns ManagementInstancesRolesCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body) {
    return this._post({
      path: ["management", "instances", instanceId, "roles"],
      body: mapManagementInstancesRolesCreateBody.transformTo(body)
    }).transform(mapManagementInstancesRolesCreateOutput);
  }
  /**
   * @name Update role
   * @description Update an existing role.
   *
   * @param `instanceId` - string
   * @param `roleId` - string
   * @param `body` - ManagementInstancesRolesUpdateBody
   *
   * @returns ManagementInstancesRolesUpdateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, roleId, body) {
    return this._patch({
      path: ["management", "instances", instanceId, "roles", roleId],
      body: mapManagementInstancesRolesUpdateBody.transformTo(body)
    }).transform(mapManagementInstancesRolesUpdateOutput);
  }
};

// src/endpoints/management-instances-runs.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint26
} from "@metorial/util-endpoint";
var MetorialManagementInstancesRunsEndpoint = class extends BaseMetorialEndpoint26 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List runs
   * @description Retrieve a list of all runs currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `instanceId` - string
   * @param `query` - ManagementInstancesRunsListQuery
   *
   * @returns ManagementInstancesRunsListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query) {
    return this._get({
      path: ["management", "instances", instanceId, "runs"],
      query: query ? mapManagementInstancesRunsListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesRunsListOutput);
  }
  /**
   * @name Create run
   * @description Create a new run.
   *
   * @param `instanceId` - string
   * @param `body` - ManagementInstancesRunsCreateBody
   *
   * @returns ManagementInstancesRunsCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body) {
    return this._post({
      path: ["management", "instances", instanceId, "runs"],
      body: mapManagementInstancesRunsCreateBody.transformTo(body)
    }).transform(mapManagementInstancesRunsCreateOutput);
  }
  /**
   * @name Get run
   * @description Retrieve a specific run by its ID.
   *
   * @param `instanceId` - string
   * @param `runId` - string
   *
   * @returns ManagementInstancesRunsGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, runId) {
    return this._get({
      path: ["management", "instances", instanceId, "runs", runId]
    }).transform(mapManagementInstancesRunsGetOutput);
  }
};

// src/endpoints/management-instances-threads-messages.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint27
} from "@metorial/util-endpoint";
var MetorialManagementInstancesThreadsMessagesEndpoint = class extends BaseMetorialEndpoint27 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List messages
   * @description Retrieve a list of all messages currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `instanceId` - string
   * @param `threadId` - string
   * @param `query` - ManagementInstancesThreadsMessagesListQuery
   *
   * @returns ManagementInstancesThreadsMessagesListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, threadId, query) {
    return this._get({
      path: [
        "management",
        "instances",
        instanceId,
        "threads",
        threadId,
        "messages"
      ],
      query: query ? mapManagementInstancesThreadsMessagesListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesThreadsMessagesListOutput);
  }
  /**
   * @name Create message
   * @description Create a new message.
   *
   * @param `instanceId` - string
   * @param `threadId` - string
   * @param `body` - ManagementInstancesThreadsMessagesCreateBody
   *
   * @returns ManagementInstancesThreadsMessagesCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, threadId, body) {
    return this._post({
      path: [
        "management",
        "instances",
        instanceId,
        "threads",
        threadId,
        "messages"
      ],
      body: mapManagementInstancesThreadsMessagesCreateBody.transformTo(body)
    }).transform(mapManagementInstancesThreadsMessagesCreateOutput);
  }
  /**
   * @name Get message
   * @description Retrieve a specific message by its ID.
   *
   * @param `instanceId` - string
   * @param `threadId` - string
   * @param `messageId` - string
   *
   * @returns ManagementInstancesThreadsMessagesGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, threadId, messageId) {
    return this._get({
      path: [
        "management",
        "instances",
        instanceId,
        "threads",
        threadId,
        "messages",
        messageId
      ]
    }).transform(mapManagementInstancesThreadsMessagesGetOutput);
  }
};

// src/endpoints/management-instances-threads-participants.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint28
} from "@metorial/util-endpoint";
var MetorialManagementInstancesThreadsParticipantsEndpoint = class extends BaseMetorialEndpoint28 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List thread participants
   * @description Retrieve a list of all participants in a specific thread.
   *
   * @param `instanceId` - string
   * @param `threadId` - string
   * @param `query` - ManagementInstancesThreadsParticipantsListQuery
   *
   * @returns ManagementInstancesThreadsParticipantsListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, threadId, query) {
    return this._get({
      path: [
        "management",
        "instances",
        instanceId,
        "threads",
        threadId,
        "participants"
      ],
      query: query ? mapManagementInstancesThreadsParticipantsListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesThreadsParticipantsListOutput);
  }
};

// src/endpoints/management-instances-threads.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint29
} from "@metorial/util-endpoint";
var MetorialManagementInstancesThreadsEndpoint = class extends BaseMetorialEndpoint29 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List threads
   * @description Retrieve a list of all threads currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `instanceId` - string
   * @param `query` - ManagementInstancesThreadsListQuery
   *
   * @returns ManagementInstancesThreadsListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query) {
    return this._get({
      path: ["management", "instances", instanceId, "threads"],
      query: query ? mapManagementInstancesThreadsListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesThreadsListOutput);
  }
  /**
   * @name Get thread
   * @description Retrieve a specific thread by its ID.
   *
   * @param `instanceId` - string
   * @param `threadId` - string
   *
   * @returns ManagementInstancesThreadsGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, threadId) {
    return this._get({
      path: ["management", "instances", instanceId, "threads", threadId]
    }).transform(mapManagementInstancesThreadsGetOutput);
  }
  /**
   * @name Create thread
   * @description Create a new thread.
   *
   * @param `instanceId` - string
   * @param `body` - ManagementInstancesThreadsCreateBody
   *
   * @returns ManagementInstancesThreadsCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body) {
    return this._post({
      path: ["management", "instances", instanceId, "threads"],
      body: mapManagementInstancesThreadsCreateBody.transformTo(body)
    }).transform(mapManagementInstancesThreadsCreateOutput);
  }
  /**
   * @name Update thread
   * @description Update an existing thread.
   *
   * @param `instanceId` - string
   * @param `threadId` - string
   * @param `body` - ManagementInstancesThreadsUpdateBody
   *
   * @returns ManagementInstancesThreadsUpdateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, threadId, body) {
    return this._patch({
      path: ["management", "instances", instanceId, "threads", threadId],
      body: mapManagementInstancesThreadsUpdateBody.transformTo(body)
    }).transform(mapManagementInstancesThreadsUpdateOutput);
  }
  /**
   * @name Delete thread
   * @description Delete a specific thread by its ID.
   *
   * @param `instanceId` - string
   * @param `threadId` - string
   *
   * @returns ManagementInstancesThreadsDeleteOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, threadId) {
    return this._delete({
      path: ["management", "instances", instanceId, "threads", threadId]
    }).transform(mapManagementInstancesThreadsDeleteOutput);
  }
};

// src/endpoints/management-instances-users.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint30
} from "@metorial/util-endpoint";
var MetorialManagementInstancesUsersEndpoint = class extends BaseMetorialEndpoint30 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List users
   * @description Retrieve a list of all users currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `instanceId` - string
   * @param `query` - ManagementInstancesUsersListQuery
   *
   * @returns ManagementInstancesUsersListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(instanceId, query) {
    return this._get({
      path: ["management", "instances", instanceId, "users"],
      query: query ? mapManagementInstancesUsersListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesUsersListOutput);
  }
  /**
   * @name Get user
   * @description Retrieve a specific user by its ID.
   *
   * @param `instanceId` - string
   * @param `userId` - string
   *
   * @returns ManagementInstancesUsersGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(instanceId, userId) {
    return this._get({
      path: ["management", "instances", instanceId, "users", userId]
    }).transform(mapManagementInstancesUsersGetOutput);
  }
  /**
   * @name Create user
   * @description Create a new user.
   *
   * @param `instanceId` - string
   * @param `body` - ManagementInstancesUsersCreateBody
   *
   * @returns ManagementInstancesUsersCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(instanceId, body) {
    return this._post({
      path: ["management", "instances", instanceId, "users"],
      body: mapManagementInstancesUsersCreateBody.transformTo(body)
    }).transform(mapManagementInstancesUsersCreateOutput);
  }
  /**
   * @name Update user
   * @description Update an existing user.
   *
   * @param `instanceId` - string
   * @param `userId` - string
   * @param `body` - ManagementInstancesUsersUpdateBody
   *
   * @returns ManagementInstancesUsersUpdateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(instanceId, userId, body) {
    return this._patch({
      path: ["management", "instances", instanceId, "users", userId],
      body: mapManagementInstancesUsersUpdateBody.transformTo(body)
    }).transform(mapManagementInstancesUsersUpdateOutput);
  }
  /**
   * @name Delete user
   * @description Delete an existing user.
   *
   * @param `instanceId` - string
   * @param `userId` - string
   *
   * @returns ManagementInstancesUsersDeleteOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(instanceId, userId) {
    return this._delete({
      path: ["management", "instances", instanceId, "users", userId]
    }).transform(mapManagementInstancesUsersDeleteOutput);
  }
};

// src/endpoints/management-projects-agents-instance-agents.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint31
} from "@metorial/util-endpoint";
var MetorialManagementProjectsAgentsInstanceAgentsEndpoint = class extends BaseMetorialEndpoint31 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List instance agents
   * @description Retrieve a list of all instance agents for a specific agent.
   *
   * @param `projectId` - string
   * @param `agentId` - string
   * @param `query` - ManagementProjectsAgentsInstanceAgentsListQuery
   *
   * @returns ManagementProjectsAgentsInstanceAgentsListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(projectId, agentId, query) {
    return this._get({
      path: [
        "management",
        "projects",
        projectId,
        "agents",
        agentId,
        "instance-agents"
      ],
      query: query ? mapManagementProjectsAgentsInstanceAgentsListQuery.transformTo(query) : void 0
    }).transform(mapManagementProjectsAgentsInstanceAgentsListOutput);
  }
  /**
   * @name Get instance agent
   * @description Retrieve a specific instance agent for an agent.
   *
   * @param `projectId` - string
   * @param `agentId` - string
   * @param `instanceId` - string
   *
   * @returns ManagementProjectsAgentsInstanceAgentsGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(projectId, agentId, instanceId) {
    return this._get({
      path: [
        "management",
        "projects",
        projectId,
        "agents",
        agentId,
        "instance-agents",
        instanceId
      ]
    }).transform(mapManagementProjectsAgentsInstanceAgentsGetOutput);
  }
};

// src/endpoints/management-projects-agents-releases.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint32
} from "@metorial/util-endpoint";
var MetorialManagementProjectsAgentsReleasesEndpoint = class extends BaseMetorialEndpoint32 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List agent releases
   * @description Retrieve a list of all releases for a specific agent.
   *
   * @param `projectId` - string
   * @param `agentId` - string
   * @param `query` - ManagementProjectsAgentsReleasesListQuery
   *
   * @returns ManagementProjectsAgentsReleasesListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(projectId, agentId, query) {
    return this._get({
      path: [
        "management",
        "projects",
        projectId,
        "agents",
        agentId,
        "releases"
      ],
      query: query ? mapManagementProjectsAgentsReleasesListQuery.transformTo(query) : void 0
    }).transform(mapManagementProjectsAgentsReleasesListOutput);
  }
  /**
   * @name Get agent release
   * @description Retrieve a specific release for an agent.
   *
   * @param `projectId` - string
   * @param `agentId` - string
   * @param `releaseId` - string
   *
   * @returns ManagementProjectsAgentsReleasesGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(projectId, agentId, releaseId) {
    return this._get({
      path: [
        "management",
        "projects",
        projectId,
        "agents",
        agentId,
        "releases",
        releaseId
      ]
    }).transform(mapManagementProjectsAgentsReleasesGetOutput);
  }
};

// src/endpoints/management-projects-agents.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint33
} from "@metorial/util-endpoint";
var MetorialManagementProjectsAgentsEndpoint = class extends BaseMetorialEndpoint33 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List agents
   * @description Retrieve a list of all agents currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `projectId` - string
   * @param `query` - ManagementProjectsAgentsListQuery
   *
   * @returns ManagementProjectsAgentsListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(projectId, query) {
    return this._get({
      path: ["management", "projects", projectId, "agents"],
      query: query ? mapManagementProjectsAgentsListQuery.transformTo(query) : void 0
    }).transform(mapManagementProjectsAgentsListOutput);
  }
  /**
   * @name Get agent
   * @description Retrieve an agent by its ID.
   *
   * @param `projectId` - string
   * @param `agentId` - string
   *
   * @returns ManagementProjectsAgentsGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(projectId, agentId) {
    return this._get({
      path: ["management", "projects", projectId, "agents", agentId]
    }).transform(mapManagementProjectsAgentsGetOutput);
  }
  /**
   * @name Update agent
   * @description Update an agent by its ID.
   *
   * @param `projectId` - string
   * @param `agentId` - string
   * @param `body` - ManagementProjectsAgentsUpdateBody
   *
   * @returns ManagementProjectsAgentsUpdateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(projectId, agentId, body) {
    return this._patch({
      path: ["management", "projects", projectId, "agents", agentId],
      body: mapManagementProjectsAgentsUpdateBody.transformTo(body)
    }).transform(mapManagementProjectsAgentsUpdateOutput);
  }
  /**
   * @name Create agent
   * @description Create a new agent.
   *
   * @param `projectId` - string
   * @param `body` - ManagementProjectsAgentsCreateBody
   *
   * @returns ManagementProjectsAgentsCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(projectId, body) {
    return this._post({
      path: ["management", "projects", projectId, "agents"],
      body: mapManagementProjectsAgentsCreateBody.transformTo(body)
    }).transform(mapManagementProjectsAgentsCreateOutput);
  }
  /**
   * @name Delete agent
   * @description Delete an agent by its ID.
   *
   * @param `projectId` - string
   * @param `agentId` - string
   *
   * @returns ManagementProjectsAgentsDeleteOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(projectId, agentId) {
    return this._delete({
      path: ["management", "projects", projectId, "agents", agentId]
    }).transform(mapManagementProjectsAgentsDeleteOutput);
  }
};

// src/endpoints/management-projects-portals-portal-agents.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint34
} from "@metorial/util-endpoint";
var MetorialManagementProjectsPortalsPortalAgentsEndpoint = class extends BaseMetorialEndpoint34 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List portal agents
   * @description Retrieve a list of all portal agents currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `projectId` - string
   * @param `portalId` - string
   * @param `query` - ManagementProjectsPortalsPortalAgentsListQuery
   *
   * @returns ManagementProjectsPortalsPortalAgentsListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(projectId, portalId, query) {
    return this._get({
      path: [
        "management",
        "projects",
        projectId,
        "portals",
        portalId,
        "portal-agents"
      ],
      query: query ? mapManagementProjectsPortalsPortalAgentsListQuery.transformTo(query) : void 0
    }).transform(mapManagementProjectsPortalsPortalAgentsListOutput);
  }
  /**
   * @name Create portal agent
   * @description Create a new portal agent.
   *
   * @param `projectId` - string
   * @param `portalId` - string
   * @param `body` - ManagementProjectsPortalsPortalAgentsCreateBody
   *
   * @returns ManagementProjectsPortalsPortalAgentsCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(projectId, portalId, body) {
    return this._post({
      path: [
        "management",
        "projects",
        projectId,
        "portals",
        portalId,
        "portal-agents"
      ],
      body: mapManagementProjectsPortalsPortalAgentsCreateBody.transformTo(body)
    }).transform(mapManagementProjectsPortalsPortalAgentsCreateOutput);
  }
  /**
   * @name Get portal agent
   * @description Retrieve a portal agent by its ID.
   *
   * @param `projectId` - string
   * @param `portalId` - string
   * @param `portalAgentId` - string
   *
   * @returns ManagementProjectsPortalsPortalAgentsGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(projectId, portalId, portalAgentId) {
    return this._get({
      path: [
        "management",
        "projects",
        projectId,
        "portals",
        portalId,
        "portal-agents",
        portalAgentId
      ]
    }).transform(mapManagementProjectsPortalsPortalAgentsGetOutput);
  }
  /**
   * @name Update portal agent
   * @description Update a portal agent by its ID.
   *
   * @param `projectId` - string
   * @param `portalId` - string
   * @param `portalAgentId` - string
   * @param `body` - ManagementProjectsPortalsPortalAgentsUpdateBody
   *
   * @returns ManagementProjectsPortalsPortalAgentsUpdateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(projectId, portalId, portalAgentId, body) {
    return this._patch({
      path: [
        "management",
        "projects",
        projectId,
        "portals",
        portalId,
        "portal-agents",
        portalAgentId
      ],
      body: mapManagementProjectsPortalsPortalAgentsUpdateBody.transformTo(body)
    }).transform(mapManagementProjectsPortalsPortalAgentsUpdateOutput);
  }
  /**
   * @name Delete portal agent
   * @description Delete a portal agent by its ID.
   *
   * @param `projectId` - string
   * @param `portalId` - string
   * @param `portalAgentId` - string
   *
   * @returns ManagementProjectsPortalsPortalAgentsDeleteOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(projectId, portalId, portalAgentId) {
    return this._delete({
      path: [
        "management",
        "projects",
        projectId,
        "portals",
        portalId,
        "portal-agents",
        portalAgentId
      ]
    }).transform(mapManagementProjectsPortalsPortalAgentsDeleteOutput);
  }
};

// src/endpoints/management-projects-portals-portal-domains.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint35
} from "@metorial/util-endpoint";
var MetorialManagementProjectsPortalsPortalDomainsEndpoint = class extends BaseMetorialEndpoint35 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List portal domains
   * @description Retrieve a list of all portal domains currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `projectId` - string
   * @param `portalId` - string
   * @param `query` - ManagementProjectsPortalsPortalDomainsListQuery
   *
   * @returns ManagementProjectsPortalsPortalDomainsListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(projectId, portalId, query) {
    return this._get({
      path: [
        "management",
        "projects",
        projectId,
        "portals",
        portalId,
        "portal-domains"
      ],
      query: query ? mapManagementProjectsPortalsPortalDomainsListQuery.transformTo(query) : void 0
    }).transform(mapManagementProjectsPortalsPortalDomainsListOutput);
  }
  /**
   * @name Create portal domain
   * @description Create a new portal domain.
   *
   * @param `projectId` - string
   * @param `portalId` - string
   * @param `body` - ManagementProjectsPortalsPortalDomainsCreateBody
   *
   * @returns ManagementProjectsPortalsPortalDomainsCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(projectId, portalId, body) {
    return this._post({
      path: [
        "management",
        "projects",
        projectId,
        "portals",
        portalId,
        "portal-domains"
      ],
      body: mapManagementProjectsPortalsPortalDomainsCreateBody.transformTo(
        body
      )
    }).transform(mapManagementProjectsPortalsPortalDomainsCreateOutput);
  }
  /**
   * @name Get portal domain
   * @description Retrieve a portal domain by its ID.
   *
   * @param `projectId` - string
   * @param `portalId` - string
   * @param `portalDomainId` - string
   *
   * @returns ManagementProjectsPortalsPortalDomainsGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(projectId, portalId, portalDomainId) {
    return this._get({
      path: [
        "management",
        "projects",
        projectId,
        "portals",
        portalId,
        "portal-domains",
        portalDomainId
      ]
    }).transform(mapManagementProjectsPortalsPortalDomainsGetOutput);
  }
  /**
   * @name Update portal domain
   * @description Update a portal domain by its ID.
   *
   * @param `projectId` - string
   * @param `portalId` - string
   * @param `portalDomainId` - string
   * @param `body` - ManagementProjectsPortalsPortalDomainsUpdateBody
   *
   * @returns ManagementProjectsPortalsPortalDomainsUpdateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(projectId, portalId, portalDomainId, body) {
    return this._patch({
      path: [
        "management",
        "projects",
        projectId,
        "portals",
        portalId,
        "portal-domains",
        portalDomainId
      ],
      body: mapManagementProjectsPortalsPortalDomainsUpdateBody.transformTo(
        body
      )
    }).transform(mapManagementProjectsPortalsPortalDomainsUpdateOutput);
  }
  /**
   * @name Delete portal domain
   * @description Delete a portal domain by its ID.
   *
   * @param `projectId` - string
   * @param `portalId` - string
   * @param `portalDomainId` - string
   *
   * @returns ManagementProjectsPortalsPortalDomainsDeleteOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(projectId, portalId, portalDomainId) {
    return this._delete({
      path: [
        "management",
        "projects",
        projectId,
        "portals",
        portalId,
        "portal-domains",
        portalDomainId
      ]
    }).transform(mapManagementProjectsPortalsPortalDomainsDeleteOutput);
  }
  /**
   * @name Delete portal domain
   * @description Delete a portal domain by its ID.
   *
   * @param `projectId` - string
   * @param `portalId` - string
   * @param `portalDomainId` - string
   *
   * @returns ManagementProjectsPortalsPortalDomainsRecheckOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  recheck(projectId, portalId, portalDomainId) {
    return this._post({
      path: [
        "management",
        "projects",
        projectId,
        "portals",
        portalId,
        "portal-domains",
        portalDomainId,
        "recheck"
      ]
    }).transform(mapManagementProjectsPortalsPortalDomainsRecheckOutput);
  }
};

// src/endpoints/management-projects-portals-portal-environments.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint36
} from "@metorial/util-endpoint";
var MetorialManagementProjectsPortalsPortalEnvironmentsEndpoint = class extends BaseMetorialEndpoint36 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List portal environments
   * @description Retrieve a list of all portal environments currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `projectId` - string
   * @param `portalId` - string
   * @param `query` - ManagementProjectsPortalsPortalEnvironmentsListQuery
   *
   * @returns ManagementProjectsPortalsPortalEnvironmentsListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(projectId, portalId, query) {
    return this._get({
      path: [
        "management",
        "projects",
        projectId,
        "portals",
        portalId,
        "portal-environments"
      ],
      query: query ? mapManagementProjectsPortalsPortalEnvironmentsListQuery.transformTo(
        query
      ) : void 0
    }).transform(mapManagementProjectsPortalsPortalEnvironmentsListOutput);
  }
  /**
   * @name Create portal environment
   * @description Create a new portal environment.
   *
   * @param `projectId` - string
   * @param `portalId` - string
   * @param `body` - ManagementProjectsPortalsPortalEnvironmentsCreateBody
   *
   * @returns ManagementProjectsPortalsPortalEnvironmentsCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(projectId, portalId, body) {
    return this._post({
      path: [
        "management",
        "projects",
        projectId,
        "portals",
        portalId,
        "portal-environments"
      ],
      body: mapManagementProjectsPortalsPortalEnvironmentsCreateBody.transformTo(
        body
      )
    }).transform(mapManagementProjectsPortalsPortalEnvironmentsCreateOutput);
  }
  /**
   * @name Get portal environment
   * @description Retrieve a portal environment by its ID.
   *
   * @param `projectId` - string
   * @param `portalId` - string
   * @param `portalEnvironmentId` - string
   *
   * @returns ManagementProjectsPortalsPortalEnvironmentsGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(projectId, portalId, portalEnvironmentId) {
    return this._get({
      path: [
        "management",
        "projects",
        projectId,
        "portals",
        portalId,
        "portal-environments",
        portalEnvironmentId
      ]
    }).transform(mapManagementProjectsPortalsPortalEnvironmentsGetOutput);
  }
  /**
   * @name Update portal environment
   * @description Update a portal environment by its ID.
   *
   * @param `projectId` - string
   * @param `portalId` - string
   * @param `portalEnvironmentId` - string
   * @param `body` - ManagementProjectsPortalsPortalEnvironmentsUpdateBody
   *
   * @returns ManagementProjectsPortalsPortalEnvironmentsUpdateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(projectId, portalId, portalEnvironmentId, body) {
    return this._patch({
      path: [
        "management",
        "projects",
        projectId,
        "portals",
        portalId,
        "portal-environments",
        portalEnvironmentId
      ],
      body: mapManagementProjectsPortalsPortalEnvironmentsUpdateBody.transformTo(
        body
      )
    }).transform(mapManagementProjectsPortalsPortalEnvironmentsUpdateOutput);
  }
};

// src/endpoints/management-projects-portals.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint37
} from "@metorial/util-endpoint";
var MetorialManagementProjectsPortalsEndpoint = class extends BaseMetorialEndpoint37 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List portals
   * @description Retrieve a list of all portals currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `projectId` - string
   * @param `query` - ManagementProjectsPortalsListQuery
   *
   * @returns ManagementProjectsPortalsListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(projectId, query) {
    return this._get({
      path: ["management", "projects", projectId, "portals"],
      query: query ? mapManagementProjectsPortalsListQuery.transformTo(query) : void 0
    }).transform(mapManagementProjectsPortalsListOutput);
  }
  /**
   * @name Get portal
   * @description Retrieve an portal by its ID.
   *
   * @param `projectId` - string
   * @param `portalId` - string
   *
   * @returns ManagementProjectsPortalsGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(projectId, portalId) {
    return this._get({
      path: ["management", "projects", projectId, "portals", portalId]
    }).transform(mapManagementProjectsPortalsGetOutput);
  }
  /**
   * @name Update portal
   * @description Update an portal by its ID.
   *
   * @param `projectId` - string
   * @param `portalId` - string
   * @param `body` - ManagementProjectsPortalsUpdateBody
   *
   * @returns ManagementProjectsPortalsUpdateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(projectId, portalId, body) {
    return this._patch({
      path: ["management", "projects", projectId, "portals", portalId],
      body: mapManagementProjectsPortalsUpdateBody.transformTo(body)
    }).transform(mapManagementProjectsPortalsUpdateOutput);
  }
  /**
   * @name Create portal
   * @description Create a new portal.
   *
   * @param `projectId` - string
   * @param `body` - ManagementProjectsPortalsCreateBody
   *
   * @returns ManagementProjectsPortalsCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(projectId, body) {
    return this._post({
      path: ["management", "projects", projectId, "portals"],
      body: mapManagementProjectsPortalsCreateBody.transformTo(body)
    }).transform(mapManagementProjectsPortalsCreateOutput);
  }
  /**
   * @name Delete portal
   * @description Delete an portal by its ID.
   *
   * @param `projectId` - string
   * @param `portalId` - string
   *
   * @returns ManagementProjectsPortalsDeleteOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(projectId, portalId) {
    return this._delete({
      path: ["management", "projects", projectId, "portals", portalId]
    }).transform(mapManagementProjectsPortalsDeleteOutput);
  }
};

// src/endpoints/management-projects.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint38
} from "@metorial/util-endpoint";
var MetorialManagementProjectsEndpoint = class extends BaseMetorialEndpoint38 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List projects
   * @description Retrieve a list of all projects currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `query` - ManagementProjectsListQuery
   *
   * @returns ManagementProjectsListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query) {
    return this._get({
      path: ["management", "projects"],
      query: query ? mapManagementProjectsListQuery.transformTo(query) : void 0
    }).transform(mapManagementProjectsListOutput);
  }
  /**
   * @name Create project
   * @description Create a new project.
   *
   * @param `body` - ManagementProjectsCreateBody
   *
   * @returns ManagementProjectsCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body) {
    return this._post({
      path: ["management", "projects"],
      body: mapManagementProjectsCreateBody.transformTo(body)
    }).transform(mapManagementProjectsCreateOutput);
  }
  /**
   * @name Get project
   * @description Retrieve a project by its ID.
   *
   * @param `projectId` - string
   *
   * @returns ManagementProjectsGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(projectId) {
    return this._get({
      path: ["management", "projects", projectId]
    }).transform(mapManagementProjectsGetOutput);
  }
  /**
   * @name Update project
   * @description Update a project by its ID.
   *
   * @param `projectId` - string
   * @param `body` - ManagementProjectsUpdateBody
   *
   * @returns ManagementProjectsUpdateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(projectId, body) {
    return this._patch({
      path: ["management", "projects", projectId],
      body: mapManagementProjectsUpdateBody.transformTo(body)
    }).transform(mapManagementProjectsUpdateOutput);
  }
};

// src/endpoints/policies-entitlements.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint39
} from "@metorial/util-endpoint";
var MetorialPoliciesEntitlementsEndpoint = class extends BaseMetorialEndpoint39 {
  constructor(config) {
    super(config);
  }
  /**
   * @name Create policy entitlement
   * @description Create a new policy entitlement.
   *
   * @param `policyId` - string
   * @param `body` - ManagementInstancesPoliciesEntitlementsCreateBody
   *
   * @returns ManagementInstancesPoliciesEntitlementsCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(policyId, body) {
    return this._post({
      path: ["policies", policyId, "entitlement"],
      body: mapManagementInstancesPoliciesEntitlementsCreateBody.transformTo(
        body
      )
    }).transform(mapManagementInstancesPoliciesEntitlementsCreateOutput);
  }
  /**
   * @name Update policy entitlement
   * @description Update an existing policy entitlement.
   *
   * @param `policyId` - string
   * @param `entitlementId` - string
   * @param `body` - ManagementInstancesPoliciesEntitlementsUpdateBody
   *
   * @returns ManagementInstancesPoliciesEntitlementsUpdateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(policyId, entitlementId, body) {
    return this._patch({
      path: ["policies", policyId, "entitlements", entitlementId],
      body: mapManagementInstancesPoliciesEntitlementsUpdateBody.transformTo(
        body
      )
    }).transform(mapManagementInstancesPoliciesEntitlementsUpdateOutput);
  }
  /**
   * @name Delete policy entitlement
   * @description Delete a specific policy entitlement by its ID.
   *
   * @param `policyId` - string
   * @param `entitlementId` - string
   *
   * @returns ManagementInstancesPoliciesEntitlementsDeleteOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(policyId, entitlementId) {
    return this._delete({
      path: ["policies", policyId, "entitlement", entitlementId]
    }).transform(mapManagementInstancesPoliciesEntitlementsDeleteOutput);
  }
};

// src/endpoints/policies.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint40
} from "@metorial/util-endpoint";
var MetorialPoliciesEndpoint = class extends BaseMetorialEndpoint40 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List policies
   * @description Retrieve a list of all policies currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `query` - ManagementInstancesPoliciesListQuery
   *
   * @returns ManagementInstancesPoliciesListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query) {
    return this._get({
      path: ["policies"],
      query: query ? mapManagementInstancesPoliciesListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesPoliciesListOutput);
  }
  /**
   * @name Get policy
   * @description Retrieve a specific policy by its ID.
   *
   * @param `policyId` - string
   *
   * @returns ManagementInstancesPoliciesGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(policyId) {
    return this._get({
      path: ["policies", policyId]
    }).transform(mapManagementInstancesPoliciesGetOutput);
  }
  /**
   * @name Create policy
   * @description Create a new policy.
   *
   * @param `body` - ManagementInstancesPoliciesCreateBody
   *
   * @returns ManagementInstancesPoliciesCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body) {
    return this._post({
      path: ["policies"],
      body: mapManagementInstancesPoliciesCreateBody.transformTo(body)
    }).transform(mapManagementInstancesPoliciesCreateOutput);
  }
  /**
   * @name Update policy
   * @description Update an existing policy.
   *
   * @param `policyId` - string
   * @param `body` - ManagementInstancesPoliciesUpdateBody
   *
   * @returns ManagementInstancesPoliciesUpdateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(policyId, body) {
    return this._patch({
      path: ["policies", policyId],
      body: mapManagementInstancesPoliciesUpdateBody.transformTo(body)
    }).transform(mapManagementInstancesPoliciesUpdateOutput);
  }
};

// src/endpoints/portals-agents.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint41
} from "@metorial/util-endpoint";
var MetorialPortalsAgentsEndpoint = class extends BaseMetorialEndpoint41 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List portal agents
   * @description Retrieve a list of all portal agents currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `portalId` - string
   * @param `query` - ManagementInstancesPortalsAgentsListQuery
   *
   * @returns ManagementInstancesPortalsAgentsListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(portalId, query) {
    return this._get({
      path: ["portals", portalId, "portal-agents"],
      query: query ? mapManagementInstancesPortalsAgentsListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesPortalsAgentsListOutput);
  }
  /**
   * @name Get portal agent
   * @description Retrieve a specific portal agent by its ID.
   *
   * @param `portalId` - string
   * @param `portalAgentId` - string
   *
   * @returns ManagementInstancesPortalsAgentsGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(portalId, portalAgentId) {
    return this._get({
      path: ["portals", portalId, "portal-agents", portalAgentId]
    }).transform(mapManagementInstancesPortalsAgentsGetOutput);
  }
  /**
   * @name Create portal agent
   * @description Create a new portal agent.
   *
   * @param `portalId` - string
   * @param `body` - ManagementInstancesPortalsAgentsCreateBody
   *
   * @returns ManagementInstancesPortalsAgentsCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(portalId, body) {
    return this._post({
      path: ["portals", portalId, "portal-agents"],
      body: mapManagementInstancesPortalsAgentsCreateBody.transformTo(body)
    }).transform(mapManagementInstancesPortalsAgentsCreateOutput);
  }
  /**
   * @name Update portal agent
   * @description Update an existing portal agent.
   *
   * @param `portalId` - string
   * @param `portalAgentId` - string
   * @param `body` - ManagementInstancesPortalsAgentsUpdateBody
   *
   * @returns ManagementInstancesPortalsAgentsUpdateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(portalId, portalAgentId, body) {
    return this._patch({
      path: ["portals", portalId, "portal-agents", portalAgentId],
      body: mapManagementInstancesPortalsAgentsUpdateBody.transformTo(body)
    }).transform(mapManagementInstancesPortalsAgentsUpdateOutput);
  }
  /**
   * @name Delete portal agent
   * @description Delete a specific portal agent by its ID.
   *
   * @param `portalId` - string
   * @param `portalAgentId` - string
   *
   * @returns ManagementInstancesPortalsAgentsDeleteOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(portalId, portalAgentId) {
    return this._delete({
      path: ["portals", portalId, "portal-agents", portalAgentId]
    }).transform(mapManagementInstancesPortalsAgentsDeleteOutput);
  }
};

// src/endpoints/portals.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint42
} from "@metorial/util-endpoint";
var MetorialPortalsEndpoint = class extends BaseMetorialEndpoint42 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List portals
   * @description Retrieve a list of all portals currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `query` - ManagementInstancesPortalsListQuery
   *
   * @returns ManagementInstancesPortalsListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query) {
    return this._get({
      path: ["portals"],
      query: query ? mapManagementInstancesPortalsListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesPortalsListOutput);
  }
  /**
   * @name Get portal
   * @description Retrieve a specific portal by its ID.
   *
   * @param `portalId` - string
   *
   * @returns ManagementInstancesPortalsGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(portalId) {
    return this._get({
      path: ["portals", portalId]
    }).transform(mapManagementInstancesPortalsGetOutput);
  }
  /**
   * @name Create portal
   * @description Create a new portal.
   *
   * @param `body` - ManagementInstancesPortalsCreateBody
   *
   * @returns ManagementInstancesPortalsCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body) {
    return this._post({
      path: ["portals"],
      body: mapManagementInstancesPortalsCreateBody.transformTo(body)
    }).transform(mapManagementInstancesPortalsCreateOutput);
  }
  /**
   * @name Update portal
   * @description Update an existing portal.
   *
   * @param `portalId` - string
   * @param `body` - ManagementInstancesPortalsUpdateBody
   *
   * @returns ManagementInstancesPortalsUpdateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(portalId, body) {
    return this._patch({
      path: ["portals", portalId],
      body: mapManagementInstancesPortalsUpdateBody.transformTo(body)
    }).transform(mapManagementInstancesPortalsUpdateOutput);
  }
  /**
   * @name Delete portal
   * @description Delete a specific portal by its ID.
   *
   * @param `portalId` - string
   *
   * @returns ManagementInstancesPortalsDeleteOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(portalId) {
    return this._delete({
      path: ["portals", portalId]
    }).transform(mapManagementInstancesPortalsDeleteOutput);
  }
};

// src/endpoints/roles.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint43
} from "@metorial/util-endpoint";
var MetorialRolesEndpoint = class extends BaseMetorialEndpoint43 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List roles
   * @description Retrieve a list of all roles currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `query` - ManagementInstancesRolesListQuery
   *
   * @returns ManagementInstancesRolesListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query) {
    return this._get({
      path: ["roles"],
      query: query ? mapManagementInstancesRolesListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesRolesListOutput);
  }
  /**
   * @name Get role
   * @description Retrieve a specific role by its ID.
   *
   * @param `roleId` - string
   *
   * @returns ManagementInstancesRolesGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(roleId) {
    return this._get({
      path: ["roles", roleId]
    }).transform(mapManagementInstancesRolesGetOutput);
  }
  /**
   * @name Create role
   * @description Create a new role.
   *
   * @param `body` - ManagementInstancesRolesCreateBody
   *
   * @returns ManagementInstancesRolesCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body) {
    return this._post({
      path: ["roles"],
      body: mapManagementInstancesRolesCreateBody.transformTo(body)
    }).transform(mapManagementInstancesRolesCreateOutput);
  }
  /**
   * @name Update role
   * @description Update an existing role.
   *
   * @param `roleId` - string
   * @param `body` - ManagementInstancesRolesUpdateBody
   *
   * @returns ManagementInstancesRolesUpdateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(roleId, body) {
    return this._patch({
      path: ["roles", roleId],
      body: mapManagementInstancesRolesUpdateBody.transformTo(body)
    }).transform(mapManagementInstancesRolesUpdateOutput);
  }
};

// src/endpoints/runs.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint44
} from "@metorial/util-endpoint";
var MetorialRunsEndpoint = class extends BaseMetorialEndpoint44 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List runs
   * @description Retrieve a list of all runs currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `query` - ManagementInstancesRunsListQuery
   *
   * @returns ManagementInstancesRunsListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query) {
    return this._get({
      path: ["runs"],
      query: query ? mapManagementInstancesRunsListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesRunsListOutput);
  }
  /**
   * @name Create run
   * @description Create a new run.
   *
   * @param `body` - ManagementInstancesRunsCreateBody
   *
   * @returns ManagementInstancesRunsCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body) {
    return this._post({
      path: ["runs"],
      body: mapManagementInstancesRunsCreateBody.transformTo(body)
    }).transform(mapManagementInstancesRunsCreateOutput);
  }
  /**
   * @name Get run
   * @description Retrieve a specific run by its ID.
   *
   * @param `runId` - string
   *
   * @returns ManagementInstancesRunsGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(runId) {
    return this._get({
      path: ["runs", runId]
    }).transform(mapManagementInstancesRunsGetOutput);
  }
};

// src/endpoints/threads-messages.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint45
} from "@metorial/util-endpoint";
var MetorialThreadsMessagesEndpoint = class extends BaseMetorialEndpoint45 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List messages
   * @description Retrieve a list of all messages currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `threadId` - string
   * @param `query` - ManagementInstancesThreadsMessagesListQuery
   *
   * @returns ManagementInstancesThreadsMessagesListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(threadId, query) {
    return this._get({
      path: ["threads", threadId, "messages"],
      query: query ? mapManagementInstancesThreadsMessagesListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesThreadsMessagesListOutput);
  }
  /**
   * @name Create message
   * @description Create a new message.
   *
   * @param `threadId` - string
   * @param `body` - ManagementInstancesThreadsMessagesCreateBody
   *
   * @returns ManagementInstancesThreadsMessagesCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(threadId, body) {
    return this._post({
      path: ["threads", threadId, "messages"],
      body: mapManagementInstancesThreadsMessagesCreateBody.transformTo(body)
    }).transform(mapManagementInstancesThreadsMessagesCreateOutput);
  }
  /**
   * @name Get message
   * @description Retrieve a specific message by its ID.
   *
   * @param `threadId` - string
   * @param `messageId` - string
   *
   * @returns ManagementInstancesThreadsMessagesGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(threadId, messageId) {
    return this._get({
      path: ["threads", threadId, "messages", messageId]
    }).transform(mapManagementInstancesThreadsMessagesGetOutput);
  }
};

// src/endpoints/threads-participants.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint46
} from "@metorial/util-endpoint";
var MetorialThreadsParticipantsEndpoint = class extends BaseMetorialEndpoint46 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List thread participants
   * @description Retrieve a list of all participants in a specific thread.
   *
   * @param `threadId` - string
   * @param `query` - ManagementInstancesThreadsParticipantsListQuery
   *
   * @returns ManagementInstancesThreadsParticipantsListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(threadId, query) {
    return this._get({
      path: ["threads", threadId, "participants"],
      query: query ? mapManagementInstancesThreadsParticipantsListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesThreadsParticipantsListOutput);
  }
};

// src/endpoints/threads.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint47
} from "@metorial/util-endpoint";
var MetorialThreadsEndpoint = class extends BaseMetorialEndpoint47 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List threads
   * @description Retrieve a list of all threads currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `query` - ManagementInstancesThreadsListQuery
   *
   * @returns ManagementInstancesThreadsListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query) {
    return this._get({
      path: ["threads"],
      query: query ? mapManagementInstancesThreadsListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesThreadsListOutput);
  }
  /**
   * @name Get thread
   * @description Retrieve a specific thread by its ID.
   *
   * @param `threadId` - string
   *
   * @returns ManagementInstancesThreadsGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(threadId) {
    return this._get({
      path: ["threads", threadId]
    }).transform(mapManagementInstancesThreadsGetOutput);
  }
  /**
   * @name Create thread
   * @description Create a new thread.
   *
   * @param `body` - ManagementInstancesThreadsCreateBody
   *
   * @returns ManagementInstancesThreadsCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body) {
    return this._post({
      path: ["threads"],
      body: mapManagementInstancesThreadsCreateBody.transformTo(body)
    }).transform(mapManagementInstancesThreadsCreateOutput);
  }
  /**
   * @name Update thread
   * @description Update an existing thread.
   *
   * @param `threadId` - string
   * @param `body` - ManagementInstancesThreadsUpdateBody
   *
   * @returns ManagementInstancesThreadsUpdateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(threadId, body) {
    return this._patch({
      path: ["threads", threadId],
      body: mapManagementInstancesThreadsUpdateBody.transformTo(body)
    }).transform(mapManagementInstancesThreadsUpdateOutput);
  }
  /**
   * @name Delete thread
   * @description Delete a specific thread by its ID.
   *
   * @param `threadId` - string
   *
   * @returns ManagementInstancesThreadsDeleteOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(threadId) {
    return this._delete({
      path: ["threads", threadId]
    }).transform(mapManagementInstancesThreadsDeleteOutput);
  }
};

// src/endpoints/users.ts
import {
  BaseMetorialEndpoint as BaseMetorialEndpoint48
} from "@metorial/util-endpoint";
var MetorialUsersEndpoint = class extends BaseMetorialEndpoint48 {
  constructor(config) {
    super(config);
  }
  /**
   * @name List users
   * @description Retrieve a list of all users currently defined in the system. Allows for optional filtering by various attributes.
   *
   * @param `query` - ManagementInstancesUsersListQuery
   *
   * @returns ManagementInstancesUsersListOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  list(query) {
    return this._get({
      path: ["users"],
      query: query ? mapManagementInstancesUsersListQuery.transformTo(query) : void 0
    }).transform(mapManagementInstancesUsersListOutput);
  }
  /**
   * @name Get user
   * @description Retrieve a specific user by its ID.
   *
   * @param `userId` - string
   *
   * @returns ManagementInstancesUsersGetOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  get(userId) {
    return this._get({
      path: ["users", userId]
    }).transform(mapManagementInstancesUsersGetOutput);
  }
  /**
   * @name Create user
   * @description Create a new user.
   *
   * @param `body` - ManagementInstancesUsersCreateBody
   *
   * @returns ManagementInstancesUsersCreateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  create(body) {
    return this._post({
      path: ["users"],
      body: mapManagementInstancesUsersCreateBody.transformTo(body)
    }).transform(mapManagementInstancesUsersCreateOutput);
  }
  /**
   * @name Update user
   * @description Update an existing user.
   *
   * @param `userId` - string
   * @param `body` - ManagementInstancesUsersUpdateBody
   *
   * @returns ManagementInstancesUsersUpdateOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  update(userId, body) {
    return this._patch({
      path: ["users", userId],
      body: mapManagementInstancesUsersUpdateBody.transformTo(body)
    }).transform(mapManagementInstancesUsersUpdateOutput);
  }
  /**
   * @name Delete user
   * @description Delete an existing user.
   *
   * @param `userId` - string
   *
   * @returns ManagementInstancesUsersDeleteOutput
   *
   * @see https://metorial.com/api
   * @see https://metorial.com/docs
   */
  delete(userId) {
    return this._delete({
      path: ["users", userId]
    }).transform(mapManagementInstancesUsersDeleteOutput);
  }
};
export {
  MetorialActorsEndpoint,
  MetorialAgentsEndpoint,
  MetorialClientTokensJwksEndpoint,
  MetorialFilesEndpoint,
  MetorialFilesLinksEndpoint,
  MetorialGroupsBlocksEndpoint,
  MetorialGroupsEndpoint,
  MetorialGroupsThreadsEndpoint,
  MetorialGroupsUsersEndpoint,
  MetorialInstanceEndpoint,
  MetorialManagementInstancesActorsEndpoint,
  MetorialManagementInstancesAgentsEndpoint,
  MetorialManagementInstancesClientTokensJwksEndpoint,
  MetorialManagementInstancesFilesEndpoint,
  MetorialManagementInstancesFilesLinksEndpoint,
  MetorialManagementInstancesGroupsBlocksEndpoint,
  MetorialManagementInstancesGroupsEndpoint,
  MetorialManagementInstancesGroupsThreadsEndpoint,
  MetorialManagementInstancesGroupsUsersEndpoint,
  MetorialManagementInstancesInstanceEndpoint,
  MetorialManagementInstancesPoliciesEndpoint,
  MetorialManagementInstancesPoliciesEntitlementsEndpoint,
  MetorialManagementInstancesPortalsAgentsEndpoint,
  MetorialManagementInstancesPortalsEndpoint,
  MetorialManagementInstancesRolesEndpoint,
  MetorialManagementInstancesRunsEndpoint,
  MetorialManagementInstancesThreadsEndpoint,
  MetorialManagementInstancesThreadsMessagesEndpoint,
  MetorialManagementInstancesThreadsParticipantsEndpoint,
  MetorialManagementInstancesUsersEndpoint,
  MetorialManagementProjectsAgentsEndpoint,
  MetorialManagementProjectsAgentsInstanceAgentsEndpoint,
  MetorialManagementProjectsAgentsReleasesEndpoint,
  MetorialManagementProjectsEndpoint,
  MetorialManagementProjectsPortalsEndpoint,
  MetorialManagementProjectsPortalsPortalAgentsEndpoint,
  MetorialManagementProjectsPortalsPortalDomainsEndpoint,
  MetorialManagementProjectsPortalsPortalEnvironmentsEndpoint,
  MetorialPoliciesEndpoint,
  MetorialPoliciesEntitlementsEndpoint,
  MetorialPortalsAgentsEndpoint,
  MetorialPortalsEndpoint,
  MetorialRolesEndpoint,
  MetorialRunsEndpoint,
  MetorialThreadsEndpoint,
  MetorialThreadsMessagesEndpoint,
  MetorialThreadsParticipantsEndpoint,
  MetorialUsersEndpoint,
  mapActorsGetOutput,
  mapActorsListOutput,
  mapActorsListQuery,
  mapAgentsGetOutput,
  mapAgentsListOutput,
  mapAgentsListQuery,
  mapClientTokensJwksListOutput,
  mapFilesGetOutput,
  mapFilesLinksCreateOutput,
  mapFilesListOutput,
  mapFilesListQuery,
  mapGroupsBlocksDeleteOutput,
  mapGroupsBlocksGetOutput,
  mapGroupsBlocksListOutput,
  mapGroupsBlocksListQuery,
  mapGroupsCreateBody,
  mapGroupsCreateOutput,
  mapGroupsDeleteOutput,
  mapGroupsGetOutput,
  mapGroupsListOutput,
  mapGroupsListQuery,
  mapGroupsThreadsCreateBody,
  mapGroupsThreadsCreateOutput,
  mapGroupsThreadsDeleteOutput,
  mapGroupsThreadsGetOutput,
  mapGroupsThreadsListOutput,
  mapGroupsThreadsListQuery,
  mapGroupsUpdateBody,
  mapGroupsUpdateOutput,
  mapGroupsUsersCreateBody,
  mapGroupsUsersCreateOutput,
  mapGroupsUsersDeleteOutput,
  mapGroupsUsersGetOutput,
  mapGroupsUsersListOutput,
  mapGroupsUsersListQuery,
  mapGroupsUsersUpdateBody,
  mapGroupsUsersUpdateOutput,
  mapInstanceGetOutput,
  mapManagementInstancesActorsGetOutput,
  mapManagementInstancesActorsListOutput,
  mapManagementInstancesActorsListQuery,
  mapManagementInstancesAgentsGetOutput,
  mapManagementInstancesAgentsListOutput,
  mapManagementInstancesAgentsListQuery,
  mapManagementInstancesClientTokensJwksListOutput,
  mapManagementInstancesFilesGetOutput,
  mapManagementInstancesFilesLinksCreateOutput,
  mapManagementInstancesFilesListOutput,
  mapManagementInstancesFilesListQuery,
  mapManagementInstancesGroupsBlocksDeleteOutput,
  mapManagementInstancesGroupsBlocksGetOutput,
  mapManagementInstancesGroupsBlocksListOutput,
  mapManagementInstancesGroupsBlocksListQuery,
  mapManagementInstancesGroupsCreateBody,
  mapManagementInstancesGroupsCreateOutput,
  mapManagementInstancesGroupsDeleteOutput,
  mapManagementInstancesGroupsGetOutput,
  mapManagementInstancesGroupsListOutput,
  mapManagementInstancesGroupsListQuery,
  mapManagementInstancesGroupsThreadsCreateBody,
  mapManagementInstancesGroupsThreadsCreateOutput,
  mapManagementInstancesGroupsThreadsDeleteOutput,
  mapManagementInstancesGroupsThreadsGetOutput,
  mapManagementInstancesGroupsThreadsListOutput,
  mapManagementInstancesGroupsThreadsListQuery,
  mapManagementInstancesGroupsUpdateBody,
  mapManagementInstancesGroupsUpdateOutput,
  mapManagementInstancesGroupsUsersCreateBody,
  mapManagementInstancesGroupsUsersCreateOutput,
  mapManagementInstancesGroupsUsersDeleteOutput,
  mapManagementInstancesGroupsUsersGetOutput,
  mapManagementInstancesGroupsUsersListOutput,
  mapManagementInstancesGroupsUsersListQuery,
  mapManagementInstancesGroupsUsersUpdateBody,
  mapManagementInstancesGroupsUsersUpdateOutput,
  mapManagementInstancesInstanceGetOutput,
  mapManagementInstancesPoliciesCreateBody,
  mapManagementInstancesPoliciesCreateOutput,
  mapManagementInstancesPoliciesEntitlementsCreateBody,
  mapManagementInstancesPoliciesEntitlementsCreateOutput,
  mapManagementInstancesPoliciesEntitlementsDeleteOutput,
  mapManagementInstancesPoliciesEntitlementsUpdateBody,
  mapManagementInstancesPoliciesEntitlementsUpdateOutput,
  mapManagementInstancesPoliciesGetOutput,
  mapManagementInstancesPoliciesListOutput,
  mapManagementInstancesPoliciesListQuery,
  mapManagementInstancesPoliciesUpdateBody,
  mapManagementInstancesPoliciesUpdateOutput,
  mapManagementInstancesPortalsAgentsCreateBody,
  mapManagementInstancesPortalsAgentsCreateOutput,
  mapManagementInstancesPortalsAgentsDeleteOutput,
  mapManagementInstancesPortalsAgentsGetOutput,
  mapManagementInstancesPortalsAgentsListOutput,
  mapManagementInstancesPortalsAgentsListQuery,
  mapManagementInstancesPortalsAgentsUpdateBody,
  mapManagementInstancesPortalsAgentsUpdateOutput,
  mapManagementInstancesPortalsCreateBody,
  mapManagementInstancesPortalsCreateOutput,
  mapManagementInstancesPortalsDeleteOutput,
  mapManagementInstancesPortalsGetOutput,
  mapManagementInstancesPortalsListOutput,
  mapManagementInstancesPortalsListQuery,
  mapManagementInstancesPortalsUpdateBody,
  mapManagementInstancesPortalsUpdateOutput,
  mapManagementInstancesRolesCreateBody,
  mapManagementInstancesRolesCreateOutput,
  mapManagementInstancesRolesGetOutput,
  mapManagementInstancesRolesListOutput,
  mapManagementInstancesRolesListQuery,
  mapManagementInstancesRolesUpdateBody,
  mapManagementInstancesRolesUpdateOutput,
  mapManagementInstancesRunsCreateBody,
  mapManagementInstancesRunsCreateOutput,
  mapManagementInstancesRunsGetOutput,
  mapManagementInstancesRunsListOutput,
  mapManagementInstancesRunsListQuery,
  mapManagementInstancesThreadsCreateBody,
  mapManagementInstancesThreadsCreateOutput,
  mapManagementInstancesThreadsDeleteOutput,
  mapManagementInstancesThreadsGetOutput,
  mapManagementInstancesThreadsListOutput,
  mapManagementInstancesThreadsListQuery,
  mapManagementInstancesThreadsMessagesCreateBody,
  mapManagementInstancesThreadsMessagesCreateOutput,
  mapManagementInstancesThreadsMessagesGetOutput,
  mapManagementInstancesThreadsMessagesListOutput,
  mapManagementInstancesThreadsMessagesListQuery,
  mapManagementInstancesThreadsParticipantsListOutput,
  mapManagementInstancesThreadsParticipantsListQuery,
  mapManagementInstancesThreadsUpdateBody,
  mapManagementInstancesThreadsUpdateOutput,
  mapManagementInstancesUsersCreateBody,
  mapManagementInstancesUsersCreateOutput,
  mapManagementInstancesUsersDeleteOutput,
  mapManagementInstancesUsersGetOutput,
  mapManagementInstancesUsersListOutput,
  mapManagementInstancesUsersListQuery,
  mapManagementInstancesUsersUpdateBody,
  mapManagementInstancesUsersUpdateOutput,
  mapManagementProjectsAgentsCreateBody,
  mapManagementProjectsAgentsCreateOutput,
  mapManagementProjectsAgentsDeleteOutput,
  mapManagementProjectsAgentsGetOutput,
  mapManagementProjectsAgentsInstanceAgentsGetOutput,
  mapManagementProjectsAgentsInstanceAgentsListOutput,
  mapManagementProjectsAgentsInstanceAgentsListQuery,
  mapManagementProjectsAgentsListOutput,
  mapManagementProjectsAgentsListQuery,
  mapManagementProjectsAgentsReleasesGetOutput,
  mapManagementProjectsAgentsReleasesListOutput,
  mapManagementProjectsAgentsReleasesListQuery,
  mapManagementProjectsAgentsUpdateBody,
  mapManagementProjectsAgentsUpdateOutput,
  mapManagementProjectsCreateBody,
  mapManagementProjectsCreateOutput,
  mapManagementProjectsGetOutput,
  mapManagementProjectsListOutput,
  mapManagementProjectsListQuery,
  mapManagementProjectsPortalsCreateBody,
  mapManagementProjectsPortalsCreateOutput,
  mapManagementProjectsPortalsDeleteOutput,
  mapManagementProjectsPortalsGetOutput,
  mapManagementProjectsPortalsListOutput,
  mapManagementProjectsPortalsListQuery,
  mapManagementProjectsPortalsPortalAgentsCreateBody,
  mapManagementProjectsPortalsPortalAgentsCreateOutput,
  mapManagementProjectsPortalsPortalAgentsDeleteOutput,
  mapManagementProjectsPortalsPortalAgentsGetOutput,
  mapManagementProjectsPortalsPortalAgentsListOutput,
  mapManagementProjectsPortalsPortalAgentsListQuery,
  mapManagementProjectsPortalsPortalAgentsUpdateBody,
  mapManagementProjectsPortalsPortalAgentsUpdateOutput,
  mapManagementProjectsPortalsPortalDomainsCreateBody,
  mapManagementProjectsPortalsPortalDomainsCreateOutput,
  mapManagementProjectsPortalsPortalDomainsDeleteOutput,
  mapManagementProjectsPortalsPortalDomainsGetOutput,
  mapManagementProjectsPortalsPortalDomainsListOutput,
  mapManagementProjectsPortalsPortalDomainsListQuery,
  mapManagementProjectsPortalsPortalDomainsRecheckOutput,
  mapManagementProjectsPortalsPortalDomainsUpdateBody,
  mapManagementProjectsPortalsPortalDomainsUpdateOutput,
  mapManagementProjectsPortalsPortalEnvironmentsCreateBody,
  mapManagementProjectsPortalsPortalEnvironmentsCreateOutput,
  mapManagementProjectsPortalsPortalEnvironmentsGetOutput,
  mapManagementProjectsPortalsPortalEnvironmentsListOutput,
  mapManagementProjectsPortalsPortalEnvironmentsListQuery,
  mapManagementProjectsPortalsPortalEnvironmentsUpdateBody,
  mapManagementProjectsPortalsPortalEnvironmentsUpdateOutput,
  mapManagementProjectsPortalsUpdateBody,
  mapManagementProjectsPortalsUpdateOutput,
  mapManagementProjectsUpdateBody,
  mapManagementProjectsUpdateOutput,
  mapPoliciesCreateBody,
  mapPoliciesCreateOutput,
  mapPoliciesEntitlementsCreateBody,
  mapPoliciesEntitlementsCreateOutput,
  mapPoliciesEntitlementsDeleteOutput,
  mapPoliciesEntitlementsUpdateBody,
  mapPoliciesEntitlementsUpdateOutput,
  mapPoliciesGetOutput,
  mapPoliciesListOutput,
  mapPoliciesListQuery,
  mapPoliciesUpdateBody,
  mapPoliciesUpdateOutput,
  mapPortalsAgentsCreateBody,
  mapPortalsAgentsCreateOutput,
  mapPortalsAgentsDeleteOutput,
  mapPortalsAgentsGetOutput,
  mapPortalsAgentsListOutput,
  mapPortalsAgentsListQuery,
  mapPortalsAgentsUpdateBody,
  mapPortalsAgentsUpdateOutput,
  mapPortalsCreateBody,
  mapPortalsCreateOutput,
  mapPortalsDeleteOutput,
  mapPortalsGetOutput,
  mapPortalsListOutput,
  mapPortalsListQuery,
  mapPortalsUpdateBody,
  mapPortalsUpdateOutput,
  mapRolesCreateBody,
  mapRolesCreateOutput,
  mapRolesGetOutput,
  mapRolesListOutput,
  mapRolesListQuery,
  mapRolesUpdateBody,
  mapRolesUpdateOutput,
  mapRunsCreateBody,
  mapRunsCreateOutput,
  mapRunsGetOutput,
  mapRunsListOutput,
  mapRunsListQuery,
  mapThreadsCreateBody,
  mapThreadsCreateOutput,
  mapThreadsDeleteOutput,
  mapThreadsGetOutput,
  mapThreadsListOutput,
  mapThreadsListQuery,
  mapThreadsMessagesCreateBody,
  mapThreadsMessagesCreateOutput,
  mapThreadsMessagesGetOutput,
  mapThreadsMessagesListOutput,
  mapThreadsMessagesListQuery,
  mapThreadsParticipantsListOutput,
  mapThreadsParticipantsListQuery,
  mapThreadsUpdateBody,
  mapThreadsUpdateOutput,
  mapUsersCreateBody,
  mapUsersCreateOutput,
  mapUsersDeleteOutput,
  mapUsersGetOutput,
  mapUsersListOutput,
  mapUsersListQuery,
  mapUsersUpdateBody,
  mapUsersUpdateOutput
};
//# sourceMappingURL=index.js.map